
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
let $8863cd8fe199f948$var$taskIdCounter = 1, $8863cd8fe199f948$var$isCallbackScheduled = false, $8863cd8fe199f948$var$isPerformingWork = false, $8863cd8fe199f948$var$taskQueue = [], $8863cd8fe199f948$var$currentTask = null, $8863cd8fe199f948$var$shouldYieldToHost = null, $8863cd8fe199f948$var$yieldInterval = 5, $8863cd8fe199f948$var$deadline = 0, $8863cd8fe199f948$var$maxYieldInterval = 300, $8863cd8fe199f948$var$maxDeadline = 0, $8863cd8fe199f948$var$scheduleCallback = null, $8863cd8fe199f948$var$scheduledCallback = null;
const $8863cd8fe199f948$var$maxSigned31BitInt = 1073741823;
function $8863cd8fe199f948$var$setupScheduler() {
    const channel = new MessageChannel(), port = channel.port2;
    $8863cd8fe199f948$var$scheduleCallback = ()=>port.postMessage(null);
    channel.port1.onmessage = ()=>{
        if ($8863cd8fe199f948$var$scheduledCallback !== null) {
            const currentTime = performance.now();
            $8863cd8fe199f948$var$deadline = currentTime + $8863cd8fe199f948$var$yieldInterval;
            $8863cd8fe199f948$var$maxDeadline = currentTime + $8863cd8fe199f948$var$maxYieldInterval;
            try {
                const hasMoreWork = $8863cd8fe199f948$var$scheduledCallback(currentTime);
                if (!hasMoreWork) $8863cd8fe199f948$var$scheduledCallback = null;
                else port.postMessage(null);
            } catch (error) {
                port.postMessage(null);
                throw error;
            }
        }
    };
    if (navigator && navigator.scheduling && navigator.scheduling.isInputPending) {
        const scheduling = navigator.scheduling;
        $8863cd8fe199f948$var$shouldYieldToHost = ()=>{
            const currentTime = performance.now();
            if (currentTime >= $8863cd8fe199f948$var$deadline) {
                if (scheduling.isInputPending()) return true;
                return currentTime >= $8863cd8fe199f948$var$maxDeadline;
            } else return false;
        };
    } else $8863cd8fe199f948$var$shouldYieldToHost = ()=>performance.now() >= $8863cd8fe199f948$var$deadline;
}
function $8863cd8fe199f948$var$enqueue(taskQueue, task) {
    function findIndex() {
        let m = 0;
        let n = taskQueue.length - 1;
        while(m <= n){
            const k = n + m >> 1;
            const cmp = task.expirationTime - taskQueue[k].expirationTime;
            if (cmp > 0) m = k + 1;
            else if (cmp < 0) n = k - 1;
            else return k;
        }
        return m;
    }
    taskQueue.splice(findIndex(), 0, task);
}
function $8863cd8fe199f948$export$4b5e076b3a2fbe0a(fn, options) {
    if (!$8863cd8fe199f948$var$scheduleCallback) $8863cd8fe199f948$var$setupScheduler();
    let startTime = performance.now(), timeout = $8863cd8fe199f948$var$maxSigned31BitInt;
    if (options && options.timeout) timeout = options.timeout;
    const newTask = {
        id: $8863cd8fe199f948$var$taskIdCounter++,
        fn: fn,
        startTime: startTime,
        expirationTime: startTime + timeout
    };
    $8863cd8fe199f948$var$enqueue($8863cd8fe199f948$var$taskQueue, newTask);
    if (!$8863cd8fe199f948$var$isCallbackScheduled && !$8863cd8fe199f948$var$isPerformingWork) {
        $8863cd8fe199f948$var$isCallbackScheduled = true;
        $8863cd8fe199f948$var$scheduledCallback = $8863cd8fe199f948$var$flushWork;
        $8863cd8fe199f948$var$scheduleCallback();
    }
    return newTask;
}
function $8863cd8fe199f948$export$b888d8f981c07a46(task) {
    task.fn = null;
}
function $8863cd8fe199f948$var$flushWork(initialTime) {
    $8863cd8fe199f948$var$isCallbackScheduled = false;
    $8863cd8fe199f948$var$isPerformingWork = true;
    try {
        return $8863cd8fe199f948$var$workLoop(initialTime);
    } finally{
        $8863cd8fe199f948$var$currentTask = null;
        $8863cd8fe199f948$var$isPerformingWork = false;
    }
}
function $8863cd8fe199f948$var$workLoop(initialTime) {
    let currentTime = initialTime;
    $8863cd8fe199f948$var$currentTask = $8863cd8fe199f948$var$taskQueue[0] || null;
    while($8863cd8fe199f948$var$currentTask !== null){
        if ($8863cd8fe199f948$var$currentTask.expirationTime > currentTime && $8863cd8fe199f948$var$shouldYieldToHost()) break;
        const callback = $8863cd8fe199f948$var$currentTask.fn;
        if (callback !== null) {
            $8863cd8fe199f948$var$currentTask.fn = null;
            const didUserCallbackTimeout = $8863cd8fe199f948$var$currentTask.expirationTime <= currentTime;
            callback(didUserCallbackTimeout);
            currentTime = performance.now();
            if ($8863cd8fe199f948$var$currentTask === $8863cd8fe199f948$var$taskQueue[0]) $8863cd8fe199f948$var$taskQueue.shift();
        } else $8863cd8fe199f948$var$taskQueue.shift();
        $8863cd8fe199f948$var$currentTask = $8863cd8fe199f948$var$taskQueue[0] || null;
    }
    return $8863cd8fe199f948$var$currentTask !== null;
}
const $8863cd8fe199f948$export$2cb4986bed338027 = {
    context: undefined,
    registry: undefined,
    effects: undefined,
    done: false,
    getContextId () {
        return $8863cd8fe199f948$var$getContextId(this.context.count);
    },
    getNextContextId () {
        return $8863cd8fe199f948$var$getContextId(this.context.count++);
    }
};
function $8863cd8fe199f948$var$getContextId(count) {
    const num = String(count), len = num.length - 1;
    return $8863cd8fe199f948$export$2cb4986bed338027.context.id + (len ? String.fromCharCode(96 + len) : "") + num;
}
function $8863cd8fe199f948$var$setHydrateContext(context) {
    $8863cd8fe199f948$export$2cb4986bed338027.context = context;
}
function $8863cd8fe199f948$var$nextHydrateContext() {
    return {
        ...$8863cd8fe199f948$export$2cb4986bed338027.context,
        id: $8863cd8fe199f948$export$2cb4986bed338027.getNextContextId(),
        count: 0
    };
}
const $8863cd8fe199f948$var$IS_DEV = false;
const $8863cd8fe199f948$export$34b67c27f2ca7498 = (a, b)=>a === b;
const $8863cd8fe199f948$export$5cd89106e2f6c2c5 = Symbol("solid-proxy");
const $8863cd8fe199f948$var$SUPPORTS_PROXY = typeof Proxy === "function";
const $8863cd8fe199f948$export$17a675b7c02a7b1d = Symbol("solid-track");
const $8863cd8fe199f948$export$f5625ae0b78e5b20 = Symbol("solid-dev-component");
const $8863cd8fe199f948$var$signalOptions = {
    equals: $8863cd8fe199f948$export$34b67c27f2ca7498
};
let $8863cd8fe199f948$var$ERROR = null;
let $8863cd8fe199f948$var$runEffects = $8863cd8fe199f948$var$runQueue;
const $8863cd8fe199f948$var$STALE = 1;
const $8863cd8fe199f948$var$PENDING = 2;
const $8863cd8fe199f948$var$UNOWNED = {
    owned: null,
    cleanups: null,
    context: null,
    owner: null
};
const $8863cd8fe199f948$var$NO_INIT = {};
var $8863cd8fe199f948$var$Owner = null;
let $8863cd8fe199f948$var$Transition = null;
let $8863cd8fe199f948$var$Scheduler = null;
let $8863cd8fe199f948$var$ExternalSourceConfig = null;
let $8863cd8fe199f948$var$Listener = null;
let $8863cd8fe199f948$var$Updates = null;
let $8863cd8fe199f948$var$Effects = null;
let $8863cd8fe199f948$var$ExecCount = 0;
function $8863cd8fe199f948$export$882461b6382ed46c(fn, detachedOwner) {
    const listener = $8863cd8fe199f948$var$Listener, owner = $8863cd8fe199f948$var$Owner, unowned = fn.length === 0, current = detachedOwner === undefined ? owner : detachedOwner, root = unowned ? $8863cd8fe199f948$var$UNOWNED : {
        owned: null,
        cleanups: null,
        context: current ? current.context : null,
        owner: current
    }, updateFn = unowned ? fn : ()=>fn(()=>$8863cd8fe199f948$export$363ebc4b78b8f807(()=>$8863cd8fe199f948$var$cleanNode(root)));
    $8863cd8fe199f948$var$Owner = root;
    $8863cd8fe199f948$var$Listener = null;
    try {
        return $8863cd8fe199f948$var$runUpdates(updateFn, true);
    } finally{
        $8863cd8fe199f948$var$Listener = listener;
        $8863cd8fe199f948$var$Owner = owner;
    }
}
function $8863cd8fe199f948$export$c1e1e1ecbbe76a5(value, options) {
    options = options ? Object.assign({}, $8863cd8fe199f948$var$signalOptions, options) : $8863cd8fe199f948$var$signalOptions;
    const s = {
        value: value,
        observers: null,
        observerSlots: null,
        comparator: options.equals || undefined
    };
    const setter = (value)=>{
        if (typeof value === "function") {
            if ($8863cd8fe199f948$var$Transition && $8863cd8fe199f948$var$Transition.running && $8863cd8fe199f948$var$Transition.sources.has(s)) value = value(s.tValue);
            else value = value(s.value);
        }
        return $8863cd8fe199f948$var$writeSignal(s, value);
    };
    return [
        $8863cd8fe199f948$var$readSignal.bind(s),
        setter
    ];
}
function $8863cd8fe199f948$export$234a23cdc77e6a3d(fn, value, options) {
    const c = $8863cd8fe199f948$var$createComputation(fn, value, true, $8863cd8fe199f948$var$STALE);
    if ($8863cd8fe199f948$var$Scheduler && $8863cd8fe199f948$var$Transition && $8863cd8fe199f948$var$Transition.running) $8863cd8fe199f948$var$Updates.push(c);
    else $8863cd8fe199f948$var$updateComputation(c);
}
function $8863cd8fe199f948$export$314dade334ae905d(fn, value, options) {
    const c = $8863cd8fe199f948$var$createComputation(fn, value, false, $8863cd8fe199f948$var$STALE);
    if ($8863cd8fe199f948$var$Scheduler && $8863cd8fe199f948$var$Transition && $8863cd8fe199f948$var$Transition.running) $8863cd8fe199f948$var$Updates.push(c);
    else $8863cd8fe199f948$var$updateComputation(c);
}
function $8863cd8fe199f948$export$7ea7134f704deda4(fn, value, options) {
    $8863cd8fe199f948$var$runEffects = $8863cd8fe199f948$var$runUserEffects;
    const c = $8863cd8fe199f948$var$createComputation(fn, value, false, $8863cd8fe199f948$var$STALE), s = $8863cd8fe199f948$var$SuspenseContext && $8863cd8fe199f948$export$fae74005e78b1a27($8863cd8fe199f948$var$SuspenseContext);
    if (s) c.suspense = s;
    if (!options || !options.render) c.user = true;
    $8863cd8fe199f948$var$Effects ? $8863cd8fe199f948$var$Effects.push(c) : $8863cd8fe199f948$var$updateComputation(c);
}
function $8863cd8fe199f948$export$5ce14d95ebb45542(onInvalidate, options) {
    let fn;
    const c = $8863cd8fe199f948$var$createComputation(()=>{
        fn ? fn() : $8863cd8fe199f948$export$363ebc4b78b8f807(onInvalidate);
        fn = undefined;
    }, undefined, false, 0), s = $8863cd8fe199f948$var$SuspenseContext && $8863cd8fe199f948$export$fae74005e78b1a27($8863cd8fe199f948$var$SuspenseContext);
    if (s) c.suspense = s;
    c.user = true;
    return (tracking)=>{
        fn = tracking;
        $8863cd8fe199f948$var$updateComputation(c);
    };
}
function $8863cd8fe199f948$export$c0c6c8b9c16bf6aa(fn, value, options) {
    options = options ? Object.assign({}, $8863cd8fe199f948$var$signalOptions, options) : $8863cd8fe199f948$var$signalOptions;
    const c = $8863cd8fe199f948$var$createComputation(fn, value, true, 0);
    c.observers = null;
    c.observerSlots = null;
    c.comparator = options.equals || undefined;
    if ($8863cd8fe199f948$var$Scheduler && $8863cd8fe199f948$var$Transition && $8863cd8fe199f948$var$Transition.running) {
        c.tState = $8863cd8fe199f948$var$STALE;
        $8863cd8fe199f948$var$Updates.push(c);
    } else $8863cd8fe199f948$var$updateComputation(c);
    return $8863cd8fe199f948$var$readSignal.bind(c);
}
function $8863cd8fe199f948$var$isPromise(v) {
    return v && typeof v === "object" && "then" in v;
}
function $8863cd8fe199f948$export$edd172c6c83c39cc(pSource, pFetcher, pOptions) {
    let source;
    let fetcher;
    let options;
    if (typeof pFetcher === "function") {
        source = pSource;
        fetcher = pFetcher;
        options = pOptions || {};
    } else {
        source = true;
        fetcher = pSource;
        options = pFetcher || {};
    }
    let pr = null, initP = $8863cd8fe199f948$var$NO_INIT, id = null, loadedUnderTransition = false, scheduled = false, resolved = "initialValue" in options, dynamic = typeof source === "function" && $8863cd8fe199f948$export$c0c6c8b9c16bf6aa(source);
    const contexts = new Set(), [value, setValue] = (options.storage || $8863cd8fe199f948$export$c1e1e1ecbbe76a5)(options.initialValue), [error, setError] = $8863cd8fe199f948$export$c1e1e1ecbbe76a5(undefined), [track, trigger] = $8863cd8fe199f948$export$c1e1e1ecbbe76a5(undefined, {
        equals: false
    }), [state, setState] = $8863cd8fe199f948$export$c1e1e1ecbbe76a5(resolved ? "ready" : "unresolved");
    if ($8863cd8fe199f948$export$2cb4986bed338027.context) {
        id = $8863cd8fe199f948$export$2cb4986bed338027.getNextContextId();
        if (options.ssrLoadFrom === "initial") initP = options.initialValue;
        else if ($8863cd8fe199f948$export$2cb4986bed338027.load && $8863cd8fe199f948$export$2cb4986bed338027.has(id)) initP = $8863cd8fe199f948$export$2cb4986bed338027.load(id);
    }
    function loadEnd(p, v, error, key) {
        if (pr === p) {
            pr = null;
            key !== undefined && (resolved = true);
            if ((p === initP || v === initP) && options.onHydrated) queueMicrotask(()=>options.onHydrated(key, {
                    value: v
                }));
            initP = $8863cd8fe199f948$var$NO_INIT;
            if ($8863cd8fe199f948$var$Transition && p && loadedUnderTransition) {
                $8863cd8fe199f948$var$Transition.promises.delete(p);
                loadedUnderTransition = false;
                $8863cd8fe199f948$var$runUpdates(()=>{
                    $8863cd8fe199f948$var$Transition.running = true;
                    completeLoad(v, error);
                }, false);
            } else completeLoad(v, error);
        }
        return v;
    }
    function completeLoad(v, err) {
        $8863cd8fe199f948$var$runUpdates(()=>{
            if (err === undefined) setValue(()=>v);
            setState(err !== undefined ? "errored" : resolved ? "ready" : "unresolved");
            setError(err);
            for (const c of contexts.keys())c.decrement();
            contexts.clear();
        }, false);
    }
    function read() {
        const c = $8863cd8fe199f948$var$SuspenseContext && $8863cd8fe199f948$export$fae74005e78b1a27($8863cd8fe199f948$var$SuspenseContext), v = value(), err = error();
        if (err !== undefined && !pr) throw err;
        if ($8863cd8fe199f948$var$Listener && !$8863cd8fe199f948$var$Listener.user && c) $8863cd8fe199f948$export$234a23cdc77e6a3d(()=>{
            track();
            if (pr) {
                if (c.resolved && $8863cd8fe199f948$var$Transition && loadedUnderTransition) $8863cd8fe199f948$var$Transition.promises.add(pr);
                else if (!contexts.has(c)) {
                    c.increment();
                    contexts.add(c);
                }
            }
        });
        return v;
    }
    function load(refetching = true) {
        if (refetching !== false && scheduled) return;
        scheduled = false;
        const lookup = dynamic ? dynamic() : source;
        loadedUnderTransition = $8863cd8fe199f948$var$Transition && $8863cd8fe199f948$var$Transition.running;
        if (lookup == null || lookup === false) {
            loadEnd(pr, $8863cd8fe199f948$export$363ebc4b78b8f807(value));
            return;
        }
        if ($8863cd8fe199f948$var$Transition && pr) $8863cd8fe199f948$var$Transition.promises.delete(pr);
        let error;
        const p = initP !== $8863cd8fe199f948$var$NO_INIT ? initP : $8863cd8fe199f948$export$363ebc4b78b8f807(()=>{
            try {
                return fetcher(lookup, {
                    value: value(),
                    refetching: refetching
                });
            } catch (fetcherError) {
                error = fetcherError;
            }
        });
        if (error !== undefined) {
            loadEnd(pr, undefined, $8863cd8fe199f948$var$castError(error), lookup);
            return;
        } else if (!$8863cd8fe199f948$var$isPromise(p)) {
            loadEnd(pr, p, undefined, lookup);
            return p;
        }
        pr = p;
        if ("v" in p) {
            if (p.s === 1) loadEnd(pr, p.v, undefined, lookup);
            else loadEnd(pr, undefined, $8863cd8fe199f948$var$castError(p.v), lookup);
            return p;
        }
        scheduled = true;
        queueMicrotask(()=>scheduled = false);
        $8863cd8fe199f948$var$runUpdates(()=>{
            setState(resolved ? "refreshing" : "pending");
            trigger();
        }, false);
        return p.then((v)=>loadEnd(p, v, undefined, lookup), (e)=>loadEnd(p, undefined, $8863cd8fe199f948$var$castError(e), lookup));
    }
    Object.defineProperties(read, {
        state: {
            get: ()=>state()
        },
        error: {
            get: ()=>error()
        },
        loading: {
            get () {
                const s = state();
                return s === "pending" || s === "refreshing";
            }
        },
        latest: {
            get () {
                if (!resolved) return read();
                const err = error();
                if (err && !pr) throw err;
                return value();
            }
        }
    });
    let owner = $8863cd8fe199f948$var$Owner;
    if (dynamic) $8863cd8fe199f948$export$234a23cdc77e6a3d(()=>(owner = $8863cd8fe199f948$var$Owner, load(false)));
    else load(false);
    return [
        read,
        {
            refetch: (info)=>$8863cd8fe199f948$export$c14f3e3abbc7d6b5(owner, ()=>load(info)),
            mutate: setValue
        }
    ];
}
function $8863cd8fe199f948$export$e673efccd97e4223(source, options) {
    let t, timeout = options ? options.timeoutMs : undefined;
    const node = $8863cd8fe199f948$var$createComputation(()=>{
        if (!t || !t.fn) t = $8863cd8fe199f948$export$4b5e076b3a2fbe0a(()=>setDeferred(()=>node.value), timeout !== undefined ? {
            timeout: timeout
        } : undefined);
        return source();
    }, undefined, true);
    const [deferred, setDeferred] = $8863cd8fe199f948$export$c1e1e1ecbbe76a5($8863cd8fe199f948$var$Transition && $8863cd8fe199f948$var$Transition.running && $8863cd8fe199f948$var$Transition.sources.has(node) ? node.tValue : node.value, options);
    $8863cd8fe199f948$var$updateComputation(node);
    setDeferred(()=>$8863cd8fe199f948$var$Transition && $8863cd8fe199f948$var$Transition.running && $8863cd8fe199f948$var$Transition.sources.has(node) ? node.tValue : node.value);
    return deferred;
}
function $8863cd8fe199f948$export$595d22ed68ca2841(source, fn = $8863cd8fe199f948$export$34b67c27f2ca7498, options) {
    const subs = new Map();
    const node = $8863cd8fe199f948$var$createComputation((p)=>{
        const v = source();
        for (const [key, val] of subs.entries())if (fn(key, v) !== fn(key, p)) for (const c of val.values()){
            c.state = $8863cd8fe199f948$var$STALE;
            if (c.pure) $8863cd8fe199f948$var$Updates.push(c);
            else $8863cd8fe199f948$var$Effects.push(c);
        }
        return v;
    }, undefined, true, $8863cd8fe199f948$var$STALE);
    $8863cd8fe199f948$var$updateComputation(node);
    return (key)=>{
        const listener = $8863cd8fe199f948$var$Listener;
        if (listener) {
            let l;
            if (l = subs.get(key)) l.add(listener);
            else subs.set(key, l = new Set([
                listener
            ]));
            $8863cd8fe199f948$export$b36e5eaa3e8c43ab(()=>{
                l.delete(listener);
                !l.size && subs.delete(key);
            });
        }
        return fn(key, $8863cd8fe199f948$var$Transition && $8863cd8fe199f948$var$Transition.running && $8863cd8fe199f948$var$Transition.sources.has(node) ? node.tValue : node.value);
    };
}
function $8863cd8fe199f948$export$712ea50be43a7858(fn) {
    return $8863cd8fe199f948$var$runUpdates(fn, false);
}
function $8863cd8fe199f948$export$363ebc4b78b8f807(fn) {
    if (!$8863cd8fe199f948$var$ExternalSourceConfig && $8863cd8fe199f948$var$Listener === null) return fn();
    const listener = $8863cd8fe199f948$var$Listener;
    $8863cd8fe199f948$var$Listener = null;
    try {
        if ($8863cd8fe199f948$var$ExternalSourceConfig) return $8863cd8fe199f948$var$ExternalSourceConfig.untrack(fn);
        return fn();
    } finally{
        $8863cd8fe199f948$var$Listener = listener;
    }
}
function $8863cd8fe199f948$export$af631764ddc44097(deps, fn, options) {
    const isArray = Array.isArray(deps);
    let prevInput;
    let defer = options && options.defer;
    return (prevValue)=>{
        let input;
        if (isArray) {
            input = Array(deps.length);
            for(let i = 0; i < deps.length; i++)input[i] = deps[i]();
        } else input = deps();
        if (defer) {
            defer = false;
            return prevValue;
        }
        const result = $8863cd8fe199f948$export$363ebc4b78b8f807(()=>fn(input, prevInput, prevValue));
        prevInput = input;
        return result;
    };
}
function $8863cd8fe199f948$export$1e848a9e87980bd5(fn) {
    $8863cd8fe199f948$export$7ea7134f704deda4(()=>$8863cd8fe199f948$export$363ebc4b78b8f807(fn));
}
function $8863cd8fe199f948$export$b36e5eaa3e8c43ab(fn) {
    if ($8863cd8fe199f948$var$Owner === null) ;
    else if ($8863cd8fe199f948$var$Owner.cleanups === null) $8863cd8fe199f948$var$Owner.cleanups = [
        fn
    ];
    else $8863cd8fe199f948$var$Owner.cleanups.push(fn);
    return fn;
}
function $8863cd8fe199f948$export$3dede90624df3ba9(fn, handler) {
    $8863cd8fe199f948$var$ERROR || ($8863cd8fe199f948$var$ERROR = Symbol("error"));
    $8863cd8fe199f948$var$Owner = $8863cd8fe199f948$var$createComputation(undefined, undefined, true);
    $8863cd8fe199f948$var$Owner.context = {
        ...$8863cd8fe199f948$var$Owner.context,
        [$8863cd8fe199f948$var$ERROR]: [
            handler
        ]
    };
    if ($8863cd8fe199f948$var$Transition && $8863cd8fe199f948$var$Transition.running) $8863cd8fe199f948$var$Transition.sources.add($8863cd8fe199f948$var$Owner);
    try {
        return fn();
    } catch (err) {
        $8863cd8fe199f948$var$handleError(err);
    } finally{
        $8863cd8fe199f948$var$Owner = $8863cd8fe199f948$var$Owner.owner;
    }
}
function $8863cd8fe199f948$export$12abb5141c6fdc9c() {
    return $8863cd8fe199f948$var$Listener;
}
function $8863cd8fe199f948$export$5f4ed0d56c2c0edf() {
    return $8863cd8fe199f948$var$Owner;
}
function $8863cd8fe199f948$export$c14f3e3abbc7d6b5(o, fn) {
    const prev = $8863cd8fe199f948$var$Owner;
    const prevListener = $8863cd8fe199f948$var$Listener;
    $8863cd8fe199f948$var$Owner = o;
    $8863cd8fe199f948$var$Listener = null;
    try {
        return $8863cd8fe199f948$var$runUpdates(fn, true);
    } catch (err) {
        $8863cd8fe199f948$var$handleError(err);
    } finally{
        $8863cd8fe199f948$var$Owner = prev;
        $8863cd8fe199f948$var$Listener = prevListener;
    }
}
function $8863cd8fe199f948$export$45e8540700504e87(scheduler = $8863cd8fe199f948$export$4b5e076b3a2fbe0a) {
    $8863cd8fe199f948$var$Scheduler = scheduler;
}
function $8863cd8fe199f948$export$7568632d0d33d16d(fn) {
    if ($8863cd8fe199f948$var$Transition && $8863cd8fe199f948$var$Transition.running) {
        fn();
        return $8863cd8fe199f948$var$Transition.done;
    }
    const l = $8863cd8fe199f948$var$Listener;
    const o = $8863cd8fe199f948$var$Owner;
    return Promise.resolve().then(()=>{
        $8863cd8fe199f948$var$Listener = l;
        $8863cd8fe199f948$var$Owner = o;
        let t;
        if ($8863cd8fe199f948$var$Scheduler || $8863cd8fe199f948$var$SuspenseContext) {
            t = $8863cd8fe199f948$var$Transition || ($8863cd8fe199f948$var$Transition = {
                sources: new Set(),
                effects: [],
                promises: new Set(),
                disposed: new Set(),
                queue: new Set(),
                running: true
            });
            t.done || (t.done = new Promise((res)=>t.resolve = res));
            t.running = true;
        }
        $8863cd8fe199f948$var$runUpdates(fn, false);
        $8863cd8fe199f948$var$Listener = $8863cd8fe199f948$var$Owner = null;
        return t ? t.done : undefined;
    });
}
const [$8863cd8fe199f948$var$transPending, $8863cd8fe199f948$var$setTransPending] = /*@__PURE__*/ $8863cd8fe199f948$export$c1e1e1ecbbe76a5(false);
function $8863cd8fe199f948$export$7b286972b8d8ccbf() {
    return [
        $8863cd8fe199f948$var$transPending,
        $8863cd8fe199f948$export$7568632d0d33d16d
    ];
}
function $8863cd8fe199f948$var$resumeEffects(e) {
    $8863cd8fe199f948$var$Effects.push.apply($8863cd8fe199f948$var$Effects, e);
    e.length = 0;
}
function $8863cd8fe199f948$export$fd42f52fd3ae1109(defaultValue, options) {
    const id = Symbol("context");
    return {
        id: id,
        Provider: $8863cd8fe199f948$var$createProvider(id),
        defaultValue: defaultValue
    };
}
function $8863cd8fe199f948$export$fae74005e78b1a27(context) {
    let value;
    return $8863cd8fe199f948$var$Owner && $8863cd8fe199f948$var$Owner.context && (value = $8863cd8fe199f948$var$Owner.context[context.id]) !== undefined ? value : context.defaultValue;
}
function $8863cd8fe199f948$export$bacb5cc5a11aef16(fn) {
    const children = $8863cd8fe199f948$export$c0c6c8b9c16bf6aa(fn);
    const memo = $8863cd8fe199f948$export$c0c6c8b9c16bf6aa(()=>$8863cd8fe199f948$var$resolveChildren(children()));
    memo.toArray = ()=>{
        const c = memo();
        return Array.isArray(c) ? c : c != null ? [
            c
        ] : [];
    };
    return memo;
}
let $8863cd8fe199f948$var$SuspenseContext;
function $8863cd8fe199f948$var$getSuspenseContext() {
    return $8863cd8fe199f948$var$SuspenseContext || ($8863cd8fe199f948$var$SuspenseContext = $8863cd8fe199f948$export$fd42f52fd3ae1109());
}
function $8863cd8fe199f948$export$315ab94ce87a624f(factory, untrack = (fn)=>fn()) {
    if ($8863cd8fe199f948$var$ExternalSourceConfig) {
        const { factory: oldFactory, untrack: oldUntrack } = $8863cd8fe199f948$var$ExternalSourceConfig;
        $8863cd8fe199f948$var$ExternalSourceConfig = {
            factory: (fn, trigger)=>{
                const oldSource = oldFactory(fn, trigger);
                const source = factory((x)=>oldSource.track(x), trigger);
                return {
                    track: (x)=>source.track(x),
                    dispose () {
                        source.dispose();
                        oldSource.dispose();
                    }
                };
            },
            untrack: (fn)=>oldUntrack(()=>untrack(fn))
        };
    } else $8863cd8fe199f948$var$ExternalSourceConfig = {
        factory: factory,
        untrack: untrack
    };
}
function $8863cd8fe199f948$var$readSignal() {
    const runningTransition = $8863cd8fe199f948$var$Transition && $8863cd8fe199f948$var$Transition.running;
    if (this.sources && (runningTransition ? this.tState : this.state)) {
        if ((runningTransition ? this.tState : this.state) === $8863cd8fe199f948$var$STALE) $8863cd8fe199f948$var$updateComputation(this);
        else {
            const updates = $8863cd8fe199f948$var$Updates;
            $8863cd8fe199f948$var$Updates = null;
            $8863cd8fe199f948$var$runUpdates(()=>$8863cd8fe199f948$var$lookUpstream(this), false);
            $8863cd8fe199f948$var$Updates = updates;
        }
    }
    if ($8863cd8fe199f948$var$Listener) {
        const sSlot = this.observers ? this.observers.length : 0;
        if (!$8863cd8fe199f948$var$Listener.sources) {
            $8863cd8fe199f948$var$Listener.sources = [
                this
            ];
            $8863cd8fe199f948$var$Listener.sourceSlots = [
                sSlot
            ];
        } else {
            $8863cd8fe199f948$var$Listener.sources.push(this);
            $8863cd8fe199f948$var$Listener.sourceSlots.push(sSlot);
        }
        if (!this.observers) {
            this.observers = [
                $8863cd8fe199f948$var$Listener
            ];
            this.observerSlots = [
                $8863cd8fe199f948$var$Listener.sources.length - 1
            ];
        } else {
            this.observers.push($8863cd8fe199f948$var$Listener);
            this.observerSlots.push($8863cd8fe199f948$var$Listener.sources.length - 1);
        }
    }
    if (runningTransition && $8863cd8fe199f948$var$Transition.sources.has(this)) return this.tValue;
    return this.value;
}
function $8863cd8fe199f948$var$writeSignal(node, value, isComp) {
    let current = $8863cd8fe199f948$var$Transition && $8863cd8fe199f948$var$Transition.running && $8863cd8fe199f948$var$Transition.sources.has(node) ? node.tValue : node.value;
    if (!node.comparator || !node.comparator(current, value)) {
        if ($8863cd8fe199f948$var$Transition) {
            const TransitionRunning = $8863cd8fe199f948$var$Transition.running;
            if (TransitionRunning || !isComp && $8863cd8fe199f948$var$Transition.sources.has(node)) {
                $8863cd8fe199f948$var$Transition.sources.add(node);
                node.tValue = value;
            }
            if (!TransitionRunning) node.value = value;
        } else node.value = value;
        if (node.observers && node.observers.length) $8863cd8fe199f948$var$runUpdates(()=>{
            for(let i = 0; i < node.observers.length; i += 1){
                const o = node.observers[i];
                const TransitionRunning = $8863cd8fe199f948$var$Transition && $8863cd8fe199f948$var$Transition.running;
                if (TransitionRunning && $8863cd8fe199f948$var$Transition.disposed.has(o)) continue;
                if (TransitionRunning ? !o.tState : !o.state) {
                    if (o.pure) $8863cd8fe199f948$var$Updates.push(o);
                    else $8863cd8fe199f948$var$Effects.push(o);
                    if (o.observers) $8863cd8fe199f948$var$markDownstream(o);
                }
                if (!TransitionRunning) o.state = $8863cd8fe199f948$var$STALE;
                else o.tState = $8863cd8fe199f948$var$STALE;
            }
            if ($8863cd8fe199f948$var$Updates.length > 10e5) {
                $8863cd8fe199f948$var$Updates = [];
                $8863cd8fe199f948$var$IS_DEV;
                throw new Error();
            }
        }, false);
    }
    return value;
}
function $8863cd8fe199f948$var$updateComputation(node) {
    if (!node.fn) return;
    $8863cd8fe199f948$var$cleanNode(node);
    const time = $8863cd8fe199f948$var$ExecCount;
    $8863cd8fe199f948$var$runComputation(node, $8863cd8fe199f948$var$Transition && $8863cd8fe199f948$var$Transition.running && $8863cd8fe199f948$var$Transition.sources.has(node) ? node.tValue : node.value, time);
    if ($8863cd8fe199f948$var$Transition && !$8863cd8fe199f948$var$Transition.running && $8863cd8fe199f948$var$Transition.sources.has(node)) queueMicrotask(()=>{
        $8863cd8fe199f948$var$runUpdates(()=>{
            $8863cd8fe199f948$var$Transition && ($8863cd8fe199f948$var$Transition.running = true);
            $8863cd8fe199f948$var$Listener = $8863cd8fe199f948$var$Owner = node;
            $8863cd8fe199f948$var$runComputation(node, node.tValue, time);
            $8863cd8fe199f948$var$Listener = $8863cd8fe199f948$var$Owner = null;
        }, false);
    });
}
function $8863cd8fe199f948$var$runComputation(node, value, time) {
    let nextValue;
    const owner = $8863cd8fe199f948$var$Owner, listener = $8863cd8fe199f948$var$Listener;
    $8863cd8fe199f948$var$Listener = $8863cd8fe199f948$var$Owner = node;
    try {
        nextValue = node.fn(value);
    } catch (err) {
        if (node.pure) {
            if ($8863cd8fe199f948$var$Transition && $8863cd8fe199f948$var$Transition.running) {
                node.tState = $8863cd8fe199f948$var$STALE;
                node.tOwned && node.tOwned.forEach($8863cd8fe199f948$var$cleanNode);
                node.tOwned = undefined;
            } else {
                node.state = $8863cd8fe199f948$var$STALE;
                node.owned && node.owned.forEach($8863cd8fe199f948$var$cleanNode);
                node.owned = null;
            }
        }
        node.updatedAt = time + 1;
        return $8863cd8fe199f948$var$handleError(err);
    } finally{
        $8863cd8fe199f948$var$Listener = listener;
        $8863cd8fe199f948$var$Owner = owner;
    }
    if (!node.updatedAt || node.updatedAt <= time) {
        if (node.updatedAt != null && "observers" in node) $8863cd8fe199f948$var$writeSignal(node, nextValue, true);
        else if ($8863cd8fe199f948$var$Transition && $8863cd8fe199f948$var$Transition.running && node.pure) {
            $8863cd8fe199f948$var$Transition.sources.add(node);
            node.tValue = nextValue;
        } else node.value = nextValue;
        node.updatedAt = time;
    }
}
function $8863cd8fe199f948$var$createComputation(fn, init, pure, state = $8863cd8fe199f948$var$STALE, options) {
    const c = {
        fn: fn,
        state: state,
        updatedAt: null,
        owned: null,
        sources: null,
        sourceSlots: null,
        cleanups: null,
        value: init,
        owner: $8863cd8fe199f948$var$Owner,
        context: $8863cd8fe199f948$var$Owner ? $8863cd8fe199f948$var$Owner.context : null,
        pure: pure
    };
    if ($8863cd8fe199f948$var$Transition && $8863cd8fe199f948$var$Transition.running) {
        c.state = 0;
        c.tState = state;
    }
    if ($8863cd8fe199f948$var$Owner === null) ;
    else if ($8863cd8fe199f948$var$Owner !== $8863cd8fe199f948$var$UNOWNED) {
        if ($8863cd8fe199f948$var$Transition && $8863cd8fe199f948$var$Transition.running && $8863cd8fe199f948$var$Owner.pure) {
            if (!$8863cd8fe199f948$var$Owner.tOwned) $8863cd8fe199f948$var$Owner.tOwned = [
                c
            ];
            else $8863cd8fe199f948$var$Owner.tOwned.push(c);
        } else if (!$8863cd8fe199f948$var$Owner.owned) $8863cd8fe199f948$var$Owner.owned = [
            c
        ];
        else $8863cd8fe199f948$var$Owner.owned.push(c);
    }
    if ($8863cd8fe199f948$var$ExternalSourceConfig && c.fn) {
        const [track, trigger] = $8863cd8fe199f948$export$c1e1e1ecbbe76a5(undefined, {
            equals: false
        });
        const ordinary = $8863cd8fe199f948$var$ExternalSourceConfig.factory(c.fn, trigger);
        $8863cd8fe199f948$export$b36e5eaa3e8c43ab(()=>ordinary.dispose());
        const triggerInTransition = ()=>$8863cd8fe199f948$export$7568632d0d33d16d(trigger).then(()=>inTransition.dispose());
        const inTransition = $8863cd8fe199f948$var$ExternalSourceConfig.factory(c.fn, triggerInTransition);
        c.fn = (x)=>{
            track();
            return $8863cd8fe199f948$var$Transition && $8863cd8fe199f948$var$Transition.running ? inTransition.track(x) : ordinary.track(x);
        };
    }
    return c;
}
function $8863cd8fe199f948$var$runTop(node) {
    const runningTransition = $8863cd8fe199f948$var$Transition && $8863cd8fe199f948$var$Transition.running;
    if ((runningTransition ? node.tState : node.state) === 0) return;
    if ((runningTransition ? node.tState : node.state) === $8863cd8fe199f948$var$PENDING) return $8863cd8fe199f948$var$lookUpstream(node);
    if (node.suspense && $8863cd8fe199f948$export$363ebc4b78b8f807(node.suspense.inFallback)) return node.suspense.effects.push(node);
    const ancestors = [
        node
    ];
    while((node = node.owner) && (!node.updatedAt || node.updatedAt < $8863cd8fe199f948$var$ExecCount)){
        if (runningTransition && $8863cd8fe199f948$var$Transition.disposed.has(node)) return;
        if (runningTransition ? node.tState : node.state) ancestors.push(node);
    }
    for(let i = ancestors.length - 1; i >= 0; i--){
        node = ancestors[i];
        if (runningTransition) {
            let top = node, prev = ancestors[i + 1];
            while((top = top.owner) && top !== prev){
                if ($8863cd8fe199f948$var$Transition.disposed.has(top)) return;
            }
        }
        if ((runningTransition ? node.tState : node.state) === $8863cd8fe199f948$var$STALE) $8863cd8fe199f948$var$updateComputation(node);
        else if ((runningTransition ? node.tState : node.state) === $8863cd8fe199f948$var$PENDING) {
            const updates = $8863cd8fe199f948$var$Updates;
            $8863cd8fe199f948$var$Updates = null;
            $8863cd8fe199f948$var$runUpdates(()=>$8863cd8fe199f948$var$lookUpstream(node, ancestors[0]), false);
            $8863cd8fe199f948$var$Updates = updates;
        }
    }
}
function $8863cd8fe199f948$var$runUpdates(fn, init) {
    if ($8863cd8fe199f948$var$Updates) return fn();
    let wait = false;
    if (!init) $8863cd8fe199f948$var$Updates = [];
    if ($8863cd8fe199f948$var$Effects) wait = true;
    else $8863cd8fe199f948$var$Effects = [];
    $8863cd8fe199f948$var$ExecCount++;
    try {
        const res = fn();
        $8863cd8fe199f948$var$completeUpdates(wait);
        return res;
    } catch (err) {
        if (!wait) $8863cd8fe199f948$var$Effects = null;
        $8863cd8fe199f948$var$Updates = null;
        $8863cd8fe199f948$var$handleError(err);
    }
}
function $8863cd8fe199f948$var$completeUpdates(wait) {
    if ($8863cd8fe199f948$var$Updates) {
        if ($8863cd8fe199f948$var$Scheduler && $8863cd8fe199f948$var$Transition && $8863cd8fe199f948$var$Transition.running) $8863cd8fe199f948$var$scheduleQueue($8863cd8fe199f948$var$Updates);
        else $8863cd8fe199f948$var$runQueue($8863cd8fe199f948$var$Updates);
        $8863cd8fe199f948$var$Updates = null;
    }
    if (wait) return;
    let res;
    if ($8863cd8fe199f948$var$Transition) {
        if (!$8863cd8fe199f948$var$Transition.promises.size && !$8863cd8fe199f948$var$Transition.queue.size) {
            const sources = $8863cd8fe199f948$var$Transition.sources;
            const disposed = $8863cd8fe199f948$var$Transition.disposed;
            $8863cd8fe199f948$var$Effects.push.apply($8863cd8fe199f948$var$Effects, $8863cd8fe199f948$var$Transition.effects);
            res = $8863cd8fe199f948$var$Transition.resolve;
            for (const e of $8863cd8fe199f948$var$Effects){
                "tState" in e && (e.state = e.tState);
                delete e.tState;
            }
            $8863cd8fe199f948$var$Transition = null;
            $8863cd8fe199f948$var$runUpdates(()=>{
                for (const d of disposed)$8863cd8fe199f948$var$cleanNode(d);
                for (const v of sources){
                    v.value = v.tValue;
                    if (v.owned) for(let i = 0, len = v.owned.length; i < len; i++)$8863cd8fe199f948$var$cleanNode(v.owned[i]);
                    if (v.tOwned) v.owned = v.tOwned;
                    delete v.tValue;
                    delete v.tOwned;
                    v.tState = 0;
                }
                $8863cd8fe199f948$var$setTransPending(false);
            }, false);
        } else if ($8863cd8fe199f948$var$Transition.running) {
            $8863cd8fe199f948$var$Transition.running = false;
            $8863cd8fe199f948$var$Transition.effects.push.apply($8863cd8fe199f948$var$Transition.effects, $8863cd8fe199f948$var$Effects);
            $8863cd8fe199f948$var$Effects = null;
            $8863cd8fe199f948$var$setTransPending(true);
            return;
        }
    }
    const e = $8863cd8fe199f948$var$Effects;
    $8863cd8fe199f948$var$Effects = null;
    if (e.length) $8863cd8fe199f948$var$runUpdates(()=>$8863cd8fe199f948$var$runEffects(e), false);
    if (res) res();
}
function $8863cd8fe199f948$var$runQueue(queue) {
    for(let i = 0; i < queue.length; i++)$8863cd8fe199f948$var$runTop(queue[i]);
}
function $8863cd8fe199f948$var$scheduleQueue(queue) {
    for(let i = 0; i < queue.length; i++){
        const item = queue[i];
        const tasks = $8863cd8fe199f948$var$Transition.queue;
        if (!tasks.has(item)) {
            tasks.add(item);
            $8863cd8fe199f948$var$Scheduler(()=>{
                tasks.delete(item);
                $8863cd8fe199f948$var$runUpdates(()=>{
                    $8863cd8fe199f948$var$Transition.running = true;
                    $8863cd8fe199f948$var$runTop(item);
                }, false);
                $8863cd8fe199f948$var$Transition && ($8863cd8fe199f948$var$Transition.running = false);
            });
        }
    }
}
function $8863cd8fe199f948$var$runUserEffects(queue) {
    let i, userLength = 0;
    for(i = 0; i < queue.length; i++){
        const e = queue[i];
        if (!e.user) $8863cd8fe199f948$var$runTop(e);
        else queue[userLength++] = e;
    }
    if ($8863cd8fe199f948$export$2cb4986bed338027.context) {
        if ($8863cd8fe199f948$export$2cb4986bed338027.count) {
            $8863cd8fe199f948$export$2cb4986bed338027.effects || ($8863cd8fe199f948$export$2cb4986bed338027.effects = []);
            $8863cd8fe199f948$export$2cb4986bed338027.effects.push(...queue.slice(0, userLength));
            return;
        }
        $8863cd8fe199f948$var$setHydrateContext();
    }
    if ($8863cd8fe199f948$export$2cb4986bed338027.effects && ($8863cd8fe199f948$export$2cb4986bed338027.done || !$8863cd8fe199f948$export$2cb4986bed338027.count)) {
        queue = [
            ...$8863cd8fe199f948$export$2cb4986bed338027.effects,
            ...queue
        ];
        userLength += $8863cd8fe199f948$export$2cb4986bed338027.effects.length;
        delete $8863cd8fe199f948$export$2cb4986bed338027.effects;
    }
    for(i = 0; i < userLength; i++)$8863cd8fe199f948$var$runTop(queue[i]);
}
function $8863cd8fe199f948$var$lookUpstream(node, ignore) {
    const runningTransition = $8863cd8fe199f948$var$Transition && $8863cd8fe199f948$var$Transition.running;
    if (runningTransition) node.tState = 0;
    else node.state = 0;
    for(let i = 0; i < node.sources.length; i += 1){
        const source = node.sources[i];
        if (source.sources) {
            const state = runningTransition ? source.tState : source.state;
            if (state === $8863cd8fe199f948$var$STALE) {
                if (source !== ignore && (!source.updatedAt || source.updatedAt < $8863cd8fe199f948$var$ExecCount)) $8863cd8fe199f948$var$runTop(source);
            } else if (state === $8863cd8fe199f948$var$PENDING) $8863cd8fe199f948$var$lookUpstream(source, ignore);
        }
    }
}
function $8863cd8fe199f948$var$markDownstream(node) {
    const runningTransition = $8863cd8fe199f948$var$Transition && $8863cd8fe199f948$var$Transition.running;
    for(let i = 0; i < node.observers.length; i += 1){
        const o = node.observers[i];
        if (runningTransition ? !o.tState : !o.state) {
            if (runningTransition) o.tState = $8863cd8fe199f948$var$PENDING;
            else o.state = $8863cd8fe199f948$var$PENDING;
            if (o.pure) $8863cd8fe199f948$var$Updates.push(o);
            else $8863cd8fe199f948$var$Effects.push(o);
            o.observers && $8863cd8fe199f948$var$markDownstream(o);
        }
    }
}
function $8863cd8fe199f948$var$cleanNode(node) {
    let i;
    if (node.sources) while(node.sources.length){
        const source = node.sources.pop(), index = node.sourceSlots.pop(), obs = source.observers;
        if (obs && obs.length) {
            const n = obs.pop(), s = source.observerSlots.pop();
            if (index < obs.length) {
                n.sourceSlots[s] = index;
                obs[index] = n;
                source.observerSlots[index] = s;
            }
        }
    }
    if (node.tOwned) {
        for(i = node.tOwned.length - 1; i >= 0; i--)$8863cd8fe199f948$var$cleanNode(node.tOwned[i]);
        delete node.tOwned;
    }
    if ($8863cd8fe199f948$var$Transition && $8863cd8fe199f948$var$Transition.running && node.pure) $8863cd8fe199f948$var$reset(node, true);
    else if (node.owned) {
        for(i = node.owned.length - 1; i >= 0; i--)$8863cd8fe199f948$var$cleanNode(node.owned[i]);
        node.owned = null;
    }
    if (node.cleanups) {
        for(i = node.cleanups.length - 1; i >= 0; i--)node.cleanups[i]();
        node.cleanups = null;
    }
    if ($8863cd8fe199f948$var$Transition && $8863cd8fe199f948$var$Transition.running) node.tState = 0;
    else node.state = 0;
}
function $8863cd8fe199f948$var$reset(node, top) {
    if (!top) {
        node.tState = 0;
        $8863cd8fe199f948$var$Transition.disposed.add(node);
    }
    if (node.owned) for(let i = 0; i < node.owned.length; i++)$8863cd8fe199f948$var$reset(node.owned[i]);
}
function $8863cd8fe199f948$var$castError(err) {
    if (err instanceof Error) return err;
    return new Error(typeof err === "string" ? err : "Unknown error", {
        cause: err
    });
}
function $8863cd8fe199f948$var$runErrors(err, fns, owner) {
    try {
        for (const f of fns)f(err);
    } catch (e) {
        $8863cd8fe199f948$var$handleError(e, owner && owner.owner || null);
    }
}
function $8863cd8fe199f948$var$handleError(err, owner = $8863cd8fe199f948$var$Owner) {
    const fns = $8863cd8fe199f948$var$ERROR && owner && owner.context && owner.context[$8863cd8fe199f948$var$ERROR];
    const error = $8863cd8fe199f948$var$castError(err);
    if (!fns) throw error;
    if ($8863cd8fe199f948$var$Effects) $8863cd8fe199f948$var$Effects.push({
        fn () {
            $8863cd8fe199f948$var$runErrors(error, fns, owner);
        },
        state: $8863cd8fe199f948$var$STALE
    });
    else $8863cd8fe199f948$var$runErrors(error, fns, owner);
}
function $8863cd8fe199f948$var$resolveChildren(children) {
    if (typeof children === "function" && !children.length) return $8863cd8fe199f948$var$resolveChildren(children());
    if (Array.isArray(children)) {
        const results = [];
        for(let i = 0; i < children.length; i++){
            const result = $8863cd8fe199f948$var$resolveChildren(children[i]);
            Array.isArray(result) ? results.push.apply(results, result) : results.push(result);
        }
        return results;
    }
    return children;
}
function $8863cd8fe199f948$var$createProvider(id, options) {
    return function provider(props) {
        let res;
        $8863cd8fe199f948$export$314dade334ae905d(()=>res = $8863cd8fe199f948$export$363ebc4b78b8f807(()=>{
                $8863cd8fe199f948$var$Owner.context = {
                    ...$8863cd8fe199f948$var$Owner.context,
                    [id]: props.value
                };
                return $8863cd8fe199f948$export$bacb5cc5a11aef16(()=>props.children);
            }), undefined);
        return res;
    };
}
function $8863cd8fe199f948$export$2288787135a8f66e(fn) {
    $8863cd8fe199f948$var$ERROR || ($8863cd8fe199f948$var$ERROR = Symbol("error"));
    if ($8863cd8fe199f948$var$Owner === null) ;
    else if ($8863cd8fe199f948$var$Owner.context === null || !$8863cd8fe199f948$var$Owner.context[$8863cd8fe199f948$var$ERROR]) {
        $8863cd8fe199f948$var$Owner.context = {
            ...$8863cd8fe199f948$var$Owner.context,
            [$8863cd8fe199f948$var$ERROR]: [
                fn
            ]
        };
        $8863cd8fe199f948$var$mutateContext($8863cd8fe199f948$var$Owner, $8863cd8fe199f948$var$ERROR, [
            fn
        ]);
    } else $8863cd8fe199f948$var$Owner.context[$8863cd8fe199f948$var$ERROR].push(fn);
}
function $8863cd8fe199f948$var$mutateContext(o, key, value) {
    if (o.owned) for(let i = 0; i < o.owned.length; i++){
        if (o.owned[i].context === o.context) $8863cd8fe199f948$var$mutateContext(o.owned[i], key, value);
        if (!o.owned[i].context) {
            o.owned[i].context = o.context;
            $8863cd8fe199f948$var$mutateContext(o.owned[i], key, value);
        } else if (!o.owned[i].context[key]) {
            o.owned[i].context[key] = value;
            $8863cd8fe199f948$var$mutateContext(o.owned[i], key, value);
        }
    }
}
function $8863cd8fe199f948$export$5ab46cbf6120b33a(input) {
    return {
        subscribe (observer) {
            if (!(observer instanceof Object) || observer == null) throw new TypeError("Expected the observer to be an object.");
            const handler = typeof observer === "function" ? observer : observer.next && observer.next.bind(observer);
            if (!handler) return {
                unsubscribe () {}
            };
            const dispose = $8863cd8fe199f948$export$882461b6382ed46c((disposer)=>{
                $8863cd8fe199f948$export$7ea7134f704deda4(()=>{
                    const v = input();
                    $8863cd8fe199f948$export$363ebc4b78b8f807(()=>handler(v));
                });
                return disposer;
            });
            if ($8863cd8fe199f948$export$5f4ed0d56c2c0edf()) $8863cd8fe199f948$export$b36e5eaa3e8c43ab(dispose);
            return {
                unsubscribe () {
                    dispose();
                }
            };
        },
        [Symbol.observable || "@@observable"] () {
            return this;
        }
    };
}
function $8863cd8fe199f948$export$6788812c4e6611e6(producer, initalValue) {
    const [s, set] = $8863cd8fe199f948$export$c1e1e1ecbbe76a5(initalValue, {
        equals: false
    });
    if ("subscribe" in producer) {
        const unsub = producer.subscribe((v)=>set(()=>v));
        $8863cd8fe199f948$export$b36e5eaa3e8c43ab(()=>"unsubscribe" in unsub ? unsub.unsubscribe() : unsub());
    } else {
        const clean = producer(set);
        $8863cd8fe199f948$export$b36e5eaa3e8c43ab(clean);
    }
    return s;
}
const $8863cd8fe199f948$var$FALLBACK = Symbol("fallback");
function $8863cd8fe199f948$var$dispose(d) {
    for(let i = 0; i < d.length; i++)d[i]();
}
function $8863cd8fe199f948$export$4c9116dcf1374231(list, mapFn, options = {}) {
    let items = [], mapped = [], disposers = [], len = 0, indexes = mapFn.length > 1 ? [] : null;
    $8863cd8fe199f948$export$b36e5eaa3e8c43ab(()=>$8863cd8fe199f948$var$dispose(disposers));
    return ()=>{
        let newItems = list() || [], newLen = newItems.length, i, j;
        newItems[$8863cd8fe199f948$export$17a675b7c02a7b1d];
        return $8863cd8fe199f948$export$363ebc4b78b8f807(()=>{
            let newIndices, newIndicesNext, temp, tempdisposers, tempIndexes, start, end, newEnd, item;
            if (newLen === 0) {
                if (len !== 0) {
                    $8863cd8fe199f948$var$dispose(disposers);
                    disposers = [];
                    items = [];
                    mapped = [];
                    len = 0;
                    indexes && (indexes = []);
                }
                if (options.fallback) {
                    items = [
                        $8863cd8fe199f948$var$FALLBACK
                    ];
                    mapped[0] = $8863cd8fe199f948$export$882461b6382ed46c((disposer)=>{
                        disposers[0] = disposer;
                        return options.fallback();
                    });
                    len = 1;
                }
            } else if (len === 0) {
                mapped = new Array(newLen);
                for(j = 0; j < newLen; j++){
                    items[j] = newItems[j];
                    mapped[j] = $8863cd8fe199f948$export$882461b6382ed46c(mapper);
                }
                len = newLen;
            } else {
                temp = new Array(newLen);
                tempdisposers = new Array(newLen);
                indexes && (tempIndexes = new Array(newLen));
                for(start = 0, end = Math.min(len, newLen); start < end && items[start] === newItems[start]; start++);
                for(end = len - 1, newEnd = newLen - 1; end >= start && newEnd >= start && items[end] === newItems[newEnd]; end--, newEnd--){
                    temp[newEnd] = mapped[end];
                    tempdisposers[newEnd] = disposers[end];
                    indexes && (tempIndexes[newEnd] = indexes[end]);
                }
                newIndices = new Map();
                newIndicesNext = new Array(newEnd + 1);
                for(j = newEnd; j >= start; j--){
                    item = newItems[j];
                    i = newIndices.get(item);
                    newIndicesNext[j] = i === undefined ? -1 : i;
                    newIndices.set(item, j);
                }
                for(i = start; i <= end; i++){
                    item = items[i];
                    j = newIndices.get(item);
                    if (j !== undefined && j !== -1) {
                        temp[j] = mapped[i];
                        tempdisposers[j] = disposers[i];
                        indexes && (tempIndexes[j] = indexes[i]);
                        j = newIndicesNext[j];
                        newIndices.set(item, j);
                    } else disposers[i]();
                }
                for(j = start; j < newLen; j++)if (j in temp) {
                    mapped[j] = temp[j];
                    disposers[j] = tempdisposers[j];
                    if (indexes) {
                        indexes[j] = tempIndexes[j];
                        indexes[j](j);
                    }
                } else mapped[j] = $8863cd8fe199f948$export$882461b6382ed46c(mapper);
                mapped = mapped.slice(0, len = newLen);
                items = newItems.slice(0);
            }
            return mapped;
        });
        function mapper(disposer) {
            disposers[j] = disposer;
            if (indexes) {
                const [s, set] = $8863cd8fe199f948$export$c1e1e1ecbbe76a5(j);
                indexes[j] = set;
                return mapFn(newItems[j], s);
            }
            return mapFn(newItems[j]);
        }
    };
}
function $8863cd8fe199f948$export$2cd1c249765cd0a4(list, mapFn, options = {}) {
    let items = [], mapped = [], disposers = [], signals = [], len = 0, i;
    $8863cd8fe199f948$export$b36e5eaa3e8c43ab(()=>$8863cd8fe199f948$var$dispose(disposers));
    return ()=>{
        const newItems = list() || [], newLen = newItems.length;
        newItems[$8863cd8fe199f948$export$17a675b7c02a7b1d];
        return $8863cd8fe199f948$export$363ebc4b78b8f807(()=>{
            if (newLen === 0) {
                if (len !== 0) {
                    $8863cd8fe199f948$var$dispose(disposers);
                    disposers = [];
                    items = [];
                    mapped = [];
                    len = 0;
                    signals = [];
                }
                if (options.fallback) {
                    items = [
                        $8863cd8fe199f948$var$FALLBACK
                    ];
                    mapped[0] = $8863cd8fe199f948$export$882461b6382ed46c((disposer)=>{
                        disposers[0] = disposer;
                        return options.fallback();
                    });
                    len = 1;
                }
                return mapped;
            }
            if (items[0] === $8863cd8fe199f948$var$FALLBACK) {
                disposers[0]();
                disposers = [];
                items = [];
                mapped = [];
                len = 0;
            }
            for(i = 0; i < newLen; i++){
                if (i < items.length && items[i] !== newItems[i]) signals[i](()=>newItems[i]);
                else if (i >= items.length) mapped[i] = $8863cd8fe199f948$export$882461b6382ed46c(mapper);
            }
            for(; i < items.length; i++)disposers[i]();
            len = signals.length = disposers.length = newLen;
            items = newItems.slice(0);
            return mapped = mapped.slice(0, len);
        });
        function mapper(disposer) {
            disposers[i] = disposer;
            const [s, set] = $8863cd8fe199f948$export$c1e1e1ecbbe76a5(newItems[i]);
            signals[i] = set;
            return mapFn(s, i);
        }
    };
}
let $8863cd8fe199f948$var$hydrationEnabled = false;
function $8863cd8fe199f948$export$849801d35d2160c9() {
    $8863cd8fe199f948$var$hydrationEnabled = true;
}
function $8863cd8fe199f948$export$60e54eaca7e7fb38(Comp, props) {
    if ($8863cd8fe199f948$var$hydrationEnabled) {
        if ($8863cd8fe199f948$export$2cb4986bed338027.context) {
            const c = $8863cd8fe199f948$export$2cb4986bed338027.context;
            $8863cd8fe199f948$var$setHydrateContext($8863cd8fe199f948$var$nextHydrateContext());
            const r = $8863cd8fe199f948$export$363ebc4b78b8f807(()=>Comp(props || {}));
            $8863cd8fe199f948$var$setHydrateContext(c);
            return r;
        }
    }
    return $8863cd8fe199f948$export$363ebc4b78b8f807(()=>Comp(props || {}));
}
function $8863cd8fe199f948$var$trueFn() {
    return true;
}
const $8863cd8fe199f948$var$propTraps = {
    get (_, property, receiver) {
        if (property === $8863cd8fe199f948$export$5cd89106e2f6c2c5) return receiver;
        return _.get(property);
    },
    has (_, property) {
        if (property === $8863cd8fe199f948$export$5cd89106e2f6c2c5) return true;
        return _.has(property);
    },
    set: $8863cd8fe199f948$var$trueFn,
    deleteProperty: $8863cd8fe199f948$var$trueFn,
    getOwnPropertyDescriptor (_, property) {
        return {
            configurable: true,
            enumerable: true,
            get () {
                return _.get(property);
            },
            set: $8863cd8fe199f948$var$trueFn,
            deleteProperty: $8863cd8fe199f948$var$trueFn
        };
    },
    ownKeys (_) {
        return _.keys();
    }
};
function $8863cd8fe199f948$var$resolveSource(s) {
    return !(s = typeof s === "function" ? s() : s) ? {} : s;
}
function $8863cd8fe199f948$var$resolveSources() {
    for(let i = 0, length = this.length; i < length; ++i){
        const v = this[i]();
        if (v !== undefined) return v;
    }
}
function $8863cd8fe199f948$export$9d1611c77c2fe928(...sources) {
    let proxy = false;
    for(let i = 0; i < sources.length; i++){
        const s = sources[i];
        proxy = proxy || !!s && $8863cd8fe199f948$export$5cd89106e2f6c2c5 in s;
        sources[i] = typeof s === "function" ? (proxy = true, $8863cd8fe199f948$export$c0c6c8b9c16bf6aa(s)) : s;
    }
    if ($8863cd8fe199f948$var$SUPPORTS_PROXY && proxy) return new Proxy({
        get (property) {
            for(let i = sources.length - 1; i >= 0; i--){
                const v = $8863cd8fe199f948$var$resolveSource(sources[i])[property];
                if (v !== undefined) return v;
            }
        },
        has (property) {
            for(let i = sources.length - 1; i >= 0; i--){
                if (property in $8863cd8fe199f948$var$resolveSource(sources[i])) return true;
            }
            return false;
        },
        keys () {
            const keys = [];
            for(let i = 0; i < sources.length; i++)keys.push(...Object.keys($8863cd8fe199f948$var$resolveSource(sources[i])));
            return [
                ...new Set(keys)
            ];
        }
    }, $8863cd8fe199f948$var$propTraps);
    const sourcesMap = {};
    const defined = Object.create(null);
    for(let i = sources.length - 1; i >= 0; i--){
        const source = sources[i];
        if (!source) continue;
        const sourceKeys = Object.getOwnPropertyNames(source);
        for(let i = sourceKeys.length - 1; i >= 0; i--){
            const key = sourceKeys[i];
            if (key === "__proto__" || key === "constructor") continue;
            const desc = Object.getOwnPropertyDescriptor(source, key);
            if (!defined[key]) defined[key] = desc.get ? {
                enumerable: true,
                configurable: true,
                get: $8863cd8fe199f948$var$resolveSources.bind(sourcesMap[key] = [
                    desc.get.bind(source)
                ])
            } : desc.value !== undefined ? desc : undefined;
            else {
                const sources = sourcesMap[key];
                if (sources) {
                    if (desc.get) sources.push(desc.get.bind(source));
                    else if (desc.value !== undefined) sources.push(()=>desc.value);
                }
            }
        }
    }
    const target = {};
    const definedKeys = Object.keys(defined);
    for(let i = definedKeys.length - 1; i >= 0; i--){
        const key = definedKeys[i], desc = defined[key];
        if (desc && desc.get) Object.defineProperty(target, key, desc);
        else target[key] = desc ? desc.value : undefined;
    }
    return target;
}
function $8863cd8fe199f948$export$45029c61b0073d87(props, ...keys) {
    const len = keys.length;
    if ($8863cd8fe199f948$var$SUPPORTS_PROXY && $8863cd8fe199f948$export$5cd89106e2f6c2c5 in props) {
        const blocked = len > 1 ? keys.flat() : keys[0];
        const res = keys.map((k)=>{
            return new Proxy({
                get (property) {
                    return k.includes(property) ? props[property] : undefined;
                },
                has (property) {
                    return k.includes(property) && property in props;
                },
                keys () {
                    return k.filter((property)=>property in props);
                }
            }, $8863cd8fe199f948$var$propTraps);
        });
        res.push(new Proxy({
            get (property) {
                return blocked.includes(property) ? undefined : props[property];
            },
            has (property) {
                return blocked.includes(property) ? false : property in props;
            },
            keys () {
                return Object.keys(props).filter((k)=>!blocked.includes(k));
            }
        }, $8863cd8fe199f948$var$propTraps));
        return res;
    }
    const objects = [];
    for(let i = 0; i <= len; i++)objects[i] = {};
    for (const propName of Object.getOwnPropertyNames(props)){
        let keyIndex = len;
        for(let i = 0; i < keys.length; i++)if (keys[i].includes(propName)) {
            keyIndex = i;
            break;
        }
        const desc = Object.getOwnPropertyDescriptor(props, propName);
        const isDefaultDesc = !desc.get && !desc.set && desc.enumerable && desc.writable && desc.configurable;
        isDefaultDesc ? objects[keyIndex][propName] = desc.value : Object.defineProperty(objects[keyIndex], propName, desc);
    }
    return objects;
}
function $8863cd8fe199f948$export$488013bae63b21da(fn) {
    let comp;
    let p;
    const wrap = (props)=>{
        const ctx = $8863cd8fe199f948$export$2cb4986bed338027.context;
        if (ctx) {
            const [s, set] = $8863cd8fe199f948$export$c1e1e1ecbbe76a5();
            $8863cd8fe199f948$export$2cb4986bed338027.count || ($8863cd8fe199f948$export$2cb4986bed338027.count = 0);
            $8863cd8fe199f948$export$2cb4986bed338027.count++;
            (p || (p = fn())).then((mod)=>{
                !$8863cd8fe199f948$export$2cb4986bed338027.done && $8863cd8fe199f948$var$setHydrateContext(ctx);
                $8863cd8fe199f948$export$2cb4986bed338027.count--;
                set(()=>mod.default);
                $8863cd8fe199f948$var$setHydrateContext();
            });
            comp = s;
        } else if (!comp) {
            const [s] = $8863cd8fe199f948$export$edd172c6c83c39cc(()=>(p || (p = fn())).then((mod)=>mod.default));
            comp = s;
        }
        let Comp;
        return $8863cd8fe199f948$export$c0c6c8b9c16bf6aa(()=>(Comp = comp()) ? $8863cd8fe199f948$export$363ebc4b78b8f807(()=>{
                $8863cd8fe199f948$var$IS_DEV;
                if (!ctx || $8863cd8fe199f948$export$2cb4986bed338027.done) return Comp(props);
                const c = $8863cd8fe199f948$export$2cb4986bed338027.context;
                $8863cd8fe199f948$var$setHydrateContext(ctx);
                const r = Comp(props);
                $8863cd8fe199f948$var$setHydrateContext(c);
                return r;
            }) : "");
    };
    wrap.preload = ()=>p || ((p = fn()).then((mod)=>comp = ()=>mod.default), p);
    return wrap;
}
let $8863cd8fe199f948$var$counter = 0;
function $8863cd8fe199f948$export$33208d63bc845a83() {
    const ctx = $8863cd8fe199f948$export$2cb4986bed338027.context;
    return ctx ? $8863cd8fe199f948$export$2cb4986bed338027.getNextContextId() : `cl-${$8863cd8fe199f948$var$counter++}`;
}
const $8863cd8fe199f948$var$narrowedError = (name)=>`Stale read from <${name}>.`;
function $8863cd8fe199f948$export$bdf530073099ce9f(props) {
    const fallback = "fallback" in props && {
        fallback: ()=>props.fallback
    };
    return $8863cd8fe199f948$export$c0c6c8b9c16bf6aa($8863cd8fe199f948$export$4c9116dcf1374231(()=>props.each, props.children, fallback || undefined));
}
function $8863cd8fe199f948$export$cf17b003b6192af3(props) {
    const fallback = "fallback" in props && {
        fallback: ()=>props.fallback
    };
    return $8863cd8fe199f948$export$c0c6c8b9c16bf6aa($8863cd8fe199f948$export$2cd1c249765cd0a4(()=>props.each, props.children, fallback || undefined));
}
function $8863cd8fe199f948$export$f6a3d19be20f5819(props) {
    const keyed = props.keyed;
    const conditionValue = $8863cd8fe199f948$export$c0c6c8b9c16bf6aa(()=>props.when, undefined, undefined);
    const condition = keyed ? conditionValue : $8863cd8fe199f948$export$c0c6c8b9c16bf6aa(conditionValue, undefined, {
        equals: (a, b)=>!a === !b
    });
    return $8863cd8fe199f948$export$c0c6c8b9c16bf6aa(()=>{
        const c = condition();
        if (c) {
            const child = props.children;
            const fn = typeof child === "function" && child.length > 0;
            return fn ? $8863cd8fe199f948$export$363ebc4b78b8f807(()=>child(keyed ? c : ()=>{
                    if (!$8863cd8fe199f948$export$363ebc4b78b8f807(condition)) throw $8863cd8fe199f948$var$narrowedError("Show");
                    return conditionValue();
                })) : child;
        }
        return props.fallback;
    }, undefined, undefined);
}
function $8863cd8fe199f948$export$b5d5cf8927ab7262(props) {
    const chs = $8863cd8fe199f948$export$bacb5cc5a11aef16(()=>props.children);
    const switchFunc = $8863cd8fe199f948$export$c0c6c8b9c16bf6aa(()=>{
        const ch = chs();
        const mps = Array.isArray(ch) ? ch : [
            ch
        ];
        let func = ()=>undefined;
        for(let i = 0; i < mps.length; i++){
            const index = i;
            const mp = mps[i];
            const prevFunc = func;
            const conditionValue = $8863cd8fe199f948$export$c0c6c8b9c16bf6aa(()=>prevFunc() ? undefined : mp.when, undefined, undefined);
            const condition = mp.keyed ? conditionValue : $8863cd8fe199f948$export$c0c6c8b9c16bf6aa(conditionValue, undefined, {
                equals: (a, b)=>!a === !b
            });
            func = ()=>prevFunc() || (condition() ? [
                    index,
                    conditionValue,
                    mp
                ] : undefined);
        }
        return func;
    });
    return $8863cd8fe199f948$export$c0c6c8b9c16bf6aa(()=>{
        const sel = switchFunc()();
        if (!sel) return props.fallback;
        const [index, conditionValue, mp] = sel;
        const child = mp.children;
        const fn = typeof child === "function" && child.length > 0;
        return fn ? $8863cd8fe199f948$export$363ebc4b78b8f807(()=>child(mp.keyed ? conditionValue() : ()=>{
                if ($8863cd8fe199f948$export$363ebc4b78b8f807(switchFunc)()?.[0] !== index) throw $8863cd8fe199f948$var$narrowedError("Match");
                return conditionValue();
            })) : child;
    }, undefined, undefined);
}
function $8863cd8fe199f948$export$f421feb8fad20413(props) {
    return props;
}
let $8863cd8fe199f948$var$Errors;
function $8863cd8fe199f948$export$4eaee74ee7a14dca() {
    $8863cd8fe199f948$var$Errors && [
        ...$8863cd8fe199f948$var$Errors
    ].forEach((fn)=>fn());
}
function $8863cd8fe199f948$export$e926676385687eaf(props) {
    let err;
    if ($8863cd8fe199f948$export$2cb4986bed338027.context && $8863cd8fe199f948$export$2cb4986bed338027.load) err = $8863cd8fe199f948$export$2cb4986bed338027.load($8863cd8fe199f948$export$2cb4986bed338027.getContextId());
    const [errored, setErrored] = $8863cd8fe199f948$export$c1e1e1ecbbe76a5(err, undefined);
    $8863cd8fe199f948$var$Errors || ($8863cd8fe199f948$var$Errors = new Set());
    $8863cd8fe199f948$var$Errors.add(setErrored);
    $8863cd8fe199f948$export$b36e5eaa3e8c43ab(()=>$8863cd8fe199f948$var$Errors.delete(setErrored));
    return $8863cd8fe199f948$export$c0c6c8b9c16bf6aa(()=>{
        let e;
        if (e = errored()) {
            const f = props.fallback;
            return typeof f === "function" && f.length ? $8863cd8fe199f948$export$363ebc4b78b8f807(()=>f(e, ()=>setErrored())) : f;
        }
        return $8863cd8fe199f948$export$3dede90624df3ba9(()=>props.children, setErrored);
    }, undefined, undefined);
}
const $8863cd8fe199f948$var$suspenseListEquals = (a, b)=>a.showContent === b.showContent && a.showFallback === b.showFallback;
const $8863cd8fe199f948$var$SuspenseListContext = /* #__PURE__ */ $8863cd8fe199f948$export$fd42f52fd3ae1109();
function $8863cd8fe199f948$export$998bcd577473dd93(props) {
    let [wrapper, setWrapper] = $8863cd8fe199f948$export$c1e1e1ecbbe76a5(()=>({
            inFallback: false
        })), show;
    const listContext = $8863cd8fe199f948$export$fae74005e78b1a27($8863cd8fe199f948$var$SuspenseListContext);
    const [registry, setRegistry] = $8863cd8fe199f948$export$c1e1e1ecbbe76a5([]);
    if (listContext) show = listContext.register($8863cd8fe199f948$export$c0c6c8b9c16bf6aa(()=>wrapper()().inFallback));
    const resolved = $8863cd8fe199f948$export$c0c6c8b9c16bf6aa((prev)=>{
        const reveal = props.revealOrder, tail = props.tail, { showContent: showContent = true, showFallback: showFallback = true } = show ? show() : {}, reg = registry(), reverse = reveal === "backwards";
        if (reveal === "together") {
            const all = reg.every((inFallback)=>!inFallback());
            const res = reg.map(()=>({
                    showContent: all && showContent,
                    showFallback: showFallback
                }));
            res.inFallback = !all;
            return res;
        }
        let stop = false;
        let inFallback = prev.inFallback;
        const res = [];
        for(let i = 0, len = reg.length; i < len; i++){
            const n = reverse ? len - i - 1 : i, s = reg[n]();
            if (!stop && !s) res[n] = {
                showContent: showContent,
                showFallback: showFallback
            };
            else {
                const next = !stop;
                if (next) inFallback = true;
                res[n] = {
                    showContent: next,
                    showFallback: !tail || next && tail === "collapsed" ? showFallback : false
                };
                stop = true;
            }
        }
        if (!stop) inFallback = false;
        res.inFallback = inFallback;
        return res;
    }, {
        inFallback: false
    });
    setWrapper(()=>resolved);
    return $8863cd8fe199f948$export$60e54eaca7e7fb38($8863cd8fe199f948$var$SuspenseListContext.Provider, {
        value: {
            register: (inFallback)=>{
                let index;
                setRegistry((registry)=>{
                    index = registry.length;
                    return [
                        ...registry,
                        inFallback
                    ];
                });
                return $8863cd8fe199f948$export$c0c6c8b9c16bf6aa(()=>resolved()[index], undefined, {
                    equals: $8863cd8fe199f948$var$suspenseListEquals
                });
            }
        },
        get children () {
            return props.children;
        }
    });
}
function $8863cd8fe199f948$export$74bf444e3cd11ea5(props) {
    let counter = 0, show, ctx, p, flicker, error;
    const [inFallback, setFallback] = $8863cd8fe199f948$export$c1e1e1ecbbe76a5(false), SuspenseContext = $8863cd8fe199f948$var$getSuspenseContext(), store = {
        increment: ()=>{
            if (++counter === 1) setFallback(true);
        },
        decrement: ()=>{
            if (--counter === 0) setFallback(false);
        },
        inFallback: inFallback,
        effects: [],
        resolved: false
    }, owner = $8863cd8fe199f948$export$5f4ed0d56c2c0edf();
    if ($8863cd8fe199f948$export$2cb4986bed338027.context && $8863cd8fe199f948$export$2cb4986bed338027.load) {
        const key = $8863cd8fe199f948$export$2cb4986bed338027.getContextId();
        let ref = $8863cd8fe199f948$export$2cb4986bed338027.load(key);
        if (ref) {
            if (typeof ref !== "object" || ref.s !== 1) p = ref;
            else $8863cd8fe199f948$export$2cb4986bed338027.gather(key);
        }
        if (p && p !== "$$f") {
            const [s, set] = $8863cd8fe199f948$export$c1e1e1ecbbe76a5(undefined, {
                equals: false
            });
            flicker = s;
            p.then(()=>{
                if ($8863cd8fe199f948$export$2cb4986bed338027.done) return set();
                $8863cd8fe199f948$export$2cb4986bed338027.gather(key);
                $8863cd8fe199f948$var$setHydrateContext(ctx);
                set();
                $8863cd8fe199f948$var$setHydrateContext();
            }, (err)=>{
                error = err;
                set();
            });
        }
    }
    const listContext = $8863cd8fe199f948$export$fae74005e78b1a27($8863cd8fe199f948$var$SuspenseListContext);
    if (listContext) show = listContext.register(store.inFallback);
    let dispose;
    $8863cd8fe199f948$export$b36e5eaa3e8c43ab(()=>dispose && dispose());
    return $8863cd8fe199f948$export$60e54eaca7e7fb38(SuspenseContext.Provider, {
        value: store,
        get children () {
            return $8863cd8fe199f948$export$c0c6c8b9c16bf6aa(()=>{
                if (error) throw error;
                ctx = $8863cd8fe199f948$export$2cb4986bed338027.context;
                if (flicker) {
                    flicker();
                    return flicker = undefined;
                }
                if (ctx && p === "$$f") $8863cd8fe199f948$var$setHydrateContext();
                const rendered = $8863cd8fe199f948$export$c0c6c8b9c16bf6aa(()=>props.children);
                return $8863cd8fe199f948$export$c0c6c8b9c16bf6aa((prev)=>{
                    const inFallback = store.inFallback(), { showContent: showContent = true, showFallback: showFallback = true } = show ? show() : {};
                    if ((!inFallback || p && p !== "$$f") && showContent) {
                        store.resolved = true;
                        dispose && dispose();
                        dispose = ctx = p = undefined;
                        $8863cd8fe199f948$var$resumeEffects(store.effects);
                        return rendered();
                    }
                    if (!showFallback) return;
                    if (dispose) return prev;
                    return $8863cd8fe199f948$export$882461b6382ed46c((disposer)=>{
                        dispose = disposer;
                        if (ctx) {
                            $8863cd8fe199f948$var$setHydrateContext({
                                id: ctx.id + "F",
                                count: 0
                            });
                            ctx = undefined;
                        }
                        return props.fallback;
                    }, owner);
                });
            });
        }
    });
}
const $8863cd8fe199f948$export$404582bc18fe4d9e = undefined;


const $6258376c5c54faa9$var$booleans = [
    "allowfullscreen",
    "async",
    "alpha",
    "autofocus",
    "autoplay",
    "checked",
    "controls",
    "default",
    "disabled",
    "formnovalidate",
    "hidden",
    "indeterminate",
    "inert",
    "ismap",
    "loop",
    "multiple",
    "muted",
    "nomodule",
    "novalidate",
    "open",
    "playsinline",
    "readonly",
    "required",
    "reversed",
    "seamless",
    "selected",
    "adauctionheaders",
    "browsingtopics",
    "credentialless",
    "defaultchecked",
    "defaultmuted",
    "defaultselected",
    "defer",
    "disablepictureinpicture",
    "disableremoteplayback",
    "preservespitch",
    "shadowrootclonable",
    "shadowrootcustomelementregistry",
    "shadowrootdelegatesfocus",
    "shadowrootserializable",
    "sharedstoragewritable"
];
const $6258376c5c54faa9$export$8714badcfa4caafb = /*#__PURE__*/ new Set([
    "className",
    "value",
    "readOnly",
    "noValidate",
    "formNoValidate",
    "isMap",
    "noModule",
    "playsInline",
    "adAuctionHeaders",
    "allowFullscreen",
    "browsingTopics",
    "defaultChecked",
    "defaultMuted",
    "defaultSelected",
    "disablePictureInPicture",
    "disableRemotePlayback",
    "preservesPitch",
    "shadowRootClonable",
    "shadowRootCustomElementRegistry",
    "shadowRootDelegatesFocus",
    "shadowRootSerializable",
    "sharedStorageWritable",
    ...$6258376c5c54faa9$var$booleans
]);
const $6258376c5c54faa9$export$2c72a9edec54d5d9 = /*#__PURE__*/ new Set([
    "innerHTML",
    "textContent",
    "innerText",
    "children"
]);
const $6258376c5c54faa9$export$8915b7db7f70cfed = /*#__PURE__*/ Object.assign(Object.create(null), {
    className: "class",
    htmlFor: "for"
});
const $6258376c5c54faa9$var$PropAliases = /*#__PURE__*/ Object.assign(Object.create(null), {
    class: "className",
    novalidate: {
        $: "noValidate",
        FORM: 1
    },
    formnovalidate: {
        $: "formNoValidate",
        BUTTON: 1,
        INPUT: 1
    },
    ismap: {
        $: "isMap",
        IMG: 1
    },
    nomodule: {
        $: "noModule",
        SCRIPT: 1
    },
    playsinline: {
        $: "playsInline",
        VIDEO: 1
    },
    readonly: {
        $: "readOnly",
        INPUT: 1,
        TEXTAREA: 1
    },
    adauctionheaders: {
        $: "adAuctionHeaders",
        IFRAME: 1
    },
    allowfullscreen: {
        $: "allowFullscreen",
        IFRAME: 1
    },
    browsingtopics: {
        $: "browsingTopics",
        IMG: 1
    },
    defaultchecked: {
        $: "defaultChecked",
        INPUT: 1
    },
    defaultmuted: {
        $: "defaultMuted",
        AUDIO: 1,
        VIDEO: 1
    },
    defaultselected: {
        $: "defaultSelected",
        OPTION: 1
    },
    disablepictureinpicture: {
        $: "disablePictureInPicture",
        VIDEO: 1
    },
    disableremoteplayback: {
        $: "disableRemotePlayback",
        AUDIO: 1,
        VIDEO: 1
    },
    preservespitch: {
        $: "preservesPitch",
        AUDIO: 1,
        VIDEO: 1
    },
    shadowrootclonable: {
        $: "shadowRootClonable",
        TEMPLATE: 1
    },
    shadowrootdelegatesfocus: {
        $: "shadowRootDelegatesFocus",
        TEMPLATE: 1
    },
    shadowrootserializable: {
        $: "shadowRootSerializable",
        TEMPLATE: 1
    },
    sharedstoragewritable: {
        $: "sharedStorageWritable",
        IFRAME: 1,
        IMG: 1
    }
});
function $6258376c5c54faa9$export$72dcdd3761a309a9(prop, tagName) {
    const a = $6258376c5c54faa9$var$PropAliases[prop];
    return typeof a === "object" ? a[tagName] ? a["$"] : undefined : a;
}
const $6258376c5c54faa9$export$389d7c657d123a81 = /*#__PURE__*/ new Set([
    "beforeinput",
    "click",
    "dblclick",
    "contextmenu",
    "focusin",
    "focusout",
    "input",
    "keydown",
    "keyup",
    "mousedown",
    "mousemove",
    "mouseout",
    "mouseover",
    "mouseup",
    "pointerdown",
    "pointermove",
    "pointerout",
    "pointerover",
    "pointerup",
    "touchend",
    "touchmove",
    "touchstart"
]);
const $6258376c5c54faa9$export$ccaf9b9a82de4b98 = /*#__PURE__*/ new Set([
    "altGlyph",
    "altGlyphDef",
    "altGlyphItem",
    "animate",
    "animateColor",
    "animateMotion",
    "animateTransform",
    "circle",
    "clipPath",
    "color-profile",
    "cursor",
    "defs",
    "desc",
    "ellipse",
    "feBlend",
    "feColorMatrix",
    "feComponentTransfer",
    "feComposite",
    "feConvolveMatrix",
    "feDiffuseLighting",
    "feDisplacementMap",
    "feDistantLight",
    "feDropShadow",
    "feFlood",
    "feFuncA",
    "feFuncB",
    "feFuncG",
    "feFuncR",
    "feGaussianBlur",
    "feImage",
    "feMerge",
    "feMergeNode",
    "feMorphology",
    "feOffset",
    "fePointLight",
    "feSpecularLighting",
    "feSpotLight",
    "feTile",
    "feTurbulence",
    "filter",
    "font",
    "font-face",
    "font-face-format",
    "font-face-name",
    "font-face-src",
    "font-face-uri",
    "foreignObject",
    "g",
    "glyph",
    "glyphRef",
    "hkern",
    "image",
    "line",
    "linearGradient",
    "marker",
    "mask",
    "metadata",
    "missing-glyph",
    "mpath",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "radialGradient",
    "rect",
    "set",
    "stop",
    "svg",
    "switch",
    "symbol",
    "text",
    "textPath",
    "tref",
    "tspan",
    "use",
    "view",
    "vkern"
]);
const $6258376c5c54faa9$export$fa927d1d0495a67d = {
    xlink: "http://www.w3.org/1999/xlink",
    xml: "http://www.w3.org/XML/1998/namespace"
};
const $6258376c5c54faa9$export$87d0e790667228e9 = /*#__PURE__*/ new Set([
    "html",
    "base",
    "head",
    "link",
    "meta",
    "style",
    "title",
    "body",
    "address",
    "article",
    "aside",
    "footer",
    "header",
    "main",
    "nav",
    "section",
    "body",
    "blockquote",
    "dd",
    "div",
    "dl",
    "dt",
    "figcaption",
    "figure",
    "hr",
    "li",
    "ol",
    "p",
    "pre",
    "ul",
    "a",
    "abbr",
    "b",
    "bdi",
    "bdo",
    "br",
    "cite",
    "code",
    "data",
    "dfn",
    "em",
    "i",
    "kbd",
    "mark",
    "q",
    "rp",
    "rt",
    "ruby",
    "s",
    "samp",
    "small",
    "span",
    "strong",
    "sub",
    "sup",
    "time",
    "u",
    "var",
    "wbr",
    "area",
    "audio",
    "img",
    "map",
    "track",
    "video",
    "embed",
    "iframe",
    "object",
    "param",
    "picture",
    "portal",
    "source",
    "svg",
    "math",
    "canvas",
    "noscript",
    "script",
    "del",
    "ins",
    "caption",
    "col",
    "colgroup",
    "table",
    "tbody",
    "td",
    "tfoot",
    "th",
    "thead",
    "tr",
    "button",
    "datalist",
    "fieldset",
    "form",
    "input",
    "label",
    "legend",
    "meter",
    "optgroup",
    "option",
    "output",
    "progress",
    "select",
    "textarea",
    "details",
    "dialog",
    "menu",
    "summary",
    "details",
    "slot",
    "template",
    "acronym",
    "applet",
    "basefont",
    "bgsound",
    "big",
    "blink",
    "center",
    "content",
    "dir",
    "font",
    "frame",
    "frameset",
    "hgroup",
    "image",
    "keygen",
    "marquee",
    "menuitem",
    "nobr",
    "noembed",
    "noframes",
    "plaintext",
    "rb",
    "rtc",
    "shadow",
    "spacer",
    "strike",
    "tt",
    "xmp",
    "a",
    "abbr",
    "acronym",
    "address",
    "applet",
    "area",
    "article",
    "aside",
    "audio",
    "b",
    "base",
    "basefont",
    "bdi",
    "bdo",
    "bgsound",
    "big",
    "blink",
    "blockquote",
    "body",
    "br",
    "button",
    "canvas",
    "caption",
    "center",
    "cite",
    "code",
    "col",
    "colgroup",
    "content",
    "data",
    "datalist",
    "dd",
    "del",
    "details",
    "dfn",
    "dialog",
    "dir",
    "div",
    "dl",
    "dt",
    "em",
    "embed",
    "fieldset",
    "figcaption",
    "figure",
    "font",
    "footer",
    "form",
    "frame",
    "frameset",
    "head",
    "header",
    "hgroup",
    "hr",
    "html",
    "i",
    "iframe",
    "image",
    "img",
    "input",
    "ins",
    "kbd",
    "keygen",
    "label",
    "legend",
    "li",
    "link",
    "main",
    "map",
    "mark",
    "marquee",
    "menu",
    "menuitem",
    "meta",
    "meter",
    "nav",
    "nobr",
    "noembed",
    "noframes",
    "noscript",
    "object",
    "ol",
    "optgroup",
    "option",
    "output",
    "p",
    "param",
    "picture",
    "plaintext",
    "portal",
    "pre",
    "progress",
    "q",
    "rb",
    "rp",
    "rt",
    "rtc",
    "ruby",
    "s",
    "samp",
    "script",
    "section",
    "select",
    "shadow",
    "slot",
    "small",
    "source",
    "spacer",
    "span",
    "strike",
    "strong",
    "style",
    "sub",
    "summary",
    "sup",
    "table",
    "tbody",
    "td",
    "template",
    "textarea",
    "tfoot",
    "th",
    "thead",
    "time",
    "title",
    "tr",
    "track",
    "tt",
    "u",
    "ul",
    "var",
    "video",
    "wbr",
    "xmp",
    "input",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "webview",
    "isindex",
    "listing",
    "multicol",
    "nextid",
    "noindex",
    "search"
]);
const $6258376c5c54faa9$export$7c73462e0d25e514 = (fn)=>(0, $8863cd8fe199f948$export$c0c6c8b9c16bf6aa)(()=>fn());
function $6258376c5c54faa9$var$reconcileArrays(parentNode, a, b) {
    let bLength = b.length, aEnd = a.length, bEnd = bLength, aStart = 0, bStart = 0, after = a[aEnd - 1].nextSibling, map = null;
    while(aStart < aEnd || bStart < bEnd){
        if (a[aStart] === b[bStart]) {
            aStart++;
            bStart++;
            continue;
        }
        while(a[aEnd - 1] === b[bEnd - 1]){
            aEnd--;
            bEnd--;
        }
        if (aEnd === aStart) {
            const node = bEnd < bLength ? bStart ? b[bStart - 1].nextSibling : b[bEnd - bStart] : after;
            while(bStart < bEnd)parentNode.insertBefore(b[bStart++], node);
        } else if (bEnd === bStart) while(aStart < aEnd){
            if (!map || !map.has(a[aStart])) a[aStart].remove();
            aStart++;
        }
        else if (a[aStart] === b[bEnd - 1] && b[bStart] === a[aEnd - 1]) {
            const node = a[--aEnd].nextSibling;
            parentNode.insertBefore(b[bStart++], a[aStart++].nextSibling);
            parentNode.insertBefore(b[--bEnd], node);
            a[aEnd] = b[bEnd];
        } else {
            if (!map) {
                map = new Map();
                let i = bStart;
                while(i < bEnd)map.set(b[i], i++);
            }
            const index = map.get(a[aStart]);
            if (index != null) {
                if (bStart < index && index < bEnd) {
                    let i = aStart, sequence = 1, t;
                    while(++i < aEnd && i < bEnd){
                        if ((t = map.get(a[i])) == null || t !== index + sequence) break;
                        sequence++;
                    }
                    if (sequence > index - bStart) {
                        const node = a[aStart];
                        while(bStart < index)parentNode.insertBefore(b[bStart++], node);
                    } else parentNode.replaceChild(b[bStart++], a[aStart++]);
                } else aStart++;
            } else a[aStart++].remove();
        }
    }
}
const $6258376c5c54faa9$var$$$EVENTS = "_$DX_DELEGATE";
function $6258376c5c54faa9$export$b3890eb0ae9dca99(code, element, init, options = {}) {
    let disposer;
    (0, $8863cd8fe199f948$export$882461b6382ed46c)((dispose)=>{
        disposer = dispose;
        element === document ? code() : $6258376c5c54faa9$export$21a5ca8aa77d35ff(element, code(), element.firstChild ? null : undefined, init);
    }, options.owner);
    return ()=>{
        disposer();
        element.textContent = "";
    };
}
function $6258376c5c54faa9$export$ce69bd05624d0c48(html, isImportNode, isSVG, isMathML) {
    let node;
    const create = ()=>{
        const t = isMathML ? document.createElementNS("http://www.w3.org/1998/Math/MathML", "template") : document.createElement("template");
        t.innerHTML = html;
        return isSVG ? t.content.firstChild.firstChild : isMathML ? t.firstChild : t.content.firstChild;
    };
    const fn = isImportNode ? ()=>(0, $8863cd8fe199f948$export$363ebc4b78b8f807)(()=>document.importNode(node || (node = create()), true)) : ()=>(node || (node = create())).cloneNode(true);
    fn.cloneNode = fn;
    return fn;
}
function $6258376c5c54faa9$export$ad0f7f87f67e17d6(eventNames, document1 = window.document) {
    const e = document1[$6258376c5c54faa9$var$$$EVENTS] || (document1[$6258376c5c54faa9$var$$$EVENTS] = new Set());
    for(let i = 0, l = eventNames.length; i < l; i++){
        const name = eventNames[i];
        if (!e.has(name)) {
            e.add(name);
            document1.addEventListener(name, $6258376c5c54faa9$var$eventHandler);
        }
    }
}
function $6258376c5c54faa9$export$aedd29ca2033b694(document1 = window.document) {
    if (document1[$6258376c5c54faa9$var$$$EVENTS]) {
        for (let name of document1[$6258376c5c54faa9$var$$$EVENTS].keys())document1.removeEventListener(name, $6258376c5c54faa9$var$eventHandler);
        delete document1[$6258376c5c54faa9$var$$$EVENTS];
    }
}
function $6258376c5c54faa9$export$a41c68a4eb5ff164(node, name, value) {
    if ($6258376c5c54faa9$var$isHydrating(node)) return;
    node[name] = value;
}
function $6258376c5c54faa9$export$9fec4d97f1922e0b(node, name, value) {
    if ($6258376c5c54faa9$var$isHydrating(node)) return;
    if (value == null) node.removeAttribute(name);
    else node.setAttribute(name, value);
}
function $6258376c5c54faa9$export$75900142c9e21800(node, namespace, name, value) {
    if ($6258376c5c54faa9$var$isHydrating(node)) return;
    if (value == null) node.removeAttributeNS(namespace, name);
    else node.setAttributeNS(namespace, name, value);
}
function $6258376c5c54faa9$export$248913d9a30bef7a(node, name, value) {
    if ($6258376c5c54faa9$var$isHydrating(node)) return;
    value ? node.setAttribute(name, "") : node.removeAttribute(name);
}
function $6258376c5c54faa9$export$2913c0c0b5623090(node, value) {
    if ($6258376c5c54faa9$var$isHydrating(node)) return;
    if (value == null) node.removeAttribute("class");
    else node.className = value;
}
function $6258376c5c54faa9$export$3f65cefe8380dbea(node, name, handler, delegate) {
    if (delegate) {
        if (Array.isArray(handler)) {
            node[`$$${name}`] = handler[0];
            node[`$$${name}Data`] = handler[1];
        } else node[`$$${name}`] = handler;
    } else if (Array.isArray(handler)) {
        const handlerFn = handler[0];
        node.addEventListener(name, handler[0] = (e)=>handlerFn.call(node, handler[1], e));
    } else node.addEventListener(name, handler, typeof handler !== "function" && handler);
}
function $6258376c5c54faa9$export$11c615ce16f87241(node, value, prev = {}) {
    const classKeys = Object.keys(value || {}), prevKeys = Object.keys(prev);
    let i, len;
    for(i = 0, len = prevKeys.length; i < len; i++){
        const key = prevKeys[i];
        if (!key || key === "undefined" || value[key]) continue;
        $6258376c5c54faa9$var$toggleClassKey(node, key, false);
        delete prev[key];
    }
    for(i = 0, len = classKeys.length; i < len; i++){
        const key = classKeys[i], classValue = !!value[key];
        if (!key || key === "undefined" || prev[key] === classValue || !classValue) continue;
        $6258376c5c54faa9$var$toggleClassKey(node, key, true);
        prev[key] = classValue;
    }
    return prev;
}
function $6258376c5c54faa9$export$1d567c320f4763bc(node, value, prev) {
    if (!value) return prev ? $6258376c5c54faa9$export$9fec4d97f1922e0b(node, "style") : value;
    const nodeStyle = node.style;
    if (typeof value === "string") return nodeStyle.cssText = value;
    typeof prev === "string" && (nodeStyle.cssText = prev = undefined);
    prev || (prev = {});
    value || (value = {});
    let v, s;
    for(s in prev){
        value[s] == null && nodeStyle.removeProperty(s);
        delete prev[s];
    }
    for(s in value){
        v = value[s];
        if (v !== prev[s]) {
            nodeStyle.setProperty(s, v);
            prev[s] = v;
        }
    }
    return prev;
}
function $6258376c5c54faa9$export$36a7c0615a5a1a31(node, name, value) {
    value != null ? node.style.setProperty(name, value) : node.style.removeProperty(name);
}
function $6258376c5c54faa9$export$3ae0fd4797ed47c8(node, props = {}, isSVG, skipChildren) {
    const prevProps = {};
    if (!skipChildren) (0, $8863cd8fe199f948$export$314dade334ae905d)(()=>prevProps.children = $6258376c5c54faa9$var$insertExpression(node, props.children, prevProps.children));
    (0, $8863cd8fe199f948$export$314dade334ae905d)(()=>typeof props.ref === "function" && $6258376c5c54faa9$export$1f96ae73734a86cc(props.ref, node));
    (0, $8863cd8fe199f948$export$314dade334ae905d)(()=>$6258376c5c54faa9$export$e6e34fd1f2686227(node, props, isSVG, true, prevProps, true));
    return prevProps;
}
function $6258376c5c54faa9$export$2810486c22c942e9(props, key) {
    const src = props[key];
    Object.defineProperty(props, key, {
        get () {
            return src();
        },
        enumerable: true
    });
    return props;
}
function $6258376c5c54faa9$export$1f96ae73734a86cc(fn, element, arg) {
    return (0, $8863cd8fe199f948$export$363ebc4b78b8f807)(()=>fn(element, arg));
}
function $6258376c5c54faa9$export$21a5ca8aa77d35ff(parent, accessor, marker, initial) {
    if (marker !== undefined && !initial) initial = [];
    if (typeof accessor !== "function") return $6258376c5c54faa9$var$insertExpression(parent, accessor, initial, marker);
    (0, $8863cd8fe199f948$export$314dade334ae905d)((current)=>$6258376c5c54faa9$var$insertExpression(parent, accessor(), current, marker), initial);
}
function $6258376c5c54faa9$export$e6e34fd1f2686227(node, props, isSVG, skipChildren, prevProps = {}, skipRef = false) {
    props || (props = {});
    for(const prop in prevProps)if (!(prop in props)) {
        if (prop === "children") continue;
        prevProps[prop] = $6258376c5c54faa9$var$assignProp(node, prop, null, prevProps[prop], isSVG, skipRef, props);
    }
    for(const prop in props){
        if (prop === "children") {
            if (!skipChildren) $6258376c5c54faa9$var$insertExpression(node, props.children);
            continue;
        }
        const value = props[prop];
        prevProps[prop] = $6258376c5c54faa9$var$assignProp(node, prop, value, prevProps[prop], isSVG, skipRef, props);
    }
}
function $6258376c5c54faa9$var$hydrate$1(code, element, options = {}) {
    if (globalThis._$HY.done) return $6258376c5c54faa9$export$b3890eb0ae9dca99(code, element, [
        ...element.childNodes
    ], options);
    (0, $8863cd8fe199f948$export$2cb4986bed338027).completed = globalThis._$HY.completed;
    (0, $8863cd8fe199f948$export$2cb4986bed338027).events = globalThis._$HY.events;
    (0, $8863cd8fe199f948$export$2cb4986bed338027).load = (id)=>globalThis._$HY.r[id];
    (0, $8863cd8fe199f948$export$2cb4986bed338027).has = (id)=>id in globalThis._$HY.r;
    (0, $8863cd8fe199f948$export$2cb4986bed338027).gather = (root)=>$6258376c5c54faa9$var$gatherHydratable(element, root);
    (0, $8863cd8fe199f948$export$2cb4986bed338027).registry = new Map();
    (0, $8863cd8fe199f948$export$2cb4986bed338027).context = {
        id: options.renderId || "",
        count: 0
    };
    try {
        $6258376c5c54faa9$var$gatherHydratable(element, options.renderId);
        return $6258376c5c54faa9$export$b3890eb0ae9dca99(code, element, [
            ...element.childNodes
        ], options);
    } finally{
        (0, $8863cd8fe199f948$export$2cb4986bed338027).context = null;
    }
}
function $6258376c5c54faa9$export$4109ed81edd7716d(template) {
    let node, key, hydrating = $6258376c5c54faa9$var$isHydrating();
    if (!hydrating || !(node = (0, $8863cd8fe199f948$export$2cb4986bed338027).registry.get(key = $6258376c5c54faa9$export$a5a9dff0691837de()))) return template();
    if ((0, $8863cd8fe199f948$export$2cb4986bed338027).completed) (0, $8863cd8fe199f948$export$2cb4986bed338027).completed.add(node);
    (0, $8863cd8fe199f948$export$2cb4986bed338027).registry.delete(key);
    return node;
}
function $6258376c5c54faa9$export$c19731b2c49ee4c9(el, nodeName) {
    while(el && el.localName !== nodeName)el = el.nextSibling;
    return el;
}
function $6258376c5c54faa9$export$5cf9b6f37b7c0802(start) {
    let end = start, count = 0, current = [];
    if ($6258376c5c54faa9$var$isHydrating(start)) while(end){
        if (end.nodeType === 8) {
            const v = end.nodeValue;
            if (v === "$") count++;
            else if (v === "/") {
                if (count === 0) return [
                    end,
                    current
                ];
                count--;
            }
        }
        current.push(end);
        end = end.nextSibling;
    }
    return [
        end,
        current
    ];
}
function $6258376c5c54faa9$export$6fef5763b6d3688d() {
    if ((0, $8863cd8fe199f948$export$2cb4986bed338027).events && !(0, $8863cd8fe199f948$export$2cb4986bed338027).events.queued) {
        queueMicrotask(()=>{
            const { completed: completed, events: events } = (0, $8863cd8fe199f948$export$2cb4986bed338027);
            if (!events) return;
            events.queued = false;
            while(events.length){
                const [el, e] = events[0];
                if (!completed.has(el)) return;
                events.shift();
                $6258376c5c54faa9$var$eventHandler(e);
            }
            if ((0, $8863cd8fe199f948$export$2cb4986bed338027).done) {
                (0, $8863cd8fe199f948$export$2cb4986bed338027).events = _$HY.events = null;
                (0, $8863cd8fe199f948$export$2cb4986bed338027).completed = _$HY.completed = null;
            }
        });
        (0, $8863cd8fe199f948$export$2cb4986bed338027).events.queued = true;
    }
}
function $6258376c5c54faa9$var$isHydrating(node) {
    return !!(0, $8863cd8fe199f948$export$2cb4986bed338027).context && !(0, $8863cd8fe199f948$export$2cb4986bed338027).done && (!node || node.isConnected);
}
function $6258376c5c54faa9$var$toPropertyName(name) {
    return name.toLowerCase().replace(/-([a-z])/g, (_, w)=>w.toUpperCase());
}
function $6258376c5c54faa9$var$toggleClassKey(node, key, value) {
    const classNames = key.trim().split(/\s+/);
    for(let i = 0, nameLen = classNames.length; i < nameLen; i++)node.classList.toggle(classNames[i], value);
}
function $6258376c5c54faa9$var$assignProp(node, prop, value, prev, isSVG, skipRef, props) {
    let isCE, isProp, isChildProp, propAlias, forceProp;
    if (prop === "style") return $6258376c5c54faa9$export$1d567c320f4763bc(node, value, prev);
    if (prop === "classList") return $6258376c5c54faa9$export$11c615ce16f87241(node, value, prev);
    if (value === prev) return prev;
    if (prop === "ref") {
        if (!skipRef) value(node);
    } else if (prop.slice(0, 3) === "on:") {
        const e = prop.slice(3);
        prev && node.removeEventListener(e, prev, typeof prev !== "function" && prev);
        value && node.addEventListener(e, value, typeof value !== "function" && value);
    } else if (prop.slice(0, 10) === "oncapture:") {
        const e = prop.slice(10);
        prev && node.removeEventListener(e, prev, true);
        value && node.addEventListener(e, value, true);
    } else if (prop.slice(0, 2) === "on") {
        const name = prop.slice(2).toLowerCase();
        const delegate = $6258376c5c54faa9$export$389d7c657d123a81.has(name);
        if (!delegate && prev) {
            const h = Array.isArray(prev) ? prev[0] : prev;
            node.removeEventListener(name, h);
        }
        if (delegate || value) {
            $6258376c5c54faa9$export$3f65cefe8380dbea(node, name, value, delegate);
            delegate && $6258376c5c54faa9$export$ad0f7f87f67e17d6([
                name
            ]);
        }
    } else if (prop.slice(0, 5) === "attr:") $6258376c5c54faa9$export$9fec4d97f1922e0b(node, prop.slice(5), value);
    else if (prop.slice(0, 5) === "bool:") $6258376c5c54faa9$export$248913d9a30bef7a(node, prop.slice(5), value);
    else if ((forceProp = prop.slice(0, 5) === "prop:") || (isChildProp = $6258376c5c54faa9$export$2c72a9edec54d5d9.has(prop)) || !isSVG && ((propAlias = $6258376c5c54faa9$export$72dcdd3761a309a9(prop, node.tagName)) || (isProp = $6258376c5c54faa9$export$8714badcfa4caafb.has(prop))) || (isCE = node.nodeName.includes("-") || "is" in props)) {
        if (forceProp) {
            prop = prop.slice(5);
            isProp = true;
        } else if ($6258376c5c54faa9$var$isHydrating(node)) return value;
        if (prop === "class" || prop === "className") $6258376c5c54faa9$export$2913c0c0b5623090(node, value);
        else if (isCE && !isProp && !isChildProp) node[$6258376c5c54faa9$var$toPropertyName(prop)] = value;
        else node[propAlias || prop] = value;
    } else {
        const ns = isSVG && prop.indexOf(":") > -1 && $6258376c5c54faa9$export$fa927d1d0495a67d[prop.split(":")[0]];
        if (ns) $6258376c5c54faa9$export$75900142c9e21800(node, ns, prop, value);
        else $6258376c5c54faa9$export$9fec4d97f1922e0b(node, $6258376c5c54faa9$export$8915b7db7f70cfed[prop] || prop, value);
    }
    return value;
}
function $6258376c5c54faa9$var$eventHandler(e) {
    if ((0, $8863cd8fe199f948$export$2cb4986bed338027).registry && (0, $8863cd8fe199f948$export$2cb4986bed338027).events) {
        if ((0, $8863cd8fe199f948$export$2cb4986bed338027).events.find(([el, ev])=>ev === e)) return;
    }
    let node = e.target;
    const key = `$$${e.type}`;
    const oriTarget = e.target;
    const oriCurrentTarget = e.currentTarget;
    const retarget = (value)=>Object.defineProperty(e, "target", {
            configurable: true,
            value: value
        });
    const handleNode = ()=>{
        const handler = node[key];
        if (handler && !node.disabled) {
            const data = node[`${key}Data`];
            data !== undefined ? handler.call(node, data, e) : handler.call(node, e);
            if (e.cancelBubble) return;
        }
        node.host && typeof node.host !== "string" && !node.host._$host && node.contains(e.target) && retarget(node.host);
        return true;
    };
    const walkUpTree = ()=>{
        while(handleNode() && (node = node._$host || node.parentNode || node.host));
    };
    Object.defineProperty(e, "currentTarget", {
        configurable: true,
        get () {
            return node || document;
        }
    });
    if ((0, $8863cd8fe199f948$export$2cb4986bed338027).registry && !(0, $8863cd8fe199f948$export$2cb4986bed338027).done) (0, $8863cd8fe199f948$export$2cb4986bed338027).done = _$HY.done = true;
    if (e.composedPath) {
        const path = e.composedPath();
        retarget(path[0]);
        for(let i = 0; i < path.length - 2; i++){
            node = path[i];
            if (!handleNode()) break;
            if (node._$host) {
                node = node._$host;
                walkUpTree();
                break;
            }
            if (node.parentNode === oriCurrentTarget) break;
        }
    } else walkUpTree();
    retarget(oriTarget);
}
function $6258376c5c54faa9$var$insertExpression(parent, value, current, marker, unwrapArray) {
    const hydrating = $6258376c5c54faa9$var$isHydrating(parent);
    if (hydrating) {
        !current && (current = [
            ...parent.childNodes
        ]);
        let cleaned = [];
        for(let i = 0; i < current.length; i++){
            const node = current[i];
            if (node.nodeType === 8 && node.data.slice(0, 2) === "!$") node.remove();
            else cleaned.push(node);
        }
        current = cleaned;
    }
    while(typeof current === "function")current = current();
    if (value === current) return current;
    const t = typeof value, multi = marker !== undefined;
    parent = multi && current[0] && current[0].parentNode || parent;
    if (t === "string" || t === "number") {
        if (hydrating) return current;
        if (t === "number") {
            value = value.toString();
            if (value === current) return current;
        }
        if (multi) {
            let node = current[0];
            if (node && node.nodeType === 3) node.data !== value && (node.data = value);
            else node = document.createTextNode(value);
            current = $6258376c5c54faa9$var$cleanChildren(parent, current, marker, node);
        } else if (current !== "" && typeof current === "string") current = parent.firstChild.data = value;
        else current = parent.textContent = value;
    } else if (value == null || t === "boolean") {
        if (hydrating) return current;
        current = $6258376c5c54faa9$var$cleanChildren(parent, current, marker);
    } else if (t === "function") {
        (0, $8863cd8fe199f948$export$314dade334ae905d)(()=>{
            let v = value();
            while(typeof v === "function")v = v();
            current = $6258376c5c54faa9$var$insertExpression(parent, v, current, marker);
        });
        return ()=>current;
    } else if (Array.isArray(value)) {
        const array = [];
        const currentArray = current && Array.isArray(current);
        if ($6258376c5c54faa9$var$normalizeIncomingArray(array, value, current, unwrapArray)) {
            (0, $8863cd8fe199f948$export$314dade334ae905d)(()=>current = $6258376c5c54faa9$var$insertExpression(parent, array, current, marker, true));
            return ()=>current;
        }
        if (hydrating) {
            if (!array.length) return current;
            if (marker === undefined) return current = [
                ...parent.childNodes
            ];
            let node = array[0];
            if (node.parentNode !== parent) return current;
            const nodes = [
                node
            ];
            while((node = node.nextSibling) !== marker)nodes.push(node);
            return current = nodes;
        }
        if (array.length === 0) {
            current = $6258376c5c54faa9$var$cleanChildren(parent, current, marker);
            if (multi) return current;
        } else if (currentArray) {
            if (current.length === 0) $6258376c5c54faa9$var$appendNodes(parent, array, marker);
            else $6258376c5c54faa9$var$reconcileArrays(parent, current, array);
        } else {
            current && $6258376c5c54faa9$var$cleanChildren(parent);
            $6258376c5c54faa9$var$appendNodes(parent, array);
        }
        current = array;
    } else if (value.nodeType) {
        if (hydrating && value.parentNode) return current = multi ? [
            value
        ] : value;
        if (Array.isArray(current)) {
            if (multi) return current = $6258376c5c54faa9$var$cleanChildren(parent, current, marker, value);
            $6258376c5c54faa9$var$cleanChildren(parent, current, null, value);
        } else if (current == null || current === "" || !parent.firstChild) parent.appendChild(value);
        else parent.replaceChild(value, parent.firstChild);
        current = value;
    }
    return current;
}
function $6258376c5c54faa9$var$normalizeIncomingArray(normalized, array, current, unwrap) {
    let dynamic = false;
    for(let i = 0, len = array.length; i < len; i++){
        let item = array[i], prev = current && current[normalized.length], t;
        if (item == null || item === true || item === false) ;
        else if ((t = typeof item) === "object" && item.nodeType) normalized.push(item);
        else if (Array.isArray(item)) dynamic = $6258376c5c54faa9$var$normalizeIncomingArray(normalized, item, prev) || dynamic;
        else if (t === "function") {
            if (unwrap) {
                while(typeof item === "function")item = item();
                dynamic = $6258376c5c54faa9$var$normalizeIncomingArray(normalized, Array.isArray(item) ? item : [
                    item
                ], Array.isArray(prev) ? prev : [
                    prev
                ]) || dynamic;
            } else {
                normalized.push(item);
                dynamic = true;
            }
        } else {
            const value = String(item);
            if (prev && prev.nodeType === 3 && prev.data === value) normalized.push(prev);
            else normalized.push(document.createTextNode(value));
        }
    }
    return dynamic;
}
function $6258376c5c54faa9$var$appendNodes(parent, array, marker = null) {
    for(let i = 0, len = array.length; i < len; i++)parent.insertBefore(array[i], marker);
}
function $6258376c5c54faa9$var$cleanChildren(parent, current, marker, replacement) {
    if (marker === undefined) return parent.textContent = "";
    const node = replacement || document.createTextNode("");
    if (current.length) {
        let inserted = false;
        for(let i = current.length - 1; i >= 0; i--){
            const el = current[i];
            if (node !== el) {
                const isParent = el.parentNode === parent;
                if (!inserted && !i) isParent ? parent.replaceChild(node, el) : parent.insertBefore(node, marker);
                else isParent && el.remove();
            } else inserted = true;
        }
    } else parent.insertBefore(node, marker);
    return [
        node
    ];
}
function $6258376c5c54faa9$var$gatherHydratable(element, root) {
    const templates = element.querySelectorAll(`*[data-hk]`);
    for(let i = 0; i < templates.length; i++){
        const node = templates[i];
        const key = node.getAttribute("data-hk");
        if ((!root || key.startsWith(root)) && !(0, $8863cd8fe199f948$export$2cb4986bed338027).registry.has(key)) (0, $8863cd8fe199f948$export$2cb4986bed338027).registry.set(key, node);
    }
}
function $6258376c5c54faa9$export$a5a9dff0691837de() {
    return (0, $8863cd8fe199f948$export$2cb4986bed338027).getNextContextId();
}
function $6258376c5c54faa9$export$36143b7c9c07dd39(props) {
    return (0, $8863cd8fe199f948$export$2cb4986bed338027).context ? undefined : props.children;
}
function $6258376c5c54faa9$export$da8cca6e5dfa3577(props) {
    return props.children;
}
const $6258376c5c54faa9$export$c8eca95e306f7116 = ()=>undefined;
const $6258376c5c54faa9$export$5df49ba75ba1c1f9 = Symbol();
function $6258376c5c54faa9$export$8bd3fff6c675ca8d(parent, content) {
    !(0, $8863cd8fe199f948$export$2cb4986bed338027).context && (parent.innerHTML = content);
}
function $6258376c5c54faa9$var$throwInBrowser(func) {
    const err = new Error(`${func.name} is not supported in the browser, returning undefined`);
    console.error(err);
}
function $6258376c5c54faa9$export$80e7718417253a51(fn, options) {
    $6258376c5c54faa9$var$throwInBrowser($6258376c5c54faa9$export$80e7718417253a51);
}
function $6258376c5c54faa9$export$f3aefc4196cd5f3e(fn, options) {
    $6258376c5c54faa9$var$throwInBrowser($6258376c5c54faa9$export$f3aefc4196cd5f3e);
}
function $6258376c5c54faa9$export$97f86213fef5749d(fn, options) {
    $6258376c5c54faa9$var$throwInBrowser($6258376c5c54faa9$export$97f86213fef5749d);
}
function $6258376c5c54faa9$export$ea2375f6c0c9ffdc(template, ...nodes) {}
function $6258376c5c54faa9$export$1844beb7faeb4553(name, props, children, needsId) {}
function $6258376c5c54faa9$export$e92e0c287593a882(value) {}
function $6258376c5c54faa9$export$9e97f11b9d683d7a(value) {}
function $6258376c5c54faa9$export$9ab8bdc1e27e51e1(key, value) {}
function $6258376c5c54faa9$export$7e66a08c0b8ab2aa() {}
function $6258376c5c54faa9$export$755e9f954b4fd36e(node) {}
function $6258376c5c54faa9$export$4e7f196112fea3c5(html) {}
function $6258376c5c54faa9$export$8c2b042ce8153017(props, isSVG, skipChildren) {}
const $6258376c5c54faa9$export$6acf61af03e62db = false;
const $6258376c5c54faa9$export$40edfb7eeb78c4e8 = false;
const $6258376c5c54faa9$var$SVG_NAMESPACE = "http://www.w3.org/2000/svg";
function $6258376c5c54faa9$var$createElement(tagName, isSVG = false, is) {
    return isSVG ? document.createElementNS($6258376c5c54faa9$var$SVG_NAMESPACE, tagName) : document.createElement(tagName, {
        is: is
    });
}
const $6258376c5c54faa9$export$fa8d919ba61d84db = (...args)=>{
    (0, $8863cd8fe199f948$export$849801d35d2160c9)();
    return $6258376c5c54faa9$var$hydrate$1(...args);
};
function $6258376c5c54faa9$export$602eac185826482c(props) {
    const { useShadow: useShadow } = props, marker = document.createTextNode(""), mount = ()=>props.mount || document.body, owner = (0, $8863cd8fe199f948$export$5f4ed0d56c2c0edf)();
    let content;
    let hydrating = !!(0, $8863cd8fe199f948$export$2cb4986bed338027).context;
    (0, $8863cd8fe199f948$export$7ea7134f704deda4)(()=>{
        if (hydrating) (0, $8863cd8fe199f948$export$5f4ed0d56c2c0edf)().user = hydrating = false;
        content || (content = (0, $8863cd8fe199f948$export$c14f3e3abbc7d6b5)(owner, ()=>(0, $8863cd8fe199f948$export$c0c6c8b9c16bf6aa)(()=>props.children)));
        const el = mount();
        if (el instanceof HTMLHeadElement) {
            const [clean, setClean] = (0, $8863cd8fe199f948$export$c1e1e1ecbbe76a5)(false);
            const cleanup = ()=>setClean(true);
            (0, $8863cd8fe199f948$export$882461b6382ed46c)((dispose)=>$6258376c5c54faa9$export$21a5ca8aa77d35ff(el, ()=>!clean() ? content() : dispose(), null));
            (0, $8863cd8fe199f948$export$b36e5eaa3e8c43ab)(cleanup);
        } else {
            const container = $6258376c5c54faa9$var$createElement(props.isSVG ? "g" : "div", props.isSVG), renderRoot = useShadow && container.attachShadow ? container.attachShadow({
                mode: "open"
            }) : container;
            Object.defineProperty(container, "_$host", {
                get () {
                    return marker.parentNode;
                },
                configurable: true
            });
            $6258376c5c54faa9$export$21a5ca8aa77d35ff(renderRoot, content);
            el.appendChild(container);
            props.ref && props.ref(container);
            (0, $8863cd8fe199f948$export$b36e5eaa3e8c43ab)(()=>el.removeChild(container));
        }
    }, undefined, {
        render: !hydrating
    });
    return marker;
}
function $6258376c5c54faa9$export$9a3ff77bac07eb26(component, props) {
    const cached = (0, $8863cd8fe199f948$export$c0c6c8b9c16bf6aa)(component);
    return (0, $8863cd8fe199f948$export$c0c6c8b9c16bf6aa)(()=>{
        const component = cached();
        switch(typeof component){
            case "function":
                return (0, $8863cd8fe199f948$export$363ebc4b78b8f807)(()=>component(props));
            case "string":
                const isSvg = $6258376c5c54faa9$export$ccaf9b9a82de4b98.has(component);
                const el = (0, $8863cd8fe199f948$export$2cb4986bed338027).context ? $6258376c5c54faa9$export$4109ed81edd7716d() : $6258376c5c54faa9$var$createElement(component, isSvg, (0, $8863cd8fe199f948$export$363ebc4b78b8f807)(()=>props.is));
                $6258376c5c54faa9$export$3ae0fd4797ed47c8(el, props, isSvg);
                return el;
        }
    });
}
function $6258376c5c54faa9$export$e18282e419e46834(props) {
    const [, others] = (0, $8863cd8fe199f948$export$45029c61b0073d87)(props, [
        "component"
    ]);
    return $6258376c5c54faa9$export$9a3ff77bac07eb26(()=>props.component, others);
}











const $caa70d287a6ddb62$export$9f4df9bfaca7e3b7 = Symbol("store-raw"), $caa70d287a6ddb62$var$$NODE = Symbol("store-node"), $caa70d287a6ddb62$var$$HAS = Symbol("store-has"), $caa70d287a6ddb62$var$$SELF = Symbol("store-self");
function $caa70d287a6ddb62$var$wrap$1(value) {
    let p = value[0, $8863cd8fe199f948$export$5cd89106e2f6c2c5];
    if (!p) {
        Object.defineProperty(value, (0, $8863cd8fe199f948$export$5cd89106e2f6c2c5), {
            value: p = new Proxy(value, $caa70d287a6ddb62$var$proxyTraps$1)
        });
        if (!Array.isArray(value)) {
            const keys = Object.keys(value), desc = Object.getOwnPropertyDescriptors(value);
            for(let i = 0, l = keys.length; i < l; i++){
                const prop = keys[i];
                if (desc[prop].get) Object.defineProperty(value, prop, {
                    enumerable: desc[prop].enumerable,
                    get: desc[prop].get.bind(p)
                });
            }
        }
    }
    return p;
}
function $caa70d287a6ddb62$var$isWrappable(obj) {
    let proto;
    return obj != null && typeof obj === "object" && (obj[0, $8863cd8fe199f948$export$5cd89106e2f6c2c5] || !(proto = Object.getPrototypeOf(obj)) || proto === Object.prototype || Array.isArray(obj));
}
function $caa70d287a6ddb62$export$debb760848ca95a(item, set = new Set()) {
    let result, unwrapped, v, prop;
    if (result = item != null && item[$caa70d287a6ddb62$export$9f4df9bfaca7e3b7]) return result;
    if (!$caa70d287a6ddb62$var$isWrappable(item) || set.has(item)) return item;
    if (Array.isArray(item)) {
        if (Object.isFrozen(item)) item = item.slice(0);
        else set.add(item);
        for(let i = 0, l = item.length; i < l; i++){
            v = item[i];
            if ((unwrapped = $caa70d287a6ddb62$export$debb760848ca95a(v, set)) !== v) item[i] = unwrapped;
        }
    } else {
        if (Object.isFrozen(item)) item = Object.assign({}, item);
        else set.add(item);
        const keys = Object.keys(item), desc = Object.getOwnPropertyDescriptors(item);
        for(let i = 0, l = keys.length; i < l; i++){
            prop = keys[i];
            if (desc[prop].get) continue;
            v = item[prop];
            if ((unwrapped = $caa70d287a6ddb62$export$debb760848ca95a(v, set)) !== v) item[prop] = unwrapped;
        }
    }
    return item;
}
function $caa70d287a6ddb62$var$getNodes(target, symbol) {
    let nodes = target[symbol];
    if (!nodes) Object.defineProperty(target, symbol, {
        value: nodes = Object.create(null)
    });
    return nodes;
}
function $caa70d287a6ddb62$var$getNode(nodes, property, value) {
    if (nodes[property]) return nodes[property];
    const [s, set] = (0, $8863cd8fe199f948$export$c1e1e1ecbbe76a5)(value, {
        equals: false,
        internal: true
    });
    s.$ = set;
    return nodes[property] = s;
}
function $caa70d287a6ddb62$var$proxyDescriptor$1(target, property) {
    const desc = Reflect.getOwnPropertyDescriptor(target, property);
    if (!desc || desc.get || !desc.configurable || property === (0, $8863cd8fe199f948$export$5cd89106e2f6c2c5) || property === $caa70d287a6ddb62$var$$NODE) return desc;
    delete desc.value;
    delete desc.writable;
    desc.get = ()=>target[0, $8863cd8fe199f948$export$5cd89106e2f6c2c5][property];
    return desc;
}
function $caa70d287a6ddb62$var$trackSelf(target) {
    (0, $8863cd8fe199f948$export$12abb5141c6fdc9c)() && $caa70d287a6ddb62$var$getNode($caa70d287a6ddb62$var$getNodes(target, $caa70d287a6ddb62$var$$NODE), $caa70d287a6ddb62$var$$SELF)();
}
function $caa70d287a6ddb62$var$ownKeys(target) {
    $caa70d287a6ddb62$var$trackSelf(target);
    return Reflect.ownKeys(target);
}
const $caa70d287a6ddb62$var$proxyTraps$1 = {
    get (target, property, receiver) {
        if (property === $caa70d287a6ddb62$export$9f4df9bfaca7e3b7) return target;
        if (property === (0, $8863cd8fe199f948$export$5cd89106e2f6c2c5)) return receiver;
        if (property === (0, $8863cd8fe199f948$export$17a675b7c02a7b1d)) {
            $caa70d287a6ddb62$var$trackSelf(target);
            return receiver;
        }
        const nodes = $caa70d287a6ddb62$var$getNodes(target, $caa70d287a6ddb62$var$$NODE);
        const tracked = nodes[property];
        let value = tracked ? tracked() : target[property];
        if (property === $caa70d287a6ddb62$var$$NODE || property === $caa70d287a6ddb62$var$$HAS || property === "__proto__") return value;
        if (!tracked) {
            const desc = Object.getOwnPropertyDescriptor(target, property);
            if ((0, $8863cd8fe199f948$export$12abb5141c6fdc9c)() && (typeof value !== "function" || target.hasOwnProperty(property)) && !(desc && desc.get)) value = $caa70d287a6ddb62$var$getNode(nodes, property, value)();
        }
        return $caa70d287a6ddb62$var$isWrappable(value) ? $caa70d287a6ddb62$var$wrap$1(value) : value;
    },
    has (target, property) {
        if (property === $caa70d287a6ddb62$export$9f4df9bfaca7e3b7 || property === (0, $8863cd8fe199f948$export$5cd89106e2f6c2c5) || property === (0, $8863cd8fe199f948$export$17a675b7c02a7b1d) || property === $caa70d287a6ddb62$var$$NODE || property === $caa70d287a6ddb62$var$$HAS || property === "__proto__") return true;
        (0, $8863cd8fe199f948$export$12abb5141c6fdc9c)() && $caa70d287a6ddb62$var$getNode($caa70d287a6ddb62$var$getNodes(target, $caa70d287a6ddb62$var$$HAS), property)();
        return property in target;
    },
    set () {
        return true;
    },
    deleteProperty () {
        return true;
    },
    ownKeys: $caa70d287a6ddb62$var$ownKeys,
    getOwnPropertyDescriptor: $caa70d287a6ddb62$var$proxyDescriptor$1
};
function $caa70d287a6ddb62$var$setProperty(state, property, value, deleting = false) {
    if (!deleting && state[property] === value) return;
    const prev = state[property], len = state.length;
    if (value === undefined) {
        delete state[property];
        if (state[$caa70d287a6ddb62$var$$HAS] && state[$caa70d287a6ddb62$var$$HAS][property] && prev !== undefined) state[$caa70d287a6ddb62$var$$HAS][property].$();
    } else {
        state[property] = value;
        if (state[$caa70d287a6ddb62$var$$HAS] && state[$caa70d287a6ddb62$var$$HAS][property] && prev === undefined) state[$caa70d287a6ddb62$var$$HAS][property].$();
    }
    let nodes = $caa70d287a6ddb62$var$getNodes(state, $caa70d287a6ddb62$var$$NODE), node;
    if (node = $caa70d287a6ddb62$var$getNode(nodes, property, prev)) node.$(()=>value);
    if (Array.isArray(state) && state.length !== len) {
        for(let i = state.length; i < len; i++)(node = nodes[i]) && node.$();
        (node = $caa70d287a6ddb62$var$getNode(nodes, "length", len)) && node.$(state.length);
    }
    (node = nodes[$caa70d287a6ddb62$var$$SELF]) && node.$();
}
function $caa70d287a6ddb62$var$mergeStoreNode(state, value) {
    const keys = Object.keys(value);
    for(let i = 0; i < keys.length; i += 1){
        const key = keys[i];
        $caa70d287a6ddb62$var$setProperty(state, key, value[key]);
    }
}
function $caa70d287a6ddb62$var$updateArray(current, next) {
    if (typeof next === "function") next = next(current);
    next = $caa70d287a6ddb62$export$debb760848ca95a(next);
    if (Array.isArray(next)) {
        if (current === next) return;
        let i = 0, len = next.length;
        for(; i < len; i++){
            const value = next[i];
            if (current[i] !== value) $caa70d287a6ddb62$var$setProperty(current, i, value);
        }
        $caa70d287a6ddb62$var$setProperty(current, "length", len);
    } else $caa70d287a6ddb62$var$mergeStoreNode(current, next);
}
function $caa70d287a6ddb62$var$updatePath(current, path, traversed = []) {
    let part, prev = current;
    if (path.length > 1) {
        part = path.shift();
        const partType = typeof part, isArray = Array.isArray(current);
        if (Array.isArray(part)) {
            for(let i = 0; i < part.length; i++)$caa70d287a6ddb62$var$updatePath(current, [
                part[i]
            ].concat(path), traversed);
            return;
        } else if (isArray && partType === "function") {
            for(let i = 0; i < current.length; i++)if (part(current[i], i)) $caa70d287a6ddb62$var$updatePath(current, [
                i
            ].concat(path), traversed);
            return;
        } else if (isArray && partType === "object") {
            const { from: from = 0, to: to = current.length - 1, by: by = 1 } = part;
            for(let i = from; i <= to; i += by)$caa70d287a6ddb62$var$updatePath(current, [
                i
            ].concat(path), traversed);
            return;
        } else if (path.length > 1) {
            $caa70d287a6ddb62$var$updatePath(current[part], path, [
                part
            ].concat(traversed));
            return;
        }
        prev = current[part];
        traversed = [
            part
        ].concat(traversed);
    }
    let value = path[0];
    if (typeof value === "function") {
        value = value(prev, traversed);
        if (value === prev) return;
    }
    if (part === undefined && value == undefined) return;
    value = $caa70d287a6ddb62$export$debb760848ca95a(value);
    if (part === undefined || $caa70d287a6ddb62$var$isWrappable(prev) && $caa70d287a6ddb62$var$isWrappable(value) && !Array.isArray(value)) $caa70d287a6ddb62$var$mergeStoreNode(prev, value);
    else $caa70d287a6ddb62$var$setProperty(current, part, value);
}
function $caa70d287a6ddb62$export$f51a9068ac82ea43(...[store, options]) {
    const unwrappedStore = $caa70d287a6ddb62$export$debb760848ca95a(store || {});
    const isArray = Array.isArray(unwrappedStore);
    const wrappedStore = $caa70d287a6ddb62$var$wrap$1(unwrappedStore);
    function setStore(...args) {
        (0, $8863cd8fe199f948$export$712ea50be43a7858)(()=>{
            isArray && args.length === 1 ? $caa70d287a6ddb62$var$updateArray(unwrappedStore, args[0]) : $caa70d287a6ddb62$var$updatePath(unwrappedStore, args);
        });
    }
    return [
        wrappedStore,
        setStore
    ];
}
function $caa70d287a6ddb62$var$proxyDescriptor(target, property) {
    const desc = Reflect.getOwnPropertyDescriptor(target, property);
    if (!desc || desc.get || desc.set || !desc.configurable || property === (0, $8863cd8fe199f948$export$5cd89106e2f6c2c5) || property === $caa70d287a6ddb62$var$$NODE) return desc;
    delete desc.value;
    delete desc.writable;
    desc.get = ()=>target[0, $8863cd8fe199f948$export$5cd89106e2f6c2c5][property];
    desc.set = (v)=>target[0, $8863cd8fe199f948$export$5cd89106e2f6c2c5][property] = v;
    return desc;
}
const $caa70d287a6ddb62$var$proxyTraps = {
    get (target, property, receiver) {
        if (property === $caa70d287a6ddb62$export$9f4df9bfaca7e3b7) return target;
        if (property === (0, $8863cd8fe199f948$export$5cd89106e2f6c2c5)) return receiver;
        if (property === (0, $8863cd8fe199f948$export$17a675b7c02a7b1d)) {
            $caa70d287a6ddb62$var$trackSelf(target);
            return receiver;
        }
        const nodes = $caa70d287a6ddb62$var$getNodes(target, $caa70d287a6ddb62$var$$NODE);
        const tracked = nodes[property];
        let value = tracked ? tracked() : target[property];
        if (property === $caa70d287a6ddb62$var$$NODE || property === $caa70d287a6ddb62$var$$HAS || property === "__proto__") return value;
        if (!tracked) {
            const desc = Object.getOwnPropertyDescriptor(target, property);
            const isFunction = typeof value === "function";
            if ((0, $8863cd8fe199f948$export$12abb5141c6fdc9c)() && (!isFunction || target.hasOwnProperty(property)) && !(desc && desc.get)) value = $caa70d287a6ddb62$var$getNode(nodes, property, value)();
            else if (value != null && isFunction && value === Array.prototype[property]) return (...args)=>(0, $8863cd8fe199f948$export$712ea50be43a7858)(()=>Array.prototype[property].apply(receiver, args));
        }
        return $caa70d287a6ddb62$var$isWrappable(value) ? $caa70d287a6ddb62$var$wrap(value) : value;
    },
    has (target, property) {
        if (property === $caa70d287a6ddb62$export$9f4df9bfaca7e3b7 || property === (0, $8863cd8fe199f948$export$5cd89106e2f6c2c5) || property === (0, $8863cd8fe199f948$export$17a675b7c02a7b1d) || property === $caa70d287a6ddb62$var$$NODE || property === $caa70d287a6ddb62$var$$HAS || property === "__proto__") return true;
        (0, $8863cd8fe199f948$export$12abb5141c6fdc9c)() && $caa70d287a6ddb62$var$getNode($caa70d287a6ddb62$var$getNodes(target, $caa70d287a6ddb62$var$$HAS), property)();
        return property in target;
    },
    set (target, property, value) {
        (0, $8863cd8fe199f948$export$712ea50be43a7858)(()=>$caa70d287a6ddb62$var$setProperty(target, property, $caa70d287a6ddb62$export$debb760848ca95a(value)));
        return true;
    },
    deleteProperty (target, property) {
        (0, $8863cd8fe199f948$export$712ea50be43a7858)(()=>$caa70d287a6ddb62$var$setProperty(target, property, undefined, true));
        return true;
    },
    ownKeys: $caa70d287a6ddb62$var$ownKeys,
    getOwnPropertyDescriptor: $caa70d287a6ddb62$var$proxyDescriptor
};
function $caa70d287a6ddb62$var$wrap(value) {
    let p = value[0, $8863cd8fe199f948$export$5cd89106e2f6c2c5];
    if (!p) {
        Object.defineProperty(value, (0, $8863cd8fe199f948$export$5cd89106e2f6c2c5), {
            value: p = new Proxy(value, $caa70d287a6ddb62$var$proxyTraps)
        });
        const keys = Object.keys(value), desc = Object.getOwnPropertyDescriptors(value);
        const proto = Object.getPrototypeOf(value);
        const isClass = proto !== null && value !== null && typeof value === "object" && !Array.isArray(value) && proto !== Object.prototype;
        if (isClass) {
            let curProto = proto;
            while(curProto != null){
                const descriptors = Object.getOwnPropertyDescriptors(curProto);
                keys.push(...Object.keys(descriptors));
                Object.assign(desc, descriptors);
                curProto = Object.getPrototypeOf(curProto);
            }
        }
        for(let i = 0, l = keys.length; i < l; i++){
            const prop = keys[i];
            if (isClass && prop === "constructor") continue;
            if (desc[prop].get) {
                const get = desc[prop].get.bind(p);
                Object.defineProperty(value, prop, {
                    get: get,
                    configurable: true
                });
            }
            if (desc[prop].set) {
                const og = desc[prop].set, set = (v)=>(0, $8863cd8fe199f948$export$712ea50be43a7858)(()=>og.call(p, v));
                Object.defineProperty(value, prop, {
                    set: set,
                    configurable: true
                });
            }
        }
    }
    return p;
}
function $caa70d287a6ddb62$export$ab7224b136d4492e(state, options) {
    const unwrappedStore = $caa70d287a6ddb62$export$debb760848ca95a(state || {});
    const wrappedStore = $caa70d287a6ddb62$var$wrap(unwrappedStore);
    return wrappedStore;
}
function $caa70d287a6ddb62$export$4939f032d60167b6(state, modifier) {
    (0, $8863cd8fe199f948$export$712ea50be43a7858)(()=>modifier($caa70d287a6ddb62$export$debb760848ca95a(state)));
}
const $caa70d287a6ddb62$var$$ROOT = Symbol("store-root");
function $caa70d287a6ddb62$var$applyState(target, parent, property, merge, key) {
    const previous = parent[property];
    if (target === previous) return;
    const isArray = Array.isArray(target);
    if (property !== $caa70d287a6ddb62$var$$ROOT && (!$caa70d287a6ddb62$var$isWrappable(target) || !$caa70d287a6ddb62$var$isWrappable(previous) || isArray !== Array.isArray(previous) || key && target[key] !== previous[key])) {
        $caa70d287a6ddb62$var$setProperty(parent, property, target);
        return;
    }
    if (isArray) {
        if (target.length && previous.length && (!merge || key && target[0] && target[0][key] != null)) {
            let i, j, start, end, newEnd, item, newIndicesNext, keyVal;
            for(start = 0, end = Math.min(previous.length, target.length); start < end && (previous[start] === target[start] || key && previous[start] && target[start] && previous[start][key] && previous[start][key] === target[start][key]); start++)$caa70d287a6ddb62$var$applyState(target[start], previous, start, merge, key);
            const temp = new Array(target.length), newIndices = new Map();
            for(end = previous.length - 1, newEnd = target.length - 1; end >= start && newEnd >= start && (previous[end] === target[newEnd] || key && previous[end] && target[newEnd] && previous[end][key] && previous[end][key] === target[newEnd][key]); end--, newEnd--)temp[newEnd] = previous[end];
            if (start > newEnd || start > end) {
                for(j = start; j <= newEnd; j++)$caa70d287a6ddb62$var$setProperty(previous, j, target[j]);
                for(; j < target.length; j++){
                    $caa70d287a6ddb62$var$setProperty(previous, j, temp[j]);
                    $caa70d287a6ddb62$var$applyState(target[j], previous, j, merge, key);
                }
                if (previous.length > target.length) $caa70d287a6ddb62$var$setProperty(previous, "length", target.length);
                return;
            }
            newIndicesNext = new Array(newEnd + 1);
            for(j = newEnd; j >= start; j--){
                item = target[j];
                keyVal = key && item ? item[key] : item;
                i = newIndices.get(keyVal);
                newIndicesNext[j] = i === undefined ? -1 : i;
                newIndices.set(keyVal, j);
            }
            for(i = start; i <= end; i++){
                item = previous[i];
                keyVal = key && item ? item[key] : item;
                j = newIndices.get(keyVal);
                if (j !== undefined && j !== -1) {
                    temp[j] = previous[i];
                    j = newIndicesNext[j];
                    newIndices.set(keyVal, j);
                }
            }
            for(j = start; j < target.length; j++)if (j in temp) {
                $caa70d287a6ddb62$var$setProperty(previous, j, temp[j]);
                $caa70d287a6ddb62$var$applyState(target[j], previous, j, merge, key);
            } else $caa70d287a6ddb62$var$setProperty(previous, j, target[j]);
        } else for(let i = 0, len = target.length; i < len; i++)$caa70d287a6ddb62$var$applyState(target[i], previous, i, merge, key);
        if (previous.length > target.length) $caa70d287a6ddb62$var$setProperty(previous, "length", target.length);
        return;
    }
    const targetKeys = Object.keys(target);
    for(let i = 0, len = targetKeys.length; i < len; i++)$caa70d287a6ddb62$var$applyState(target[targetKeys[i]], previous, targetKeys[i], merge, key);
    const previousKeys = Object.keys(previous);
    for(let i = 0, len = previousKeys.length; i < len; i++)if (target[previousKeys[i]] === undefined) $caa70d287a6ddb62$var$setProperty(previous, previousKeys[i], undefined);
}
function $caa70d287a6ddb62$export$38319cad1f6d89e0(value, options = {}) {
    const { merge: merge, key: key = "id" } = options, v = $caa70d287a6ddb62$export$debb760848ca95a(value);
    return (state)=>{
        if (!$caa70d287a6ddb62$var$isWrappable(state) || !$caa70d287a6ddb62$var$isWrappable(v)) return v;
        const res = $caa70d287a6ddb62$var$applyState(v, {
            [$caa70d287a6ddb62$var$$ROOT]: state
        }, $caa70d287a6ddb62$var$$ROOT, merge, key);
        return res === undefined ? state : res;
    };
}
const $caa70d287a6ddb62$var$producers = new WeakMap();
const $caa70d287a6ddb62$var$setterTraps = {
    get (target, property) {
        if (property === $caa70d287a6ddb62$export$9f4df9bfaca7e3b7) return target;
        const value = target[property];
        let proxy;
        return $caa70d287a6ddb62$var$isWrappable(value) ? $caa70d287a6ddb62$var$producers.get(value) || ($caa70d287a6ddb62$var$producers.set(value, proxy = new Proxy(value, $caa70d287a6ddb62$var$setterTraps)), proxy) : value;
    },
    set (target, property, value) {
        $caa70d287a6ddb62$var$setProperty(target, property, $caa70d287a6ddb62$export$debb760848ca95a(value));
        return true;
    },
    deleteProperty (target, property) {
        $caa70d287a6ddb62$var$setProperty(target, property, undefined, true);
        return true;
    }
};
function $caa70d287a6ddb62$export$b46cabe22e78bc00(fn) {
    return (state)=>{
        if ($caa70d287a6ddb62$var$isWrappable(state)) {
            let proxy;
            if (!(proxy = $caa70d287a6ddb62$var$producers.get(state))) $caa70d287a6ddb62$var$producers.set(state, proxy = new Proxy(state, $caa70d287a6ddb62$var$setterTraps));
            fn(proxy);
        }
        return state;
    };
}
const $caa70d287a6ddb62$export$404582bc18fe4d9e = undefined;



const $b417fd17fc84e4e3$export$c169aefb7330cccb = Object.create(null); // no Map = no polyfill
$b417fd17fc84e4e3$export$c169aefb7330cccb["open"] = "0";
$b417fd17fc84e4e3$export$c169aefb7330cccb["close"] = "1";
$b417fd17fc84e4e3$export$c169aefb7330cccb["ping"] = "2";
$b417fd17fc84e4e3$export$c169aefb7330cccb["pong"] = "3";
$b417fd17fc84e4e3$export$c169aefb7330cccb["message"] = "4";
$b417fd17fc84e4e3$export$c169aefb7330cccb["upgrade"] = "5";
$b417fd17fc84e4e3$export$c169aefb7330cccb["noop"] = "6";
const $b417fd17fc84e4e3$export$47791e8004edd485 = Object.create(null);
Object.keys($b417fd17fc84e4e3$export$c169aefb7330cccb).forEach((key)=>{
    $b417fd17fc84e4e3$export$47791e8004edd485[$b417fd17fc84e4e3$export$c169aefb7330cccb[key]] = key;
});
const $b417fd17fc84e4e3$export$c718b5840781f8a7 = {
    type: "error",
    data: "parser error"
};


const $8a3662315a48cdbd$var$withNativeBlob = typeof Blob === "function" || typeof Blob !== "undefined" && Object.prototype.toString.call(Blob) === "[object BlobConstructor]";
const $8a3662315a48cdbd$var$withNativeArrayBuffer = typeof ArrayBuffer === "function";
// ArrayBuffer.isView method is not defined in IE10
const $8a3662315a48cdbd$var$isView = (obj)=>{
    return typeof ArrayBuffer.isView === "function" ? ArrayBuffer.isView(obj) : obj && obj.buffer instanceof ArrayBuffer;
};
const $8a3662315a48cdbd$export$57852049361a8e62 = ({ type: type, data: data }, supportsBinary, callback)=>{
    if ($8a3662315a48cdbd$var$withNativeBlob && data instanceof Blob) {
        if (supportsBinary) return callback(data);
        else return $8a3662315a48cdbd$var$encodeBlobAsBase64(data, callback);
    } else if ($8a3662315a48cdbd$var$withNativeArrayBuffer && (data instanceof ArrayBuffer || $8a3662315a48cdbd$var$isView(data))) {
        if (supportsBinary) return callback(data);
        else return $8a3662315a48cdbd$var$encodeBlobAsBase64(new Blob([
            data
        ]), callback);
    }
    // plain string
    return callback((0, $b417fd17fc84e4e3$export$c169aefb7330cccb)[type] + (data || ""));
};
const $8a3662315a48cdbd$var$encodeBlobAsBase64 = (data, callback)=>{
    const fileReader = new FileReader();
    fileReader.onload = function() {
        const content = fileReader.result.split(",")[1];
        callback("b" + (content || ""));
    };
    return fileReader.readAsDataURL(data);
};
function $8a3662315a48cdbd$var$toArray(data) {
    if (data instanceof Uint8Array) return data;
    else if (data instanceof ArrayBuffer) return new Uint8Array(data);
    else return new Uint8Array(data.buffer, data.byteOffset, data.byteLength);
}
let $8a3662315a48cdbd$var$TEXT_ENCODER;
function $8a3662315a48cdbd$export$ec0c9b9013ee0ef5(packet, callback) {
    if ($8a3662315a48cdbd$var$withNativeBlob && packet.data instanceof Blob) return packet.data.arrayBuffer().then($8a3662315a48cdbd$var$toArray).then(callback);
    else if ($8a3662315a48cdbd$var$withNativeArrayBuffer && (packet.data instanceof ArrayBuffer || $8a3662315a48cdbd$var$isView(packet.data))) return callback($8a3662315a48cdbd$var$toArray(packet.data));
    $8a3662315a48cdbd$export$57852049361a8e62(packet, false, (encoded)=>{
        if (!$8a3662315a48cdbd$var$TEXT_ENCODER) $8a3662315a48cdbd$var$TEXT_ENCODER = new TextEncoder();
        callback($8a3662315a48cdbd$var$TEXT_ENCODER.encode(encoded));
    });
}



// imported from https://github.com/socketio/base64-arraybuffer
const $7f4e842ae29bcbc5$var$chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
// Use a lookup table to find the index.
const $7f4e842ae29bcbc5$var$lookup = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
for(let i = 0; i < $7f4e842ae29bcbc5$var$chars.length; i++)$7f4e842ae29bcbc5$var$lookup[$7f4e842ae29bcbc5$var$chars.charCodeAt(i)] = i;
const $7f4e842ae29bcbc5$export$c564cdbbe6da493 = (arraybuffer)=>{
    let bytes = new Uint8Array(arraybuffer), i, len = bytes.length, base64 = '';
    for(i = 0; i < len; i += 3){
        base64 += $7f4e842ae29bcbc5$var$chars[bytes[i] >> 2];
        base64 += $7f4e842ae29bcbc5$var$chars[(bytes[i] & 3) << 4 | bytes[i + 1] >> 4];
        base64 += $7f4e842ae29bcbc5$var$chars[(bytes[i + 1] & 15) << 2 | bytes[i + 2] >> 6];
        base64 += $7f4e842ae29bcbc5$var$chars[bytes[i + 2] & 63];
    }
    if (len % 3 === 2) base64 = base64.substring(0, base64.length - 1) + '=';
    else if (len % 3 === 1) base64 = base64.substring(0, base64.length - 2) + '==';
    return base64;
};
const $7f4e842ae29bcbc5$export$2f872c0f2117be69 = (base64)=>{
    let bufferLength = base64.length * 0.75, len = base64.length, i, p = 0, encoded1, encoded2, encoded3, encoded4;
    if (base64[base64.length - 1] === '=') {
        bufferLength--;
        if (base64[base64.length - 2] === '=') bufferLength--;
    }
    const arraybuffer = new ArrayBuffer(bufferLength), bytes = new Uint8Array(arraybuffer);
    for(i = 0; i < len; i += 4){
        encoded1 = $7f4e842ae29bcbc5$var$lookup[base64.charCodeAt(i)];
        encoded2 = $7f4e842ae29bcbc5$var$lookup[base64.charCodeAt(i + 1)];
        encoded3 = $7f4e842ae29bcbc5$var$lookup[base64.charCodeAt(i + 2)];
        encoded4 = $7f4e842ae29bcbc5$var$lookup[base64.charCodeAt(i + 3)];
        bytes[p++] = encoded1 << 2 | encoded2 >> 4;
        bytes[p++] = (encoded2 & 15) << 4 | encoded3 >> 2;
        bytes[p++] = (encoded3 & 3) << 6 | encoded4 & 63;
    }
    return arraybuffer;
};


const $a9bf3da28855a34f$var$withNativeArrayBuffer = typeof ArrayBuffer === "function";
const $a9bf3da28855a34f$export$4647901878f33f31 = (encodedPacket, binaryType)=>{
    if (typeof encodedPacket !== "string") return {
        type: "message",
        data: $a9bf3da28855a34f$var$mapBinary(encodedPacket, binaryType)
    };
    const type = encodedPacket.charAt(0);
    if (type === "b") return {
        type: "message",
        data: $a9bf3da28855a34f$var$decodeBase64Packet(encodedPacket.substring(1), binaryType)
    };
    const packetType = (0, $b417fd17fc84e4e3$export$47791e8004edd485)[type];
    if (!packetType) return 0, $b417fd17fc84e4e3$export$c718b5840781f8a7;
    return encodedPacket.length > 1 ? {
        type: (0, $b417fd17fc84e4e3$export$47791e8004edd485)[type],
        data: encodedPacket.substring(1)
    } : {
        type: (0, $b417fd17fc84e4e3$export$47791e8004edd485)[type]
    };
};
const $a9bf3da28855a34f$var$decodeBase64Packet = (data, binaryType)=>{
    if ($a9bf3da28855a34f$var$withNativeArrayBuffer) {
        const decoded = (0, $7f4e842ae29bcbc5$export$2f872c0f2117be69)(data);
        return $a9bf3da28855a34f$var$mapBinary(decoded, binaryType);
    } else return {
        base64: true,
        data: data
    }; // fallback for old browsers
};
const $a9bf3da28855a34f$var$mapBinary = (data, binaryType)=>{
    switch(binaryType){
        case "blob":
            if (data instanceof Blob) // from WebSocket + binaryType "blob"
            return data;
            else // from HTTP long-polling or WebTransport
            return new Blob([
                data
            ]);
        case "arraybuffer":
        default:
            if (data instanceof ArrayBuffer) // from HTTP long-polling (base64) or WebSocket + binaryType "arraybuffer"
            return data;
            else // from WebTransport (Uint8Array)
            return data.buffer;
    }
};



const $0736208648dc8bae$var$SEPARATOR = String.fromCharCode(30); // see https://en.wikipedia.org/wiki/Delimiter#ASCII_delimited_text
const $0736208648dc8bae$export$144d64fe58dad441 = (packets, callback)=>{
    // some packets may be added to the array while encoding, so the initial length must be saved
    const length = packets.length;
    const encodedPackets = new Array(length);
    let count = 0;
    packets.forEach((packet, i)=>{
        // force base64 encoding for binary packets
        (0, $8a3662315a48cdbd$export$57852049361a8e62)(packet, false, (encodedPacket)=>{
            encodedPackets[i] = encodedPacket;
            if (++count === length) callback(encodedPackets.join($0736208648dc8bae$var$SEPARATOR));
        });
    });
};
const $0736208648dc8bae$export$d10cc2e7f7566a2d = (encodedPayload, binaryType)=>{
    const encodedPackets = encodedPayload.split($0736208648dc8bae$var$SEPARATOR);
    const packets = [];
    for(let i = 0; i < encodedPackets.length; i++){
        const decodedPacket = (0, $a9bf3da28855a34f$export$4647901878f33f31)(encodedPackets[i], binaryType);
        packets.push(decodedPacket);
        if (decodedPacket.type === "error") break;
    }
    return packets;
};
function $0736208648dc8bae$export$a525fb718e9c623a() {
    return new TransformStream({
        transform (packet, controller) {
            (0, $8a3662315a48cdbd$export$ec0c9b9013ee0ef5)(packet, (encodedPacket)=>{
                const payloadLength = encodedPacket.length;
                let header;
                // inspired by the WebSocket format: https://developer.mozilla.org/en-US/docs/Web/API/WebSockets_API/Writing_WebSocket_servers#decoding_payload_length
                if (payloadLength < 126) {
                    header = new Uint8Array(1);
                    new DataView(header.buffer).setUint8(0, payloadLength);
                } else if (payloadLength < 65536) {
                    header = new Uint8Array(3);
                    const view = new DataView(header.buffer);
                    view.setUint8(0, 126);
                    view.setUint16(1, payloadLength);
                } else {
                    header = new Uint8Array(9);
                    const view = new DataView(header.buffer);
                    view.setUint8(0, 127);
                    view.setBigUint64(1, BigInt(payloadLength));
                }
                // first bit indicates whether the payload is plain text (0) or binary (1)
                if (packet.data && typeof packet.data !== "string") header[0] |= 0x80;
                controller.enqueue(header);
                controller.enqueue(encodedPacket);
            });
        }
    });
}
let $0736208648dc8bae$var$TEXT_DECODER;
function $0736208648dc8bae$var$totalLength(chunks) {
    return chunks.reduce((acc, chunk)=>acc + chunk.length, 0);
}
function $0736208648dc8bae$var$concatChunks(chunks, size) {
    if (chunks[0].length === size) return chunks.shift();
    const buffer = new Uint8Array(size);
    let j = 0;
    for(let i = 0; i < size; i++){
        buffer[i] = chunks[0][j++];
        if (j === chunks[0].length) {
            chunks.shift();
            j = 0;
        }
    }
    if (chunks.length && j < chunks[0].length) chunks[0] = chunks[0].slice(j);
    return buffer;
}
function $0736208648dc8bae$export$552d20aac7500f47(maxPayload, binaryType) {
    if (!$0736208648dc8bae$var$TEXT_DECODER) $0736208648dc8bae$var$TEXT_DECODER = new TextDecoder();
    const chunks = [];
    let state = 0 /* State.READ_HEADER */ ;
    let expectedLength = -1;
    let isBinary = false;
    return new TransformStream({
        transform (chunk, controller) {
            chunks.push(chunk);
            while(true){
                if (state === 0 /* State.READ_HEADER */ ) {
                    if ($0736208648dc8bae$var$totalLength(chunks) < 1) break;
                    const header = $0736208648dc8bae$var$concatChunks(chunks, 1);
                    isBinary = (header[0] & 0x80) === 0x80;
                    expectedLength = header[0] & 0x7f;
                    if (expectedLength < 126) state = 3 /* State.READ_PAYLOAD */ ;
                    else if (expectedLength === 126) state = 1 /* State.READ_EXTENDED_LENGTH_16 */ ;
                    else state = 2 /* State.READ_EXTENDED_LENGTH_64 */ ;
                } else if (state === 1 /* State.READ_EXTENDED_LENGTH_16 */ ) {
                    if ($0736208648dc8bae$var$totalLength(chunks) < 2) break;
                    const headerArray = $0736208648dc8bae$var$concatChunks(chunks, 2);
                    expectedLength = new DataView(headerArray.buffer, headerArray.byteOffset, headerArray.length).getUint16(0);
                    state = 3 /* State.READ_PAYLOAD */ ;
                } else if (state === 2 /* State.READ_EXTENDED_LENGTH_64 */ ) {
                    if ($0736208648dc8bae$var$totalLength(chunks) < 8) break;
                    const headerArray = $0736208648dc8bae$var$concatChunks(chunks, 8);
                    const view = new DataView(headerArray.buffer, headerArray.byteOffset, headerArray.length);
                    const n = view.getUint32(0);
                    if (n > Math.pow(2, 21) - 1) {
                        // the maximum safe integer in JavaScript is 2^53 - 1
                        controller.enqueue((0, $b417fd17fc84e4e3$export$c718b5840781f8a7));
                        break;
                    }
                    expectedLength = n * Math.pow(2, 32) + view.getUint32(4);
                    state = 3 /* State.READ_PAYLOAD */ ;
                } else {
                    if ($0736208648dc8bae$var$totalLength(chunks) < expectedLength) break;
                    const data = $0736208648dc8bae$var$concatChunks(chunks, expectedLength);
                    controller.enqueue((0, $a9bf3da28855a34f$export$4647901878f33f31)(isBinary ? data : $0736208648dc8bae$var$TEXT_DECODER.decode(data), binaryType));
                    state = 0 /* State.READ_HEADER */ ;
                }
                if (expectedLength === 0 || expectedLength > maxPayload) {
                    controller.enqueue((0, $b417fd17fc84e4e3$export$c718b5840781f8a7));
                    break;
                }
            }
        }
    });
}
const $0736208648dc8bae$export$a51d6b395ff4c65a = 4;


/**
 * Initialize a new `Emitter`.
 *
 * @api public
 */ function $3d905a8ca243a015$export$4293555f241ae35a(obj) {
    if (obj) return $3d905a8ca243a015$var$mixin(obj);
}
/**
 * Mixin the emitter properties.
 *
 * @param {Object} obj
 * @return {Object}
 * @api private
 */ function $3d905a8ca243a015$var$mixin(obj) {
    for(var key in $3d905a8ca243a015$export$4293555f241ae35a.prototype)obj[key] = $3d905a8ca243a015$export$4293555f241ae35a.prototype[key];
    return obj;
}
/**
 * Listen on the given `event` with `fn`.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */ $3d905a8ca243a015$export$4293555f241ae35a.prototype.on = $3d905a8ca243a015$export$4293555f241ae35a.prototype.addEventListener = function(event, fn) {
    this._callbacks = this._callbacks || {};
    (this._callbacks['$' + event] = this._callbacks['$' + event] || []).push(fn);
    return this;
};
/**
 * Adds an `event` listener that will be invoked a single
 * time then automatically removed.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */ $3d905a8ca243a015$export$4293555f241ae35a.prototype.once = function(event, fn) {
    function on() {
        this.off(event, on);
        fn.apply(this, arguments);
    }
    on.fn = fn;
    this.on(event, on);
    return this;
};
/**
 * Remove the given callback for `event` or all
 * registered callbacks.
 *
 * @param {String} event
 * @param {Function} fn
 * @return {Emitter}
 * @api public
 */ $3d905a8ca243a015$export$4293555f241ae35a.prototype.off = $3d905a8ca243a015$export$4293555f241ae35a.prototype.removeListener = $3d905a8ca243a015$export$4293555f241ae35a.prototype.removeAllListeners = $3d905a8ca243a015$export$4293555f241ae35a.prototype.removeEventListener = function(event, fn) {
    this._callbacks = this._callbacks || {};
    // all
    if (0 == arguments.length) {
        this._callbacks = {};
        return this;
    }
    // specific event
    var callbacks = this._callbacks['$' + event];
    if (!callbacks) return this;
    // remove all handlers
    if (1 == arguments.length) {
        delete this._callbacks['$' + event];
        return this;
    }
    // remove specific handler
    var cb;
    for(var i = 0; i < callbacks.length; i++){
        cb = callbacks[i];
        if (cb === fn || cb.fn === fn) {
            callbacks.splice(i, 1);
            break;
        }
    }
    // Remove event specific arrays for event types that no
    // one is subscribed for to avoid memory leak.
    if (callbacks.length === 0) delete this._callbacks['$' + event];
    return this;
};
/**
 * Emit `event` with the given args.
 *
 * @param {String} event
 * @param {Mixed} ...
 * @return {Emitter}
 */ $3d905a8ca243a015$export$4293555f241ae35a.prototype.emit = function(event) {
    this._callbacks = this._callbacks || {};
    var args = new Array(arguments.length - 1), callbacks = this._callbacks['$' + event];
    for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    if (callbacks) {
        callbacks = callbacks.slice(0);
        for(var i = 0, len = callbacks.length; i < len; ++i)callbacks[i].apply(this, args);
    }
    return this;
};
// alias used for reserved events (protected method)
$3d905a8ca243a015$export$4293555f241ae35a.prototype.emitReserved = $3d905a8ca243a015$export$4293555f241ae35a.prototype.emit;
/**
 * Return array of callbacks for `event`.
 *
 * @param {String} event
 * @return {Array}
 * @api public
 */ $3d905a8ca243a015$export$4293555f241ae35a.prototype.listeners = function(event) {
    this._callbacks = this._callbacks || {};
    return this._callbacks['$' + event] || [];
};
/**
 * Check if this emitter has `event` handlers.
 *
 * @param {String} event
 * @return {Boolean}
 * @api public
 */ $3d905a8ca243a015$export$4293555f241ae35a.prototype.hasListeners = function(event) {
    return !!this.listeners(event).length;
};


const $8959bb304e43f43f$export$bdd553fddd433dcb = (()=>{
    const isPromiseAvailable = typeof Promise === "function" && typeof Promise.resolve === "function";
    if (isPromiseAvailable) return (cb)=>Promise.resolve().then(cb);
    else return (cb, setTimeoutFn)=>setTimeoutFn(cb, 0);
})();
const $8959bb304e43f43f$export$394f9358f6231289 = (()=>{
    if (typeof self !== "undefined") return self;
    else if (typeof window !== "undefined") return window;
    else return Function("return this")();
})();
const $8959bb304e43f43f$export$790dcbc41e2d75d5 = "arraybuffer";
function $8959bb304e43f43f$export$19413efcf2fac759() {}


function $4028d5a20a4526d1$export$357523c63a2253b9(obj, ...attr) {
    return attr.reduce((acc, k)=>{
        if (obj.hasOwnProperty(k)) acc[k] = obj[k];
        return acc;
    }, {});
}
// Keep a reference to the real timeout functions so they can be used when overridden
const $4028d5a20a4526d1$var$NATIVE_SET_TIMEOUT = (0, $8959bb304e43f43f$export$394f9358f6231289).setTimeout;
const $4028d5a20a4526d1$var$NATIVE_CLEAR_TIMEOUT = (0, $8959bb304e43f43f$export$394f9358f6231289).clearTimeout;
function $4028d5a20a4526d1$export$2f67576668b97183(obj, opts) {
    if (opts.useNativeTimers) {
        obj.setTimeoutFn = $4028d5a20a4526d1$var$NATIVE_SET_TIMEOUT.bind((0, $8959bb304e43f43f$export$394f9358f6231289));
        obj.clearTimeoutFn = $4028d5a20a4526d1$var$NATIVE_CLEAR_TIMEOUT.bind((0, $8959bb304e43f43f$export$394f9358f6231289));
    } else {
        obj.setTimeoutFn = (0, $8959bb304e43f43f$export$394f9358f6231289).setTimeout.bind((0, $8959bb304e43f43f$export$394f9358f6231289));
        obj.clearTimeoutFn = (0, $8959bb304e43f43f$export$394f9358f6231289).clearTimeout.bind((0, $8959bb304e43f43f$export$394f9358f6231289));
    }
}
// base64 encoded buffers are about 33% bigger (https://en.wikipedia.org/wiki/Base64)
const $4028d5a20a4526d1$var$BASE64_OVERHEAD = 1.33;
function $4028d5a20a4526d1$export$a48f0734ac7c2329(obj) {
    if (typeof obj === "string") return $4028d5a20a4526d1$var$utf8Length(obj);
    // arraybuffer or blob
    return Math.ceil((obj.byteLength || obj.size) * $4028d5a20a4526d1$var$BASE64_OVERHEAD);
}
function $4028d5a20a4526d1$var$utf8Length(str) {
    let c = 0, length = 0;
    for(let i = 0, l = str.length; i < l; i++){
        c = str.charCodeAt(i);
        if (c < 0x80) length += 1;
        else if (c < 0x800) length += 2;
        else if (c < 0xd800 || c >= 0xe000) length += 3;
        else {
            i++;
            length += 4;
        }
    }
    return length;
}
function $4028d5a20a4526d1$export$7fa8378418b4411e() {
    return Date.now().toString(36).substring(3) + Math.random().toString(36).substring(2, 5);
}


// imported from https://github.com/galkn/querystring
/**
 * Compiles a querystring
 * Returns string representation of the object
 *
 * @param {Object}
 * @api private
 */ function $19744bce3c183d10$export$c564cdbbe6da493(obj) {
    let str = '';
    for(let i in obj)if (obj.hasOwnProperty(i)) {
        if (str.length) str += '&';
        str += encodeURIComponent(i) + '=' + encodeURIComponent(obj[i]);
    }
    return str;
}
function $19744bce3c183d10$export$2f872c0f2117be69(qs) {
    let qry = {};
    let pairs = qs.split('&');
    for(let i = 0, l = pairs.length; i < l; i++){
        let pair = pairs[i].split('=');
        qry[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1]);
    }
    return qry;
}


class $4a78f487f5bb98d8$export$8e68de6fb26f2236 extends Error {
    constructor(reason, description, context){
        super(reason);
        this.description = description;
        this.context = context;
        this.type = "TransportError";
    }
}
class $4a78f487f5bb98d8$export$86495b081fef8e52 extends (0, $3d905a8ca243a015$export$4293555f241ae35a) {
    /**
     * Transport abstract constructor.
     *
     * @param {Object} opts - options
     * @protected
     */ constructor(opts){
        super();
        this.writable = false;
        (0, $4028d5a20a4526d1$export$2f67576668b97183)(this, opts);
        this.opts = opts;
        this.query = opts.query;
        this.socket = opts.socket;
        this.supportsBinary = !opts.forceBase64;
    }
    /**
     * Emits an error.
     *
     * @param {String} reason
     * @param description
     * @param context - the error context
     * @return {Transport} for chaining
     * @protected
     */ onError(reason, description, context) {
        super.emitReserved("error", new $4a78f487f5bb98d8$export$8e68de6fb26f2236(reason, description, context));
        return this;
    }
    /**
     * Opens the transport.
     */ open() {
        this.readyState = "opening";
        this.doOpen();
        return this;
    }
    /**
     * Closes the transport.
     */ close() {
        if (this.readyState === "opening" || this.readyState === "open") {
            this.doClose();
            this.onClose();
        }
        return this;
    }
    /**
     * Sends multiple packets.
     *
     * @param {Array} packets
     */ send(packets) {
        if (this.readyState === "open") this.write(packets);
    }
    /**
     * Called upon open
     *
     * @protected
     */ onOpen() {
        this.readyState = "open";
        this.writable = true;
        super.emitReserved("open");
    }
    /**
     * Called with data.
     *
     * @param {String} data
     * @protected
     */ onData(data) {
        const packet = (0, $a9bf3da28855a34f$export$4647901878f33f31)(data, this.socket.binaryType);
        this.onPacket(packet);
    }
    /**
     * Called with a decoded packet.
     *
     * @protected
     */ onPacket(packet) {
        super.emitReserved("packet", packet);
    }
    /**
     * Called upon close.
     *
     * @protected
     */ onClose(details) {
        this.readyState = "closed";
        super.emitReserved("close", details);
    }
    /**
     * Pauses the transport, in order not to lose packets during an upgrade.
     *
     * @param onPause
     */ pause(onPause) {}
    createUri(schema, query = {}) {
        return schema + "://" + this._hostname() + this._port() + this.opts.path + this._query(query);
    }
    _hostname() {
        const hostname = this.opts.hostname;
        return hostname.indexOf(":") === -1 ? hostname : "[" + hostname + "]";
    }
    _port() {
        if (this.opts.port && (this.opts.secure && Number(this.opts.port !== 443) || !this.opts.secure && Number(this.opts.port) !== 80)) return ":" + this.opts.port;
        else return "";
    }
    _query(query) {
        const encodedQuery = (0, $19744bce3c183d10$export$c564cdbbe6da493)(query);
        return encodedQuery.length ? "?" + encodedQuery : "";
    }
}




class $56534be56e5aa809$export$265ee5eefd4c309b extends (0, $4a78f487f5bb98d8$export$86495b081fef8e52) {
    constructor(){
        super(...arguments);
        this._polling = false;
    }
    get name() {
        return "polling";
    }
    /**
     * Opens the socket (triggers polling). We write a PING message to determine
     * when the transport is open.
     *
     * @protected
     */ doOpen() {
        this._poll();
    }
    /**
     * Pauses polling.
     *
     * @param {Function} onPause - callback upon buffers are flushed and transport is paused
     * @package
     */ pause(onPause) {
        this.readyState = "pausing";
        const pause = ()=>{
            this.readyState = "paused";
            onPause();
        };
        if (this._polling || !this.writable) {
            let total = 0;
            if (this._polling) {
                total++;
                this.once("pollComplete", function() {
                    --total || pause();
                });
            }
            if (!this.writable) {
                total++;
                this.once("drain", function() {
                    --total || pause();
                });
            }
        } else pause();
    }
    /**
     * Starts polling cycle.
     *
     * @private
     */ _poll() {
        this._polling = true;
        this.doPoll();
        this.emitReserved("poll");
    }
    /**
     * Overloads onData to detect payloads.
     *
     * @protected
     */ onData(data) {
        const callback = (packet)=>{
            // if its the first message we consider the transport open
            if ("opening" === this.readyState && packet.type === "open") this.onOpen();
            // if its a close packet, we close the ongoing requests
            if ("close" === packet.type) {
                this.onClose({
                    description: "transport closed by the server"
                });
                return false;
            }
            // otherwise bypass onData and handle the message
            this.onPacket(packet);
        };
        // decode payload
        (0, $0736208648dc8bae$export$d10cc2e7f7566a2d)(data, this.socket.binaryType).forEach(callback);
        // if an event did not trigger closing
        if ("closed" !== this.readyState) {
            // if we got data we're not polling
            this._polling = false;
            this.emitReserved("pollComplete");
            if ("open" === this.readyState) this._poll();
        }
    }
    /**
     * For polling, send a close packet.
     *
     * @protected
     */ doClose() {
        const close = ()=>{
            this.write([
                {
                    type: "close"
                }
            ]);
        };
        if ("open" === this.readyState) close();
        else // in case we're trying to close while
        // handshaking is in progress (GH-164)
        this.once("open", close);
    }
    /**
     * Writes a packets payload.
     *
     * @param {Array} packets - data packets
     * @protected
     */ write(packets) {
        this.writable = false;
        (0, $0736208648dc8bae$export$144d64fe58dad441)(packets, (data)=>{
            this.doWrite(data, ()=>{
                this.writable = true;
                this.emitReserved("drain");
            });
        });
    }
    /**
     * Generates uri for connection.
     *
     * @private
     */ uri() {
        const schema = this.opts.secure ? "https" : "http";
        const query = this.query || {};
        // cache busting is forced
        if (false !== this.opts.timestampRequests) query[this.opts.timestampParam] = (0, $4028d5a20a4526d1$export$7fa8378418b4411e)();
        if (!this.supportsBinary && !query.sid) query.b64 = 1;
        return this.createUri(schema, query);
    }
}





// imported from https://github.com/component/has-cors
let $ef3f42a25dd224af$var$value = false;
try {
    $ef3f42a25dd224af$var$value = typeof XMLHttpRequest !== 'undefined' && 'withCredentials' in new XMLHttpRequest();
} catch (err) {
// if XMLHttp support is disabled in IE then it will throw
// when trying to create
}
const $ef3f42a25dd224af$export$5235bbd4a1ef06e = $ef3f42a25dd224af$var$value;


function $2ddd02863faa1587$var$empty() {}
class $2ddd02863faa1587$export$c959f2344155d309 extends (0, $56534be56e5aa809$export$265ee5eefd4c309b) {
    /**
     * XHR Polling constructor.
     *
     * @param {Object} opts
     * @package
     */ constructor(opts){
        super(opts);
        if (typeof location !== "undefined") {
            const isSSL = "https:" === location.protocol;
            let port = location.port;
            // some user agents have empty `location.port`
            if (!port) port = isSSL ? "443" : "80";
            this.xd = typeof location !== "undefined" && opts.hostname !== location.hostname || port !== opts.port;
        }
    }
    /**
     * Sends data.
     *
     * @param {String} data to send.
     * @param {Function} called upon flush.
     * @private
     */ doWrite(data, fn) {
        const req = this.request({
            method: "POST",
            data: data
        });
        req.on("success", fn);
        req.on("error", (xhrStatus, context)=>{
            this.onError("xhr post error", xhrStatus, context);
        });
    }
    /**
     * Starts a poll cycle.
     *
     * @private
     */ doPoll() {
        const req = this.request();
        req.on("data", this.onData.bind(this));
        req.on("error", (xhrStatus, context)=>{
            this.onError("xhr poll error", xhrStatus, context);
        });
        this.pollXhr = req;
    }
}
class $2ddd02863faa1587$export$7fa6c5b6f8193917 extends (0, $3d905a8ca243a015$export$4293555f241ae35a) {
    /**
     * Request constructor
     *
     * @param {Object} options
     * @package
     */ constructor(createRequest, uri, opts){
        super();
        this.createRequest = createRequest;
        (0, $4028d5a20a4526d1$export$2f67576668b97183)(this, opts);
        this._opts = opts;
        this._method = opts.method || "GET";
        this._uri = uri;
        this._data = undefined !== opts.data ? opts.data : null;
        this._create();
    }
    /**
     * Creates the XHR object and sends the request.
     *
     * @private
     */ _create() {
        var _a;
        const opts = (0, $4028d5a20a4526d1$export$357523c63a2253b9)(this._opts, "agent", "pfx", "key", "passphrase", "cert", "ca", "ciphers", "rejectUnauthorized", "autoUnref");
        opts.xdomain = !!this._opts.xd;
        const xhr = this._xhr = this.createRequest(opts);
        try {
            xhr.open(this._method, this._uri, true);
            try {
                if (this._opts.extraHeaders) {
                    // @ts-ignore
                    xhr.setDisableHeaderCheck && xhr.setDisableHeaderCheck(true);
                    for(let i in this._opts.extraHeaders)if (this._opts.extraHeaders.hasOwnProperty(i)) xhr.setRequestHeader(i, this._opts.extraHeaders[i]);
                }
            } catch (e) {}
            if ("POST" === this._method) try {
                xhr.setRequestHeader("Content-type", "text/plain;charset=UTF-8");
            } catch (e) {}
            try {
                xhr.setRequestHeader("Accept", "*/*");
            } catch (e) {}
            (_a = this._opts.cookieJar) === null || _a === void 0 || _a.addCookies(xhr);
            // ie6 check
            if ("withCredentials" in xhr) xhr.withCredentials = this._opts.withCredentials;
            if (this._opts.requestTimeout) xhr.timeout = this._opts.requestTimeout;
            xhr.onreadystatechange = ()=>{
                var _a;
                if (xhr.readyState === 3) (_a = this._opts.cookieJar) === null || _a === void 0 || _a.parseCookies(// @ts-ignore
                xhr.getResponseHeader("set-cookie"));
                if (4 !== xhr.readyState) return;
                if (200 === xhr.status || 1223 === xhr.status) this._onLoad();
                else // make sure the `error` event handler that's user-set
                // does not throw in the same tick and gets caught here
                this.setTimeoutFn(()=>{
                    this._onError(typeof xhr.status === "number" ? xhr.status : 0);
                }, 0);
            };
            xhr.send(this._data);
        } catch (e) {
            // Need to defer since .create() is called directly from the constructor
            // and thus the 'error' event can only be only bound *after* this exception
            // occurs.  Therefore, also, we cannot throw here at all.
            this.setTimeoutFn(()=>{
                this._onError(e);
            }, 0);
            return;
        }
        if (typeof document !== "undefined") {
            this._index = $2ddd02863faa1587$export$7fa6c5b6f8193917.requestsCount++;
            $2ddd02863faa1587$export$7fa6c5b6f8193917.requests[this._index] = this;
        }
    }
    /**
     * Called upon error.
     *
     * @private
     */ _onError(err) {
        this.emitReserved("error", err, this._xhr);
        this._cleanup(true);
    }
    /**
     * Cleans up house.
     *
     * @private
     */ _cleanup(fromError) {
        if ("undefined" === typeof this._xhr || null === this._xhr) return;
        this._xhr.onreadystatechange = $2ddd02863faa1587$var$empty;
        if (fromError) try {
            this._xhr.abort();
        } catch (e) {}
        if (typeof document !== "undefined") delete $2ddd02863faa1587$export$7fa6c5b6f8193917.requests[this._index];
        this._xhr = null;
    }
    /**
     * Called upon load.
     *
     * @private
     */ _onLoad() {
        const data = this._xhr.responseText;
        if (data !== null) {
            this.emitReserved("data", data);
            this.emitReserved("success");
            this._cleanup();
        }
    }
    /**
     * Aborts the request.
     *
     * @package
     */ abort() {
        this._cleanup();
    }
}
$2ddd02863faa1587$export$7fa6c5b6f8193917.requestsCount = 0;
$2ddd02863faa1587$export$7fa6c5b6f8193917.requests = {};
/**
 * Aborts pending requests when unloading the window. This is needed to prevent
 * memory leaks (e.g. when using IE) and to ensure that no spurious error is
 * emitted.
 */ if (typeof document !== "undefined") {
    // @ts-ignore
    if (typeof attachEvent === "function") // @ts-ignore
    attachEvent("onunload", $2ddd02863faa1587$var$unloadHandler);
    else if (typeof addEventListener === "function") {
        const terminationEvent = "onpagehide" in (0, $8959bb304e43f43f$export$394f9358f6231289) ? "pagehide" : "unload";
        addEventListener(terminationEvent, $2ddd02863faa1587$var$unloadHandler, false);
    }
}
function $2ddd02863faa1587$var$unloadHandler() {
    for(let i in $2ddd02863faa1587$export$7fa6c5b6f8193917.requests)if ($2ddd02863faa1587$export$7fa6c5b6f8193917.requests.hasOwnProperty(i)) $2ddd02863faa1587$export$7fa6c5b6f8193917.requests[i].abort();
}
const $2ddd02863faa1587$var$hasXHR2 = function() {
    const xhr = $2ddd02863faa1587$var$newRequest({
        xdomain: false
    });
    return xhr && xhr.responseType !== null;
}();
class $2ddd02863faa1587$export$a2d42eb087c10497 extends $2ddd02863faa1587$export$c959f2344155d309 {
    constructor(opts){
        super(opts);
        const forceBase64 = opts && opts.forceBase64;
        this.supportsBinary = $2ddd02863faa1587$var$hasXHR2 && !forceBase64;
    }
    request(opts = {}) {
        Object.assign(opts, {
            xd: this.xd
        }, this.opts);
        return new $2ddd02863faa1587$export$7fa6c5b6f8193917($2ddd02863faa1587$var$newRequest, this.uri(), opts);
    }
}
function $2ddd02863faa1587$var$newRequest(opts) {
    const xdomain = opts.xdomain;
    // XMLHttpRequest can be disabled on IE
    try {
        if ("undefined" !== typeof XMLHttpRequest && (!xdomain || (0, $ef3f42a25dd224af$export$5235bbd4a1ef06e))) return new XMLHttpRequest();
    } catch (e) {}
    if (!xdomain) try {
        return new (0, $8959bb304e43f43f$export$394f9358f6231289)[[
            "Active"
        ].concat("Object").join("X")]("Microsoft.XMLHTTP");
    } catch (e) {}
}






// detect ReactNative environment
const $9ab7b46a38551fa4$var$isReactNative = typeof navigator !== "undefined" && typeof navigator.product === "string" && navigator.product.toLowerCase() === "reactnative";
class $9ab7b46a38551fa4$export$570bf71d2367e261 extends (0, $4a78f487f5bb98d8$export$86495b081fef8e52) {
    get name() {
        return "websocket";
    }
    doOpen() {
        const uri = this.uri();
        const protocols = this.opts.protocols;
        // React Native only supports the 'headers' option, and will print a warning if anything else is passed
        const opts = $9ab7b46a38551fa4$var$isReactNative ? {} : (0, $4028d5a20a4526d1$export$357523c63a2253b9)(this.opts, "agent", "perMessageDeflate", "pfx", "key", "passphrase", "cert", "ca", "ciphers", "rejectUnauthorized", "localAddress", "protocolVersion", "origin", "maxPayload", "family", "checkServerIdentity");
        if (this.opts.extraHeaders) opts.headers = this.opts.extraHeaders;
        try {
            this.ws = this.createSocket(uri, protocols, opts);
        } catch (err) {
            return this.emitReserved("error", err);
        }
        this.ws.binaryType = this.socket.binaryType;
        this.addEventListeners();
    }
    /**
     * Adds event listeners to the socket
     *
     * @private
     */ addEventListeners() {
        this.ws.onopen = ()=>{
            if (this.opts.autoUnref) this.ws._socket.unref();
            this.onOpen();
        };
        this.ws.onclose = (closeEvent)=>this.onClose({
                description: "websocket connection closed",
                context: closeEvent
            });
        this.ws.onmessage = (ev)=>this.onData(ev.data);
        this.ws.onerror = (e)=>this.onError("websocket error", e);
    }
    write(packets) {
        this.writable = false;
        // encodePacket efficient as it uses WS framing
        // no need for encodePayload
        for(let i = 0; i < packets.length; i++){
            const packet = packets[i];
            const lastPacket = i === packets.length - 1;
            (0, $8a3662315a48cdbd$export$57852049361a8e62)(packet, this.supportsBinary, (data)=>{
                // Sometimes the websocket has already been closed but the browser didn't
                // have a chance of informing us about it yet, in that case send will
                // throw an error
                try {
                    this.doWrite(packet, data);
                } catch (e) {}
                if (lastPacket) // fake drain
                // defer to next tick to allow Socket to clear writeBuffer
                (0, $8959bb304e43f43f$export$bdd553fddd433dcb)(()=>{
                    this.writable = true;
                    this.emitReserved("drain");
                }, this.setTimeoutFn);
            });
        }
    }
    doClose() {
        if (typeof this.ws !== "undefined") {
            this.ws.onerror = ()=>{};
            this.ws.close();
            this.ws = null;
        }
    }
    /**
     * Generates uri for connection.
     *
     * @private
     */ uri() {
        const schema = this.opts.secure ? "wss" : "ws";
        const query = this.query || {};
        // append timestamp to URI
        if (this.opts.timestampRequests) query[this.opts.timestampParam] = (0, $4028d5a20a4526d1$export$7fa8378418b4411e)();
        // communicate binary support capabilities
        if (!this.supportsBinary) query.b64 = 1;
        return this.createUri(schema, query);
    }
}
const $9ab7b46a38551fa4$var$WebSocketCtor = (0, $8959bb304e43f43f$export$394f9358f6231289).WebSocket || (0, $8959bb304e43f43f$export$394f9358f6231289).MozWebSocket;
class $9ab7b46a38551fa4$export$911baa0677ac404c extends $9ab7b46a38551fa4$export$570bf71d2367e261 {
    createSocket(uri, protocols, opts) {
        return !$9ab7b46a38551fa4$var$isReactNative ? protocols ? new $9ab7b46a38551fa4$var$WebSocketCtor(uri, protocols) : new $9ab7b46a38551fa4$var$WebSocketCtor(uri) : new $9ab7b46a38551fa4$var$WebSocketCtor(uri, protocols, opts);
    }
    doWrite(_packet, data) {
        this.ws.send(data);
    }
}





class $cea1ad415a07b478$export$961c930859384407 extends (0, $4a78f487f5bb98d8$export$86495b081fef8e52) {
    get name() {
        return "webtransport";
    }
    doOpen() {
        try {
            // @ts-ignore
            this._transport = new WebTransport(this.createUri("https"), this.opts.transportOptions[this.name]);
        } catch (err) {
            return this.emitReserved("error", err);
        }
        this._transport.closed.then(()=>{
            this.onClose();
        }).catch((err)=>{
            this.onError("webtransport error", err);
        });
        // note: we could have used async/await, but that would require some additional polyfills
        this._transport.ready.then(()=>{
            this._transport.createBidirectionalStream().then((stream)=>{
                const decoderStream = (0, $0736208648dc8bae$export$552d20aac7500f47)(Number.MAX_SAFE_INTEGER, this.socket.binaryType);
                const reader = stream.readable.pipeThrough(decoderStream).getReader();
                const encoderStream = (0, $0736208648dc8bae$export$a525fb718e9c623a)();
                encoderStream.readable.pipeTo(stream.writable);
                this._writer = encoderStream.writable.getWriter();
                const read = ()=>{
                    reader.read().then(({ done: done, value: value })=>{
                        if (done) return;
                        this.onPacket(value);
                        read();
                    }).catch((err)=>{});
                };
                read();
                const packet = {
                    type: "open"
                };
                if (this.query.sid) packet.data = `{"sid":"${this.query.sid}"}`;
                this._writer.write(packet).then(()=>this.onOpen());
            });
        });
    }
    write(packets) {
        this.writable = false;
        for(let i = 0; i < packets.length; i++){
            const packet = packets[i];
            const lastPacket = i === packets.length - 1;
            this._writer.write(packet).then(()=>{
                if (lastPacket) (0, $8959bb304e43f43f$export$bdd553fddd433dcb)(()=>{
                    this.writable = true;
                    this.emitReserved("drain");
                }, this.setTimeoutFn);
            });
        }
    }
    doClose() {
        var _a;
        (_a = this._transport) === null || _a === void 0 || _a.close();
    }
}


const $c1f726e793763466$export$46dec00755c1153b = {
    websocket: (0, $9ab7b46a38551fa4$export$911baa0677ac404c),
    webtransport: (0, $cea1ad415a07b478$export$961c930859384407),
    polling: (0, $2ddd02863faa1587$export$a2d42eb087c10497)
};




// imported from https://github.com/galkn/parseuri
/**
 * Parses a URI
 *
 * Note: we could also have used the built-in URL object, but it isn't supported on all platforms.
 *
 * See:
 * - https://developer.mozilla.org/en-US/docs/Web/API/URL
 * - https://caniuse.com/url
 * - https://www.rfc-editor.org/rfc/rfc3986#appendix-B
 *
 * History of the parse() method:
 * - first commit: https://github.com/socketio/socket.io-client/commit/4ee1d5d94b3906a9c052b459f1a818b15f38f91c
 * - export into its own module: https://github.com/socketio/engine.io-client/commit/de2c561e4564efeb78f1bdb1ba39ef81b2822cb3
 * - reimport: https://github.com/socketio/engine.io-client/commit/df32277c3f6d622eec5ed09f493cae3f3391d242
 *
 * @author Steven Levithan <stevenlevithan.com> (MIT license)
 * @api private
 */ const $f603c1892ffe9e8b$var$re = /^(?:(?![^:@\/?#]+:[^:@\/]*@)(http|https|ws|wss):\/\/)?((?:(([^:@\/?#]*)(?::([^:@\/?#]*))?)?@)?((?:[a-f0-9]{0,4}:){2,7}[a-f0-9]{0,4}|[^:\/?#]*)(?::(\d*))?)(((\/(?:[^?#](?![^?#\/]*\.[^?#\/.]+(?:[?#]|$)))*\/?)?([^?#\/]*))(?:\?([^#]*))?(?:#(.*))?)/;
const $f603c1892ffe9e8b$var$parts = [
    'source',
    'protocol',
    'authority',
    'userInfo',
    'user',
    'password',
    'host',
    'port',
    'relative',
    'path',
    'directory',
    'file',
    'query',
    'anchor'
];
function $f603c1892ffe9e8b$export$98e6a39c04603d36(str) {
    if (str.length > 8000) throw "URI too long";
    const src = str, b = str.indexOf('['), e = str.indexOf(']');
    if (b != -1 && e != -1) str = str.substring(0, b) + str.substring(b, e).replace(/:/g, ';') + str.substring(e, str.length);
    let m = $f603c1892ffe9e8b$var$re.exec(str || ''), uri = {}, i = 14;
    while(i--)uri[$f603c1892ffe9e8b$var$parts[i]] = m[i] || '';
    if (b != -1 && e != -1) {
        uri.source = src;
        uri.host = uri.host.substring(1, uri.host.length - 1).replace(/;/g, ':');
        uri.authority = uri.authority.replace('[', '').replace(']', '').replace(/;/g, ':');
        uri.ipv6uri = true;
    }
    uri.pathNames = $f603c1892ffe9e8b$var$pathNames(uri, uri['path']);
    uri.queryKey = $f603c1892ffe9e8b$var$queryKey(uri, uri['query']);
    return uri;
}
function $f603c1892ffe9e8b$var$pathNames(obj, path) {
    const regx = /\/{2,9}/g, names = path.replace(regx, "/").split("/");
    if (path.slice(0, 1) == '/' || path.length === 0) names.splice(0, 1);
    if (path.slice(-1) == '/') names.splice(names.length - 1, 1);
    return names;
}
function $f603c1892ffe9e8b$var$queryKey(uri, query) {
    const data = {};
    query.replace(/(?:^|&)([^&=]*)=?([^&]*)/g, function($0, $1, $2) {
        if ($1) data[$1] = $2;
    });
    return data;
}





const $787375aed2c43820$var$withEventListeners = typeof addEventListener === "function" && typeof removeEventListener === "function";
const $787375aed2c43820$var$OFFLINE_EVENT_LISTENERS = [];
if ($787375aed2c43820$var$withEventListeners) // within a ServiceWorker, any event handler for the 'offline' event must be added on the initial evaluation of the
// script, so we create one single event listener here which will forward the event to the socket instances
addEventListener("offline", ()=>{
    $787375aed2c43820$var$OFFLINE_EVENT_LISTENERS.forEach((listener)=>listener());
}, false);
class $787375aed2c43820$export$3874118029a0ee0d extends (0, $3d905a8ca243a015$export$4293555f241ae35a) {
    /**
     * Socket constructor.
     *
     * @param {String|Object} uri - uri or options
     * @param {Object} opts - options
     */ constructor(uri, opts){
        super();
        this.binaryType = (0, $8959bb304e43f43f$export$790dcbc41e2d75d5);
        this.writeBuffer = [];
        this._prevBufferLen = 0;
        this._pingInterval = -1;
        this._pingTimeout = -1;
        this._maxPayload = -1;
        /**
         * The expiration timestamp of the {@link _pingTimeoutTimer} object is tracked, in case the timer is throttled and the
         * callback is not fired on time. This can happen for example when a laptop is suspended or when a phone is locked.
         */ this._pingTimeoutTime = Infinity;
        if (uri && "object" === typeof uri) {
            opts = uri;
            uri = null;
        }
        if (uri) {
            const parsedUri = (0, $f603c1892ffe9e8b$export$98e6a39c04603d36)(uri);
            opts.hostname = parsedUri.host;
            opts.secure = parsedUri.protocol === "https" || parsedUri.protocol === "wss";
            opts.port = parsedUri.port;
            if (parsedUri.query) opts.query = parsedUri.query;
        } else if (opts.host) opts.hostname = (0, $f603c1892ffe9e8b$export$98e6a39c04603d36)(opts.host).host;
        (0, $4028d5a20a4526d1$export$2f67576668b97183)(this, opts);
        this.secure = null != opts.secure ? opts.secure : typeof location !== "undefined" && "https:" === location.protocol;
        if (opts.hostname && !opts.port) // if no port is specified manually, use the protocol default
        opts.port = this.secure ? "443" : "80";
        this.hostname = opts.hostname || (typeof location !== "undefined" ? location.hostname : "localhost");
        this.port = opts.port || (typeof location !== "undefined" && location.port ? location.port : this.secure ? "443" : "80");
        this.transports = [];
        this._transportsByName = {};
        opts.transports.forEach((t)=>{
            const transportName = t.prototype.name;
            this.transports.push(transportName);
            this._transportsByName[transportName] = t;
        });
        this.opts = Object.assign({
            path: "/engine.io",
            agent: false,
            withCredentials: false,
            upgrade: true,
            timestampParam: "t",
            rememberUpgrade: false,
            addTrailingSlash: true,
            rejectUnauthorized: true,
            perMessageDeflate: {
                threshold: 1024
            },
            transportOptions: {},
            closeOnBeforeunload: false
        }, opts);
        this.opts.path = this.opts.path.replace(/\/$/, "") + (this.opts.addTrailingSlash ? "/" : "");
        if (typeof this.opts.query === "string") this.opts.query = (0, $19744bce3c183d10$export$2f872c0f2117be69)(this.opts.query);
        if ($787375aed2c43820$var$withEventListeners) {
            if (this.opts.closeOnBeforeunload) {
                // Firefox closes the connection when the "beforeunload" event is emitted but not Chrome. This event listener
                // ensures every browser behaves the same (no "disconnect" event at the Socket.IO level when the page is
                // closed/reloaded)
                this._beforeunloadEventListener = ()=>{
                    if (this.transport) {
                        // silently close the transport
                        this.transport.removeAllListeners();
                        this.transport.close();
                    }
                };
                addEventListener("beforeunload", this._beforeunloadEventListener, false);
            }
            if (this.hostname !== "localhost") {
                this._offlineEventListener = ()=>{
                    this._onClose("transport close", {
                        description: "network connection lost"
                    });
                };
                $787375aed2c43820$var$OFFLINE_EVENT_LISTENERS.push(this._offlineEventListener);
            }
        }
        if (this.opts.withCredentials) this._cookieJar = (0, $8959bb304e43f43f$export$19413efcf2fac759)();
        this._open();
    }
    /**
     * Creates transport of the given type.
     *
     * @param {String} name - transport name
     * @return {Transport}
     * @private
     */ createTransport(name) {
        const query = Object.assign({}, this.opts.query);
        // append engine.io protocol identifier
        query.EIO = (0, $0736208648dc8bae$export$a51d6b395ff4c65a);
        // transport name
        query.transport = name;
        // session id if we already have one
        if (this.id) query.sid = this.id;
        const opts = Object.assign({}, this.opts, {
            query: query,
            socket: this,
            hostname: this.hostname,
            secure: this.secure,
            port: this.port
        }, this.opts.transportOptions[name]);
        return new this._transportsByName[name](opts);
    }
    /**
     * Initializes transport to use and starts probe.
     *
     * @private
     */ _open() {
        if (this.transports.length === 0) {
            // Emit error on next tick so it can be listened to
            this.setTimeoutFn(()=>{
                this.emitReserved("error", "No transports available");
            }, 0);
            return;
        }
        const transportName = this.opts.rememberUpgrade && $787375aed2c43820$export$3874118029a0ee0d.priorWebsocketSuccess && this.transports.indexOf("websocket") !== -1 ? "websocket" : this.transports[0];
        this.readyState = "opening";
        const transport = this.createTransport(transportName);
        transport.open();
        this.setTransport(transport);
    }
    /**
     * Sets the current transport. Disables the existing one (if any).
     *
     * @private
     */ setTransport(transport) {
        if (this.transport) this.transport.removeAllListeners();
        // set up transport
        this.transport = transport;
        // set up transport listeners
        transport.on("drain", this._onDrain.bind(this)).on("packet", this._onPacket.bind(this)).on("error", this._onError.bind(this)).on("close", (reason)=>this._onClose("transport close", reason));
    }
    /**
     * Called when connection is deemed open.
     *
     * @private
     */ onOpen() {
        this.readyState = "open";
        $787375aed2c43820$export$3874118029a0ee0d.priorWebsocketSuccess = "websocket" === this.transport.name;
        this.emitReserved("open");
        this.flush();
    }
    /**
     * Handles a packet.
     *
     * @private
     */ _onPacket(packet) {
        if ("opening" === this.readyState || "open" === this.readyState || "closing" === this.readyState) {
            this.emitReserved("packet", packet);
            // Socket is live - any packet counts
            this.emitReserved("heartbeat");
            switch(packet.type){
                case "open":
                    this.onHandshake(JSON.parse(packet.data));
                    break;
                case "ping":
                    this._sendPacket("pong");
                    this.emitReserved("ping");
                    this.emitReserved("pong");
                    this._resetPingTimeout();
                    break;
                case "error":
                    const err = new Error("server error");
                    // @ts-ignore
                    err.code = packet.data;
                    this._onError(err);
                    break;
                case "message":
                    this.emitReserved("data", packet.data);
                    this.emitReserved("message", packet.data);
                    break;
            }
        }
    }
    /**
     * Called upon handshake completion.
     *
     * @param {Object} data - handshake obj
     * @private
     */ onHandshake(data) {
        this.emitReserved("handshake", data);
        this.id = data.sid;
        this.transport.query.sid = data.sid;
        this._pingInterval = data.pingInterval;
        this._pingTimeout = data.pingTimeout;
        this._maxPayload = data.maxPayload;
        this.onOpen();
        // In case open handler closes socket
        if ("closed" === this.readyState) return;
        this._resetPingTimeout();
    }
    /**
     * Sets and resets ping timeout timer based on server pings.
     *
     * @private
     */ _resetPingTimeout() {
        this.clearTimeoutFn(this._pingTimeoutTimer);
        const delay = this._pingInterval + this._pingTimeout;
        this._pingTimeoutTime = Date.now() + delay;
        this._pingTimeoutTimer = this.setTimeoutFn(()=>{
            this._onClose("ping timeout");
        }, delay);
        if (this.opts.autoUnref) this._pingTimeoutTimer.unref();
    }
    /**
     * Called on `drain` event
     *
     * @private
     */ _onDrain() {
        this.writeBuffer.splice(0, this._prevBufferLen);
        // setting prevBufferLen = 0 is very important
        // for example, when upgrading, upgrade packet is sent over,
        // and a nonzero prevBufferLen could cause problems on `drain`
        this._prevBufferLen = 0;
        if (0 === this.writeBuffer.length) this.emitReserved("drain");
        else this.flush();
    }
    /**
     * Flush write buffers.
     *
     * @private
     */ flush() {
        if ("closed" !== this.readyState && this.transport.writable && !this.upgrading && this.writeBuffer.length) {
            const packets = this._getWritablePackets();
            this.transport.send(packets);
            // keep track of current length of writeBuffer
            // splice writeBuffer and callbackBuffer on `drain`
            this._prevBufferLen = packets.length;
            this.emitReserved("flush");
        }
    }
    /**
     * Ensure the encoded size of the writeBuffer is below the maxPayload value sent by the server (only for HTTP
     * long-polling)
     *
     * @private
     */ _getWritablePackets() {
        const shouldCheckPayloadSize = this._maxPayload && this.transport.name === "polling" && this.writeBuffer.length > 1;
        if (!shouldCheckPayloadSize) return this.writeBuffer;
        let payloadSize = 1; // first packet type
        for(let i = 0; i < this.writeBuffer.length; i++){
            const data = this.writeBuffer[i].data;
            if (data) payloadSize += (0, $4028d5a20a4526d1$export$a48f0734ac7c2329)(data);
            if (i > 0 && payloadSize > this._maxPayload) return this.writeBuffer.slice(0, i);
            payloadSize += 2; // separator + packet type
        }
        return this.writeBuffer;
    }
    /**
     * Checks whether the heartbeat timer has expired but the socket has not yet been notified.
     *
     * Note: this method is private for now because it does not really fit the WebSocket API, but if we put it in the
     * `write()` method then the message would not be buffered by the Socket.IO client.
     *
     * @return {boolean}
     * @private
     */ /* private */ _hasPingExpired() {
        if (!this._pingTimeoutTime) return true;
        const hasExpired = Date.now() > this._pingTimeoutTime;
        if (hasExpired) {
            this._pingTimeoutTime = 0;
            (0, $8959bb304e43f43f$export$bdd553fddd433dcb)(()=>{
                this._onClose("ping timeout");
            }, this.setTimeoutFn);
        }
        return hasExpired;
    }
    /**
     * Sends a message.
     *
     * @param {String} msg - message.
     * @param {Object} options.
     * @param {Function} fn - callback function.
     * @return {Socket} for chaining.
     */ write(msg, options, fn) {
        this._sendPacket("message", msg, options, fn);
        return this;
    }
    /**
     * Sends a message. Alias of {@link Socket#write}.
     *
     * @param {String} msg - message.
     * @param {Object} options.
     * @param {Function} fn - callback function.
     * @return {Socket} for chaining.
     */ send(msg, options, fn) {
        this._sendPacket("message", msg, options, fn);
        return this;
    }
    /**
     * Sends a packet.
     *
     * @param {String} type: packet type.
     * @param {String} data.
     * @param {Object} options.
     * @param {Function} fn - callback function.
     * @private
     */ _sendPacket(type, data, options, fn) {
        if ("function" === typeof data) {
            fn = data;
            data = undefined;
        }
        if ("function" === typeof options) {
            fn = options;
            options = null;
        }
        if ("closing" === this.readyState || "closed" === this.readyState) return;
        options = options || {};
        options.compress = false !== options.compress;
        const packet = {
            type: type,
            data: data,
            options: options
        };
        this.emitReserved("packetCreate", packet);
        this.writeBuffer.push(packet);
        if (fn) this.once("flush", fn);
        this.flush();
    }
    /**
     * Closes the connection.
     */ close() {
        const close = ()=>{
            this._onClose("forced close");
            this.transport.close();
        };
        const cleanupAndClose = ()=>{
            this.off("upgrade", cleanupAndClose);
            this.off("upgradeError", cleanupAndClose);
            close();
        };
        const waitForUpgrade = ()=>{
            // wait for upgrade to finish since we can't send packets while pausing a transport
            this.once("upgrade", cleanupAndClose);
            this.once("upgradeError", cleanupAndClose);
        };
        if ("opening" === this.readyState || "open" === this.readyState) {
            this.readyState = "closing";
            if (this.writeBuffer.length) this.once("drain", ()=>{
                if (this.upgrading) waitForUpgrade();
                else close();
            });
            else if (this.upgrading) waitForUpgrade();
            else close();
        }
        return this;
    }
    /**
     * Called upon transport error
     *
     * @private
     */ _onError(err) {
        $787375aed2c43820$export$3874118029a0ee0d.priorWebsocketSuccess = false;
        if (this.opts.tryAllTransports && this.transports.length > 1 && this.readyState === "opening") {
            this.transports.shift();
            return this._open();
        }
        this.emitReserved("error", err);
        this._onClose("transport error", err);
    }
    /**
     * Called upon transport close.
     *
     * @private
     */ _onClose(reason, description) {
        if ("opening" === this.readyState || "open" === this.readyState || "closing" === this.readyState) {
            // clear timers
            this.clearTimeoutFn(this._pingTimeoutTimer);
            // stop event from firing again for transport
            this.transport.removeAllListeners("close");
            // ensure transport won't stay open
            this.transport.close();
            // ignore further transport communication
            this.transport.removeAllListeners();
            if ($787375aed2c43820$var$withEventListeners) {
                if (this._beforeunloadEventListener) removeEventListener("beforeunload", this._beforeunloadEventListener, false);
                if (this._offlineEventListener) {
                    const i = $787375aed2c43820$var$OFFLINE_EVENT_LISTENERS.indexOf(this._offlineEventListener);
                    if (i !== -1) $787375aed2c43820$var$OFFLINE_EVENT_LISTENERS.splice(i, 1);
                }
            }
            // set ready state
            this.readyState = "closed";
            // clear session id
            this.id = null;
            // emit close event
            this.emitReserved("close", reason, description);
            // clean buffers after, so users can still
            // grab the buffers on `close` event
            this.writeBuffer = [];
            this._prevBufferLen = 0;
        }
    }
}
$787375aed2c43820$export$3874118029a0ee0d.protocol = (0, $0736208648dc8bae$export$a51d6b395ff4c65a);
class $787375aed2c43820$export$cc521fcb1004e85c extends $787375aed2c43820$export$3874118029a0ee0d {
    constructor(){
        super(...arguments);
        this._upgrades = [];
    }
    onOpen() {
        super.onOpen();
        if ("open" === this.readyState && this.opts.upgrade) for(let i = 0; i < this._upgrades.length; i++)this._probe(this._upgrades[i]);
    }
    /**
     * Probes a transport.
     *
     * @param {String} name - transport name
     * @private
     */ _probe(name) {
        let transport = this.createTransport(name);
        let failed = false;
        $787375aed2c43820$export$3874118029a0ee0d.priorWebsocketSuccess = false;
        const onTransportOpen = ()=>{
            if (failed) return;
            transport.send([
                {
                    type: "ping",
                    data: "probe"
                }
            ]);
            transport.once("packet", (msg)=>{
                if (failed) return;
                if ("pong" === msg.type && "probe" === msg.data) {
                    this.upgrading = true;
                    this.emitReserved("upgrading", transport);
                    if (!transport) return;
                    $787375aed2c43820$export$3874118029a0ee0d.priorWebsocketSuccess = "websocket" === transport.name;
                    this.transport.pause(()=>{
                        if (failed) return;
                        if ("closed" === this.readyState) return;
                        cleanup();
                        this.setTransport(transport);
                        transport.send([
                            {
                                type: "upgrade"
                            }
                        ]);
                        this.emitReserved("upgrade", transport);
                        transport = null;
                        this.upgrading = false;
                        this.flush();
                    });
                } else {
                    const err = new Error("probe error");
                    // @ts-ignore
                    err.transport = transport.name;
                    this.emitReserved("upgradeError", err);
                }
            });
        };
        function freezeTransport() {
            if (failed) return;
            // Any callback called by transport should be ignored since now
            failed = true;
            cleanup();
            transport.close();
            transport = null;
        }
        // Handle any error that happens while probing
        const onerror = (err)=>{
            const error = new Error("probe error: " + err);
            // @ts-ignore
            error.transport = transport.name;
            freezeTransport();
            this.emitReserved("upgradeError", error);
        };
        function onTransportClose() {
            onerror("transport closed");
        }
        // When the socket is closed while we're probing
        function onclose() {
            onerror("socket closed");
        }
        // When the socket is upgraded while we're probing
        function onupgrade(to) {
            if (transport && to.name !== transport.name) freezeTransport();
        }
        // Remove all listeners on the transport and on self
        const cleanup = ()=>{
            transport.removeListener("open", onTransportOpen);
            transport.removeListener("error", onerror);
            transport.removeListener("close", onTransportClose);
            this.off("close", onclose);
            this.off("upgrading", onupgrade);
        };
        transport.once("open", onTransportOpen);
        transport.once("error", onerror);
        transport.once("close", onTransportClose);
        this.once("close", onclose);
        this.once("upgrading", onupgrade);
        if (this._upgrades.indexOf("webtransport") !== -1 && name !== "webtransport") // favor WebTransport
        this.setTimeoutFn(()=>{
            if (!failed) transport.open();
        }, 200);
        else transport.open();
    }
    onHandshake(data) {
        this._upgrades = this._filterUpgrades(data.upgrades);
        super.onHandshake(data);
    }
    /**
     * Filters upgrades, returning only those matching client transports.
     *
     * @param {Array} upgrades - server upgrades
     * @private
     */ _filterUpgrades(upgrades) {
        const filteredUpgrades = [];
        for(let i = 0; i < upgrades.length; i++)if (~this.transports.indexOf(upgrades[i])) filteredUpgrades.push(upgrades[i]);
        return filteredUpgrades;
    }
}
class $787375aed2c43820$export$4798917dbf149b79 extends $787375aed2c43820$export$cc521fcb1004e85c {
    constructor(uri, opts = {}){
        const o = typeof uri === "object" ? uri : opts;
        if (!o.transports || o.transports && typeof o.transports[0] === "string") o.transports = (o.transports || [
            "polling",
            "websocket",
            "webtransport"
        ]).map((transportName)=>(0, $c1f726e793763466$export$46dec00755c1153b)[transportName]).filter((t)=>!!t);
        super(uri, o);
    }
}








class $d25cf4f3df002b9c$export$1e7deca84b429035 extends (0, $56534be56e5aa809$export$265ee5eefd4c309b) {
    doPoll() {
        this._fetch().then((res)=>{
            if (!res.ok) return this.onError("fetch read error", res.status, res);
            res.text().then((data)=>this.onData(data));
        }).catch((err)=>{
            this.onError("fetch read error", err);
        });
    }
    doWrite(data, callback) {
        this._fetch(data).then((res)=>{
            if (!res.ok) return this.onError("fetch write error", res.status, res);
            callback();
        }).catch((err)=>{
            this.onError("fetch write error", err);
        });
    }
    _fetch(data) {
        var _a;
        const isPost = data !== undefined;
        const headers = new Headers(this.opts.extraHeaders);
        if (isPost) headers.set("content-type", "text/plain;charset=UTF-8");
        (_a = this.socket._cookieJar) === null || _a === void 0 || _a.appendCookies(headers);
        return fetch(this.uri(), {
            method: isPost ? "POST" : "GET",
            body: isPost ? data : null,
            headers: headers,
            credentials: this.opts.withCredentials ? "include" : "omit"
        }).then((res)=>{
            var _a;
            // @ts-ignore getSetCookie() was added in Node.js v19.7.0
            (_a = this.socket._cookieJar) === null || _a === void 0 || _a.parseCookies(res.headers.getSetCookie());
            return res;
        });
    }
}







const $16df97babd1aadf1$export$a51d6b395ff4c65a = (0, $787375aed2c43820$export$4798917dbf149b79).protocol;


function $efe27346e00da8a8$export$128fa18b7194ef(uri, path = "", loc) {
    let obj = uri;
    // default to window.location
    loc = loc || typeof location !== "undefined" && location;
    if (null == uri) uri = loc.protocol + "//" + loc.host;
    // relative path support
    if (typeof uri === "string") {
        if ("/" === uri.charAt(0)) {
            if ("/" === uri.charAt(1)) uri = loc.protocol + uri;
            else uri = loc.host + uri;
        }
        if (!/^(https?|wss?):\/\//.test(uri)) {
            if ("undefined" !== typeof loc) uri = loc.protocol + "//" + uri;
            else uri = "https://" + uri;
        }
        // parse
        obj = (0, $f603c1892ffe9e8b$export$98e6a39c04603d36)(uri);
    }
    // make sure we treat `localhost:80` and `localhost` equally
    if (!obj.port) {
        if (/^(http|ws)$/.test(obj.protocol)) obj.port = "80";
        else if (/^(http|ws)s$/.test(obj.protocol)) obj.port = "443";
    }
    obj.path = obj.path || "/";
    const ipv6 = obj.host.indexOf(":") !== -1;
    const host = ipv6 ? "[" + obj.host + "]" : obj.host;
    // define unique id
    obj.id = obj.protocol + "://" + host + ":" + obj.port + path;
    // define href
    obj.href = obj.protocol + "://" + host + (loc && loc.port === obj.port ? "" : ":" + obj.port);
    return obj;
}



var $1e4e6e6cc3958162$exports = {};

$parcel$export($1e4e6e6cc3958162$exports, "protocol", () => $1e4e6e6cc3958162$export$a51d6b395ff4c65a);
$parcel$export($1e4e6e6cc3958162$exports, "PacketType", () => $1e4e6e6cc3958162$export$84d4095e16c6fc19);
$parcel$export($1e4e6e6cc3958162$exports, "Encoder", () => $1e4e6e6cc3958162$export$a50aceb0e02a00aa);
$parcel$export($1e4e6e6cc3958162$exports, "Decoder", () => $1e4e6e6cc3958162$export$f9de6ca0bc043724);

const $ab192732c3780e48$var$withNativeArrayBuffer = typeof ArrayBuffer === "function";
const $ab192732c3780e48$var$isView = (obj)=>{
    return typeof ArrayBuffer.isView === "function" ? ArrayBuffer.isView(obj) : obj.buffer instanceof ArrayBuffer;
};
const $ab192732c3780e48$var$toString = Object.prototype.toString;
const $ab192732c3780e48$var$withNativeBlob = typeof Blob === "function" || typeof Blob !== "undefined" && $ab192732c3780e48$var$toString.call(Blob) === "[object BlobConstructor]";
const $ab192732c3780e48$var$withNativeFile = typeof File === "function" || typeof File !== "undefined" && $ab192732c3780e48$var$toString.call(File) === "[object FileConstructor]";
function $ab192732c3780e48$export$37488ff1135b1696(obj) {
    return $ab192732c3780e48$var$withNativeArrayBuffer && (obj instanceof ArrayBuffer || $ab192732c3780e48$var$isView(obj)) || $ab192732c3780e48$var$withNativeBlob && obj instanceof Blob || $ab192732c3780e48$var$withNativeFile && obj instanceof File;
}
function $ab192732c3780e48$export$5234c529abdb5610(obj, toJSON) {
    if (!obj || typeof obj !== "object") return false;
    if (Array.isArray(obj)) {
        for(let i = 0, l = obj.length; i < l; i++){
            if ($ab192732c3780e48$export$5234c529abdb5610(obj[i])) return true;
        }
        return false;
    }
    if ($ab192732c3780e48$export$37488ff1135b1696(obj)) return true;
    if (obj.toJSON && typeof obj.toJSON === "function" && arguments.length === 1) return $ab192732c3780e48$export$5234c529abdb5610(obj.toJSON(), true);
    for(const key in obj){
        if (Object.prototype.hasOwnProperty.call(obj, key) && $ab192732c3780e48$export$5234c529abdb5610(obj[key])) return true;
    }
    return false;
}


function $67dd224d5a131c9e$export$ac2edb9eb7af56f6(packet) {
    const buffers = [];
    const packetData = packet.data;
    const pack = packet;
    pack.data = $67dd224d5a131c9e$var$_deconstructPacket(packetData, buffers);
    pack.attachments = buffers.length; // number of binary 'attachments'
    return {
        packet: pack,
        buffers: buffers
    };
}
function $67dd224d5a131c9e$var$_deconstructPacket(data, buffers) {
    if (!data) return data;
    if ((0, $ab192732c3780e48$export$37488ff1135b1696)(data)) {
        const placeholder = {
            _placeholder: true,
            num: buffers.length
        };
        buffers.push(data);
        return placeholder;
    } else if (Array.isArray(data)) {
        const newData = new Array(data.length);
        for(let i = 0; i < data.length; i++)newData[i] = $67dd224d5a131c9e$var$_deconstructPacket(data[i], buffers);
        return newData;
    } else if (typeof data === "object" && !(data instanceof Date)) {
        const newData = {};
        for(const key in data)if (Object.prototype.hasOwnProperty.call(data, key)) newData[key] = $67dd224d5a131c9e$var$_deconstructPacket(data[key], buffers);
        return newData;
    }
    return data;
}
function $67dd224d5a131c9e$export$a00da3b1ec037a04(packet, buffers) {
    packet.data = $67dd224d5a131c9e$var$_reconstructPacket(packet.data, buffers);
    delete packet.attachments; // no longer useful
    return packet;
}
function $67dd224d5a131c9e$var$_reconstructPacket(data, buffers) {
    if (!data) return data;
    if (data && data._placeholder === true) {
        const isIndexValid = typeof data.num === "number" && data.num >= 0 && data.num < buffers.length;
        if (isIndexValid) return buffers[data.num]; // appropriate buffer (should be natural order anyway)
        else throw new Error("illegal attachments");
    } else if (Array.isArray(data)) for(let i = 0; i < data.length; i++)data[i] = $67dd224d5a131c9e$var$_reconstructPacket(data[i], buffers);
    else if (typeof data === "object") {
        for(const key in data)if (Object.prototype.hasOwnProperty.call(data, key)) data[key] = $67dd224d5a131c9e$var$_reconstructPacket(data[key], buffers);
    }
    return data;
}



/**
 * These strings must not be used as event names, as they have a special meaning.
 */ const $1e4e6e6cc3958162$var$RESERVED_EVENTS = [
    "connect",
    "connect_error",
    "disconnect",
    "disconnecting",
    "newListener",
    "removeListener"
];
const $1e4e6e6cc3958162$export$a51d6b395ff4c65a = 5;
var $1e4e6e6cc3958162$export$84d4095e16c6fc19;
(function(PacketType) {
    PacketType[PacketType["CONNECT"] = 0] = "CONNECT";
    PacketType[PacketType["DISCONNECT"] = 1] = "DISCONNECT";
    PacketType[PacketType["EVENT"] = 2] = "EVENT";
    PacketType[PacketType["ACK"] = 3] = "ACK";
    PacketType[PacketType["CONNECT_ERROR"] = 4] = "CONNECT_ERROR";
    PacketType[PacketType["BINARY_EVENT"] = 5] = "BINARY_EVENT";
    PacketType[PacketType["BINARY_ACK"] = 6] = "BINARY_ACK";
})($1e4e6e6cc3958162$export$84d4095e16c6fc19 || ($1e4e6e6cc3958162$export$84d4095e16c6fc19 = {}));
class $1e4e6e6cc3958162$export$a50aceb0e02a00aa {
    /**
     * Encoder constructor
     *
     * @param {function} replacer - custom replacer to pass down to JSON.parse
     */ constructor(replacer){
        this.replacer = replacer;
    }
    /**
     * Encode a packet as a single string if non-binary, or as a
     * buffer sequence, depending on packet type.
     *
     * @param {Object} obj - packet object
     */ encode(obj) {
        if (obj.type === $1e4e6e6cc3958162$export$84d4095e16c6fc19.EVENT || obj.type === $1e4e6e6cc3958162$export$84d4095e16c6fc19.ACK) {
            if ((0, $ab192732c3780e48$export$5234c529abdb5610)(obj)) return this.encodeAsBinary({
                type: obj.type === $1e4e6e6cc3958162$export$84d4095e16c6fc19.EVENT ? $1e4e6e6cc3958162$export$84d4095e16c6fc19.BINARY_EVENT : $1e4e6e6cc3958162$export$84d4095e16c6fc19.BINARY_ACK,
                nsp: obj.nsp,
                data: obj.data,
                id: obj.id
            });
        }
        return [
            this.encodeAsString(obj)
        ];
    }
    /**
     * Encode packet as string.
     */ encodeAsString(obj) {
        // first is type
        let str = "" + obj.type;
        // attachments if we have them
        if (obj.type === $1e4e6e6cc3958162$export$84d4095e16c6fc19.BINARY_EVENT || obj.type === $1e4e6e6cc3958162$export$84d4095e16c6fc19.BINARY_ACK) str += obj.attachments + "-";
        // if we have a namespace other than `/`
        // we append it followed by a comma `,`
        if (obj.nsp && "/" !== obj.nsp) str += obj.nsp + ",";
        // immediately followed by the id
        if (null != obj.id) str += obj.id;
        // json data
        if (null != obj.data) str += JSON.stringify(obj.data, this.replacer);
        return str;
    }
    /**
     * Encode packet as 'buffer sequence' by removing blobs, and
     * deconstructing packet into object with placeholders and
     * a list of buffers.
     */ encodeAsBinary(obj) {
        const deconstruction = (0, $67dd224d5a131c9e$export$ac2edb9eb7af56f6)(obj);
        const pack = this.encodeAsString(deconstruction.packet);
        const buffers = deconstruction.buffers;
        buffers.unshift(pack); // add packet info to beginning of data list
        return buffers; // write all the buffers
    }
}
// see https://stackoverflow.com/questions/8511281/check-if-a-value-is-an-object-in-javascript
function $1e4e6e6cc3958162$var$isObject(value) {
    return Object.prototype.toString.call(value) === "[object Object]";
}
class $1e4e6e6cc3958162$export$f9de6ca0bc043724 extends (0, $3d905a8ca243a015$export$4293555f241ae35a) {
    /**
     * Decoder constructor
     *
     * @param {function} reviver - custom reviver to pass down to JSON.stringify
     */ constructor(reviver){
        super();
        this.reviver = reviver;
    }
    /**
     * Decodes an encoded packet string into packet JSON.
     *
     * @param {String} obj - encoded packet
     */ add(obj) {
        let packet;
        if (typeof obj === "string") {
            if (this.reconstructor) throw new Error("got plaintext data when reconstructing a packet");
            packet = this.decodeString(obj);
            const isBinaryEvent = packet.type === $1e4e6e6cc3958162$export$84d4095e16c6fc19.BINARY_EVENT;
            if (isBinaryEvent || packet.type === $1e4e6e6cc3958162$export$84d4095e16c6fc19.BINARY_ACK) {
                packet.type = isBinaryEvent ? $1e4e6e6cc3958162$export$84d4095e16c6fc19.EVENT : $1e4e6e6cc3958162$export$84d4095e16c6fc19.ACK;
                // binary packet's json
                this.reconstructor = new $1e4e6e6cc3958162$var$BinaryReconstructor(packet);
                // no attachments, labeled binary but no binary data to follow
                if (packet.attachments === 0) super.emitReserved("decoded", packet);
            } else // non-binary full packet
            super.emitReserved("decoded", packet);
        } else if ((0, $ab192732c3780e48$export$37488ff1135b1696)(obj) || obj.base64) {
            // raw binary data
            if (!this.reconstructor) throw new Error("got binary data when not reconstructing a packet");
            else {
                packet = this.reconstructor.takeBinaryData(obj);
                if (packet) {
                    // received final buffer
                    this.reconstructor = null;
                    super.emitReserved("decoded", packet);
                }
            }
        } else throw new Error("Unknown type: " + obj);
    }
    /**
     * Decode a packet String (JSON data)
     *
     * @param {String} str
     * @return {Object} packet
     */ decodeString(str) {
        let i = 0;
        // look up type
        const p = {
            type: Number(str.charAt(0))
        };
        if ($1e4e6e6cc3958162$export$84d4095e16c6fc19[p.type] === undefined) throw new Error("unknown packet type " + p.type);
        // look up attachments if type binary
        if (p.type === $1e4e6e6cc3958162$export$84d4095e16c6fc19.BINARY_EVENT || p.type === $1e4e6e6cc3958162$export$84d4095e16c6fc19.BINARY_ACK) {
            const start = i + 1;
            while(str.charAt(++i) !== "-" && i != str.length);
            const buf = str.substring(start, i);
            if (buf != Number(buf) || str.charAt(i) !== "-") throw new Error("Illegal attachments");
            p.attachments = Number(buf);
        }
        // look up namespace (if any)
        if ("/" === str.charAt(i + 1)) {
            const start = i + 1;
            while(++i){
                const c = str.charAt(i);
                if ("," === c) break;
                if (i === str.length) break;
            }
            p.nsp = str.substring(start, i);
        } else p.nsp = "/";
        // look up id
        const next = str.charAt(i + 1);
        if ("" !== next && Number(next) == next) {
            const start = i + 1;
            while(++i){
                const c = str.charAt(i);
                if (null == c || Number(c) != c) {
                    --i;
                    break;
                }
                if (i === str.length) break;
            }
            p.id = Number(str.substring(start, i + 1));
        }
        // look up json data
        if (str.charAt(++i)) {
            const payload = this.tryParse(str.substr(i));
            if ($1e4e6e6cc3958162$export$f9de6ca0bc043724.isPayloadValid(p.type, payload)) p.data = payload;
            else throw new Error("invalid payload");
        }
        return p;
    }
    tryParse(str) {
        try {
            return JSON.parse(str, this.reviver);
        } catch (e) {
            return false;
        }
    }
    static isPayloadValid(type, payload) {
        switch(type){
            case $1e4e6e6cc3958162$export$84d4095e16c6fc19.CONNECT:
                return $1e4e6e6cc3958162$var$isObject(payload);
            case $1e4e6e6cc3958162$export$84d4095e16c6fc19.DISCONNECT:
                return payload === undefined;
            case $1e4e6e6cc3958162$export$84d4095e16c6fc19.CONNECT_ERROR:
                return typeof payload === "string" || $1e4e6e6cc3958162$var$isObject(payload);
            case $1e4e6e6cc3958162$export$84d4095e16c6fc19.EVENT:
            case $1e4e6e6cc3958162$export$84d4095e16c6fc19.BINARY_EVENT:
                return Array.isArray(payload) && (typeof payload[0] === "number" || typeof payload[0] === "string" && $1e4e6e6cc3958162$var$RESERVED_EVENTS.indexOf(payload[0]) === -1);
            case $1e4e6e6cc3958162$export$84d4095e16c6fc19.ACK:
            case $1e4e6e6cc3958162$export$84d4095e16c6fc19.BINARY_ACK:
                return Array.isArray(payload);
        }
    }
    /**
     * Deallocates a parser's resources
     */ destroy() {
        if (this.reconstructor) {
            this.reconstructor.finishedReconstruction();
            this.reconstructor = null;
        }
    }
}
/**
 * A manager of a binary event's 'buffer sequence'. Should
 * be constructed whenever a packet of type BINARY_EVENT is
 * decoded.
 *
 * @param {Object} packet
 * @return {BinaryReconstructor} initialized reconstructor
 */ class $1e4e6e6cc3958162$var$BinaryReconstructor {
    constructor(packet){
        this.packet = packet;
        this.buffers = [];
        this.reconPack = packet;
    }
    /**
     * Method to be called when binary data received from connection
     * after a BINARY_EVENT packet.
     *
     * @param {Buffer | ArrayBuffer} binData - the raw binary data received
     * @return {null | Object} returns null if more binary data is expected or
     *   a reconstructed packet object if all buffers have been received.
     */ takeBinaryData(binData) {
        this.buffers.push(binData);
        if (this.buffers.length === this.reconPack.attachments) {
            // done with buffer list
            const packet = (0, $67dd224d5a131c9e$export$a00da3b1ec037a04)(this.reconPack, this.buffers);
            this.finishedReconstruction();
            return packet;
        }
        return null;
    }
    /**
     * Cleans up binary packet reconstruction variables.
     */ finishedReconstruction() {
        this.reconPack = null;
        this.buffers = [];
    }
}


function $05fb321879039179$export$af631764ddc44097(obj, ev, fn) {
    obj.on(ev, fn);
    return function subDestroy() {
        obj.off(ev, fn);
    };
}



/**
 * Internal events.
 * These events can't be emitted by the user.
 */ const $fcab49da21a6222a$var$RESERVED_EVENTS = Object.freeze({
    connect: 1,
    connect_error: 1,
    disconnect: 1,
    disconnecting: 1,
    // EventEmitter reserved events: https://nodejs.org/api/events.html#events_event_newlistener
    newListener: 1,
    removeListener: 1
});
class $fcab49da21a6222a$export$4798917dbf149b79 extends (0, $3d905a8ca243a015$export$4293555f241ae35a) {
    /**
     * `Socket` constructor.
     */ constructor(io, nsp, opts){
        super();
        /**
         * Whether the socket is currently connected to the server.
         *
         * @example
         * const socket = io();
         *
         * socket.on("connect", () => {
         *   console.log(socket.connected); // true
         * });
         *
         * socket.on("disconnect", () => {
         *   console.log(socket.connected); // false
         * });
         */ this.connected = false;
        /**
         * Whether the connection state was recovered after a temporary disconnection. In that case, any missed packets will
         * be transmitted by the server.
         */ this.recovered = false;
        /**
         * Buffer for packets received before the CONNECT packet
         */ this.receiveBuffer = [];
        /**
         * Buffer for packets that will be sent once the socket is connected
         */ this.sendBuffer = [];
        /**
         * The queue of packets to be sent with retry in case of failure.
         *
         * Packets are sent one by one, each waiting for the server acknowledgement, in order to guarantee the delivery order.
         * @private
         */ this._queue = [];
        /**
         * A sequence to generate the ID of the {@link QueuedPacket}.
         * @private
         */ this._queueSeq = 0;
        this.ids = 0;
        /**
         * A map containing acknowledgement handlers.
         *
         * The `withError` attribute is used to differentiate handlers that accept an error as first argument:
         *
         * - `socket.emit("test", (err, value) => { ... })` with `ackTimeout` option
         * - `socket.timeout(5000).emit("test", (err, value) => { ... })`
         * - `const value = await socket.emitWithAck("test")`
         *
         * From those that don't:
         *
         * - `socket.emit("test", (value) => { ... });`
         *
         * In the first case, the handlers will be called with an error when:
         *
         * - the timeout is reached
         * - the socket gets disconnected
         *
         * In the second case, the handlers will be simply discarded upon disconnection, since the client will never receive
         * an acknowledgement from the server.
         *
         * @private
         */ this.acks = {};
        this.flags = {};
        this.io = io;
        this.nsp = nsp;
        if (opts && opts.auth) this.auth = opts.auth;
        this._opts = Object.assign({}, opts);
        if (this.io._autoConnect) this.open();
    }
    /**
     * Whether the socket is currently disconnected
     *
     * @example
     * const socket = io();
     *
     * socket.on("connect", () => {
     *   console.log(socket.disconnected); // false
     * });
     *
     * socket.on("disconnect", () => {
     *   console.log(socket.disconnected); // true
     * });
     */ get disconnected() {
        return !this.connected;
    }
    /**
     * Subscribe to open, close and packet events
     *
     * @private
     */ subEvents() {
        if (this.subs) return;
        const io = this.io;
        this.subs = [
            (0, $05fb321879039179$export$af631764ddc44097)(io, "open", this.onopen.bind(this)),
            (0, $05fb321879039179$export$af631764ddc44097)(io, "packet", this.onpacket.bind(this)),
            (0, $05fb321879039179$export$af631764ddc44097)(io, "error", this.onerror.bind(this)),
            (0, $05fb321879039179$export$af631764ddc44097)(io, "close", this.onclose.bind(this))
        ];
    }
    /**
     * Whether the Socket will try to reconnect when its Manager connects or reconnects.
     *
     * @example
     * const socket = io();
     *
     * console.log(socket.active); // true
     *
     * socket.on("disconnect", (reason) => {
     *   if (reason === "io server disconnect") {
     *     // the disconnection was initiated by the server, you need to manually reconnect
     *     console.log(socket.active); // false
     *   }
     *   // else the socket will automatically try to reconnect
     *   console.log(socket.active); // true
     * });
     */ get active() {
        return !!this.subs;
    }
    /**
     * "Opens" the socket.
     *
     * @example
     * const socket = io({
     *   autoConnect: false
     * });
     *
     * socket.connect();
     */ connect() {
        if (this.connected) return this;
        this.subEvents();
        if (!this.io["_reconnecting"]) this.io.open(); // ensure open
        if ("open" === this.io._readyState) this.onopen();
        return this;
    }
    /**
     * Alias for {@link connect()}.
     */ open() {
        return this.connect();
    }
    /**
     * Sends a `message` event.
     *
     * This method mimics the WebSocket.send() method.
     *
     * @see https://developer.mozilla.org/en-US/docs/Web/API/WebSocket/send
     *
     * @example
     * socket.send("hello");
     *
     * // this is equivalent to
     * socket.emit("message", "hello");
     *
     * @return self
     */ send(...args) {
        args.unshift("message");
        this.emit.apply(this, args);
        return this;
    }
    /**
     * Override `emit`.
     * If the event is in `events`, it's emitted normally.
     *
     * @example
     * socket.emit("hello", "world");
     *
     * // all serializable datastructures are supported (no need to call JSON.stringify)
     * socket.emit("hello", 1, "2", { 3: ["4"], 5: Uint8Array.from([6]) });
     *
     * // with an acknowledgement from the server
     * socket.emit("hello", "world", (val) => {
     *   // ...
     * });
     *
     * @return self
     */ emit(ev, ...args) {
        var _a, _b, _c;
        if ($fcab49da21a6222a$var$RESERVED_EVENTS.hasOwnProperty(ev)) throw new Error('"' + ev.toString() + '" is a reserved event name');
        args.unshift(ev);
        if (this._opts.retries && !this.flags.fromQueue && !this.flags.volatile) {
            this._addToQueue(args);
            return this;
        }
        const packet = {
            type: (0, $1e4e6e6cc3958162$export$84d4095e16c6fc19).EVENT,
            data: args
        };
        packet.options = {};
        packet.options.compress = this.flags.compress !== false;
        // event ack callback
        if ("function" === typeof args[args.length - 1]) {
            const id = this.ids++;
            const ack = args.pop();
            this._registerAckCallback(id, ack);
            packet.id = id;
        }
        const isTransportWritable = (_b = (_a = this.io.engine) === null || _a === void 0 ? void 0 : _a.transport) === null || _b === void 0 ? void 0 : _b.writable;
        const isConnected = this.connected && !((_c = this.io.engine) === null || _c === void 0 ? void 0 : _c._hasPingExpired());
        const discardPacket = this.flags.volatile && !isTransportWritable;
        if (discardPacket) ;
        else if (isConnected) {
            this.notifyOutgoingListeners(packet);
            this.packet(packet);
        } else this.sendBuffer.push(packet);
        this.flags = {};
        return this;
    }
    /**
     * @private
     */ _registerAckCallback(id, ack) {
        var _a;
        const timeout = (_a = this.flags.timeout) !== null && _a !== void 0 ? _a : this._opts.ackTimeout;
        if (timeout === undefined) {
            this.acks[id] = ack;
            return;
        }
        // @ts-ignore
        const timer = this.io.setTimeoutFn(()=>{
            delete this.acks[id];
            for(let i = 0; i < this.sendBuffer.length; i++)if (this.sendBuffer[i].id === id) this.sendBuffer.splice(i, 1);
            ack.call(this, new Error("operation has timed out"));
        }, timeout);
        const fn = (...args)=>{
            // @ts-ignore
            this.io.clearTimeoutFn(timer);
            ack.apply(this, args);
        };
        fn.withError = true;
        this.acks[id] = fn;
    }
    /**
     * Emits an event and waits for an acknowledgement
     *
     * @example
     * // without timeout
     * const response = await socket.emitWithAck("hello", "world");
     *
     * // with a specific timeout
     * try {
     *   const response = await socket.timeout(1000).emitWithAck("hello", "world");
     * } catch (err) {
     *   // the server did not acknowledge the event in the given delay
     * }
     *
     * @return a Promise that will be fulfilled when the server acknowledges the event
     */ emitWithAck(ev, ...args) {
        return new Promise((resolve, reject)=>{
            const fn = (arg1, arg2)=>{
                return arg1 ? reject(arg1) : resolve(arg2);
            };
            fn.withError = true;
            args.push(fn);
            this.emit(ev, ...args);
        });
    }
    /**
     * Add the packet to the queue.
     * @param args
     * @private
     */ _addToQueue(args) {
        let ack;
        if (typeof args[args.length - 1] === "function") ack = args.pop();
        const packet = {
            id: this._queueSeq++,
            tryCount: 0,
            pending: false,
            args: args,
            flags: Object.assign({
                fromQueue: true
            }, this.flags)
        };
        args.push((err, ...responseArgs)=>{
            if (packet !== this._queue[0]) // the packet has already been acknowledged
            return;
            const hasError = err !== null;
            if (hasError) {
                if (packet.tryCount > this._opts.retries) {
                    this._queue.shift();
                    if (ack) ack(err);
                }
            } else {
                this._queue.shift();
                if (ack) ack(null, ...responseArgs);
            }
            packet.pending = false;
            return this._drainQueue();
        });
        this._queue.push(packet);
        this._drainQueue();
    }
    /**
     * Send the first packet of the queue, and wait for an acknowledgement from the server.
     * @param force - whether to resend a packet that has not been acknowledged yet
     *
     * @private
     */ _drainQueue(force = false) {
        if (!this.connected || this._queue.length === 0) return;
        const packet = this._queue[0];
        if (packet.pending && !force) return;
        packet.pending = true;
        packet.tryCount++;
        this.flags = packet.flags;
        this.emit.apply(this, packet.args);
    }
    /**
     * Sends a packet.
     *
     * @param packet
     * @private
     */ packet(packet) {
        packet.nsp = this.nsp;
        this.io._packet(packet);
    }
    /**
     * Called upon engine `open`.
     *
     * @private
     */ onopen() {
        if (typeof this.auth == "function") this.auth((data)=>{
            this._sendConnectPacket(data);
        });
        else this._sendConnectPacket(this.auth);
    }
    /**
     * Sends a CONNECT packet to initiate the Socket.IO session.
     *
     * @param data
     * @private
     */ _sendConnectPacket(data) {
        this.packet({
            type: (0, $1e4e6e6cc3958162$export$84d4095e16c6fc19).CONNECT,
            data: this._pid ? Object.assign({
                pid: this._pid,
                offset: this._lastOffset
            }, data) : data
        });
    }
    /**
     * Called upon engine or manager `error`.
     *
     * @param err
     * @private
     */ onerror(err) {
        if (!this.connected) this.emitReserved("connect_error", err);
    }
    /**
     * Called upon engine `close`.
     *
     * @param reason
     * @param description
     * @private
     */ onclose(reason, description) {
        this.connected = false;
        delete this.id;
        this.emitReserved("disconnect", reason, description);
        this._clearAcks();
    }
    /**
     * Clears the acknowledgement handlers upon disconnection, since the client will never receive an acknowledgement from
     * the server.
     *
     * @private
     */ _clearAcks() {
        Object.keys(this.acks).forEach((id)=>{
            const isBuffered = this.sendBuffer.some((packet)=>String(packet.id) === id);
            if (!isBuffered) {
                // note: handlers that do not accept an error as first argument are ignored here
                const ack = this.acks[id];
                delete this.acks[id];
                if (ack.withError) ack.call(this, new Error("socket has been disconnected"));
            }
        });
    }
    /**
     * Called with socket packet.
     *
     * @param packet
     * @private
     */ onpacket(packet) {
        const sameNamespace = packet.nsp === this.nsp;
        if (!sameNamespace) return;
        switch(packet.type){
            case (0, $1e4e6e6cc3958162$export$84d4095e16c6fc19).CONNECT:
                if (packet.data && packet.data.sid) this.onconnect(packet.data.sid, packet.data.pid);
                else this.emitReserved("connect_error", new Error("It seems you are trying to reach a Socket.IO server in v2.x with a v3.x client, but they are not compatible (more information here: https://socket.io/docs/v3/migrating-from-2-x-to-3-0/)"));
                break;
            case (0, $1e4e6e6cc3958162$export$84d4095e16c6fc19).EVENT:
            case (0, $1e4e6e6cc3958162$export$84d4095e16c6fc19).BINARY_EVENT:
                this.onevent(packet);
                break;
            case (0, $1e4e6e6cc3958162$export$84d4095e16c6fc19).ACK:
            case (0, $1e4e6e6cc3958162$export$84d4095e16c6fc19).BINARY_ACK:
                this.onack(packet);
                break;
            case (0, $1e4e6e6cc3958162$export$84d4095e16c6fc19).DISCONNECT:
                this.ondisconnect();
                break;
            case (0, $1e4e6e6cc3958162$export$84d4095e16c6fc19).CONNECT_ERROR:
                this.destroy();
                const err = new Error(packet.data.message);
                // @ts-ignore
                err.data = packet.data.data;
                this.emitReserved("connect_error", err);
                break;
        }
    }
    /**
     * Called upon a server event.
     *
     * @param packet
     * @private
     */ onevent(packet) {
        const args = packet.data || [];
        if (null != packet.id) args.push(this.ack(packet.id));
        if (this.connected) this.emitEvent(args);
        else this.receiveBuffer.push(Object.freeze(args));
    }
    emitEvent(args) {
        if (this._anyListeners && this._anyListeners.length) {
            const listeners = this._anyListeners.slice();
            for (const listener of listeners)listener.apply(this, args);
        }
        super.emit.apply(this, args);
        if (this._pid && args.length && typeof args[args.length - 1] === "string") this._lastOffset = args[args.length - 1];
    }
    /**
     * Produces an ack callback to emit with an event.
     *
     * @private
     */ ack(id) {
        const self = this;
        let sent = false;
        return function(...args) {
            // prevent double callbacks
            if (sent) return;
            sent = true;
            self.packet({
                type: (0, $1e4e6e6cc3958162$export$84d4095e16c6fc19).ACK,
                id: id,
                data: args
            });
        };
    }
    /**
     * Called upon a server acknowledgement.
     *
     * @param packet
     * @private
     */ onack(packet) {
        const ack = this.acks[packet.id];
        if (typeof ack !== "function") return;
        delete this.acks[packet.id];
        // @ts-ignore FIXME ack is incorrectly inferred as 'never'
        if (ack.withError) packet.data.unshift(null);
        // @ts-ignore
        ack.apply(this, packet.data);
    }
    /**
     * Called upon server connect.
     *
     * @private
     */ onconnect(id, pid) {
        this.id = id;
        this.recovered = pid && this._pid === pid;
        this._pid = pid; // defined only if connection state recovery is enabled
        this.connected = true;
        this.emitBuffered();
        this.emitReserved("connect");
        this._drainQueue(true);
    }
    /**
     * Emit buffered events (received and emitted).
     *
     * @private
     */ emitBuffered() {
        this.receiveBuffer.forEach((args)=>this.emitEvent(args));
        this.receiveBuffer = [];
        this.sendBuffer.forEach((packet)=>{
            this.notifyOutgoingListeners(packet);
            this.packet(packet);
        });
        this.sendBuffer = [];
    }
    /**
     * Called upon server disconnect.
     *
     * @private
     */ ondisconnect() {
        this.destroy();
        this.onclose("io server disconnect");
    }
    /**
     * Called upon forced client/server side disconnections,
     * this method ensures the manager stops tracking us and
     * that reconnections don't get triggered for this.
     *
     * @private
     */ destroy() {
        if (this.subs) {
            // clean subscriptions to avoid reconnections
            this.subs.forEach((subDestroy)=>subDestroy());
            this.subs = undefined;
        }
        this.io["_destroy"](this);
    }
    /**
     * Disconnects the socket manually. In that case, the socket will not try to reconnect.
     *
     * If this is the last active Socket instance of the {@link Manager}, the low-level connection will be closed.
     *
     * @example
     * const socket = io();
     *
     * socket.on("disconnect", (reason) => {
     *   // console.log(reason); prints "io client disconnect"
     * });
     *
     * socket.disconnect();
     *
     * @return self
     */ disconnect() {
        if (this.connected) this.packet({
            type: (0, $1e4e6e6cc3958162$export$84d4095e16c6fc19).DISCONNECT
        });
        // remove socket from pool
        this.destroy();
        if (this.connected) // fire events
        this.onclose("io client disconnect");
        return this;
    }
    /**
     * Alias for {@link disconnect()}.
     *
     * @return self
     */ close() {
        return this.disconnect();
    }
    /**
     * Sets the compress flag.
     *
     * @example
     * socket.compress(false).emit("hello");
     *
     * @param compress - if `true`, compresses the sending data
     * @return self
     */ compress(compress) {
        this.flags.compress = compress;
        return this;
    }
    /**
     * Sets a modifier for a subsequent event emission that the event message will be dropped when this socket is not
     * ready to send messages.
     *
     * @example
     * socket.volatile.emit("hello"); // the server may or may not receive it
     *
     * @returns self
     */ get volatile() {
        this.flags.volatile = true;
        return this;
    }
    /**
     * Sets a modifier for a subsequent event emission that the callback will be called with an error when the
     * given number of milliseconds have elapsed without an acknowledgement from the server:
     *
     * @example
     * socket.timeout(5000).emit("my-event", (err) => {
     *   if (err) {
     *     // the server did not acknowledge the event in the given delay
     *   }
     * });
     *
     * @returns self
     */ timeout(timeout) {
        this.flags.timeout = timeout;
        return this;
    }
    /**
     * Adds a listener that will be fired when any event is emitted. The event name is passed as the first argument to the
     * callback.
     *
     * @example
     * socket.onAny((event, ...args) => {
     *   console.log(`got ${event}`);
     * });
     *
     * @param listener
     */ onAny(listener) {
        this._anyListeners = this._anyListeners || [];
        this._anyListeners.push(listener);
        return this;
    }
    /**
     * Adds a listener that will be fired when any event is emitted. The event name is passed as the first argument to the
     * callback. The listener is added to the beginning of the listeners array.
     *
     * @example
     * socket.prependAny((event, ...args) => {
     *   console.log(`got event ${event}`);
     * });
     *
     * @param listener
     */ prependAny(listener) {
        this._anyListeners = this._anyListeners || [];
        this._anyListeners.unshift(listener);
        return this;
    }
    /**
     * Removes the listener that will be fired when any event is emitted.
     *
     * @example
     * const catchAllListener = (event, ...args) => {
     *   console.log(`got event ${event}`);
     * }
     *
     * socket.onAny(catchAllListener);
     *
     * // remove a specific listener
     * socket.offAny(catchAllListener);
     *
     * // or remove all listeners
     * socket.offAny();
     *
     * @param listener
     */ offAny(listener) {
        if (!this._anyListeners) return this;
        if (listener) {
            const listeners = this._anyListeners;
            for(let i = 0; i < listeners.length; i++)if (listener === listeners[i]) {
                listeners.splice(i, 1);
                return this;
            }
        } else this._anyListeners = [];
        return this;
    }
    /**
     * Returns an array of listeners that are listening for any event that is specified. This array can be manipulated,
     * e.g. to remove listeners.
     */ listenersAny() {
        return this._anyListeners || [];
    }
    /**
     * Adds a listener that will be fired when any event is emitted. The event name is passed as the first argument to the
     * callback.
     *
     * Note: acknowledgements sent to the server are not included.
     *
     * @example
     * socket.onAnyOutgoing((event, ...args) => {
     *   console.log(`sent event ${event}`);
     * });
     *
     * @param listener
     */ onAnyOutgoing(listener) {
        this._anyOutgoingListeners = this._anyOutgoingListeners || [];
        this._anyOutgoingListeners.push(listener);
        return this;
    }
    /**
     * Adds a listener that will be fired when any event is emitted. The event name is passed as the first argument to the
     * callback. The listener is added to the beginning of the listeners array.
     *
     * Note: acknowledgements sent to the server are not included.
     *
     * @example
     * socket.prependAnyOutgoing((event, ...args) => {
     *   console.log(`sent event ${event}`);
     * });
     *
     * @param listener
     */ prependAnyOutgoing(listener) {
        this._anyOutgoingListeners = this._anyOutgoingListeners || [];
        this._anyOutgoingListeners.unshift(listener);
        return this;
    }
    /**
     * Removes the listener that will be fired when any event is emitted.
     *
     * @example
     * const catchAllListener = (event, ...args) => {
     *   console.log(`sent event ${event}`);
     * }
     *
     * socket.onAnyOutgoing(catchAllListener);
     *
     * // remove a specific listener
     * socket.offAnyOutgoing(catchAllListener);
     *
     * // or remove all listeners
     * socket.offAnyOutgoing();
     *
     * @param [listener] - the catch-all listener (optional)
     */ offAnyOutgoing(listener) {
        if (!this._anyOutgoingListeners) return this;
        if (listener) {
            const listeners = this._anyOutgoingListeners;
            for(let i = 0; i < listeners.length; i++)if (listener === listeners[i]) {
                listeners.splice(i, 1);
                return this;
            }
        } else this._anyOutgoingListeners = [];
        return this;
    }
    /**
     * Returns an array of listeners that are listening for any event that is specified. This array can be manipulated,
     * e.g. to remove listeners.
     */ listenersAnyOutgoing() {
        return this._anyOutgoingListeners || [];
    }
    /**
     * Notify the listeners for each packet sent
     *
     * @param packet
     *
     * @private
     */ notifyOutgoingListeners(packet) {
        if (this._anyOutgoingListeners && this._anyOutgoingListeners.length) {
            const listeners = this._anyOutgoingListeners.slice();
            for (const listener of listeners)listener.apply(this, packet.data);
        }
    }
}




/**
 * Initialize backoff timer with `opts`.
 *
 * - `min` initial timeout in milliseconds [100]
 * - `max` max timeout [10000]
 * - `jitter` [0]
 * - `factor` [2]
 *
 * @param {Object} opts
 * @api public
 */ function $3f0f0eae169725b6$export$2d38012449449c89(opts) {
    opts = opts || {};
    this.ms = opts.min || 100;
    this.max = opts.max || 10000;
    this.factor = opts.factor || 2;
    this.jitter = opts.jitter > 0 && opts.jitter <= 1 ? opts.jitter : 0;
    this.attempts = 0;
}
/**
 * Return the backoff duration.
 *
 * @return {Number}
 * @api public
 */ $3f0f0eae169725b6$export$2d38012449449c89.prototype.duration = function() {
    var ms = this.ms * Math.pow(this.factor, this.attempts++);
    if (this.jitter) {
        var rand = Math.random();
        var deviation = Math.floor(rand * this.jitter * ms);
        ms = (Math.floor(rand * 10) & 1) == 0 ? ms - deviation : ms + deviation;
    }
    return Math.min(ms, this.max) | 0;
};
/**
 * Reset the number of attempts.
 *
 * @api public
 */ $3f0f0eae169725b6$export$2d38012449449c89.prototype.reset = function() {
    this.attempts = 0;
};
/**
 * Set the minimum duration
 *
 * @api public
 */ $3f0f0eae169725b6$export$2d38012449449c89.prototype.setMin = function(min) {
    this.ms = min;
};
/**
 * Set the maximum duration
 *
 * @api public
 */ $3f0f0eae169725b6$export$2d38012449449c89.prototype.setMax = function(max) {
    this.max = max;
};
/**
 * Set the jitter
 *
 * @api public
 */ $3f0f0eae169725b6$export$2d38012449449c89.prototype.setJitter = function(jitter) {
    this.jitter = jitter;
};



class $b78f1c3cb524f77d$export$d0d38e7dec7a1a61 extends (0, $3d905a8ca243a015$export$4293555f241ae35a) {
    constructor(uri, opts){
        var _a;
        super();
        this.nsps = {};
        this.subs = [];
        if (uri && "object" === typeof uri) {
            opts = uri;
            uri = undefined;
        }
        opts = opts || {};
        opts.path = opts.path || "/socket.io";
        this.opts = opts;
        (0, $4028d5a20a4526d1$export$2f67576668b97183)(this, opts);
        this.reconnection(opts.reconnection !== false);
        this.reconnectionAttempts(opts.reconnectionAttempts || Infinity);
        this.reconnectionDelay(opts.reconnectionDelay || 1000);
        this.reconnectionDelayMax(opts.reconnectionDelayMax || 5000);
        this.randomizationFactor((_a = opts.randomizationFactor) !== null && _a !== void 0 ? _a : 0.5);
        this.backoff = new (0, $3f0f0eae169725b6$export$2d38012449449c89)({
            min: this.reconnectionDelay(),
            max: this.reconnectionDelayMax(),
            jitter: this.randomizationFactor()
        });
        this.timeout(null == opts.timeout ? 20000 : opts.timeout);
        this._readyState = "closed";
        this.uri = uri;
        const _parser = opts.parser || $1e4e6e6cc3958162$exports;
        this.encoder = new _parser.Encoder();
        this.decoder = new _parser.Decoder();
        this._autoConnect = opts.autoConnect !== false;
        if (this._autoConnect) this.open();
    }
    reconnection(v) {
        if (!arguments.length) return this._reconnection;
        this._reconnection = !!v;
        if (!v) this.skipReconnect = true;
        return this;
    }
    reconnectionAttempts(v) {
        if (v === undefined) return this._reconnectionAttempts;
        this._reconnectionAttempts = v;
        return this;
    }
    reconnectionDelay(v) {
        var _a;
        if (v === undefined) return this._reconnectionDelay;
        this._reconnectionDelay = v;
        (_a = this.backoff) === null || _a === void 0 || _a.setMin(v);
        return this;
    }
    randomizationFactor(v) {
        var _a;
        if (v === undefined) return this._randomizationFactor;
        this._randomizationFactor = v;
        (_a = this.backoff) === null || _a === void 0 || _a.setJitter(v);
        return this;
    }
    reconnectionDelayMax(v) {
        var _a;
        if (v === undefined) return this._reconnectionDelayMax;
        this._reconnectionDelayMax = v;
        (_a = this.backoff) === null || _a === void 0 || _a.setMax(v);
        return this;
    }
    timeout(v) {
        if (!arguments.length) return this._timeout;
        this._timeout = v;
        return this;
    }
    /**
     * Starts trying to reconnect if reconnection is enabled and we have not
     * started reconnecting yet
     *
     * @private
     */ maybeReconnectOnOpen() {
        // Only try to reconnect if it's the first time we're connecting
        if (!this._reconnecting && this._reconnection && this.backoff.attempts === 0) // keeps reconnection from firing twice for the same reconnection loop
        this.reconnect();
    }
    /**
     * Sets the current transport `socket`.
     *
     * @param {Function} fn - optional, callback
     * @return self
     * @public
     */ open(fn) {
        if (~this._readyState.indexOf("open")) return this;
        this.engine = new (0, $787375aed2c43820$export$4798917dbf149b79)(this.uri, this.opts);
        const socket = this.engine;
        const self = this;
        this._readyState = "opening";
        this.skipReconnect = false;
        // emit `open`
        const openSubDestroy = (0, $05fb321879039179$export$af631764ddc44097)(socket, "open", function() {
            self.onopen();
            fn && fn();
        });
        const onError = (err)=>{
            this.cleanup();
            this._readyState = "closed";
            this.emitReserved("error", err);
            if (fn) fn(err);
            else // Only do this if there is no fn to handle the error
            this.maybeReconnectOnOpen();
        };
        // emit `error`
        const errorSub = (0, $05fb321879039179$export$af631764ddc44097)(socket, "error", onError);
        if (false !== this._timeout) {
            const timeout = this._timeout;
            // set timer
            const timer = this.setTimeoutFn(()=>{
                openSubDestroy();
                onError(new Error("timeout"));
                socket.close();
            }, timeout);
            if (this.opts.autoUnref) timer.unref();
            this.subs.push(()=>{
                this.clearTimeoutFn(timer);
            });
        }
        this.subs.push(openSubDestroy);
        this.subs.push(errorSub);
        return this;
    }
    /**
     * Alias for open()
     *
     * @return self
     * @public
     */ connect(fn) {
        return this.open(fn);
    }
    /**
     * Called upon transport open.
     *
     * @private
     */ onopen() {
        // clear old subs
        this.cleanup();
        // mark as open
        this._readyState = "open";
        this.emitReserved("open");
        // add new subs
        const socket = this.engine;
        this.subs.push((0, $05fb321879039179$export$af631764ddc44097)(socket, "ping", this.onping.bind(this)), (0, $05fb321879039179$export$af631764ddc44097)(socket, "data", this.ondata.bind(this)), (0, $05fb321879039179$export$af631764ddc44097)(socket, "error", this.onerror.bind(this)), (0, $05fb321879039179$export$af631764ddc44097)(socket, "close", this.onclose.bind(this)), // @ts-ignore
        (0, $05fb321879039179$export$af631764ddc44097)(this.decoder, "decoded", this.ondecoded.bind(this)));
    }
    /**
     * Called upon a ping.
     *
     * @private
     */ onping() {
        this.emitReserved("ping");
    }
    /**
     * Called with data.
     *
     * @private
     */ ondata(data) {
        try {
            this.decoder.add(data);
        } catch (e) {
            this.onclose("parse error", e);
        }
    }
    /**
     * Called when parser fully decodes a packet.
     *
     * @private
     */ ondecoded(packet) {
        // the nextTick call prevents an exception in a user-provided event listener from triggering a disconnection due to a "parse error"
        (0, $8959bb304e43f43f$export$bdd553fddd433dcb)(()=>{
            this.emitReserved("packet", packet);
        }, this.setTimeoutFn);
    }
    /**
     * Called upon socket error.
     *
     * @private
     */ onerror(err) {
        this.emitReserved("error", err);
    }
    /**
     * Creates a new socket for the given `nsp`.
     *
     * @return {Socket}
     * @public
     */ socket(nsp, opts) {
        let socket = this.nsps[nsp];
        if (!socket) {
            socket = new (0, $fcab49da21a6222a$export$4798917dbf149b79)(this, nsp, opts);
            this.nsps[nsp] = socket;
        } else if (this._autoConnect && !socket.active) socket.connect();
        return socket;
    }
    /**
     * Called upon a socket close.
     *
     * @param socket
     * @private
     */ _destroy(socket) {
        const nsps = Object.keys(this.nsps);
        for (const nsp of nsps){
            const socket = this.nsps[nsp];
            if (socket.active) return;
        }
        this._close();
    }
    /**
     * Writes a packet.
     *
     * @param packet
     * @private
     */ _packet(packet) {
        const encodedPackets = this.encoder.encode(packet);
        for(let i = 0; i < encodedPackets.length; i++)this.engine.write(encodedPackets[i], packet.options);
    }
    /**
     * Clean up transport subscriptions and packet buffer.
     *
     * @private
     */ cleanup() {
        this.subs.forEach((subDestroy)=>subDestroy());
        this.subs.length = 0;
        this.decoder.destroy();
    }
    /**
     * Close the current socket.
     *
     * @private
     */ _close() {
        this.skipReconnect = true;
        this._reconnecting = false;
        this.onclose("forced close");
    }
    /**
     * Alias for close()
     *
     * @private
     */ disconnect() {
        return this._close();
    }
    /**
     * Called when:
     *
     * - the low-level engine is closed
     * - the parser encountered a badly formatted packet
     * - all sockets are disconnected
     *
     * @private
     */ onclose(reason, description) {
        var _a;
        this.cleanup();
        (_a = this.engine) === null || _a === void 0 || _a.close();
        this.backoff.reset();
        this._readyState = "closed";
        this.emitReserved("close", reason, description);
        if (this._reconnection && !this.skipReconnect) this.reconnect();
    }
    /**
     * Attempt a reconnection.
     *
     * @private
     */ reconnect() {
        if (this._reconnecting || this.skipReconnect) return this;
        const self = this;
        if (this.backoff.attempts >= this._reconnectionAttempts) {
            this.backoff.reset();
            this.emitReserved("reconnect_failed");
            this._reconnecting = false;
        } else {
            const delay = this.backoff.duration();
            this._reconnecting = true;
            const timer = this.setTimeoutFn(()=>{
                if (self.skipReconnect) return;
                this.emitReserved("reconnect_attempt", self.backoff.attempts);
                // check again for the case socket closed in above events
                if (self.skipReconnect) return;
                self.open((err)=>{
                    if (err) {
                        self._reconnecting = false;
                        self.reconnect();
                        this.emitReserved("reconnect_error", err);
                    } else self.onreconnect();
                });
            }, delay);
            if (this.opts.autoUnref) timer.unref();
            this.subs.push(()=>{
                this.clearTimeoutFn(timer);
            });
        }
    }
    /**
     * Called upon successful reconnect.
     *
     * @private
     */ onreconnect() {
        const attempt = this.backoff.attempts;
        this._reconnecting = false;
        this.backoff.reset();
        this.emitReserved("reconnect", attempt);
    }
}





/**
 * Managers cache.
 */ const $523eaa49d3f99bf8$var$cache = {};
function $523eaa49d3f99bf8$export$841407ceb083bd74(uri, opts) {
    if (typeof uri === "object") {
        opts = uri;
        uri = undefined;
    }
    opts = opts || {};
    const parsed = (0, $efe27346e00da8a8$export$128fa18b7194ef)(uri, opts.path || "/socket.io");
    const source = parsed.source;
    const id = parsed.id;
    const path = parsed.path;
    const sameNamespace = $523eaa49d3f99bf8$var$cache[id] && path in $523eaa49d3f99bf8$var$cache[id]["nsps"];
    const newConnection = opts.forceNew || opts["force new connection"] || false === opts.multiplex || sameNamespace;
    let io;
    if (newConnection) io = new (0, $b78f1c3cb524f77d$export$d0d38e7dec7a1a61)(source, opts);
    else {
        if (!$523eaa49d3f99bf8$var$cache[id]) $523eaa49d3f99bf8$var$cache[id] = new (0, $b78f1c3cb524f77d$export$d0d38e7dec7a1a61)(source, opts);
        io = $523eaa49d3f99bf8$var$cache[id];
    }
    if (parsed.query && !opts.query) opts.query = parsed.queryKey;
    return io.socket(parsed.path, opts);
}
// so that "lookup" can be used both as a function (e.g. `io(...)`) and as a
// namespace (e.g. `io.connect(...)`), for backward compatibility
Object.assign($523eaa49d3f99bf8$export$841407ceb083bd74, {
    Manager: $b78f1c3cb524f77d$export$d0d38e7dec7a1a61,
    Socket: $fcab49da21a6222a$export$4798917dbf149b79,
    io: $523eaa49d3f99bf8$export$841407ceb083bd74,
    connect: $523eaa49d3f99bf8$export$841407ceb083bd74
});



var $a26018a1d2174fbf$var$_tmpl$ = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<div class=socket-status style=position:fixed;top:20px;left:50%;transform:translateX(-50%);z-index:9999;width:90%;max-width:600px><div class="alert alert-warning text-center shadow-lg"role=alert><h4 class=alert-heading><i class="fas fa-tools me-2"></i>Maintenance en cours</h4><p class=mb-0>`), $a26018a1d2174fbf$var$_tmpl$2 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<div class=socket-status><div class="alert alert-danger"role=alert><div class=spinner-border role=status><span class=visually-hidden>Loading...</span></div>Connexion au serveur perdue...`);
const $a26018a1d2174fbf$var$socket = (0, $523eaa49d3f99bf8$export$841407ceb083bd74)({
    transports: [
        "websocket",
        "polling"
    ] // use WebSocket first, if available
});
var $a26018a1d2174fbf$export$2e2bcd8739ae039 = $a26018a1d2174fbf$var$socket;
const $a26018a1d2174fbf$export$d049364d16567d0d = ()=>{
    const [status, setStatus] = (0, $8863cd8fe199f948$export$c1e1e1ecbbe76a5)('disconnected');
    const [maintenanceMessage, setMaintenanceMessage] = (0, $8863cd8fe199f948$export$c1e1e1ecbbe76a5)(null);
    (0, $8863cd8fe199f948$export$1e848a9e87980bd5)(()=>{
        $a26018a1d2174fbf$var$socket.on('connect', ()=>{
            console.log('connected');
            setStatus('connected');
            setMaintenanceMessage(null);
        });
        $a26018a1d2174fbf$var$socket.on('disconnect', ()=>{
            setStatus('disconnected');
            console.log('disconnect');
        });
        $a26018a1d2174fbf$var$socket.on('maintenance-mode', (data)=>{
            console.log('Maintenance mode:', data);
            setMaintenanceMessage(data.message);
            setStatus('maintenance');
        });
    });
    return [
        (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
            get when () {
                return maintenanceMessage();
            },
            get children () {
                var _el$ = $a26018a1d2174fbf$var$_tmpl$(), _el$2 = _el$.firstChild, _el$3 = _el$2.firstChild, _el$4 = _el$3.nextSibling;
                (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$4, maintenanceMessage);
                return _el$;
            }
        }),
        (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
            get when () {
                return (0, $6258376c5c54faa9$export$7c73462e0d25e514)(()=>status() === 'disconnected')() && !maintenanceMessage();
            },
            get children () {
                return $a26018a1d2174fbf$var$_tmpl$2();
            }
        })
    ];
};






// Create a context for connection management
const $89c51277d5b9a262$var$ConnectionContext = (0, $8863cd8fe199f948$export$fd42f52fd3ae1109)();
function $89c51277d5b9a262$export$30c420163f6d7eb3(props) {
    // Create connection store
    const [connectionStore, setConnectionStore] = (0, $caa70d287a6ddb62$export$f51a9068ac82ea43)({
        isOffline: !navigator.onLine,
        // Initial value based on browser's online status
        socketConnected: false,
        connectionAttempts: 0
    });
    const MAX_CONNECTION_ATTEMPTS = 2; // Switch to offline after 2 failed attempts
    // Socket connection events handlers
    const handleConnect = ()=>{
        console.log("Socket connected to server");
        setConnectionStore({
            socketConnected: true,
            connectionAttempts: 0,
            isOffline: false
        });
    };
    const handleConnectError = (error)=>{
        console.log("Socket connection error:", error);
        // Increment connection attempts
        const newAttempts = connectionStore.connectionAttempts + 1;
        setConnectionStore('connectionAttempts', newAttempts);
        // If we've reached max attempts, consider server offline
        if (newAttempts >= MAX_CONNECTION_ATTEMPTS) {
            console.log(`Failed to connect ${newAttempts} times, switching to offline mode`);
            setConnectionStore('isOffline', true);
        }
    };
    const handleDisconnect = (reason)=>{
        console.log("Socket disconnected:", reason);
        setConnectionStore('socketConnected', false);
        // If the disconnection wasn't initiated by the client, consider it a server issue
        if (reason === 'io server disconnect' || reason === 'transport close' || reason === 'transport error') {
            const newAttempts = connectionStore.connectionAttempts + 1;
            setConnectionStore('connectionAttempts', newAttempts);
            if (newAttempts >= MAX_CONNECTION_ATTEMPTS) {
                console.log(`Disconnected ${newAttempts} times, switching to offline mode`);
                setConnectionStore('isOffline', true);
            }
        }
    };
    // Browser online/offline event handler
    const handleOnlineStatusChange = ()=>{
        const isOffline = !navigator.onLine;
        console.log(`Device is now ${isOffline ? 'offline' : 'online'}`);
        if (isOffline) // Device went offline
        setConnectionStore('isOffline', true);
        else // Device came online, but we still need to check server availability
        // The server might still be offline even though the device is online
        // We'll let socket connection handle this (don't immediately set to online)
        // Try reconnecting
        (0, $a26018a1d2174fbf$export$2e2bcd8739ae039).connect();
    };
    // Initialize connection manager
    (0, $8863cd8fe199f948$export$1e848a9e87980bd5)(()=>{
        console.log('ConnectionManager mounted');
        // Register socket event handlers
        (0, $a26018a1d2174fbf$export$2e2bcd8739ae039).on("connect", handleConnect);
        (0, $a26018a1d2174fbf$export$2e2bcd8739ae039).on("connect_error", handleConnectError);
        (0, $a26018a1d2174fbf$export$2e2bcd8739ae039).on("disconnect", handleDisconnect);
        // Register browser online/offline event handlers
        window.addEventListener('online', handleOnlineStatusChange);
        window.addEventListener('offline', handleOnlineStatusChange);
        // Initial connection if online
        if (navigator.onLine) {
            console.log('Browser is online, attempting socket connection');
            (0, $a26018a1d2174fbf$export$2e2bcd8739ae039).connect();
        } else {
            console.log('Browser is offline, not attempting socket connection');
            setConnectionStore('isOffline', true);
        }
        // Cleanup on unmount
        (0, $8863cd8fe199f948$export$b36e5eaa3e8c43ab)(()=>{
            console.log('ConnectionManager unmounted');
            (0, $a26018a1d2174fbf$export$2e2bcd8739ae039).off("connect", handleConnect);
            (0, $a26018a1d2174fbf$export$2e2bcd8739ae039).off("connect_error", handleConnectError);
            (0, $a26018a1d2174fbf$export$2e2bcd8739ae039).off("disconnect", handleDisconnect);
            window.removeEventListener('online', handleOnlineStatusChange);
            window.removeEventListener('offline', handleOnlineStatusChange);
        });
    });
    // Expose methods for components to use
    const connectionManager = {
        connect: ()=>{
            if (navigator.onLine && !(0, $a26018a1d2174fbf$export$2e2bcd8739ae039).connected) (0, $a26018a1d2174fbf$export$2e2bcd8739ae039).connect();
        },
        disconnect: ()=>{
            (0, $a26018a1d2174fbf$export$2e2bcd8739ae039).disconnect();
        },
        // Method to reset connection attempts counter
        resetConnectionAttempts: ()=>{
            setConnectionStore('connectionAttempts', 0);
        }
    };
    return (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)($89c51277d5b9a262$var$ConnectionContext.Provider, {
        value: [
            connectionStore,
            setConnectionStore,
            connectionManager
        ],
        get children () {
            return props.children;
        }
    });
}
function $89c51277d5b9a262$export$985e8768c0e91dbc() {
    return (0, $8863cd8fe199f948$export$fae74005e78b1a27)($89c51277d5b9a262$var$ConnectionContext);
}




// offlineDB.js - Handles IndexedDB operations for offline data
const $982a2c16e80ec032$export$3c22ff8b64b8f565 = 'prestage-offline-db';
const $982a2c16e80ec032$export$6a9022b4c5fcea02 = 2; // Incrementing the version number to trigger database upgrade
const $982a2c16e80ec032$export$e0470b7b7d82ad1c = 'conventions';
const $982a2c16e80ec032$export$ff73bb0e6b82b882 = 'user-data';
function $982a2c16e80ec032$export$ca0ed41b1a2af7e() {
    return new Promise((resolve, reject)=>{
        const request = indexedDB.open($982a2c16e80ec032$export$3c22ff8b64b8f565, $982a2c16e80ec032$export$6a9022b4c5fcea02);
        request.onerror = (event)=>{
            console.error('IndexedDB error:', event.target.error);
            reject(event.target.error);
        };
        request.onsuccess = (event)=>{
            resolve(event.target.result);
        };
        request.onupgradeneeded = (event)=>{
            const db = event.target.result;
            // Create object stores when the database is first created or version is upgraded
            if (!db.objectStoreNames.contains($982a2c16e80ec032$export$e0470b7b7d82ad1c)) {
                db.createObjectStore($982a2c16e80ec032$export$e0470b7b7d82ad1c, {
                    keyPath: 'timestamp'
                });
                console.log('Created conventions store in IndexedDB');
            }
            // Create user data store if it doesn't exist
            if (!db.objectStoreNames.contains($982a2c16e80ec032$export$ff73bb0e6b82b882)) {
                db.createObjectStore($982a2c16e80ec032$export$ff73bb0e6b82b882, {
                    keyPath: 'id'
                });
                console.log('Created user data store in IndexedDB');
            }
        };
    });
}
async function $982a2c16e80ec032$export$7e3e36ccee9b2311(data) {
    try {
        const db = await $982a2c16e80ec032$export$ca0ed41b1a2af7e();
        // Create a single transaction for both operations
        const transaction = db.transaction($982a2c16e80ec032$export$e0470b7b7d82ad1c, 'readwrite');
        const store = transaction.objectStore($982a2c16e80ec032$export$e0470b7b7d82ad1c);
        // Return a promise that resolves when the transaction is complete
        return new Promise((resolve, reject)=>{
            // First clear the store
            const clearRequest = store.clear();
            clearRequest.onerror = (event)=>{
                console.error('Error clearing store:', event.target.error);
                reject(event.target.error);
            };
            clearRequest.onsuccess = ()=>{
                // After clearing, add the new data in the same transaction
                const record = {
                    timestamp: Date.now(),
                    data: data
                };
                const addRequest = store.add(record);
                addRequest.onerror = (event)=>{
                    console.error('Error saving conventions data:', event.target.error);
                    reject(event.target.error);
                };
                addRequest.onsuccess = ()=>{
                    console.log('Conventions data saved to IndexedDB');
                    resolve(true);
                };
            };
            // Listen for transaction completion
            transaction.oncomplete = ()=>{
                console.log('Transaction completed successfully');
            };
            transaction.onerror = (event)=>{
                console.error('Transaction failed:', event.target.error);
                reject(event.target.error);
            };
        });
    } catch (error) {
        console.error('Failed to save conventions data:', error);
        return false;
    }
}
async function $982a2c16e80ec032$export$7586138ff715c604() {
    try {
        const db = await $982a2c16e80ec032$export$ca0ed41b1a2af7e();
        const transaction = db.transaction($982a2c16e80ec032$export$e0470b7b7d82ad1c, 'readonly');
        const store = transaction.objectStore($982a2c16e80ec032$export$e0470b7b7d82ad1c);
        // Use IDBKeyRange to get the latest entry
        const request = store.openCursor(null, 'prev');
        return new Promise((resolve, reject)=>{
            request.onsuccess = (event)=>{
                const cursor = event.target.result;
                if (cursor) resolve(cursor.value);
                else resolve(null);
            };
            request.onerror = (event)=>{
                console.error('Error retrieving conventions data:', event.target.error);
                reject(event.target.error);
            };
        });
    } catch (error) {
        console.error('Failed to get conventions data:', error);
        return null;
    }
}
async function $982a2c16e80ec032$export$9f43f72cb45956cb(userData) {
    try {
        const db = await $982a2c16e80ec032$export$ca0ed41b1a2af7e();
        const transaction = db.transaction($982a2c16e80ec032$export$ff73bb0e6b82b882, 'readwrite');
        const store = transaction.objectStore($982a2c16e80ec032$export$ff73bb0e6b82b882);
        return new Promise((resolve, reject)=>{
            // Store with fixed ID to always have single current user record
            const record = {
                id: 'currentUser',
                data: userData,
                timestamp: Date.now()
            };
            const addRequest = store.put(record); // use put instead of add to overwrite existing
            addRequest.onerror = (event)=>{
                console.error('Error saving user data:', event.target.error);
                reject(event.target.error);
            };
            addRequest.onsuccess = ()=>{
                console.log('User data saved to IndexedDB');
                resolve(true);
            };
        });
    } catch (error) {
        console.error('Failed to save user data:', error);
        return false;
    }
}
async function $982a2c16e80ec032$export$3f90b926bc531097() {
    try {
        const db = await $982a2c16e80ec032$export$ca0ed41b1a2af7e();
        const transaction = db.transaction($982a2c16e80ec032$export$ff73bb0e6b82b882, 'readonly');
        const store = transaction.objectStore($982a2c16e80ec032$export$ff73bb0e6b82b882);
        const request = store.get('currentUser');
        return new Promise((resolve, reject)=>{
            request.onsuccess = (event)=>{
                if (request.result) resolve(request.result.data);
                else resolve(null);
            };
            request.onerror = (event)=>{
                console.error('Error retrieving user data:', event.target.error);
                reject(event.target.error);
            };
        });
    } catch (error) {
        console.error('Failed to get user data:', error);
        return null;
    }
}
async function $982a2c16e80ec032$export$882c9a08d8a4fe48() {
    try {
        const userData = await $982a2c16e80ec032$export$3f90b926bc531097();
        return userData && userData.isAdmin === true;
    } catch (error) {
        console.error('Error checking admin status:', error);
        return false;
    }
}



// Create context for offline data management
const $ef60b4f4f09c584e$var$OfflineDataContext = (0, $8863cd8fe199f948$export$fd42f52fd3ae1109)();
function $ef60b4f4f09c584e$export$dc480220161ce7c5(props) {
    const [connectionStore] = (0, $89c51277d5b9a262$export$985e8768c0e91dbc)();
    // Create effect to watch for offline state changes
    (0, $8863cd8fe199f948$export$7ea7134f704deda4)(()=>{
        if (connectionStore.isOffline) console.log("Application went offline, will use cached data");
        else console.log("Application is online, will use live data");
    });
    // Offline data manager functions
    const offlineDataManager = {
        // User data functions
        saveUserData: async (userData)=>{
            if (!userData?.username) {
                console.warn("Cannot save empty user data to cache");
                return false;
            }
            console.log('Saving user data to IndexedDB for offline use:', userData);
            try {
                return await (0, $982a2c16e80ec032$export$9f43f72cb45956cb)(userData);
            } catch (error) {
                console.error("Error saving user data:", error);
                return false;
            }
        },
        loadUserData: async ()=>{
            console.log('Loading user data from cache...');
            try {
                const data = await (0, $982a2c16e80ec032$export$3f90b926bc531097)();
                if (data) {
                    console.log('Loaded cached user data:', data);
                    return data;
                } else {
                    console.log('No cached user data found.');
                    return null;
                }
            } catch (error) {
                console.error("Error loading user data:", error);
                return null;
            }
        },
        // Conventions data functions
        saveConventionsData: async (data)=>{
            if (!data || Array.isArray(data) && data.length === 0) {
                console.warn("Cannot save empty conventions data to cache");
                return false;
            }
            console.log('Saving conventions data to IndexedDB for offline use');
            try {
                return await (0, $982a2c16e80ec032$export$7e3e36ccee9b2311)(data);
            } catch (error) {
                console.error("Error saving conventions data:", error);
                return false;
            }
        },
        loadConventionsData: async ()=>{
            console.log('Loading conventions data from cache...');
            try {
                const result = await (0, $982a2c16e80ec032$export$7586138ff715c604)();
                if (result && result.data) {
                    console.log('Loaded cached conventions data');
                    return {
                        conventions: result.data,
                        lastUpdated: result.timestamp
                    };
                } else {
                    console.log('No cached conventions data found.');
                    return null;
                }
            } catch (error) {
                console.error("Error loading conventions data:", error);
                return null;
            }
        },
        // Helper functions
        isOffline: ()=>connectionStore.isOffline
    };
    return (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)($ef60b4f4f09c584e$var$OfflineDataContext.Provider, {
        value: offlineDataManager,
        get children () {
            return props.children;
        }
    });
}
function $ef60b4f4f09c584e$export$c5bb400d30441f4c() {
    return (0, $8863cd8fe199f948$export$fae74005e78b1a27)($ef60b4f4f09c584e$var$OfflineDataContext);
}








const $c3b276e29c1ce2f2$var$UserContext = (0, $8863cd8fe199f948$export$fd42f52fd3ae1109)();
// retrieve query params 'jwt' and 'page'
const $c3b276e29c1ce2f2$var$urlParams = new URLSearchParams(window.location.search);
const $c3b276e29c1ce2f2$var$jwt = $c3b276e29c1ce2f2$var$urlParams.get('jwt') || localStorage.getItem('jwt');
// Get the page from URL or default to homepage
const $c3b276e29c1ce2f2$var$initialPage = $c3b276e29c1ce2f2$var$urlParams.get('page') || '/';
if ($c3b276e29c1ce2f2$var$jwt) localStorage.setItem('jwt', $c3b276e29c1ce2f2$var$jwt);
if ($c3b276e29c1ce2f2$var$urlParams.get('jwt')) {
    const newUrl = $c3b276e29c1ce2f2$var$initialPage === '/' ? '/' : `/?page=${encodeURIComponent($c3b276e29c1ce2f2$var$initialPage)}`;
    //remove jwt from url but keep the page parameter if needed
    window.history.replaceState({}, document.title, newUrl);
}
function $c3b276e29c1ce2f2$export$2e7f18b06f26b111(props) {
    // Get connection status from ConnectionManager
    const [connectionStore] = (0, $89c51277d5b9a262$export$985e8768c0e91dbc)();
    // Get offline data manager
    const offlineDataManager = (0, $ef60b4f4f09c584e$export$c5bb400d30441f4c)();
    const [userStore, setUserStore] = (0, $caa70d287a6ddb62$export$f51a9068ac82ea43)({
        isConnected: false,
        isAuthenticated: false,
        projects: [],
        page: $c3b276e29c1ce2f2$var$initialPage,
        // Use the page from URL
        username: null,
        fullname: null,
        email: null,
        role: null,
        isAdmin: false,
        loadingUser: true,
        conventions: [],
        // Only used for non-admin user's own conventions
        promos_by_id: {},
        conventionStructure: {
            fields: []
        } // Default empty structure
    });
    // Handler for popstate events (browser back/forward)
    const handlePopstate = ()=>{
        // Extract the page from the URL
        const urlParams = new URLSearchParams(window.location.search);
        const page = urlParams.get('page') || '/';
        // Update the store with the new page
        setUserStore({
            page: page
        });
    };
    // Effect to react to connection status changes
    (0, $8863cd8fe199f948$export$7ea7134f704deda4)(()=>{
        // Update user store with offline status
        setUserStore('isOffline', connectionStore.isOffline);
        // Load cached user data when going offline
        if (connectionStore.isOffline && userStore.loadingUser) loadUserDataFromCache();
    });
    // Load user data from cache
    const loadUserDataFromCache = async ()=>{
        const userData = await offlineDataManager.loadUserData();
        if (userData) setUserStore({
            ...userData,
            loadingUser: false
        });
        else setUserStore({
            loadingUser: false
        });
    };
    (0, $8863cd8fe199f948$export$7ea7134f704deda4)(()=>{
        if (userStore.isAuthenticated && !connectionStore.isOffline) (0, $a26018a1d2174fbf$export$2e2bcd8739ae039).emit("get-convention-structure");
    });
    (0, $8863cd8fe199f948$export$1e848a9e87980bd5)(()=>{
        console.log('Mounted UserContext');
        // Only try socket connection if online
        if (!connectionStore.isOffline) {
            if ($c3b276e29c1ce2f2$var$jwt) (0, $a26018a1d2174fbf$export$2e2bcd8739ae039).emit("authenticate", $c3b276e29c1ce2f2$var$jwt);
            else setUserStore({
                loadingUser: false
            });
        }
        // Handle browser back/forward buttons
        window.addEventListener('popstate', handlePopstate);
        // Register socket event handlers
        (0, $a26018a1d2174fbf$export$2e2bcd8739ae039).on("projects", (projects)=>{
            setUserStore({
                projects: projects
            });
        });
        (0, $a26018a1d2174fbf$export$2e2bcd8739ae039).on("authenticated", ({ username: username, fullname: fullname, email: email, role: role, promo_id: promo_id, id: id, student_number: student_number, additional_info: additional_info })=>{
            console.log('connected as', {
                username: username,
                fullname: fullname,
                email: email,
                role: role,
                promo_id: promo_id,
                id: id,
                student_number: student_number,
                additional_info: additional_info
            });
            const isAdmin = role === 'admin';
            const userData = {
                isAuthenticated: true,
                username: username,
                fullname: fullname,
                email: email,
                role: role,
                promo_id: promo_id,
                id: id,
                isAdmin: isAdmin,
                loadingUser: false,
                student_number: student_number,
                additional_info: additional_info
            };
            setUserStore(userData);
            // Save user data for offline access
            offlineDataManager.saveUserData(userData);
        });
        (0, $a26018a1d2174fbf$export$2e2bcd8739ae039).on("unauthorized", (error)=>{
            console.log({
                error: error
            });
            localStorage.removeItem('jwt');
            setUserStore({
                username: null,
                role: null,
                isAdmin: false,
                loadingUser: false
            });
        });
        (0, $a26018a1d2174fbf$export$2e2bcd8739ae039).on("conventions-list", (conventions)=>{
            console.log('received conventions-list', conventions);
            setUserStore({
                conventions: conventions
            });
        });
        (0, $a26018a1d2174fbf$export$2e2bcd8739ae039).on("promo-list", (promos)=>{
            console.log('received promo-list', promos);
            // Convert the array to an object with id key for easier lookup
            const promos_by_id = promos.reduce((acc, promo)=>{
                acc[promo.id] = promo;
                return acc;
            }, {});
            setUserStore({
                promos_by_id: promos_by_id
            });
        });
        (0, $a26018a1d2174fbf$export$2e2bcd8739ae039).on("select-promo-done", (promo_id)=>{
            setUserStore((store)=>({
                    ...store,
                    promo_id: promo_id
                }));
        });
        // Handle convention structure from server
        (0, $a26018a1d2174fbf$export$2e2bcd8739ae039).on("convention-structure", (structure)=>{
            console.log('received convention structure', structure);
            setUserStore({
                conventionStructure: structure
            });
        });
        // Cleanup on unmount
        (0, $8863cd8fe199f948$export$b36e5eaa3e8c43ab)(()=>{
            window.removeEventListener('popstate', handlePopstate);
        });
    });
    const actions = {
        createProject: (fields)=>{
            console.log('createProject', fields);
        },
        setPage: (page)=>{
            console.log('setPage', page);
            // Update the URL to reflect the current page
            if (page === '/') // For homepage, remove the page parameter entirely
            window.history.pushState({}, document.title, "/");
            else // For other pages, add/update the page parameter
            window.history.pushState({}, document.title, `/?page=${encodeURIComponent(page)}`);
            setUserStore({
                page: page
            });
        },
        createConvention: ()=>{
            if (connectionStore.isOffline) {
                console.log('Cannot create convention in offline mode');
                return;
            }
            (0, $a26018a1d2174fbf$export$2e2bcd8739ae039).emit("create-convention");
        },
        updateConvention: (id, info)=>{
            if (connectionStore.isOffline) {
                console.log('Cannot update convention in offline mode');
                return;
            }
            (0, $a26018a1d2174fbf$export$2e2bcd8739ae039).emit("update-convention", {
                id: id,
                info: info
            });
        },
        changeConventionStatus: (id, status)=>{
            if (connectionStore.isOffline) {
                console.log('Cannot change convention status in offline mode');
                return;
            }
            (0, $a26018a1d2174fbf$export$2e2bcd8739ae039).emit("change-convention-status", {
                id: id,
                status: status
            });
        },
        deleteConvention: (id)=>{
            if (connectionStore.isOffline) {
                console.log('Cannot delete convention in offline mode');
                return;
            }
            (0, $a26018a1d2174fbf$export$2e2bcd8739ae039).emit("delete-convention", id);
        },
        selectPromo: (promo_id)=>{
            if (connectionStore.isOffline) {
                console.log('Cannot select promo in offline mode');
                return;
            }
            (0, $a26018a1d2174fbf$export$2e2bcd8739ae039).emit("select-promo", promo_id);
        },
        leavePromo: ()=>{
            if (connectionStore.isOffline) {
                console.log('Cannot leave promo in offline mode');
                return;
            }
            // Set promo_id to null in user store and emit event to server
            setUserStore((store)=>({
                    ...store,
                    promo_id: null
                }));
            (0, $a26018a1d2174fbf$export$2e2bcd8739ae039).emit("leave-promo");
        },
        updateUserProfile: (fields)=>{
            if (connectionStore.isOffline) {
                console.log('Cannot update profile in offline mode');
                return Promise.reject(new Error('Cannot update profile in offline mode'));
            }
            return new Promise((resolve, reject)=>{
                const onSuccess = (data)=>{
                    (0, $a26018a1d2174fbf$export$2e2bcd8739ae039).off('update-profile-success', onSuccess);
                    (0, $a26018a1d2174fbf$export$2e2bcd8739ae039).off('update-profile-error', onError);
                    setUserStore(data);
                    // Save updated user data for offline access
                    offlineDataManager.saveUserData(data);
                    resolve(data);
                };
                const onError = (error)=>{
                    (0, $a26018a1d2174fbf$export$2e2bcd8739ae039).off('update-profile-success', onSuccess);
                    (0, $a26018a1d2174fbf$export$2e2bcd8739ae039).off('update-profile-error', onError);
                    reject(error);
                };
                (0, $a26018a1d2174fbf$export$2e2bcd8739ae039).on('update-profile-success', onSuccess);
                (0, $a26018a1d2174fbf$export$2e2bcd8739ae039).on('update-profile-error', onError);
                (0, $a26018a1d2174fbf$export$2e2bcd8739ae039).emit("update-profile", fields);
            });
        }
    };
    return (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)($c3b276e29c1ce2f2$var$UserContext.Provider, {
        value: [
            userStore,
            setUserStore,
            actions
        ],
        get children () {
            return props.children;
        }
    });
}
function $c3b276e29c1ce2f2$export$87c54b525b914dab() {
    return (0, $8863cd8fe199f948$export$fae74005e78b1a27)($c3b276e29c1ce2f2$var$UserContext);
}


const $059fd204a72364ff$var$AdminContext = (0, $8863cd8fe199f948$export$fd42f52fd3ae1109)();
function $059fd204a72364ff$export$66cafb854a568b29(props) {
    // Get connection status from ConnectionManager
    const [connectionStore] = (0, $89c51277d5b9a262$export$985e8768c0e91dbc)();
    // Get offline data manager
    const offlineDataManager = (0, $ef60b4f4f09c584e$export$c5bb400d30441f4c)();
    const [userStore] = (0, $c3b276e29c1ce2f2$export$87c54b525b914dab)();
    const [adminStore, setAdminStore] = (0, $caa70d287a6ddb62$export$f51a9068ac82ea43)({
        users: [],
        conventionStructure: {
            fields: []
        },
        conventionStructureLoading: true,
        results: false,
        resultsFetching: false,
        cachedConventions: null,
        conventionsLastUpdated: null,
        isLoadingConventions: true
    });
    // Effect to handle offline/online transitions
    (0, $8863cd8fe199f948$export$7ea7134f704deda4)(()=>{
        // If we go offline, load cached conventions data
        if (connectionStore.isOffline && adminStore.isLoadingConventions) loadCachedConventions();
    });
    // Load conventions data from cache
    const loadCachedConventions = async ()=>{
        const result = await offlineDataManager.loadConventionsData();
        if (result) {
            setAdminStore({
                cachedConventions: result.conventions,
                conventionsLastUpdated: result.lastUpdated,
                isLoadingConventions: false
            });
            console.log('Admin context loaded cached conventions data');
        } else {
            setAdminStore({
                isLoadingConventions: false
            });
            console.log('No cached conventions data found');
        }
    };
    // Save conventions data to cache
    const saveConventionsToCache = async (data)=>{
        if (!data || Array.isArray(data) && data.length === 0) return;
        try {
            await offlineDataManager.saveConventionsData(data);
            setAdminStore({
                cachedConventions: data,
                conventionsLastUpdated: new Date().getTime()
            });
            console.log('Admin context saved conventions data to cache');
        } catch (error) {
            console.error('Failed to save conventions data to cache:', error);
        }
    };
    (0, $8863cd8fe199f948$export$7ea7134f704deda4)(()=>{
        if (userStore.isAuthenticated && userStore.isAdmin) (0, $a26018a1d2174fbf$export$2e2bcd8739ae039).emit("admin-get-convention-structure", (data)=>{
            if (data && data.success) {
                setAdminStore("conventionStructure", data.structure);
                setAdminStore({
                    conventionStructureLoading: false
                });
            }
        });
    });
    (0, $8863cd8fe199f948$export$1e848a9e87980bd5)(()=>{
        console.log('Mounted AdminContext');
        (0, $a26018a1d2174fbf$export$2e2bcd8739ae039).on("user-list", (users)=>{
            setAdminStore({
                users: users
            });
        });
        (0, $a26018a1d2174fbf$export$2e2bcd8739ae039).on('results', (results)=>{
            setAdminStore({
                results: results,
                resultsFetching: false
            });
        });
        // Handle admin conventions data
        (0, $a26018a1d2174fbf$export$2e2bcd8739ae039).on("admin-all-conventions", (data)=>{
            console.log("Admin received all conventions data");
            setAdminStore({
                cachedConventions: data,
                isLoadingConventions: false
            });
            // Save admin conventions data for offline use
            saveConventionsToCache(data);
        });
    });
    const actions = {
        // Load all conventions (for admin users)
        loadAllConventions: ()=>{
            if (connectionStore.isOffline) // If offline, try to load from cache
            loadCachedConventions();
            else // If online, request from server
            (0, $a26018a1d2174fbf$export$2e2bcd8739ae039).emit("admin-get-all-conventions");
        },
        editPromo: (id, fields)=>{
            if (connectionStore.isOffline) {
                console.log('Cannot edit promo in offline mode');
                return;
            }
            (0, $a26018a1d2174fbf$export$2e2bcd8739ae039).emit('update-promo', {
                id: id,
                fields: fields
            });
        },
        deletePromo: (promo_id)=>{
            if (connectionStore.isOffline) {
                console.log('Cannot delete promo in offline mode');
                return;
            }
            (0, $a26018a1d2174fbf$export$2e2bcd8739ae039).emit('delete-promo', promo_id);
        },
        addPromo: (fields)=>{
            if (connectionStore.isOffline) {
                console.log('Cannot add promo in offline mode');
                return;
            }
            (0, $a26018a1d2174fbf$export$2e2bcd8739ae039).emit('add-promo', fields);
        },
        addPromoValidator: (promo_id, user_id)=>{
            if (connectionStore.isOffline) {
                console.log('Cannot add promo validator in offline mode');
                return;
            }
            (0, $a26018a1d2174fbf$export$2e2bcd8739ae039).emit('add-promo-validator', {
                promo_id: promo_id,
                user_id: user_id
            });
        },
        deletePromoValidator: (promo_id, user_id)=>{
            if (connectionStore.isOffline) {
                console.log('Cannot delete promo validator in offline mode');
                return;
            }
            (0, $a26018a1d2174fbf$export$2e2bcd8739ae039).emit('delete-promo-validator', {
                promo_id: promo_id,
                user_id: user_id
            });
        },
        editUser: (index)=>{
            if (connectionStore.isOffline) {
                console.log('Cannot edit user in offline mode');
                return;
            }
            const user = adminStore.users[index];
            const fields = {
                role: user.roleInput
            };
            // Include email in update if it exists
            if (user.emailInput !== undefined) fields.email = user.emailInput;
            (0, $a26018a1d2174fbf$export$2e2bcd8739ae039).emit('update-user', {
                id: user.id,
                fields: fields
            });
            setAdminStore('users', index, 'editing', false);
        },
        deleteUser: (user_id)=>{
            if (connectionStore.isOffline) {
                console.log('Cannot delete user in offline mode');
                return;
            }
            (0, $a26018a1d2174fbf$export$2e2bcd8739ae039).emit('delete-user', user_id);
            setAdminStore('users', (u)=>u.filter((user)=>user.id !== user_id));
        },
        addUser: (fields)=>{
            if (connectionStore.isOffline) {
                console.log('Cannot add user in offline mode');
                return;
            }
            (0, $a26018a1d2174fbf$export$2e2bcd8739ae039).emit('add-user', fields);
        },
        lockConvention: (conventionId)=>{
            if (connectionStore.isOffline) {
                console.log('Cannot lock convention in offline mode');
                return;
            }
            (0, $a26018a1d2174fbf$export$2e2bcd8739ae039).emit('admin-lock-convention', conventionId, (response)=>{
                if (response.success) console.log('Convention locked successfully');
                else {
                    console.error('Failed to lock convention:', response.error);
                    alert('Failed to lock convention: ' + (response.error || 'Unknown error'));
                }
            });
        },
        unlockConvention: (conventionId)=>{
            if (connectionStore.isOffline) {
                console.log('Cannot unlock convention in offline mode');
                return;
            }
            (0, $a26018a1d2174fbf$export$2e2bcd8739ae039).emit('admin-unlock-convention', conventionId, (response)=>{
                if (response.success) console.log('Convention unlocked successfully');
                else {
                    console.error('Failed to unlock convention:', response.error);
                    alert('Failed to unlock convention: ' + (response.error || 'Unknown error'));
                }
            });
        }
    };
    return (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)($059fd204a72364ff$var$AdminContext.Provider, {
        value: [
            adminStore,
            setAdminStore,
            actions
        ],
        get children () {
            return props.children;
        }
    });
}
function $059fd204a72364ff$export$b3189d039b00bb0c() {
    return (0, $8863cd8fe199f948$export$fae74005e78b1a27)($059fd204a72364ff$var$AdminContext);
}




// filepath: /mnt/d/Seafile/Projects/pre-stage/client/utils.ts
/**
 * Generates a default email address for a user based on their username and role
 * @param username User's username
 * @param role User's role (admin, teacher, or student)
 * @returns The default email address
 */ const $bc18280b634ac0b4$export$a92adec574c54595 = (username, role)=>{
    if (role === 'teacher' || role === 'admin') return `${username}@unistra.fr`;
    else return `${username}@etu.unistra.fr`;
};




// French translations
const $87927b02874039c5$var$translations = {
    // Navigation & Common
    "Pre-Stage": "Pr\xe9-Stage",
    "Home": "Accueil",
    "Admin": "Administration",
    "Settings": "Param\xe8tres",
    "Logout": "D\xe9connexion",
    // User Profile
    "Please enter your full name": "Veuillez entrer votre nom complet",
    "Enter your full name": "Entrez votre nom complet",
    "Save": "Enregistrer",
    "Saving...": "Enregistrement...",
    "Error updating profile. Please try again.": "Erreur lors de la mise \xe0 jour du profil. Veuillez r\xe9essayer.",
    "Complete Your Profile": "Compl\xe9tez votre profil",
    "Please set your full name to continue. This will be displayed to other users.": "Veuillez d\xe9finir votre nom complet pour continuer. Il sera affich\xe9 aux autres utilisateurs.",
    "Please complete your profile information before creating internship agreements:": "Veuillez compl\xe9ter votre profil avant de cr\xe9er des pr\xe9-conventions de stage :",
    "Please also verify that your email address is correct.": "Veuillez \xe9galement v\xe9rifier que votre adresse email est correcte.",
    "Go to Settings": "Aller aux param\xe8tres",
    "Student Number": "Num\xe9ro \xe9tudiant",
    "Enter your student number": "Entrez votre num\xe9ro \xe9tudiant",
    "Your student number for administrative purposes.": "Votre num\xe9ro \xe9tudiant pour les besoins administratifs.",
    "Health Insurance - City + Region": "Caisse d'assurance maladie - Ville + R\xe9gion",
    "e.g., CPAM Strasbourg - Grand Est": "ex: CPAM Strasbourg - Grand Est",
    "Your health insurance fund with city and region.": "Votre caisse d'assurance maladie avec ville et r\xe9gion.",
    "Internship Management Platform": "Plateforme de gestion des stages",
    "Email Address": "Adresse email",
    "Your login username cannot be changed.": "Votre nom d'utilisateur de connexion ne peut pas \xeatre modifi\xe9.",
    "Your full name will be displayed to other users.": "Votre nom complet sera affich\xe9 aux autres utilisateurs.",
    "Your email address cannot be changed. Contact an administrator if it needs to be updated.": "Votre adresse email ne peut pas \xeatre modifi\xe9e. Contactez un administrateur si elle doit \xeatre mise \xe0 jour.",
    "Your class determines who can validate your internship agreements.": "Votre classe d\xe9termine qui peut valider vos conventions de stage.",
    "Profile Information": "Informations du profil",
    "Class Information": "Informations sur votre classe",
    "Account Actions": "Actions du compte",
    "This is your default email based on your username and role. You can change it if needed.": "Ceci est votre email par d\xe9faut bas\xe9 sur votre nom d'utilisateur et votre r\xf4le. Vous pouvez le changer si n\xe9cessaire.",
    // Promo Selector
    "Select your promotion": "S\xe9lectionnez votre promotion",
    "Please select your promotion to continue": "Veuillez s\xe9lectionner votre promotion pour continuer",
    "Select Promotion": "S\xe9lectionner la promotion",
    "Welcome to the Internship Management Platform": "Bienvenue sur la plateforme de gestion des stages",
    "Before you can create internship agreements, please select your class/promo:": "Avant de cr\xe9er des pr\xe9-conventions de stage, veuillez s\xe9lectionner votre classe/promotion :",
    "Select your class:": "S\xe9lectionnez votre classe",
    "Choose a class": "Choisissez une classe",
    "Confirm Selection": "Confirmer la s\xe9lection",
    // Conventions
    "Internship Agreements": "Pr\xe9-conventions",
    "Your Internship Agreements": "Vos pr\xe9-conventions",
    "Internship Agreement": "Pr\xe9-convention",
    "Create New Agreement": "Cr\xe9er une nouvelle pr\xe9-convention",
    "Draft Agreements": "Pr\xe9-conventions en cours de r\xe9daction",
    "Pending Validation": "En attente de validation",
    "Validated Convention": "Pr\xe9-convention valid\xe9e",
    "Active Convention": "Pr\xe9-convention active",
    "Archived Agreements": "Pr\xe9-conventions archiv\xe9es",
    "Archived Conventions": "Pr\xe9-conventions archiv\xe9es",
    "Not specified": "Non sp\xe9cifi\xe9",
    "Previous Feedback": "Retours pr\xe9c\xe9dents",
    "You have received feedback on earlier versions of this convention.": "Vous avez re\xe7u des retours sur des versions ant\xe9rieures de cette pr\xe9-convention.",
    "Convention Status Guide": "Guide des statuts de pr\xe9-convention",
    "Private to you": "Priv\xe9",
    "Visible to teachers": "Visible par les enseignants",
    "Fully approved": "Enti\xe8rement approuv\xe9e",
    "Inactive": "Inactive",
    "Edit and prepare your convention": "Modifiez et pr\xe9parez votre pr\xe9-convention",
    "Awaiting teacher validation": "En attente de validation enseignant",
    "Awaiting validation": "En attente de validation",
    "All teachers have validated": "Tous les enseignants ont valid\xe9",
    "Stored for reference": "Archiv\xe9e pour r\xe9f\xe9rence",
    "Process": "Traiter",
    "You already have an active convention. To create a new one, you need to archive your current active convention.": "Vous avez d\xe9j\xe0 une pr\xe9-convention active. Pour en cr\xe9er une nouvelle, vous devez archiver votre pr\xe9-convention actuelle.",
    "You already have a locked convention. You cannot create new conventions while having a locked one.": "Vous avez d\xe9j\xe0 une pr\xe9-convention verrouill\xe9e. Vous ne pouvez pas cr\xe9er de nouvelles pr\xe9-conventions tant qu'une est verrouill\xe9e.",
    "You don't have any internship agreements yet. Create one to get started.": "Vous n'avez pas encore de pr\xe9-convention de stage. Cr\xe9ez-en une pour commencer.",
    "Active - Draft Mode": "Active - Mode brouillon",
    "Submit for validation": "Soumettre pour validation",
    "Archive this convention": "Archiver cette pr\xe9-convention",
    "Awaiting Teacher Validation": "En attente de validation enseignant",
    "Move back to draft mode for editing": "Revenir au mode brouillon pour modification",
    "Back to Draft": "Retour au brouillon",
    "Feedback requested on": "Validation demand\xe9e le",
    "teachers validated": "enseignants ont valid\xe9",
    "Validated by All Teachers": "Valid\xe9e par tous les enseignants",
    "Fully Validated!": "Enti\xe8rement valid\xe9e !",
    "All teachers have approved your internship agreement.": "Tous les enseignants ont approuv\xe9 votre pr\xe9-convention de stage.",
    "See below the feedback history, the current version is Version": "Voir ci-dessous l'historique des retours, la version actuelle est la version",
    "Feedback History": "Historique des retours",
    "Version": "Version",
    "by": "par",
    "on": "le",
    "Notification received": "Notification re\xe7ue",
    "Validated by": "Valid\xe9 par",
    "teacher(s)": "enseignant(s)",
    "Validators": "Validateurs",
    "Title": "Titre",
    "Business": "Entreprise",
    "Period": "P\xe9riode",
    "This convention was validated by all teachers": "Cette pr\xe9-convention a \xe9t\xe9 valid\xe9e par tous les enseignants",
    "Restore this convention as validated": "Restaurer cette pr\xe9-convention comme valid\xe9e",
    "Make this convention active": "Activer cette pr\xe9-convention",
    "Restore": "Restaurer",
    "Activate": "Activer",
    "Edit non-critical fields": "Modifier les champs non critiques",
    "You can still edit fields that don't require teacher validation. Click Edit to modify them.": "Vous pouvez toujours modifier les champs qui ne n\xe9cessitent pas de validation par un enseignant. Cliquez sur Modifier pour les modifier.",
    // Actions
    "Edit": "Modifier",
    "Delete": "Supprimer",
    "Cancel": "Annuler",
    "Archive": "Archiver",
    "Request Feedback": "Demander une validation",
    "Make Active": "Remettre en cours",
    "View": "Voir",
    "Download PDF": "T\xe9l\xe9charger le PDF",
    // Confirmation messages
    "Are you sure you want to request feedback? This will make your convention visible to teachers for validation.": "\xcates-vous s\xfbr de vouloir demander une validation ? Cela rendra votre pr\xe9-convention visible aux enseignants pour validation.",
    "This convention was previously validated. It will be restored as a validated convention. Continue?": "Cette pr\xe9-convention a \xe9t\xe9 pr\xe9c\xe9demment valid\xe9e. Elle sera restaur\xe9e en tant que pr\xe9-convention valid\xe9e. Continuer ?",
    "Moving back to draft mode will hide this convention from teachers. You will need to request feedback again after making your changes. Continue?": "Repasser en mode brouillon masquera cette pr\xe9-convention aux enseignants. Vous devrez demander une validation \xe0 nouveau apr\xe8s vos modifications. Continuer ?",
    "Are you sure you want to archive this convention?": "\xcates-vous s\xfbr de vouloir archiver cette pr\xe9-convention ?",
    "Are you sure you want to delete this convention?": "\xcates-vous s\xfbr de vouloir supprimer cette pr\xe9-convention ?",
    // Status
    "Status": "Statut",
    "Draft": "Brouillon",
    "Pending": "En attente",
    "Validated": "Valid\xe9e",
    "Archived": "Archiv\xe9e",
    "Active": "Active",
    "Locked": "Verrouill\xe9e",
    "Lock": "Verrouiller",
    "Unlock": "D\xe9verrouiller",
    "Locked Convention": "Pr\xe9-convention verrouill\xe9e",
    "Locked Conventions": "Pr\xe9-conventions verrouill\xe9es",
    "Locked by Administrator": "Verrouill\xe9e par un administrateur",
    "This convention is locked.": "Cette pr\xe9-convention est verrouill\xe9e.",
    "You cannot modify or archive it. Contact an administrator if you need changes.": "Vous ne pouvez ni la modifier ni l'archiver. Contactez un administrateur si vous avez besoin de modifications.",
    "Lock this convention": "Verrouiller cette pr\xe9-convention",
    "Unlock this convention": "D\xe9verrouiller cette pr\xe9-convention",
    "Fully Validated Conventions": "Pr\xe9-conventions enti\xe8rement valid\xe9es",
    "Pending Teacher Validation": "En attente de validation enseignant",
    "Print": "Imprimer",
    "Print this convention": "Imprimer cette pr\xe9-convention",
    "Please allow pop-ups to print the convention.": "Veuillez autoriser les pop-ups pour imprimer la pr\xe9-convention.",
    "LOCKED CONVENTION": "PR\xc9-CONVENTION VERROUILL\xc9E",
    "Academic Year": "Ann\xe9e universitaire",
    "Convention Details": "D\xe9tails de la pr\xe9-convention",
    "Validations": "Validations",
    "Validator": "Validateur",
    "Date": "Date",
    "This convention is locked by an administrator and cannot be modified.": "Cette pr\xe9-convention est verrouill\xe9e par un administrateur et ne peut pas \xeatre modifi\xe9e.",
    "This convention is locked by an administrator and cannot be deleted.": "Cette pr\xe9-convention est verrouill\xe9e par un administrateur et ne peut pas \xeatre supprim\xe9e.",
    "You have a locked convention. You cannot create a new convention while one is locked. Please contact an administrator.": "Vous avez une pr\xe9-convention verrouill\xe9e. Vous ne pouvez pas cr\xe9er de nouvelle pr\xe9-convention tant qu'une est verrouill\xe9e. Veuillez contacter un administrateur.",
    "You have a locked convention. You cannot modify any conventions while one is locked. Please contact an administrator.": "Vous avez une pr\xe9-convention verrouill\xe9e. Vous ne pouvez modifier aucune pr\xe9-convention tant qu'une est verrouill\xe9e. Veuillez contacter un administrateur.",
    "You have a locked convention. You cannot change the status of any conventions while one is locked. Please contact an administrator.": "Vous avez une pr\xe9-convention verrouill\xe9e. Vous ne pouvez changer le statut d'aucune pr\xe9-convention tant qu'une est verrouill\xe9e. Veuillez contacter un administrateur.",
    "You have a locked convention. You cannot delete any conventions while one is locked. Please contact an administrator.": "Vous avez une pr\xe9-convention verrouill\xe9e. Vous ne pouvez supprimer aucune pr\xe9-convention tant qu'une est verrouill\xe9e. Veuillez contacter un administrateur.",
    // Months (for dates)
    "Limited editing mode": "Mode \xe9dition limit\xe9e",
    "Only fields that don't require teacher validation can be edited. Fields requiring validation are disabled.": "Seuls les champs qui ne n\xe9cessitent pas de validation par un enseignant peuvent \xeatre modifi\xe9s. Les champs n\xe9cessitant une validation sont d\xe9sactiv\xe9s.",
    "Requires teacher validation": "N\xe9cessite une validation par un enseignant",
    // Teacher View
    "Pending Review": "En attente de relecture",
    "Reviewed": "Relues",
    "Student": "\xc9tudiant",
    "Year": "Ann\xe9e",
    "Review": "Relire",
    "View Details": "Voir les d\xe9tails",
    "Feedback": "Retour",
    "Mark as Validated": "Marquer comme valid\xe9e",
    "Mark as Needs Changes": "N\xe9cessite des modifications",
    "Save (No Notification)": "Enregistrer (sans notification)",
    "Save & Notify Student": "Enregistrer et notifier l'\xe9tudiant",
    "Save & Send Notification": "Enregistrer et envoyer une notification",
    "Close": "Fermer",
    "Send Notification": "Envoyer une notification",
    "Save without sending notification to student": "Enregistrer sans envoyer de notification \xe0 l'\xe9tudiant",
    "Save and send notification to student": "Enregistrer et envoyer une notification \xe0 l'\xe9tudiant",
    "Send notification to student about this feedback": "Envoyer une notification \xe0 l'\xe9tudiant concernant ce retour",
    "The convention will return to draft mode for the student, and they will receive a notification. Continue?": "La convention retournera en mode brouillon pour l'\xe9tudiant, et il recevra une notification. Continuer ?",
    "Resubmitted": "Resoumise",
    "This convention has been resubmitted after receiving feedback.": "Cette convention a \xe9t\xe9 resoumise apr\xe8s avoir re\xe7u des retours.",
    "Previous feedback can be found below.": "Les retours pr\xe9c\xe9dents se trouvent ci-dessous.",
    "Teacher Dashboard": "Tableau de bord enseignant",
    "You are not assigned as a validator for any class yet.": "Vous n'\xeates pas encore assign\xe9 comme validateur pour une classe.",
    "No internship agreements in this class yet.": "Aucune pr\xe9-convention de stage dans cette classe pour le moment.",
    "Pending Agreements": "Pr\xe9-conventions en attente",
    "Validated Agreements": "Pr\xe9-conventions valid\xe9es",
    "Validate": "Valider",
    "Validated by you": "Valid\xe9e par vous",
    "Subject": "Sujet",
    "Skills": "Comp\xe9tences",
    "Address": "Adresse",
    "Supervisor": "Responsable",
    "to": "\xe0",
    "Validation Status": "Statut de validation",
    "Teacher Feedback:": "Retour enseignant :",
    "No feedback for current version": "Pas de retour pour la version actuelle",
    "Validated by:": "Valid\xe9e par :",
    "Not validated yet": "Pas encore valid\xe9e",
    "Waiting for validation from": "En attente de validation de",
    "Teacher Feedback": "Retour enseignant",
    "Save Draft": "Enregistrer le brouillon",
    "Last updated": "Derni\xe8re mise \xe0 jour",
    "No feedback draft": "Pas de brouillon de retour",
    "Edit Feedback": "Modifier le retour",
    "Add Feedback": "Ajouter un retour",
    "Notification sent": "Notification envoy\xe9e",
    "Fully Validated": "Enti\xe8rement valid\xe9e",
    "Hide Details": "Masquer les d\xe9tails",
    "Show Details": "Afficher les d\xe9tails",
    "Locked Agreements": "Pr\xe9-conventions verrouill\xe9es",
    "These agreements have been locked by an administrator and cannot be modified.": "Ces pr\xe9-conventions ont \xe9t\xe9 verrouill\xe9es par un administrateur et ne peuvent plus \xeatre modifi\xe9es.",
    "Returned for Revision": "Retourn\xe9es pour r\xe9vision",
    "In Revision": "En r\xe9vision",
    "These agreements were returned to the student with feedback and are being revised.": "Ces pr\xe9-conventions ont \xe9t\xe9 retourn\xe9es \xe0 l'\xe9tudiant avec des commentaires et sont en cours de r\xe9vision.",
    "Last Feedback Sent": "Dernier retour envoy\xe9",
    "Hide Feedback History": "Masquer l'historique des retours",
    "Show Feedback History": "Afficher l'historique des retours",
    // Admin
    "Users": "Utilisateurs",
    "Promotions": "Promotions",
    "Years": "Ann\xe9es",
    "Email Templates": "Mod\xe8les d'email",
    "Notifications": "Notifications",
    "Convention Structure": "Structure des pr\xe9-conventions",
    "Username": "Nom d'utilisateur",
    "Full Name": "Nom complet",
    "Email": "Email",
    "Role": "R\xf4le",
    "Promotion": "Promotion",
    "Actions": "Actions",
    "default": "par d\xe9faut",
    "Default email based on username and role": "Email par d\xe9faut bas\xe9 sur le nom d'utilisateur et le r\xf4le",
    "Manage Users": "G\xe9rer les utilisateurs",
    "Manage Promos": "G\xe9rer les promotions",
    "Manage Years": "G\xe9rer les ann\xe9es",
    "Form Structure": "Structure du formulaire",
    "Notification Log": "Journal des notifications",
    // Roles
    "admin": "Administrateur",
    "teacher": "Enseignant",
    "student": "\xc9tudiant",
    // Loading & Errors
    "Loading...": "Chargement...",
    "Error": "Erreur",
    "Success": "Succ\xe8s",
    // AdminUsers
    "Generate Teacher Invite Link": "G\xe9n\xe9rer un lien d'invitation enseignant",
    "Teacher invite link (valid for 7 days)": "Lien d'invitation enseignant (valide pendant 7 jours)",
    "Link copied to clipboard!": "Lien copi\xe9 dans le presse-papiers !",
    "Search by username or fullname": "Rechercher par nom d'utilisateur ou nom complet",
    "Copy": "Copier",
    "Class": "Classe",
    "Add User": "Ajouter un utilisateur",
    // AdminPromos
    "Add Promo": "Ajouter une promotion",
    "Id": "Id",
    "Name": "Nom",
    "No validators": "Aucun validateur",
    "Remove validator": "Retirer le validateur",
    "Add Validator": "Ajouter un validateur",
    "Add Validator to": "Ajouter un validateur \xe0",
    "Select a teacher to add as validator:": "S\xe9lectionnez un enseignant \xe0 ajouter comme validateur :",
    "Not implemented": "Pas encore impl\xe9ment\xe9",
    "save": "enregistrer",
    "edit": "modifier",
    "delete": "supprimer",
    "cancel": "annuler",
    // AdminYears
    "Academic Year Management": "Gestion de l'ann\xe9e universitaire",
    "Current Academic Year": "Ann\xe9e universitaire actuelle",
    "Important:": "Important :",
    "WARNING: Changing the academic year will reset ALL student promo assignments. Students will need to select their promo again. This action cannot be undone. Are you sure you want to proceed?": "ATTENTION : Changer l'ann\xe9e universitaire r\xe9initialisera TOUTES les affectations de promotion des \xe9tudiants. Les \xe9tudiants devront s\xe9lectionner \xe0 nouveau leur promotion. Cette action ne peut pas \xeatre annul\xe9e. \xcates-vous s\xfbr de vouloir continuer ?",
    "Changing the academic year will reset all student promo assignments. Students will need to select their promo again when they login.": "Changer l'ann\xe9e universitaire r\xe9initialisera toutes les affectations de promotion des \xe9tudiants. Les \xe9tudiants devront s\xe9lectionner \xe0 nouveau leur promotion lors de leur connexion.",
    "Loading current year setting...": "Chargement du param\xe8tre d'ann\xe9e actuelle...",
    "Set Current Academic Year": "D\xe9finir l'ann\xe9e universitaire actuelle",
    "This setting determines the academic year for new conventions.": "Ce param\xe8tre d\xe9termine l'ann\xe9e universitaire pour les nouvelles conventions.",
    "Update Academic Year": "Mettre \xe0 jour l'ann\xe9e universitaire",
    "Academic year updated successfully.": "Ann\xe9e universitaire mise \xe0 jour avec succ\xe8s.",
    "students": "\xe9tudiants",
    "had their promo reset": "ont vu leur promotion r\xe9initialis\xe9e",
    "Failed to update academic year": "\xc9chec de la mise \xe0 jour de l'ann\xe9e universitaire",
    "View Conventions by Year": "Voir les pr\xe9-conventions par ann\xe9e",
    "Select Year": "S\xe9lectionner l'ann\xe9e",
    "Choose a year...": "Choisissez une ann\xe9e...",
    "Select a year to view pending and validated conventions.": "S\xe9lectionnez une ann\xe9e pour voir les pr\xe9-conventions en attente et valid\xe9es.",
    "Conventions for": "Pr\xe9-conventions pour",
    "Loading conventions...": "Chargement des pr\xe9-conventions...",
    "No pending or validated conventions found for": "Aucune pr\xe9-convention en attente ou valid\xe9e trouv\xe9e pour",
    "No conventions in this class.": "Aucune pr\xe9-convention dans cette classe.",
    // AdminEmailTemplates
    "Email Template Management": "Gestion des mod\xe8les d'email",
    "Loading templates...": "Chargement des mod\xe8les...",
    "Error loading templates": "Erreur de chargement des mod\xe8les",
    "No description": "Pas de description",
    "Edit Template": "Modifier le mod\xe8le",
    "Description": "Description",
    "Body": "Corps",
    "Use placeholders like {{student_name}}, {{teacher_name}}, and {{base_url}}.": "Utilisez des placeholders comme {{student_name}}, {{teacher_name}}, et {{base_url}}.",
    "Save Changes": "Enregistrer les modifications",
    "Select a template to edit": "S\xe9lectionnez un mod\xe8le \xe0 modifier",
    "Template updated successfully": "Mod\xe8le mis \xe0 jour avec succ\xe8s",
    "Failed to update template": "\xc9chec de la mise \xe0 jour du mod\xe8le",
    // AdminConventionStructure
    "Convention Structure Management": "Gestion de la structure des pr\xe9-conventions",
    "Warning": "Attention",
    "Changing the convention structure will affect all existing and new conventions. Remove fields with caution as this may result in data loss.": "Modifier la structure des pr\xe9-conventions affectera toutes les pr\xe9-conventions existantes et nouvelles. Supprimez les champs avec pr\xe9caution car cela peut entra\xeener une perte de donn\xe9es.",
    "Form Fields": "Champs du formulaire",
    "Add Field": "Ajouter un champ",
    "Loading convention structure...": "Chargement de la structure des pr\xe9-conventions...",
    "No fields have been defined yet. Click \"Add Field\" to create your first field.": 'Aucun champ n\'a encore \xe9t\xe9 d\xe9fini. Cliquez sur "Ajouter un champ" pour cr\xe9er votre premier champ.',
    "Are you sure you want to remove this field? This may affect existing conventions.": "\xcates-vous s\xfbr de vouloir supprimer ce champ ? Cela peut affecter les pr\xe9-conventions existantes.",
    "All fields must have a name and label": "Tous les champs doivent avoir un nom et un libell\xe9",
    "Duplicate field name": "Nom de champ en double",
    "Convention structure updated successfully": "Structure des pr\xe9-conventions mise \xe0 jour avec succ\xe8s",
    "Failed to update convention structure": "\xc9chec de la mise \xe0 jour de la structure des pr\xe9-conventions",
    "Edit this field": "Modifier ce champ",
    "Move up": "Monter",
    "Move down": "Descendre",
    "Remove this field": "Supprimer ce champ",
    "Remove": "Supprimer",
    "Field Name (ID)": "Nom du champ (ID)",
    "Unique identifier for the field (no spaces)": "Identifiant unique pour le champ (sans espaces)",
    "Field Label": "Libell\xe9 du champ",
    "Display label": "Libell\xe9 d'affichage",
    "This text will be shown to users": "Ce texte sera affich\xe9 aux utilisateurs",
    "Field Type": "Type de champ",
    "Required field": "Champ obligatoire",
    "Done": "Termin\xe9",
    "Save Structure": "Enregistrer la structure",
    "Preview": "Aper\xe7u",
    "Enter": "Entrer",
    "Add some fields to see a preview of the convention form": "Ajoutez des champs pour voir un aper\xe7u du formulaire de pr\xe9-convention",
    "Group header - following fields will be grouped under this section": "En-t\xeate de groupe - les champs suivants seront regroup\xe9s sous cette section",
    "Groups are used to organize fields visually and cannot be required": "Les groupes servent \xe0 organiser les champs visuellement et ne peuvent pas \xeatre obligatoires",
    "Marks the end of a group section": "Marque la fin d'une section de groupe",
    // AdminConventions
    "All Internship Agreements": "Toutes les pr\xe9-conventions de stage",
    "You are offline.": "Vous \xeates hors ligne.",
    "Viewing cached data in read-only mode.": "Affichage des donn\xe9es en cache en mode lecture seule.",
    "No internship agreements found for the current year.": "Aucune pr\xe9-convention de stage trouv\xe9e pour l'ann\xe9e en cours.",
    "No agreements in this class.": "Aucune pr\xe9-convention dans cette classe.",
    "Validation": "Validation",
    "Not validated by": "Non valid\xe9 par",
    "Student Information": "Informations \xe9tudiant",
    "Business Information": "Informations entreprise",
    "Internship Details": "D\xe9tails du stage",
    "Required Skills": "Comp\xe9tences requises",
    "Not validated by any teacher yet.": "Pas encore valid\xe9 par un enseignant.",
    // Months (for dates)
    "January": "Janvier",
    "February": "F\xe9vrier",
    "March": "Mars",
    "April": "Avril",
    "May": "Mai",
    "June": "Juin",
    "July": "Juillet",
    "August": "Ao\xfbt",
    "September": "Septembre",
    "October": "Octobre",
    "November": "Novembre",
    "December": "D\xe9cembre"
};
const $87927b02874039c5$var$I18nContext = (0, $8863cd8fe199f948$export$fd42f52fd3ae1109)();
function $87927b02874039c5$export$a54013f0d02a8f82(props) {
    const t = (key)=>{
        return $87927b02874039c5$var$translations[key] || key;
    };
    return (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)($87927b02874039c5$var$I18nContext.Provider, {
        value: t,
        get children () {
            return props.children;
        }
    });
}
function $87927b02874039c5$export$3f3caade1c12f8c9() {
    const context = (0, $8863cd8fe199f948$export$fae74005e78b1a27)($87927b02874039c5$var$I18nContext);
    if (!context) throw new Error("useI18n must be used within I18nProvider");
    return context;
}
const $87927b02874039c5$export$625550452a3fa3ec = (key)=>{
    return $87927b02874039c5$var$translations[key] || key;
};


var $dd67cc782607ead6$var$_tmpl$ = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<div><button type=button class="btn btn-primary btn-sm me-2"></button><button type=button class="btn btn-success btn-sm">`), $dd67cc782607ead6$var$_tmpl$2 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<div class="alert alert-info mt-3"><p>:</p><div class=input-group><input type=text class=form-control readonly><button class="btn btn-outline-secondary">`), $dd67cc782607ead6$var$_tmpl$3 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<div class=mt-3><input type=text class=form-control>`), $dd67cc782607ead6$var$_tmpl$4 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<table class="table table-striped table-hover mt-3"><thead><tr><th scope=col>Id</th><th scope=col></th><th scope=col></th><th scope=col></th><th scope=col></th><th scope=col></th><th scope=col></th></tr></thead><tbody>`), $dd67cc782607ead6$var$_tmpl$5 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<input class=form-control type=email placeholder=user@example.com>`), $dd67cc782607ead6$var$_tmpl$6 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<select class=form-select><option value=admin></option><option value=teacher></option><option value=student>`), $dd67cc782607ead6$var$_tmpl$7 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<button type=button class="btn btn-outline-primary btn-sm">`), $dd67cc782607ead6$var$_tmpl$8 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<button type=button class="btn btn-outline-info btn-sm">`), $dd67cc782607ead6$var$_tmpl$9 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<tr><td></td><td></td><td></td><td></td><td></td><td></td><td> <button type=button class="btn btn-outline-danger btn-sm">`), $dd67cc782607ead6$var$_tmpl$0 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<span class="ms-1 badge bg-secondary">`), $dd67cc782607ead6$var$_tmpl$1 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<div class="form-text small">`), $dd67cc782607ead6$var$_tmpl$10 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<span class=text-muted>`);
var $dd67cc782607ead6$export$2e2bcd8739ae039 = ()=>{
    const t = (0, $87927b02874039c5$export$3f3caade1c12f8c9)();
    const [teacherInviteLink, setTeacherInviteLink] = (0, $8863cd8fe199f948$export$c1e1e1ecbbe76a5)(null);
    const [adminStore, setAdminStore, { editUser: editUser, deleteUser: deleteUser, addUser: addUser }] = (0, $059fd204a72364ff$export$b3189d039b00bb0c)();
    const [userStore] = (0, $c3b276e29c1ce2f2$export$87c54b525b914dab)();
    const [searchTerm, setSearchTerm] = (0, $8863cd8fe199f948$export$c1e1e1ecbbe76a5)("");
    const filteredUsers = (0, $8863cd8fe199f948$export$c0c6c8b9c16bf6aa)(()=>{
        const term = searchTerm().toLowerCase();
        return adminStore.users.filter((user)=>user.username.toLowerCase().includes(term) || user.fullname.toLowerCase().includes(term));
    });
    (0, $8863cd8fe199f948$export$1e848a9e87980bd5)(()=>{
        (0, $a26018a1d2174fbf$export$2e2bcd8739ae039).on('teacher-invite-link', (link)=>{
            setTeacherInviteLink(link);
        });
    });
    (0, $8863cd8fe199f948$export$b36e5eaa3e8c43ab)(()=>{
        (0, $a26018a1d2174fbf$export$2e2bcd8739ae039).off('teacher-invite-link');
    });
    const generateTeacherInvite = ()=>{
        (0, $a26018a1d2174fbf$export$2e2bcd8739ae039).emit('generate-teacher-invite');
    };
    return [
        (()=>{
            var _el$ = $dd67cc782607ead6$var$_tmpl$(), _el$2 = _el$.firstChild, _el$3 = _el$2.nextSibling;
            _el$2.$$click = ()=>{
                const username = prompt(t("username"), "");
                if (!username) return;
                addUser({
                    username: username,
                    role: 'student'
                });
            };
            (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$2, ()=>t("Add User"));
            _el$3.$$click = generateTeacherInvite;
            (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$3, ()=>t("Generate Teacher Invite Link"));
            return _el$;
        })(),
        (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
            get when () {
                return teacherInviteLink();
            },
            get children () {
                var _el$4 = $dd67cc782607ead6$var$_tmpl$2(), _el$5 = _el$4.firstChild, _el$6 = _el$5.firstChild, _el$7 = _el$5.nextSibling, _el$8 = _el$7.firstChild, _el$9 = _el$8.nextSibling;
                (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$5, ()=>t("Teacher invite link (valid for 7 days)"), _el$6);
                _el$9.$$click = ()=>{
                    if (teacherInviteLink()) {
                        navigator.clipboard.writeText(teacherInviteLink());
                        alert(t("Link copied to clipboard!"));
                    }
                };
                (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$9, ()=>t("Copy"));
                (0, $8863cd8fe199f948$export$314dade334ae905d)(()=>_el$8.value = teacherInviteLink() || '');
                return _el$4;
            }
        }),
        (()=>{
            var _el$0 = $dd67cc782607ead6$var$_tmpl$3(), _el$1 = _el$0.firstChild;
            _el$1.$$input = (e)=>setSearchTerm(e.target.value);
            (0, $8863cd8fe199f948$export$314dade334ae905d)(()=>(0, $6258376c5c54faa9$export$9fec4d97f1922e0b)(_el$1, "placeholder", t("Search by username or fullname")));
            return _el$0;
        })(),
        (()=>{
            var _el$10 = $dd67cc782607ead6$var$_tmpl$4(), _el$11 = _el$10.firstChild, _el$12 = _el$11.firstChild, _el$13 = _el$12.firstChild, _el$14 = _el$13.nextSibling, _el$15 = _el$14.nextSibling, _el$16 = _el$15.nextSibling, _el$17 = _el$16.nextSibling, _el$18 = _el$17.nextSibling, _el$19 = _el$18.nextSibling, _el$20 = _el$11.nextSibling;
            (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$14, ()=>t("Username"));
            (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$15, ()=>t("Full Name"));
            (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$16, ()=>t("Email"));
            (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$17, ()=>t("Role"));
            (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$18, ()=>t("Class"));
            (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$19, ()=>t("Actions"));
            (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$20, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$bdf530073099ce9f), {
                get each () {
                    return filteredUsers();
                },
                children: (user, index)=>{
                    const isDefaultEmail = !user.email;
                    const displayEmail = user.email || (0, $bc18280b634ac0b4$export$a92adec574c54595)(user.username, user.role);
                    const promoName = (0, $8863cd8fe199f948$export$c0c6c8b9c16bf6aa)(()=>{
                        if (!user.promo_id) return null;
                        return userStore.promos_by_id[user.promo_id]?.name || 'Loading...';
                    });
                    return (()=>{
                        var _el$21 = $dd67cc782607ead6$var$_tmpl$9(), _el$22 = _el$21.firstChild, _el$23 = _el$22.nextSibling, _el$24 = _el$23.nextSibling, _el$25 = _el$24.nextSibling, _el$27 = _el$25.nextSibling, _el$32 = _el$27.nextSibling, _el$33 = _el$32.nextSibling, _el$36 = _el$33.firstChild, _el$37 = _el$36.nextSibling;
                        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$22, ()=>user.id);
                        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$23, ()=>user.username);
                        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$24, ()=>user.fullname);
                        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$25, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
                            get when () {
                                return user.editing;
                            },
                            get fallback () {
                                return [
                                    displayEmail,
                                    isDefaultEmail && (()=>{
                                        var _el$38 = $dd67cc782607ead6$var$_tmpl$0();
                                        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$38, ()=>t("default"));
                                        (0, $8863cd8fe199f948$export$314dade334ae905d)(()=>(0, $6258376c5c54faa9$export$9fec4d97f1922e0b)(_el$38, "title", t("Default email based on username and role")));
                                        return _el$38;
                                    })()
                                ];
                            },
                            get children () {
                                return [
                                    (()=>{
                                        var _el$26 = $dd67cc782607ead6$var$_tmpl$5();
                                        _el$26.$$input = (e)=>setAdminStore('users', index(), {
                                                emailInput: e.target.value
                                            });
                                        (0, $8863cd8fe199f948$export$314dade334ae905d)(()=>_el$26.value = user.emailInput !== undefined ? user.emailInput : displayEmail);
                                        return _el$26;
                                    })(),
                                    (0, $6258376c5c54faa9$export$7c73462e0d25e514)(()=>isDefaultEmail && (()=>{
                                            var _el$39 = $dd67cc782607ead6$var$_tmpl$1();
                                            (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$39, ()=>t("Default email - will be saved if changed"));
                                            return _el$39;
                                        })())
                                ];
                            }
                        }));
                        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$27, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
                            get when () {
                                return user.editing;
                            },
                            get fallback () {
                                return user.role;
                            },
                            get children () {
                                var _el$28 = $dd67cc782607ead6$var$_tmpl$6(), _el$29 = _el$28.firstChild, _el$30 = _el$29.nextSibling, _el$31 = _el$30.nextSibling;
                                _el$28.addEventListener("change", (e)=>setAdminStore('users', index(), {
                                        roleInput: e.target.value
                                    }));
                                (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$29, ()=>t("admin"));
                                (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$30, ()=>t("teacher"));
                                (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$31, ()=>t("student"));
                                (0, $8863cd8fe199f948$export$314dade334ae905d)(()=>_el$28.value = user.roleInput);
                                return _el$28;
                            }
                        }));
                        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$32, (()=>{
                            var _c$ = (0, $6258376c5c54faa9$export$7c73462e0d25e514)(()=>!!promoName());
                            return ()=>_c$() ? promoName() : (()=>{
                                    var _el$40 = $dd67cc782607ead6$var$_tmpl$10();
                                    (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$40, ()=>t("No class"));
                                    return _el$40;
                                })();
                        })());
                        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$33, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
                            get when () {
                                return user.editing;
                            },
                            get children () {
                                var _el$34 = $dd67cc782607ead6$var$_tmpl$7();
                                _el$34.$$click = ()=>editUser(index());
                                (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$34, ()=>t("save"));
                                return _el$34;
                            }
                        }), _el$36);
                        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$33, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
                            get when () {
                                return !user.editing;
                            },
                            get children () {
                                var _el$35 = $dd67cc782607ead6$var$_tmpl$8();
                                _el$35.$$click = ()=>setAdminStore('users', index(), {
                                        editing: true,
                                        roleInput: user.role,
                                        emailInput: user.email || ""
                                    });
                                (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$35, ()=>t("edit"));
                                return _el$35;
                            }
                        }), _el$36);
                        _el$37.$$click = ()=>{
                            if (confirm(t('Confirm deletion'))) deleteUser(user.id);
                        };
                        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$37, ()=>t("delete"));
                        return _el$21;
                    })();
                }
            }));
            return _el$10;
        })()
    ];
};
(0, $6258376c5c54faa9$export$ad0f7f87f67e17d6)([
    "click",
    "input"
]);






var $b1a355c10f370609$var$_tmpl$ = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<div class=loader>`), $b1a355c10f370609$var$_tmpl$2 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<li><a class="nav-link dropdown-toggle"href=# id=navbarDropdownMenuLink role=button></a><ul aria-labelledby=navbarDropdownMenuLink>`);
const $b1a355c10f370609$export$3b0d6d7590275603 = ()=>$b1a355c10f370609$var$_tmpl$();
const $b1a355c10f370609$export$461cb598b7fcff7b = (props)=>{
    const [showMenu, setShowMenu] = (0, $8863cd8fe199f948$export$c1e1e1ecbbe76a5)(false);
    let menuDropdown;
    let dropdownElement;
    const handleToggleClick = (event)=>{
        event.preventDefault();
        event.stopPropagation();
        setShowMenu(!showMenu());
    };
    const handleOutsideClick = (event)=>{
        // Close menu when clicking outside
        if (dropdownElement && !dropdownElement.contains(event.target)) setShowMenu(false);
    };
    (0, $8863cd8fe199f948$export$1e848a9e87980bd5)(()=>{
        document.addEventListener('click', handleOutsideClick);
    });
    (0, $8863cd8fe199f948$export$b36e5eaa3e8c43ab)(()=>{
        document.removeEventListener('click', handleOutsideClick);
    });
    return (()=>{
        var _el$2 = $b1a355c10f370609$var$_tmpl$2(), _el$3 = _el$2.firstChild, _el$4 = _el$3.nextSibling;
        var _ref$ = dropdownElement;
        typeof _ref$ === "function" ? (0, $6258376c5c54faa9$export$1f96ae73734a86cc)(_ref$, _el$2) : dropdownElement = _el$2;
        _el$3.$$click = handleToggleClick;
        var _ref$2 = menuDropdown;
        typeof _ref$2 === "function" ? (0, $6258376c5c54faa9$export$1f96ae73734a86cc)(_ref$2, _el$3) : menuDropdown = _el$3;
        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$3, ()=>props.label);
        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$4, ()=>props.children);
        (0, $8863cd8fe199f948$export$314dade334ae905d)((_p$)=>{
            var _v$ = "nav-item dropdown" + (showMenu() ? ' show' : ''), _v$2 = showMenu() ? "true" : "false", _v$3 = "dropdown-menu" + (showMenu() ? ' show' : '');
            _v$ !== _p$.e && (0, $6258376c5c54faa9$export$2913c0c0b5623090)(_el$2, _p$.e = _v$);
            _v$2 !== _p$.t && (0, $6258376c5c54faa9$export$9fec4d97f1922e0b)(_el$3, "aria-expanded", _p$.t = _v$2);
            _v$3 !== _p$.a && (0, $6258376c5c54faa9$export$2913c0c0b5623090)(_el$4, _p$.a = _v$3);
            return _p$;
        }, {
            e: undefined,
            t: undefined,
            a: undefined
        });
        return _el$2;
    })();
};
(0, $6258376c5c54faa9$export$ad0f7f87f67e17d6)([
    "click"
]);







var $2bee3b9158526810$var$_tmpl$ = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<div><button type=button class="btn btn btn-primary btn-sm">`), $2bee3b9158526810$var$_tmpl$2 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<table class="table table-striped table-hover"><thead><tr><th scope=col>Id</th><th scope=col></th><th scope=col></th><th scope=col></th></tr></thead><tbody>`), $2bee3b9158526810$var$_tmpl$3 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<div class="modal d-block"tabindex=-1 role=dialog style=background:rgba(0,0,0,0.5)><div class=modal-dialog role=document><div class=modal-content><div class=modal-header><h5 class=modal-title> </h5><button type=button class=btn-close aria-label=Close></button></div><div class=modal-body><form><div class=mb-3><label for=teacher-select class=form-label></label><select id=teacher-select class=form-select></select></div></form></div><div class=modal-footer><button type=button class="btn btn-secondary"></button><button type=button class="btn btn-primary">`), $2bee3b9158526810$var$_tmpl$4 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<input class=form-control>`), $2bee3b9158526810$var$_tmpl$5 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<button type=button class="btn btn btn-outline-primary btn-sm">`), $2bee3b9158526810$var$_tmpl$6 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<button type=button class="btn btn btn-outline-info btn-sm">`), $2bee3b9158526810$var$_tmpl$7 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<tr><td scope=row></td><td></td><td><div class="d-flex flex-column"><button type=button class="btn btn-outline-primary btn-sm mt-2"></button></div></td><td> <button type=button class="btn btn btn-outline-danger btn-sm">`), $2bee3b9158526810$var$_tmpl$8 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<span class=text-muted>`), $2bee3b9158526810$var$_tmpl$9 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<div class="d-flex align-items-center mb-1"><span></span><button type=button class="btn btn-outline-danger btn-sm ms-2">&times;`), $2bee3b9158526810$var$_tmpl$0 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<small class=text-muted>(<!>)`), $2bee3b9158526810$var$_tmpl$1 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<option>`);
var $2bee3b9158526810$export$2e2bcd8739ae039 = (props)=>{
    const t = (0, $87927b02874039c5$export$3f3caade1c12f8c9)();
    const [showModal, setShowModal] = (0, $8863cd8fe199f948$export$c1e1e1ecbbe76a5)(false);
    const [selectedPromo, setSelectedPromo] = (0, $8863cd8fe199f948$export$c1e1e1ecbbe76a5)(null);
    const [selectedTeacher, setSelectedTeacher] = (0, $8863cd8fe199f948$export$c1e1e1ecbbe76a5)(null);
    const [availableTeachers, setAvailableTeachers] = (0, $8863cd8fe199f948$export$c1e1e1ecbbe76a5)([]);
    const [adminStore, setAdminStore, { editPromo: editPromo, deletePromo: deletePromo, addPromo: addPromo, addPromoValidator: addPromoValidator, deletePromoValidator: deletePromoValidator }] = (0, $059fd204a72364ff$export$b3189d039b00bb0c)();
    const [userStore, setUserStore, userActions] = (0, $c3b276e29c1ce2f2$export$87c54b525b914dab)();
    return [
        (()=>{
            var _el$ = $2bee3b9158526810$var$_tmpl$(), _el$2 = _el$.firstChild;
            _el$2.$$click = ()=>{
                const name = prompt(t("Nom ?"), "");
                addPromo({
                    name: name
                });
            };
            (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$2, ()=>t("Add Promo"));
            return _el$;
        })(),
        (()=>{
            var _el$3 = $2bee3b9158526810$var$_tmpl$2(), _el$4 = _el$3.firstChild, _el$5 = _el$4.firstChild, _el$6 = _el$5.firstChild, _el$7 = _el$6.nextSibling, _el$8 = _el$7.nextSibling, _el$9 = _el$8.nextSibling, _el$0 = _el$4.nextSibling;
            (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$7, ()=>t("Name"));
            (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$8, ()=>t("Validators"));
            (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$9, ()=>t("Actions"));
            (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$0, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$bdf530073099ce9f), {
                get each () {
                    return Object.values(userStore.promos_by_id);
                },
                children: (promo, index)=>(()=>{
                        var _el$24 = $2bee3b9158526810$var$_tmpl$7(), _el$25 = _el$24.firstChild, _el$26 = _el$25.nextSibling, _el$28 = _el$26.nextSibling, _el$29 = _el$28.firstChild, _el$30 = _el$29.firstChild, _el$31 = _el$28.nextSibling, _el$34 = _el$31.firstChild, _el$35 = _el$34.nextSibling;
                        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$25, ()=>promo.id);
                        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$26, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
                            get when () {
                                return promo.editing;
                            },
                            get fallback () {
                                return promo.name;
                            },
                            get children () {
                                var _el$27 = $2bee3b9158526810$var$_tmpl$4();
                                _el$27.$$input = (e)=>setUserStore('promos_by_id', promo.id, {
                                        nameInput: e.target.value
                                    });
                                (0, $8863cd8fe199f948$export$314dade334ae905d)(()=>_el$27.value = promo.nameInput);
                                return _el$27;
                            }
                        }));
                        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$29, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
                            get when () {
                                return (0, $6258376c5c54faa9$export$7c73462e0d25e514)(()=>!!promo.validators)() && promo.validators.length > 0;
                            },
                            get fallback () {
                                return (()=>{
                                    var _el$36 = $2bee3b9158526810$var$_tmpl$8();
                                    (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$36, ()=>t("No validators"));
                                    return _el$36;
                                })();
                            },
                            get children () {
                                return (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$bdf530073099ce9f), {
                                    get each () {
                                        return promo.validators;
                                    },
                                    children: (validator)=>(()=>{
                                            var _el$37 = $2bee3b9158526810$var$_tmpl$9(), _el$38 = _el$37.firstChild, _el$39 = _el$38.nextSibling;
                                            (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$38, (()=>{
                                                var _c$ = (0, $6258376c5c54faa9$export$7c73462e0d25e514)(()=>!!validator.fullname);
                                                return ()=>_c$() ? [
                                                        (0, $6258376c5c54faa9$export$7c73462e0d25e514)(()=>validator.fullname),
                                                        " ",
                                                        (()=>{
                                                            var _el$40 = $2bee3b9158526810$var$_tmpl$0(), _el$41 = _el$40.firstChild, _el$43 = _el$41.nextSibling, _el$42 = _el$43.nextSibling;
                                                            (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$40, ()=>validator.username, _el$43);
                                                            return _el$40;
                                                        })()
                                                    ] : validator.username;
                                            })());
                                            _el$39.$$click = ()=>deletePromoValidator(promo.id, validator.id);
                                            (0, $8863cd8fe199f948$export$314dade334ae905d)(()=>(0, $6258376c5c54faa9$export$9fec4d97f1922e0b)(_el$39, "title", t("Remove validator")));
                                            return _el$37;
                                        })()
                                });
                            }
                        }), _el$30);
                        _el$30.$$click = ()=>{
                            // Find teachers
                            const teachers = adminStore.users.filter((user)=>user.role === 'teacher');
                            // If no teachers, alert and return
                            if (teachers.length === 0) {
                                alert(t('No teachers available. Please add teacher users first.'));
                                return;
                            }
                            // Get current validator IDs to filter out
                            const currentValidatorIds = promo.validators ? promo.validators.map((v)=>v.id) : [];
                            // Filter out teachers who are already validators
                            const available = teachers.filter((teacher)=>!currentValidatorIds.includes(teacher.id));
                            if (available.length === 0) {
                                alert(t('All teachers are already validators for this promo.'));
                                return;
                            }
                            // Open modal with available teachers
                            setSelectedPromo(promo);
                            setAvailableTeachers(available);
                            setSelectedTeacher(available[0].id);
                            setShowModal(true);
                        };
                        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$30, ()=>t("Add Validator"));
                        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$31, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
                            get when () {
                                return promo.editing;
                            },
                            get children () {
                                var _el$32 = $2bee3b9158526810$var$_tmpl$5();
                                _el$32.$$click = ()=>{
                                    setUserStore('promos_by_id', promo.id, 'editing', false);
                                    editPromo(promo.id, {
                                        name: promo.nameInput
                                    });
                                };
                                (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$32, ()=>t("save"));
                                return _el$32;
                            }
                        }), _el$34);
                        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$31, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
                            get when () {
                                return !promo.editing;
                            },
                            get children () {
                                var _el$33 = $2bee3b9158526810$var$_tmpl$6();
                                _el$33.$$click = ()=>setUserStore('promos_by_id', promo.id, {
                                        editing: true,
                                        nameInput: promo.name
                                    });
                                (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$33, ()=>t("edit"));
                                return _el$33;
                            }
                        }), _el$34);
                        _el$35.$$click = ()=>{
                            alert(t('Not implemented'));
                        /*
          if (confirm('Confirm deletion')) {
            deletePromo(promo.id)
            setUserStore('promos_by_id', promo.id, undefined);
          }*/ };
                        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$35, ()=>t("delete"));
                        return _el$24;
                    })()
            }));
            return _el$3;
        })(),
        (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
            get when () {
                return showModal();
            },
            get children () {
                var _el$1 = $2bee3b9158526810$var$_tmpl$3(), _el$10 = _el$1.firstChild, _el$11 = _el$10.firstChild, _el$12 = _el$11.firstChild, _el$13 = _el$12.firstChild, _el$14 = _el$13.firstChild, _el$15 = _el$13.nextSibling, _el$16 = _el$12.nextSibling, _el$17 = _el$16.firstChild, _el$18 = _el$17.firstChild, _el$19 = _el$18.firstChild, _el$20 = _el$19.nextSibling, _el$21 = _el$16.nextSibling, _el$22 = _el$21.firstChild, _el$23 = _el$22.nextSibling;
                (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$13, ()=>t("Add Validator to"), _el$14);
                (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$13, ()=>selectedPromo()?.name, null);
                _el$15.$$click = ()=>setShowModal(false);
                (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$19, ()=>t("Select a teacher to add as validator:"));
                _el$20.addEventListener("change", (e)=>setSelectedTeacher(Number(e.target.value)));
                (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$20, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$bdf530073099ce9f), {
                    get each () {
                        return availableTeachers();
                    },
                    children: (teacher)=>(()=>{
                            var _el$44 = $2bee3b9158526810$var$_tmpl$1();
                            (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$44, ()=>teacher.fullname || teacher.username);
                            (0, $8863cd8fe199f948$export$314dade334ae905d)(()=>_el$44.value = teacher.id);
                            return _el$44;
                        })()
                }));
                _el$22.$$click = ()=>setShowModal(false);
                (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$22, ()=>t("cancel"));
                _el$23.$$click = ()=>{
                    if (selectedPromo() && selectedTeacher()) {
                        addPromoValidator(selectedPromo().id, selectedTeacher());
                        setShowModal(false);
                    }
                };
                (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$23, ()=>t("Add Validator"));
                (0, $8863cd8fe199f948$export$314dade334ae905d)(()=>_el$20.value = selectedTeacher());
                return _el$1;
            }
        })
    ];
};
(0, $6258376c5c54faa9$export$ad0f7f87f67e17d6)([
    "click",
    "input"
]);









function $5aac5cd12531494a$export$548b48b1fc5fe68(convention, conventionStructure, promos) {
    // Create a new window for printing
    const printWindow = window.open('', '_blank');
    if (!printWindow) {
        alert((0, $87927b02874039c5$export$625550452a3fa3ec)("Please allow pop-ups to print the convention."));
        return;
    }
    // Build the HTML content
    const studentName = convention.fullname || convention.username;
    // Get promo name
    const promo = promos.find((p)=>p.id === convention.promo_id);
    const promoName = promo?.name || (0, $87927b02874039c5$export$625550452a3fa3ec)("Not specified");
    // Build student info block
    const studentInfoHtml = `
    <div class="section-box">
      <div class="section-header">
          <h3>${(0, $87927b02874039c5$export$625550452a3fa3ec)("Student Information")}</h3>
      </div>
      <div class="section-content">
        <table>
          <tr>
            <td class="label">${(0, $87927b02874039c5$export$625550452a3fa3ec)("Class")}:</td>
            <td class="value">${promoName}</td>
          </tr>
          <tr>
            <td class="label">${(0, $87927b02874039c5$export$625550452a3fa3ec)("Full Name")}:</td>
            <td class="value">${studentName}</td>
          </tr>
          <tr>
            <td class="label">${(0, $87927b02874039c5$export$625550452a3fa3ec)("Username")}:</td>
            <td class="value">${convention.username}</td>
          </tr>
          ${convention.student_number ? `
          <tr>
            <td class="label">${(0, $87927b02874039c5$export$625550452a3fa3ec)("Student Number")}:</td>
            <td class="value">${convention.student_number}</td>
          </tr>
          ` : ''}
          ${convention.email ? `
          <tr>
            <td class="label">${(0, $87927b02874039c5$export$625550452a3fa3ec)("Email")}:</td>
            <td class="value">${convention.email}</td>
          </tr>
          ` : ''}
          ${convention.additional_info?.healthInsurance ? `
          <tr>
            <td class="label">${(0, $87927b02874039c5$export$625550452a3fa3ec)("Health Insurance - City + Region")}:</td>
            <td class="value">${convention.additional_info.healthInsurance}</td>
          </tr>
          ` : ''}
        </table>
      </div>
    </div>
  `;
    // Build fields HTML with group support
    let fieldsHtml = '';
    let inGroup = false;
    let groupHtml = '';
    let groupTitle = '';
    let ungroupedFieldsHtml = '';
    if (conventionStructure && conventionStructure.fields) {
        conventionStructure.fields.forEach((field)=>{
            // Skip title field
            if (field.name === 'title') return;
            if (field.type === 'group') {
                // Add any accumulated ungrouped fields first
                if (ungroupedFieldsHtml) {
                    fieldsHtml += `
          <div class="section-ungrouped">
            <div class="section-content">
              <table>
                ${ungroupedFieldsHtml}
              </table>
            </div>
            </div>
          </div>
          `;
                    ungroupedFieldsHtml = '';
                }
                // Start a new group
                inGroup = true;
                groupTitle = field.label;
                groupHtml = '';
            } else if (field.type === 'group-end') {
                // End the current group
                if (inGroup) fieldsHtml += `
            <div class="section-box">
              <div class="section-header">
                  <h4>${groupTitle}</h4>
              </div>
              <div class="section-content">
                <table>
                  ${groupHtml}
                </table>
              </div>
            </div>
          `;
                inGroup = false;
                groupHtml = '';
            } else {
                // Regular field
                const value = convention.info?.[field.name] || (0, $87927b02874039c5$export$625550452a3fa3ec)("Not specified");
                const fieldRow = `
          <tr>
            <td class="label">${field.label}${field.required ? '*' : ''}:</td>
            <td class="value">${value}</td>
          </tr>
        `;
                if (inGroup) groupHtml += fieldRow;
                else ungroupedFieldsHtml += fieldRow;
            }
        });
        // Close any unclosed group
        if (inGroup && groupHtml) fieldsHtml += `
        <div class="section-box">
            <div class="section-header">
                <h4>${groupTitle}</h4>
            </div>
            <div class="section-content">
            <table>
              ${groupHtml}
            </table>
          </div>
        </div>
      `;
        // Add any remaining ungrouped fields
        if (ungroupedFieldsHtml) fieldsHtml += `
        <div class="section-ungrouped">
          <div class="section-content">
            <table style="width: 100%; border-collapse: collapse; margin-bottom: 20px;">
              ${ungroupedFieldsHtml}
            </table>
          </div>
        </div>
      `;
    }
    // Build validators HTML
    let validatorsHtml = '';
    if (convention.info?.validations && convention.info.validations.length > 0) convention.info.validations.forEach((validation)=>{
        validatorsHtml += `
        <tr>
          <td style="padding: 6px 8px; border: 1px solid #666;">${validation.validatorName}</td>
          <td style="padding: 6px 8px; border: 1px solid #666;">${new Date(validation.timestamp).toLocaleString()}</td>
        </tr>
      `;
    });
    const html = `
<!DOCTYPE html>
<html lang="fr">
<head>
    <meta charset="utf-8">
    <title>${(0, $87927b02874039c5$export$625550452a3fa3ec)("Internship Agreement")} - ${studentName} (${convention.year})</title>
    <style>
        /* --- GENERAL STYLES --- */
        body {
            font-family: "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
            font-size: 11pt; /* Taille standard impression */
            line-height: 1.5;
            color: #333;
            margin: 0;
            background-color: #f9f9f9; /* Fond gris clair \xe0 l'\xe9cran seulement */
        }

        /* Conteneur principal pour simuler la feuille A4 \xe0 l'\xe9cran */
        .page-container {
            max-width: 21cm;
            margin: 40px auto;
            background: white;
            padding: 2cm;
            box-shadow: 0 0 15px rgba(0,0,0,0.1);
            min-height: 29.7cm;
        }

        /* --- TYPOGRAPHY --- */
        h1 {
            font-family: Georgia, "Times New Roman", serif;
            text-transform: uppercase;
            font-size: 20pt;
            text-align: center;
            border-bottom: 2px solid #333;
            padding-bottom: 15px;
            margin-bottom: 30px;
            letter-spacing: 1px;
        }

        h2 {
            font-size: 16pt;
            border-bottom: 1px solid #ddd;
            padding-bottom: 5px;
            margin-top: 30px;
            color: #000;
        }

        h3, h4 {
            margin: 0;
            font-size: 12pt;
            font-weight: 700;
            text-transform: uppercase;
            color: #444;
        }

        /* --- SECTIONS & BOXES --- */
        .section-ungrouped {
            margin-bottom: 25px;
            background-color: #fff;
            page-break-inside: avoid; /* \xc9vite de couper le bloc \xe0 l'impression */
        }
        .section-box {
            border: 1px solid #ddd; /* Bordure fine et discr\xe8te */
            margin-bottom: 25px;
            background-color: #fff;
            page-break-inside: avoid; /* \xc9vite de couper le bloc \xe0 l'impression */
        }

        .section-header {
            background-color: #f0f0f0; /* Fond gris clair pour le titre du bloc */
            padding: 8px 15px;
            border-bottom: 1px solid #ddd;
        }

        .section-content {
            padding: 10px 15px;
        }

        /* --- TABLES --- */
        table {
            width: 100%;
            border-collapse: collapse;
            margin-bottom: 10px;
        }

        /* Colonne des \xe9tiquettes (Labels) */
        td.label {
            width: 35%;
            font-weight: 600;
            color: #555;
            padding: 6px 0;
            vertical-align: top;
            border-bottom: 1px dotted #ccc; /* Ligne pointill\xe9e discr\xe8te */
        }

        /* Colonne des valeurs */
        td.value {
            padding: 6px 0 6px 15px;
            color: #000;
            border-bottom: 1px dotted #ccc;
        }

        /* Supprimer la bordure du bas pour la derni\xe8re ligne */
        tr:last-child td {
            border-bottom: none;
        }

        /* Tableau de validation sp\xe9cifique */
        .validation-table th {
            background-color: #eee;
            color: #000;
            padding: 8px;
            text-align: left;
            font-size: 10pt;
            border: 1px solid #333;
        }

        .validation-table td {
            border: 1px solid #ccc;
            padding: 8px;
        }

        /* --- UTILS --- */
        .text-pre {
            white-space: pre-wrap; /* Garde les retours \xe0 la ligne */
        }

        /* --- BUTTONS (SCREEN ONLY) --- */
        .actions {
            text-align: center;
            padding: 20px;
            background: #eee;
            border-top: 1px solid #ccc;
            position: fixed;
            bottom: 0;
            left: 0;
            width: 100%;
        }
        
        .btn {
            padding: 10px 20px;
            font-size: 14px;
            cursor: pointer;
            border: none;
            border-radius: 4px;
            font-weight: bold;
        }
        
        .btn-print { background-color: #333; color: white; }
        .btn-close { background-color: #999; color: white; margin-left: 10px; }

        /* --- PRINT SETTINGS (CRITICAL) --- */
        @media print {
            body {
                background: none;
                font-size: 11pt;
            }
            .page-container {
                box-shadow: none;
                margin: 0;
                padding: 0;
                width: 100%;
                max-width: none;
            }
            .actions { display: none !important; }
            
            /* Force les couleurs exactes (pour que les gris de fond s'impriment) */
            * { -webkit-print-color-adjust: exact !important; print-color-adjust: exact !important; }
            
            @page {
                margin: 1.5cm; /* Marges saines pour l'impression */
                size: A4;
            }
        }
    </style>
</head>
<body>
  <div class="page-container">
    <h1>${(0, $87927b02874039c5$export$625550452a3fa3ec)("Internship Agreement")} - ${(0, $87927b02874039c5$export$625550452a3fa3ec)("Academic Year")} ${convention.year}</h1>
    
    ${studentInfoHtml}
    
    ${fieldsHtml}
    
    ${validatorsHtml ? `
      <!-- Bloc Signatures / Validations -->
        <div style="margin-top: 40px; page-break-inside: avoid;">
          <h2>${(0, $87927b02874039c5$export$625550452a3fa3ec)("Validations")}</h2>
          <table class="validation-table">
            <thead>
              <tr>
                <th style="width: 60%">${(0, $87927b02874039c5$export$625550452a3fa3ec)("Validator")}</th>
                <th style="width: 40%">${(0, $87927b02874039c5$export$625550452a3fa3ec)("Date")}</th>
              </tr>
            </thead>
            <tbody>
              ${validatorsHtml}
            </tbody>
          </table>
        </div>
    ` : ''}
    
      <div style="margin-top: 40px; text-align: center; page-break-inside: avoid;">
        <button onclick="window.print()" style="padding: 10px 20px; font-size: 14px; cursor: pointer; background-color: #333; color: white; border: none; border-radius: 3px; margin-right: 10px;">
          ${(0, $87927b02874039c5$export$625550452a3fa3ec)("Print")}
        </button>
        <button onclick="window.close()" style="padding: 10px 20px; font-size: 14px; cursor: pointer; background-color: #666; color: white; border: none; border-radius: 3px;">
          ${(0, $87927b02874039c5$export$625550452a3fa3ec)("Close")}
        </button>
      </div>
    </div>
  </body>
</html>
  `;
    printWindow.document.write(html);
    printWindow.document.close();
}







var $18e8c93f2f49788f$var$_tmpl$ = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<h5 class=card-title>`), $18e8c93f2f49788f$var$_tmpl$2 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<div class="alert alert-info mt-3"><strong>:</strong> `), $18e8c93f2f49788f$var$_tmpl$3 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<button type=button class="btn btn-primary me-2">`), $18e8c93f2f49788f$var$_tmpl$4 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<button type=button class="btn btn-danger">`), $18e8c93f2f49788f$var$_tmpl$5 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<button type=button class="btn btn-outline-primary me-2"><i class="fas fa-edit me-1">`), $18e8c93f2f49788f$var$_tmpl$6 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<div>`), $18e8c93f2f49788f$var$_tmpl$7 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<div class="border rounded p-3 mb-3 bg-light"><h5 class="border-bottom pb-2 mb-3 text-primary"></h5><div class=ps-3>`), $18e8c93f2f49788f$var$_tmpl$8 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<span class=text-danger>*`), $18e8c93f2f49788f$var$_tmpl$9 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<div class=text-dark style=white-space:pre-wrap>`), $18e8c93f2f49788f$var$_tmpl$0 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<div class="mb-3 row"><div class=col-md-4><strong class=text-secondary></strong></div><div class=col-md-8>`), $18e8c93f2f49788f$var$_tmpl$1 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<span class="text-muted fst-italic">`), $18e8c93f2f49788f$var$_tmpl$10 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<div class="border rounded p-3 mb-3 bg-light"><h5 class="border-bottom pb-2 mb-3"></h5><div class=ps-3>`), $18e8c93f2f49788f$var$_tmpl$11 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<span class="text-danger ms-1">*`), $18e8c93f2f49788f$var$_tmpl$12 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<span class="badge bg-warning text-dark ms-2"style=font-size:0.65rem><i class="fas fa-user-check"style=font-size:0.6rem>`), $18e8c93f2f49788f$var$_tmpl$13 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<div class="form-check mb-3"><input class=form-check-input type=checkbox><label class=form-check-label>`), $18e8c93f2f49788f$var$_tmpl$14 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<div class="form-floating mb-3"><textarea class=form-control style=height:100px></textarea><label>`), $18e8c93f2f49788f$var$_tmpl$15 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<div class="form-floating mb-3"><input type=date class=form-control><label>`), $18e8c93f2f49788f$var$_tmpl$16 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<div class="form-floating mb-3"><select class=form-select><option value></option></select><label>`), $18e8c93f2f49788f$var$_tmpl$17 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<div class=mb-3><label class=form-label></label><div class="border rounded p-2">`), $18e8c93f2f49788f$var$_tmpl$18 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<div class="form-floating mb-3"><input type=text class=form-control><label>`), $18e8c93f2f49788f$var$_tmpl$19 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<option>`), $18e8c93f2f49788f$var$_tmpl$20 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<div class=form-check><input class=form-check-input type=checkbox><label class=form-check-label>`), $18e8c93f2f49788f$var$_tmpl$21 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<div><button type=button class="btn btn-sm btn-light me-2"></button><button type=button class="btn btn-sm btn-outline-light">`), $18e8c93f2f49788f$var$_tmpl$22 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<div><button type=button class="btn btn-sm btn-outline-primary me-2"></button><button type=button class="btn btn-sm btn-outline-dark">`), $18e8c93f2f49788f$var$_tmpl$23 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<span class="badge bg-primary"> `), $18e8c93f2f49788f$var$_tmpl$24 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<div class="alert alert-info"><div class="d-flex justify-content-between align-items-center"><div> </div><div>`), $18e8c93f2f49788f$var$_tmpl$25 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<div><button type=button class="btn btn-sm btn-outline-light">`), $18e8c93f2f49788f$var$_tmpl$26 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<div class="alert alert-success"><strong></strong> `), $18e8c93f2f49788f$var$_tmpl$27 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<div class="alert alert-warning"><i class="fas fa-exclamation-triangle me-2"></i><strong>:</strong> `), $18e8c93f2f49788f$var$_tmpl$28 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<form><div class="alert alert-light border mb-3"><small><strong>:</strong><span class=ms-3><span class=text-danger>*</span> = </span><span class=ms-3><span class="badge bg-warning text-dark"style=font-size:0.65rem><i class="fas fa-user-check"style=font-size:0.6rem></i></span> = </span></small></div><button type=button class="btn btn-success me-2"></button><button type=button class="btn btn-secondary">`), $18e8c93f2f49788f$var$_tmpl$29 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<div><div><span></span></div><div class=card-body>`), $18e8c93f2f49788f$var$_tmpl$30 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<div class="alert alert-info mt-3"><i class="fas fa-info-circle me-2">`), $18e8c93f2f49788f$var$_tmpl$31 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<div class="alert alert-secondary mt-3"> <!>.`), $18e8c93f2f49788f$var$_tmpl$32 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<div class="card mt-3 mb-3"><div class="card-header bg-light"><strong></strong></div><div class="card-body p-0"><div class="list-group list-group-flush">`), $18e8c93f2f49788f$var$_tmpl$33 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<div class=mt-3><h6>:</h6><ul class=list-group>`), $18e8c93f2f49788f$var$_tmpl$34 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<small class="badge bg-info"><i class="fas fa-envelope me-1"></i> `), $18e8c93f2f49788f$var$_tmpl$35 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<small class=text-muted> <!> `), $18e8c93f2f49788f$var$_tmpl$36 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<div class=list-group-item><div class="d-flex justify-content-between align-items-center mb-1"><strong> </strong><small class=text-muted> <!> <!> </small></div><p class=mb-1 style=white-space:pre-wrap></p><div class="d-flex gap-2">`), $18e8c93f2f49788f$var$_tmpl$37 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<li class="list-group-item d-flex justify-content-between align-items-center"><span></span><small class=text-muted>`), $18e8c93f2f49788f$var$_tmpl$38 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<div class="alert alert-danger">`), $18e8c93f2f49788f$var$_tmpl$39 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<button type=button class="btn btn-primary mb-4">`), $18e8c93f2f49788f$var$_tmpl$40 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<h3 class="border-bottom pb-2 mt-4 text-danger"><i class="fas fa-lock me-2">`), $18e8c93f2f49788f$var$_tmpl$41 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<h3 class="border-bottom pb-2 mt-4">`), $18e8c93f2f49788f$var$_tmpl$42 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<div class="table-responsive mb-4"><table class="table table-hover"><thead class=table-light><tr><th></th><th></th><th></th><th></th></tr></thead><tbody>`), $18e8c93f2f49788f$var$_tmpl$43 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<div class="container mt-4"><h2></h2><div class="card mb-4"><div class=card-header></div><div class=card-body><div class=row><div class=col-md-3><div class="d-flex align-items-center mb-2"><span class="badge bg-primary me-2"></span><span></span></div><small class=text-muted></small></div><div class=col-md-3><div class="d-flex align-items-center mb-2"><span class="badge bg-warning me-2"></span><span></span></div><small class=text-muted></small></div><div class=col-md-3><div class="d-flex align-items-center mb-2"><span class="badge bg-success me-2"></span><span></span></div><small class=text-muted></small></div><div class=col-md-3><div class="d-flex align-items-center mb-2"><span class="badge bg-secondary me-2"></span><span></span></div><small class=text-muted>`), $18e8c93f2f49788f$var$_tmpl$44 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<div class="alert alert-info mb-4">`), $18e8c93f2f49788f$var$_tmpl$45 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<p>`), $18e8c93f2f49788f$var$_tmpl$46 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<div class="card mb-3 border-danger"><div class="card-header bg-danger text-white d-flex justify-content-between align-items-center"><span><i class="fas fa-lock me-2"></i></span></div><div class=card-body><div class="alert alert-warning mt-3"><i class="fas fa-info-circle me-2"></i><strong></strong> `), $18e8c93f2f49788f$var$_tmpl$47 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<span class="badge bg-success ms-2">`), $18e8c93f2f49788f$var$_tmpl$48 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<tr><td></td><td></td><td> - </td><td><div class=btn-group><button type=button><i class="bi bi-arrow-up-circle"></i> `);
function $18e8c93f2f49788f$export$8346eeeee374fb8e(fields = []) {
    const out = [];
    let currentGroup = null;
    for (const f of fields || []){
        if (f && f.type === "group") {
            // start a new group
            currentGroup = {
                ...f,
                children: []
            };
            out.push(currentGroup);
        } else if (f && f.type === "group-end") // end current group
        currentGroup = null;
        else if (currentGroup) currentGroup.children.push(f);
        else out.push(f);
    }
    return out;
}
const $18e8c93f2f49788f$export$665b5ec824ef65f = (props)=>{
    const t = (0, $87927b02874039c5$export$3f3caade1c12f8c9)();
    (0, $8863cd8fe199f948$export$7ea7134f704deda4)(()=>{
        console.log('Rendering ConventionDetails for convention', props.convention, 'with structure', JSON.parse(JSON.stringify(props.conventionStructure)));
    });
    return [
        (()=>{
            var _el$ = $18e8c93f2f49788f$var$_tmpl$();
            (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$, ()=>props.convention.info?.title || `${t("Internship Agreement")} (${props.convention.year})`);
            return _el$;
        })(),
        (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)($18e8c93f2f49788f$export$f3a2aee00b20d975, {
            get fields () {
                return props.conventionStructure.fields;
            },
            get values () {
                return props.convention.info;
            }
        }),
        (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
            get when () {
                return (0, $6258376c5c54faa9$export$7c73462e0d25e514)(()=>!!(props.convention.status === 'active' && props.convention.info?.feedbackHistory))() && props.convention.info.feedbackHistory.length > 0;
            },
            get children () {
                var _el$2 = $18e8c93f2f49788f$var$_tmpl$2(), _el$3 = _el$2.firstChild, _el$4 = _el$3.firstChild, _el$5 = _el$3.nextSibling;
                (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$3, ()=>t("Previous Feedback"), _el$4);
                (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$2, ()=>t("You have received feedback on earlier versions of this convention."), null);
                return _el$2;
            }
        }),
        (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
            get when () {
                return (0, $6258376c5c54faa9$export$7c73462e0d25e514)(()=>props.convention.status === 'active')() && props.startEditing;
            },
            get children () {
                return [
                    (()=>{
                        var _el$6 = $18e8c93f2f49788f$var$_tmpl$3();
                        _el$6.$$click = ()=>props.startEditing(props.convention);
                        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$6, ()=>t("Edit"));
                        return _el$6;
                    })(),
                    (()=>{
                        var _el$7 = $18e8c93f2f49788f$var$_tmpl$4();
                        _el$7.$$click = ()=>actions.deleteConvention(props.convention.id);
                        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$7, ()=>t("Delete"));
                        return _el$7;
                    })()
                ];
            }
        }),
        (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
            get when () {
                return (0, $6258376c5c54faa9$export$7c73462e0d25e514)(()=>!!(props.convention.status === 'pending' || props.convention.status === 'validated'))() && props.startEditing;
            },
            get children () {
                var _el$8 = $18e8c93f2f49788f$var$_tmpl$5(), _el$9 = _el$8.firstChild;
                _el$8.$$click = ()=>props.startEditing(props.convention);
                (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$8, ()=>t("Edit non-critical fields"), null);
                return _el$8;
            }
        })
    ];
};
function $18e8c93f2f49788f$export$f3a2aee00b20d975(props) {
    const grouped = (0, $8863cd8fe199f948$export$c0c6c8b9c16bf6aa)(()=>{
        const fields = props.fields || [];
        return $18e8c93f2f49788f$export$8346eeeee374fb8e(fields);
    });
    const formatFieldValue = (field, value)=>{
        if (!value) return null;
        if (field.type === "checkbox") return value === true || value === "true" ? "\u2713 Yes" : "\u2717 No";
        if (field.type === "select-multiple") {
            if (Array.isArray(value)) return value.join(", ");
            return value;
        }
        return value;
    };
    return (()=>{
        var _el$0 = $18e8c93f2f49788f$var$_tmpl$6();
        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$0, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$bdf530073099ce9f), {
            get each () {
                return grouped();
            },
            children: (item)=>(0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
                    get when () {
                        return item && item.children;
                    },
                    get fallback () {
                        return (()=>{
                            var _el$12 = $18e8c93f2f49788f$var$_tmpl$0(), _el$13 = _el$12.firstChild, _el$14 = _el$13.firstChild, _el$16 = _el$13.nextSibling;
                            (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$14, ()=>item.label, null);
                            (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$14, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
                                get when () {
                                    return item.required;
                                },
                                get children () {
                                    return $18e8c93f2f49788f$var$_tmpl$8();
                                }
                            }), null);
                            (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$16, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
                                get when () {
                                    return props.values?.[item.name];
                                },
                                get fallback () {
                                    return (()=>{
                                        var _el$18 = $18e8c93f2f49788f$var$_tmpl$1();
                                        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$18, ()=>$18e8c93f2f49788f$var$tPlaceholder(item));
                                        return _el$18;
                                    })();
                                },
                                get children () {
                                    var _el$17 = $18e8c93f2f49788f$var$_tmpl$9();
                                    (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$17, ()=>formatFieldValue(item, props.values[item.name]));
                                    return _el$17;
                                }
                            }));
                            return _el$12;
                        })();
                    },
                    get children () {
                        var _el$1 = $18e8c93f2f49788f$var$_tmpl$7(), _el$10 = _el$1.firstChild, _el$11 = _el$10.nextSibling;
                        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$10, ()=>item.label);
                        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$11, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$bdf530073099ce9f), {
                            get each () {
                                return item.children;
                            },
                            children: (f)=>(()=>{
                                    var _el$19 = $18e8c93f2f49788f$var$_tmpl$0(), _el$20 = _el$19.firstChild, _el$21 = _el$20.firstChild, _el$23 = _el$20.nextSibling;
                                    (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$21, ()=>f.label, null);
                                    (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$21, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
                                        get when () {
                                            return f.required;
                                        },
                                        get children () {
                                            return $18e8c93f2f49788f$var$_tmpl$8();
                                        }
                                    }), null);
                                    (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$23, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
                                        get when () {
                                            return props.values?.[f.name];
                                        },
                                        get fallback () {
                                            return (()=>{
                                                var _el$25 = $18e8c93f2f49788f$var$_tmpl$1();
                                                (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$25, ()=>$18e8c93f2f49788f$var$tPlaceholder(f));
                                                return _el$25;
                                            })();
                                        },
                                        get children () {
                                            var _el$24 = $18e8c93f2f49788f$var$_tmpl$9();
                                            (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$24, ()=>formatFieldValue(f, props.values[f.name]));
                                            return _el$24;
                                        }
                                    }));
                                    return _el$19;
                                })()
                        }));
                        return _el$1;
                    }
                })
        }));
        return _el$0;
    })();
}
// Helper to return a placeholder text for preview
function $18e8c93f2f49788f$var$tPlaceholder(f) {
    if (!f) return "";
    if (f.type === "textarea") return "---";
    if (f.type === "date") return "YYYY-MM-DD";
    if (f.type === "checkbox") return "\u2610 Not checked";
    if (f.type === "select-single") return "No option selected";
    if (f.type === "select-multiple") return "No options selected";
    return "";
}
function $18e8c93f2f49788f$export$29a02d8b29a909dd(props) {
    const grouped = (0, $8863cd8fe199f948$export$c0c6c8b9c16bf6aa)(()=>{
        const fields = props.fields || [];
        return $18e8c93f2f49788f$export$8346eeeee374fb8e(fields);
    });
    return (()=>{
        var _el$26 = $18e8c93f2f49788f$var$_tmpl$6();
        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$26, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$bdf530073099ce9f), {
            get each () {
                return grouped();
            },
            children: (item)=>(0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
                    get when () {
                        return item && item.children;
                    },
                    get fallback () {
                        return (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)($18e8c93f2f49788f$var$FieldInput, {
                            f: item,
                            get values () {
                                return props.values;
                            },
                            get onChange () {
                                return props.onChange;
                            },
                            get readonly () {
                                return props.readonly;
                            },
                            get editableFields () {
                                return props.editableFields;
                            }
                        });
                    },
                    get children () {
                        var _el$27 = $18e8c93f2f49788f$var$_tmpl$10(), _el$28 = _el$27.firstChild, _el$29 = _el$28.nextSibling;
                        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$28, ()=>item.label);
                        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$29, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$bdf530073099ce9f), {
                            get each () {
                                return item.children;
                            },
                            children: (f)=>(0, $8863cd8fe199f948$export$60e54eaca7e7fb38)($18e8c93f2f49788f$var$FieldInput, {
                                    f: f,
                                    get values () {
                                        return props.values;
                                    },
                                    get onChange () {
                                        return props.onChange;
                                    },
                                    get readonly () {
                                        return props.readonly;
                                    },
                                    get editableFields () {
                                        return props.editableFields;
                                    }
                                })
                        }));
                        return _el$27;
                    }
                })
        }));
        return _el$26;
    })();
}
function $18e8c93f2f49788f$var$FieldInput(props) {
    const t = (0, $87927b02874039c5$export$3f3caade1c12f8c9)();
    // Determine if this specific field should be readonly
    const isFieldReadonly = (0, $8863cd8fe199f948$export$c0c6c8b9c16bf6aa)(()=>{
        if (!props.readonly) return false;
        // If editableFields is provided and this field is in it, it's editable
        if (props.editableFields && props.editableFields.includes(props.f.name)) return false;
        return true;
    });
    // Check if field requires validation
    const requiresValidation = (0, $8863cd8fe199f948$export$c0c6c8b9c16bf6aa)(()=>props.f.requiresValidation !== false);
    return (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$b5d5cf8927ab7262), {
        get fallback () {
            return (()=>{
                var _el$56 = $18e8c93f2f49788f$var$_tmpl$18(), _el$57 = _el$56.firstChild, _el$58 = _el$57.nextSibling;
                _el$57.$$input = (e)=>props.onChange(props.f.name, e.target.value);
                (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$58, ()=>props.f.label, null);
                (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$58, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
                    get when () {
                        return props.f.required;
                    },
                    get children () {
                        return $18e8c93f2f49788f$var$_tmpl$11();
                    }
                }), null);
                (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$58, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
                    get when () {
                        return requiresValidation();
                    },
                    get children () {
                        var _el$60 = $18e8c93f2f49788f$var$_tmpl$12();
                        (0, $8863cd8fe199f948$export$314dade334ae905d)(()=>(0, $6258376c5c54faa9$export$9fec4d97f1922e0b)(_el$60, "title", t("This field requires teacher validation")));
                        return _el$60;
                    }
                }), null);
                (0, $8863cd8fe199f948$export$314dade334ae905d)((_p$)=>{
                    var _v$16 = props.f.name, _v$17 = props.f.label, _v$18 = props.f.required, _v$19 = isFieldReadonly(), _v$20 = props.f.name;
                    _v$16 !== _p$.e && (0, $6258376c5c54faa9$export$9fec4d97f1922e0b)(_el$57, "id", _p$.e = _v$16);
                    _v$17 !== _p$.t && (0, $6258376c5c54faa9$export$9fec4d97f1922e0b)(_el$57, "placeholder", _p$.t = _v$17);
                    _v$18 !== _p$.a && (_el$57.required = _p$.a = _v$18);
                    _v$19 !== _p$.o && (_el$57.disabled = _p$.o = _v$19);
                    _v$20 !== _p$.i && (0, $6258376c5c54faa9$export$9fec4d97f1922e0b)(_el$58, "for", _p$.i = _v$20);
                    return _p$;
                }, {
                    e: undefined,
                    t: undefined,
                    a: undefined,
                    o: undefined,
                    i: undefined
                });
                (0, $8863cd8fe199f948$export$314dade334ae905d)(()=>_el$57.value = props.values[props.f.name] || "");
                return _el$56;
            })();
        },
        get children () {
            return [
                (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f421feb8fad20413), {
                    get when () {
                        return props.f.type === "checkbox";
                    },
                    get children () {
                        var _el$30 = $18e8c93f2f49788f$var$_tmpl$13(), _el$31 = _el$30.firstChild, _el$32 = _el$31.nextSibling;
                        _el$31.addEventListener("change", (e)=>props.onChange(props.f.name, e.target.checked));
                        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$32, ()=>props.f.label, null);
                        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$32, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
                            get when () {
                                return props.f.required;
                            },
                            get children () {
                                return $18e8c93f2f49788f$var$_tmpl$11();
                            }
                        }), null);
                        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$32, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
                            get when () {
                                return requiresValidation();
                            },
                            get children () {
                                var _el$34 = $18e8c93f2f49788f$var$_tmpl$12();
                                (0, $8863cd8fe199f948$export$314dade334ae905d)(()=>(0, $6258376c5c54faa9$export$9fec4d97f1922e0b)(_el$34, "title", t("This field requires teacher validation")));
                                return _el$34;
                            }
                        }), null);
                        (0, $8863cd8fe199f948$export$314dade334ae905d)((_p$)=>{
                            var _v$ = props.f.name, _v$2 = isFieldReadonly(), _v$3 = props.f.name;
                            _v$ !== _p$.e && (0, $6258376c5c54faa9$export$9fec4d97f1922e0b)(_el$31, "id", _p$.e = _v$);
                            _v$2 !== _p$.t && (_el$31.disabled = _p$.t = _v$2);
                            _v$3 !== _p$.a && (0, $6258376c5c54faa9$export$9fec4d97f1922e0b)(_el$32, "for", _p$.a = _v$3);
                            return _p$;
                        }, {
                            e: undefined,
                            t: undefined,
                            a: undefined
                        });
                        (0, $8863cd8fe199f948$export$314dade334ae905d)(()=>_el$31.checked = props.values[props.f.name] === true || props.values[props.f.name] === "true");
                        return _el$30;
                    }
                }),
                (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f421feb8fad20413), {
                    get when () {
                        return props.f.type === "textarea";
                    },
                    get children () {
                        var _el$35 = $18e8c93f2f49788f$var$_tmpl$14(), _el$36 = _el$35.firstChild, _el$37 = _el$36.nextSibling;
                        _el$36.$$input = (e)=>props.onChange(props.f.name, e.target.value);
                        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$37, ()=>props.f.label, null);
                        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$37, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
                            get when () {
                                return props.f.required;
                            },
                            get children () {
                                return $18e8c93f2f49788f$var$_tmpl$11();
                            }
                        }), null);
                        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$37, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
                            get when () {
                                return requiresValidation();
                            },
                            get children () {
                                var _el$39 = $18e8c93f2f49788f$var$_tmpl$12();
                                (0, $8863cd8fe199f948$export$314dade334ae905d)(()=>(0, $6258376c5c54faa9$export$9fec4d97f1922e0b)(_el$39, "title", t("This field requires teacher validation")));
                                return _el$39;
                            }
                        }), null);
                        (0, $8863cd8fe199f948$export$314dade334ae905d)((_p$)=>{
                            var _v$4 = props.f.name, _v$5 = props.f.label, _v$6 = props.f.required, _v$7 = isFieldReadonly(), _v$8 = props.f.name;
                            _v$4 !== _p$.e && (0, $6258376c5c54faa9$export$9fec4d97f1922e0b)(_el$36, "id", _p$.e = _v$4);
                            _v$5 !== _p$.t && (0, $6258376c5c54faa9$export$9fec4d97f1922e0b)(_el$36, "placeholder", _p$.t = _v$5);
                            _v$6 !== _p$.a && (_el$36.required = _p$.a = _v$6);
                            _v$7 !== _p$.o && (_el$36.disabled = _p$.o = _v$7);
                            _v$8 !== _p$.i && (0, $6258376c5c54faa9$export$9fec4d97f1922e0b)(_el$37, "for", _p$.i = _v$8);
                            return _p$;
                        }, {
                            e: undefined,
                            t: undefined,
                            a: undefined,
                            o: undefined,
                            i: undefined
                        });
                        (0, $8863cd8fe199f948$export$314dade334ae905d)(()=>_el$36.value = props.values[props.f.name] || "");
                        return _el$35;
                    }
                }),
                (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f421feb8fad20413), {
                    get when () {
                        return props.f.type === "date";
                    },
                    get children () {
                        var _el$40 = $18e8c93f2f49788f$var$_tmpl$15(), _el$41 = _el$40.firstChild, _el$42 = _el$41.nextSibling;
                        _el$41.$$input = (e)=>props.onChange(props.f.name, e.target.value);
                        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$42, ()=>props.f.label, null);
                        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$42, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
                            get when () {
                                return props.f.required;
                            },
                            get children () {
                                return $18e8c93f2f49788f$var$_tmpl$11();
                            }
                        }), null);
                        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$42, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
                            get when () {
                                return requiresValidation();
                            },
                            get children () {
                                var _el$44 = $18e8c93f2f49788f$var$_tmpl$12();
                                (0, $8863cd8fe199f948$export$314dade334ae905d)(()=>(0, $6258376c5c54faa9$export$9fec4d97f1922e0b)(_el$44, "title", t("This field requires teacher validation")));
                                return _el$44;
                            }
                        }), null);
                        (0, $8863cd8fe199f948$export$314dade334ae905d)((_p$)=>{
                            var _v$9 = props.f.name, _v$0 = props.f.label, _v$1 = props.f.required, _v$10 = isFieldReadonly(), _v$11 = props.f.name;
                            _v$9 !== _p$.e && (0, $6258376c5c54faa9$export$9fec4d97f1922e0b)(_el$41, "id", _p$.e = _v$9);
                            _v$0 !== _p$.t && (0, $6258376c5c54faa9$export$9fec4d97f1922e0b)(_el$41, "placeholder", _p$.t = _v$0);
                            _v$1 !== _p$.a && (_el$41.required = _p$.a = _v$1);
                            _v$10 !== _p$.o && (_el$41.disabled = _p$.o = _v$10);
                            _v$11 !== _p$.i && (0, $6258376c5c54faa9$export$9fec4d97f1922e0b)(_el$42, "for", _p$.i = _v$11);
                            return _p$;
                        }, {
                            e: undefined,
                            t: undefined,
                            a: undefined,
                            o: undefined,
                            i: undefined
                        });
                        (0, $8863cd8fe199f948$export$314dade334ae905d)(()=>_el$41.value = props.values[props.f.name] || "");
                        return _el$40;
                    }
                }),
                (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f421feb8fad20413), {
                    get when () {
                        return props.f.type === "select-single";
                    },
                    get children () {
                        var _el$45 = $18e8c93f2f49788f$var$_tmpl$16(), _el$46 = _el$45.firstChild, _el$47 = _el$46.firstChild, _el$48 = _el$46.nextSibling;
                        _el$46.addEventListener("change", (e)=>props.onChange(props.f.name, e.target.value));
                        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$47, ()=>props.f.label);
                        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$46, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$bdf530073099ce9f), {
                            get each () {
                                return props.f.options || [];
                            },
                            children: (option)=>(()=>{
                                    var _el$61 = $18e8c93f2f49788f$var$_tmpl$19();
                                    _el$61.value = option;
                                    (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$61, option);
                                    return _el$61;
                                })()
                        }), null);
                        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$48, ()=>props.f.label, null);
                        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$48, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
                            get when () {
                                return props.f.required;
                            },
                            get children () {
                                return $18e8c93f2f49788f$var$_tmpl$11();
                            }
                        }), null);
                        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$48, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
                            get when () {
                                return requiresValidation();
                            },
                            get children () {
                                var _el$50 = $18e8c93f2f49788f$var$_tmpl$12();
                                (0, $8863cd8fe199f948$export$314dade334ae905d)(()=>(0, $6258376c5c54faa9$export$9fec4d97f1922e0b)(_el$50, "title", t("This field requires teacher validation")));
                                return _el$50;
                            }
                        }), null);
                        (0, $8863cd8fe199f948$export$314dade334ae905d)((_p$)=>{
                            var _v$12 = props.f.name, _v$13 = props.f.required, _v$14 = isFieldReadonly(), _v$15 = props.f.name;
                            _v$12 !== _p$.e && (0, $6258376c5c54faa9$export$9fec4d97f1922e0b)(_el$46, "id", _p$.e = _v$12);
                            _v$13 !== _p$.t && (_el$46.required = _p$.t = _v$13);
                            _v$14 !== _p$.a && (_el$46.disabled = _p$.a = _v$14);
                            _v$15 !== _p$.o && (0, $6258376c5c54faa9$export$9fec4d97f1922e0b)(_el$48, "for", _p$.o = _v$15);
                            return _p$;
                        }, {
                            e: undefined,
                            t: undefined,
                            a: undefined,
                            o: undefined
                        });
                        (0, $8863cd8fe199f948$export$314dade334ae905d)(()=>_el$46.value = props.values[props.f.name] || "");
                        return _el$45;
                    }
                }),
                (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f421feb8fad20413), {
                    get when () {
                        return props.f.type === "select-multiple";
                    },
                    get children () {
                        var _el$51 = $18e8c93f2f49788f$var$_tmpl$17(), _el$52 = _el$51.firstChild, _el$55 = _el$52.nextSibling;
                        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$52, ()=>props.f.label, null);
                        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$52, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
                            get when () {
                                return props.f.required;
                            },
                            get children () {
                                return $18e8c93f2f49788f$var$_tmpl$11();
                            }
                        }), null);
                        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$52, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
                            get when () {
                                return requiresValidation();
                            },
                            get children () {
                                var _el$54 = $18e8c93f2f49788f$var$_tmpl$12();
                                (0, $8863cd8fe199f948$export$314dade334ae905d)(()=>(0, $6258376c5c54faa9$export$9fec4d97f1922e0b)(_el$54, "title", t("This field requires teacher validation")));
                                return _el$54;
                            }
                        }), null);
                        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$55, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$bdf530073099ce9f), {
                            get each () {
                                return props.f.options || [];
                            },
                            children: (option)=>{
                                const isChecked = (0, $8863cd8fe199f948$export$c0c6c8b9c16bf6aa)(()=>{
                                    const value = props.values[props.f.name];
                                    if (Array.isArray(value)) return value.includes(option);
                                    return false;
                                });
                                const handleChange = (checked)=>{
                                    const currentValue = Array.isArray(props.values[props.f.name]) ? props.values[props.f.name] : [];
                                    let newValue;
                                    if (checked) newValue = [
                                        ...currentValue,
                                        option
                                    ];
                                    else newValue = currentValue.filter((v)=>v !== option);
                                    props.onChange(props.f.name, newValue);
                                };
                                return (()=>{
                                    var _el$62 = $18e8c93f2f49788f$var$_tmpl$20(), _el$63 = _el$62.firstChild, _el$64 = _el$63.nextSibling;
                                    _el$63.addEventListener("change", (e)=>handleChange(e.target.checked));
                                    (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$64, option);
                                    (0, $8863cd8fe199f948$export$314dade334ae905d)((_p$)=>{
                                        var _v$21 = `${props.f.name}_${option}`, _v$22 = isFieldReadonly(), _v$23 = `${props.f.name}_${option}`;
                                        _v$21 !== _p$.e && (0, $6258376c5c54faa9$export$9fec4d97f1922e0b)(_el$63, "id", _p$.e = _v$21);
                                        _v$22 !== _p$.t && (_el$63.disabled = _p$.t = _v$22);
                                        _v$23 !== _p$.a && (0, $6258376c5c54faa9$export$9fec4d97f1922e0b)(_el$64, "for", _p$.a = _v$23);
                                        return _p$;
                                    }, {
                                        e: undefined,
                                        t: undefined,
                                        a: undefined
                                    });
                                    (0, $8863cd8fe199f948$export$314dade334ae905d)(()=>_el$63.checked = isChecked());
                                    return _el$62;
                                })();
                            }
                        }));
                        return _el$51;
                    }
                })
            ];
        }
    });
}
function $18e8c93f2f49788f$export$2e2bcd8739ae039() {
    const t = (0, $87927b02874039c5$export$3f3caade1c12f8c9)();
    const [userStore, setUserStore, actions1] = (0, $c3b276e29c1ce2f2$export$87c54b525b914dab)();
    const [editingId, setEditingId] = (0, $8863cd8fe199f948$export$c1e1e1ecbbe76a5)(null);
    const [editForm, setEditForm] = (0, $8863cd8fe199f948$export$c1e1e1ecbbe76a5)({});
    const [errorMessage, setErrorMessage] = (0, $8863cd8fe199f948$export$c1e1e1ecbbe76a5)(null);
    // Group conventions by status
    const groupedConventions = (0, $8863cd8fe199f948$export$c0c6c8b9c16bf6aa)(()=>{
        const active = [];
        const pending = [];
        const validated = [];
        const locked = [];
        const archived = [];
        userStore.conventions.forEach((convention)=>{
            if (convention.status === 'active') active.push(convention);
            else if (convention.status === 'pending') pending.push(convention);
            else if (convention.status === 'validated') validated.push(convention);
            else if (convention.status === 'locked') locked.push(convention);
            else if (convention.status === 'archived') archived.push(convention);
        });
        return {
            active: active,
            pending: pending,
            validated: validated,
            locked: locked,
            archived: archived
        };
    });
    // Add event listener for convention errors
    if (!userStore.conventionErrorHandlerSet) {
        (0, $a26018a1d2174fbf$export$2e2bcd8739ae039).on('convention-error', (error)=>{
            setErrorMessage(error.message);
            // Clear the error message after 5 seconds
            setTimeout(()=>setErrorMessage(null), 5000);
        });
        setUserStore('conventionErrorHandlerSet', true);
    }
    // Helper function to initialize empty form (using createMemo to cache based on structure)
    const createEmptyForm = (0, $8863cd8fe199f948$export$c0c6c8b9c16bf6aa)(()=>{
        // Create an object with empty values for all fields in the structure
        const form = {};
        if (userStore.conventionStructure && userStore.conventionStructure.fields) userStore.conventionStructure.fields.forEach((field)=>{
            if (field.type === "checkbox") form[field.name] = false;
            else if (field.type === "select-multiple") form[field.name] = [];
            else form[field.name] = "";
        });
        return form;
    });
    const startEditing = (convention)=>{
        setEditingId(convention.id);
        // Initialize form with values from convention or empty strings if not present
        const initialForm = {
            ...createEmptyForm()
        };
        // Fill in existing values
        if (convention.info) Object.keys(convention.info).forEach((key)=>{
            if (initialForm[key] !== undefined) initialForm[key] = convention.info[key];
        });
        setEditForm(initialForm);
    };
    const saveEditing = ()=>{
        actions1.updateConvention(editingId(), editForm());
        setEditingId(null);
    };
    const cancelEditing = ()=>{
        setEditingId(null);
    };
    const changeStatus = (conventionId, newStatus)=>{
        actions1.changeConventionStatus(conventionId, newStatus);
    };
    const requestFeedback = (conventionId)=>{
        if (confirm(t('Are you sure you want to request feedback? This will make your convention visible to teachers for validation.'))) changeStatus(conventionId, 'pending');
    };
    const makeActive = (conventionId)=>{
        // Find the convention
        const convention = userStore.conventions.find((c)=>c.id === conventionId);
        if (convention) {
            // If convention was previously validated, explain that it will be restored as validated
            if (convention.info && convention.info.fullyValidated) {
                if (confirm(t('This convention was previously validated. It will be restored as a validated convention. Continue?'))) changeStatus(conventionId, 'active');
            } else if (convention.status === 'pending') {
                if (confirm(t('Moving back to draft mode will hide this convention from teachers. You will need to request feedback again after making your changes. Continue?'))) changeStatus(conventionId, 'active');
            } else changeStatus(conventionId, 'active');
        }
    };
    const archiveConvention = (conventionId)=>{
        //if (confirm('Are you sure you want to archive this convention?')) {
        changeStatus(conventionId, 'archived');
    //}
    };
    // Render a convention card with appropriate styling and actions based on status
    const renderConventionCard = (convention)=>{
        const t = (0, $87927b02874039c5$export$3f3caade1c12f8c9)();
        // Define styling and actions based on status
        const cardConfig = {
            'active': {
                borderClass: 'border-primary',
                headerClass: 'bg-primary text-white',
                statusText: t('Active - Draft Mode'),
                actions: (()=>{
                    var _el$65 = $18e8c93f2f49788f$var$_tmpl$21(), _el$66 = _el$65.firstChild, _el$67 = _el$66.nextSibling;
                    _el$66.$$click = ()=>requestFeedback(convention.id);
                    (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$66, ()=>t("Request Feedback"));
                    _el$67.$$click = ()=>archiveConvention(convention.id);
                    (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$67, ()=>t("Archive"));
                    (0, $8863cd8fe199f948$export$314dade334ae905d)((_p$)=>{
                        var _v$24 = t("Submit for validation"), _v$25 = groupedConventions().locked.length > 0, _v$26 = t("Archive this convention"), _v$27 = groupedConventions().locked.length > 0;
                        _v$24 !== _p$.e && (0, $6258376c5c54faa9$export$9fec4d97f1922e0b)(_el$66, "title", _p$.e = _v$24);
                        _v$25 !== _p$.t && (_el$66.disabled = _p$.t = _v$25);
                        _v$26 !== _p$.a && (0, $6258376c5c54faa9$export$9fec4d97f1922e0b)(_el$67, "title", _p$.a = _v$26);
                        _v$27 !== _p$.o && (_el$67.disabled = _p$.o = _v$27);
                        return _p$;
                    }, {
                        e: undefined,
                        t: undefined,
                        a: undefined,
                        o: undefined
                    });
                    return _el$65;
                })()
            },
            'pending': {
                borderClass: 'border-warning',
                headerClass: 'bg-warning',
                statusText: t('Awaiting Teacher Validation'),
                actions: (()=>{
                    var _el$68 = $18e8c93f2f49788f$var$_tmpl$22(), _el$69 = _el$68.firstChild, _el$70 = _el$69.nextSibling;
                    _el$69.$$click = ()=>makeActive(convention.id);
                    (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$69, ()=>t("Back to Draft"));
                    _el$70.$$click = ()=>archiveConvention(convention.id);
                    (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$70, ()=>t("Archive"));
                    (0, $8863cd8fe199f948$export$314dade334ae905d)((_p$)=>{
                        var _v$28 = t("Move back to draft mode for editing"), _v$29 = groupedConventions().locked.length > 0, _v$30 = t("Archive this convention"), _v$31 = groupedConventions().locked.length > 0;
                        _v$28 !== _p$.e && (0, $6258376c5c54faa9$export$9fec4d97f1922e0b)(_el$69, "title", _p$.e = _v$28);
                        _v$29 !== _p$.t && (_el$69.disabled = _p$.t = _v$29);
                        _v$30 !== _p$.a && (0, $6258376c5c54faa9$export$9fec4d97f1922e0b)(_el$70, "title", _p$.a = _v$30);
                        _v$31 !== _p$.o && (_el$70.disabled = _p$.o = _v$31);
                        return _p$;
                    }, {
                        e: undefined,
                        t: undefined,
                        a: undefined,
                        o: undefined
                    });
                    return _el$68;
                })(),
                extraInfo: (()=>{
                    var _el$71 = $18e8c93f2f49788f$var$_tmpl$24(), _el$72 = _el$71.firstChild, _el$73 = _el$72.firstChild, _el$74 = _el$73.firstChild, _el$75 = _el$73.nextSibling;
                    (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$73, ()=>t("Feedback requested on"), _el$74);
                    (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$73, ()=>new Date(convention.info?.requestedFeedbackDate).toLocaleString(), null);
                    (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$75, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
                        get when () {
                            return (0, $6258376c5c54faa9$export$7c73462e0d25e514)(()=>!!convention.info?.validations)() && convention.info.validations.length > 0;
                        },
                        get children () {
                            var _el$76 = $18e8c93f2f49788f$var$_tmpl$23(), _el$77 = _el$76.firstChild;
                            (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$76, ()=>convention.info.validations.length, _el$77);
                            (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$76, ()=>t("teachers validated"), null);
                            return _el$76;
                        }
                    }));
                    return _el$71;
                })()
            },
            'validated': {
                borderClass: 'border-success',
                headerClass: 'bg-success text-white',
                statusText: t('Validated by All Teachers'),
                actions: (()=>{
                    var _el$78 = $18e8c93f2f49788f$var$_tmpl$25(), _el$79 = _el$78.firstChild;
                    _el$79.$$click = ()=>archiveConvention(convention.id);
                    (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$79, ()=>t("Archive"));
                    (0, $8863cd8fe199f948$export$314dade334ae905d)((_p$)=>{
                        var _v$32 = t("Archive this convention"), _v$33 = groupedConventions().locked.length > 0;
                        _v$32 !== _p$.e && (0, $6258376c5c54faa9$export$9fec4d97f1922e0b)(_el$79, "title", _p$.e = _v$32);
                        _v$33 !== _p$.t && (_el$79.disabled = _p$.t = _v$33);
                        return _p$;
                    }, {
                        e: undefined,
                        t: undefined
                    });
                    return _el$78;
                })(),
                extraInfo: (()=>{
                    var _el$80 = $18e8c93f2f49788f$var$_tmpl$26(), _el$81 = _el$80.firstChild, _el$82 = _el$81.nextSibling;
                    (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$81, ()=>t("Fully Validated!"));
                    (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$80, ()=>t("All teachers have approved your internship agreement."), null);
                    return _el$80;
                })()
            }
        };
        const config = (0, $8863cd8fe199f948$export$c0c6c8b9c16bf6aa)(()=>cardConfig[convention.status] || {});
        const currentEditableFields = (0, $8863cd8fe199f948$export$c0c6c8b9c16bf6aa)(()=>userStore.conventionStructure.fields.filter((field)=>field.requiresValidation === false).map((field)=>field.name));
        return (()=>{
            var _el$83 = $18e8c93f2f49788f$var$_tmpl$29(), _el$84 = _el$83.firstChild, _el$85 = _el$84.firstChild, _el$86 = _el$84.nextSibling;
            (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$85, ()=>config().statusText || convention.status);
            (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$84, ()=>config().actions, null);
            (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$86, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
                get when () {
                    return editingId() === convention.id;
                },
                get fallback () {
                    return [
                        (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)($18e8c93f2f49788f$export$665b5ec824ef65f, {
                            convention: convention,
                            startEditing: startEditing,
                            get conventionStructure () {
                                return userStore.conventionStructure;
                            }
                        }),
                        (0, $6258376c5c54faa9$export$7c73462e0d25e514)(()=>config().extraInfo),
                        (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
                            get when () {
                                return convention.status === 'pending' || convention.status === 'validated';
                            },
                            get children () {
                                var _el$105 = $18e8c93f2f49788f$var$_tmpl$30(), _el$106 = _el$105.firstChild;
                                (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$105, ()=>t("You can still edit fields that don't require teacher validation. Click Edit to modify them."), null);
                                return _el$105;
                            }
                        }),
                        (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
                            get when () {
                                return (0, $6258376c5c54faa9$export$7c73462e0d25e514)(()=>!!(convention.status === 'pending' && convention.info?.feedbackHistory && convention.info.feedbackHistory.length > 0))() && convention.info.feedbackHistory[0].conventionVersion === convention.info.version;
                            },
                            get children () {
                                var _el$107 = $18e8c93f2f49788f$var$_tmpl$31(), _el$108 = _el$107.firstChild, _el$110 = _el$108.nextSibling, _el$109 = _el$110.nextSibling;
                                (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$107, ()=>t("See below the feedback history, the current version is Version"), _el$108);
                                (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$107, ()=>convention.info.version, _el$110);
                                return _el$107;
                            }
                        }),
                        (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
                            get when () {
                                return (0, $6258376c5c54faa9$export$7c73462e0d25e514)(()=>!!convention.info?.feedbackHistory)() && convention.info.feedbackHistory.length > 0;
                            },
                            get children () {
                                var _el$111 = $18e8c93f2f49788f$var$_tmpl$32(), _el$112 = _el$111.firstChild, _el$113 = _el$112.firstChild, _el$114 = _el$112.nextSibling, _el$115 = _el$114.firstChild;
                                (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$113, ()=>t("Feedback History"));
                                (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$115, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$bdf530073099ce9f), {
                                    get each () {
                                        return convention.info.feedbackHistory;
                                    },
                                    children: (historyItem, index)=>(()=>{
                                            var _el$120 = $18e8c93f2f49788f$var$_tmpl$36(), _el$121 = _el$120.firstChild, _el$122 = _el$121.firstChild, _el$123 = _el$122.firstChild, _el$124 = _el$122.nextSibling, _el$125 = _el$124.firstChild, _el$128 = _el$125.nextSibling, _el$126 = _el$128.nextSibling, _el$129 = _el$126.nextSibling, _el$127 = _el$129.nextSibling, _el$130 = _el$121.nextSibling, _el$131 = _el$130.nextSibling;
                                            (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$122, ()=>t("Version"), _el$123);
                                            (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$122, ()=>historyItem.conventionVersion || '?', null);
                                            (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$124, ()=>t("by"), _el$125);
                                            (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$124, ()=>historyItem.teacher, _el$128);
                                            (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$124, ()=>t("on"), _el$129);
                                            (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$124, ()=>new Date(historyItem.date).toLocaleString(), null);
                                            (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$130, ()=>historyItem.feedback);
                                            (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$131, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
                                                get when () {
                                                    return historyItem.notificationSent;
                                                },
                                                get children () {
                                                    var _el$132 = $18e8c93f2f49788f$var$_tmpl$34(), _el$133 = _el$132.firstChild, _el$134 = _el$133.nextSibling;
                                                    (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$132, ()=>t("Notification received"), null);
                                                    return _el$132;
                                                }
                                            }), null);
                                            (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$131, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
                                                get when () {
                                                    return (0, $6258376c5c54faa9$export$7c73462e0d25e514)(()=>!!historyItem.validations)() && historyItem.validations.length > 0;
                                                },
                                                get children () {
                                                    var _el$135 = $18e8c93f2f49788f$var$_tmpl$35(), _el$136 = _el$135.firstChild, _el$138 = _el$136.nextSibling, _el$137 = _el$138.nextSibling;
                                                    (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$135, ()=>t("Validated by"), _el$136);
                                                    (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$135, ()=>historyItem.validations.length, _el$138);
                                                    (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$135, ()=>t("teacher(s)"), null);
                                                    return _el$135;
                                                }
                                            }), null);
                                            return _el$120;
                                        })()
                                }));
                                return _el$111;
                            }
                        }),
                        (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
                            get when () {
                                return (0, $6258376c5c54faa9$export$7c73462e0d25e514)(()=>!!(convention.status === 'pending' && convention.info?.validations))() && convention.info.validations.length > 0;
                            },
                            get children () {
                                var _el$116 = $18e8c93f2f49788f$var$_tmpl$33(), _el$117 = _el$116.firstChild, _el$118 = _el$117.firstChild, _el$119 = _el$117.nextSibling;
                                (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$117, ()=>t("Validators"), _el$118);
                                (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$119, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$bdf530073099ce9f), {
                                    get each () {
                                        return convention.info.validations;
                                    },
                                    children: (validation)=>(()=>{
                                            var _el$139 = $18e8c93f2f49788f$var$_tmpl$37(), _el$140 = _el$139.firstChild, _el$141 = _el$140.nextSibling;
                                            (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$140, ()=>validation.validatorName);
                                            (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$141, ()=>new Date(validation.timestamp).toLocaleString());
                                            return _el$139;
                                        })()
                                }));
                                return _el$116;
                            }
                        })
                    ];
                },
                get children () {
                    var _el$87 = $18e8c93f2f49788f$var$_tmpl$28(), _el$93 = _el$87.firstChild, _el$94 = _el$93.firstChild, _el$95 = _el$94.firstChild, _el$96 = _el$95.firstChild, _el$97 = _el$95.nextSibling, _el$98 = _el$97.firstChild, _el$99 = _el$98.nextSibling, _el$100 = _el$97.nextSibling, _el$101 = _el$100.firstChild, _el$102 = _el$101.nextSibling, _el$103 = _el$93.nextSibling, _el$104 = _el$103.nextSibling;
                    (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$87, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
                        get when () {
                            return convention.status === 'pending' || convention.status === 'validated';
                        },
                        get children () {
                            var _el$88 = $18e8c93f2f49788f$var$_tmpl$27(), _el$89 = _el$88.firstChild, _el$90 = _el$89.nextSibling, _el$91 = _el$90.firstChild, _el$92 = _el$90.nextSibling;
                            (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$90, ()=>t("Limited editing mode"), _el$91);
                            (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$88, ()=>t("Only fields that don't require teacher validation can be edited. Fields requiring validation are disabled."), null);
                            return _el$88;
                        }
                    }), _el$93);
                    (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$95, ()=>t("Field indicators"), _el$96);
                    (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$97, ()=>t("Required field"), null);
                    (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$100, ()=>t("Requires teacher validation"), null);
                    (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$87, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)($18e8c93f2f49788f$export$29a02d8b29a909dd, {
                        get fields () {
                            return userStore.conventionStructure.fields;
                        },
                        get values () {
                            return editForm();
                        },
                        onChange: (name, value)=>setEditForm({
                                ...editForm(),
                                [name]: value
                            }),
                        get readonly () {
                            return convention.status === 'pending' || convention.status === 'validated';
                        },
                        get editableFields () {
                            return currentEditableFields();
                        }
                    }), _el$103);
                    _el$103.$$click = saveEditing;
                    (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$103, ()=>t("Save"));
                    _el$104.$$click = cancelEditing;
                    (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$104, ()=>t("Cancel"));
                    return _el$87;
                }
            }));
            (0, $8863cd8fe199f948$export$314dade334ae905d)((_p$)=>{
                var _v$34 = `card mb-3 ${config().borderClass || 'border'}`, _v$35 = `card-header ${config().headerClass || ''} d-flex justify-content-between align-items-center`;
                _v$34 !== _p$.e && (0, $6258376c5c54faa9$export$2913c0c0b5623090)(_el$83, _p$.e = _v$34);
                _v$35 !== _p$.t && (0, $6258376c5c54faa9$export$2913c0c0b5623090)(_el$84, _p$.t = _v$35);
                return _p$;
            }, {
                e: undefined,
                t: undefined
            });
            return _el$83;
        })();
    };
    return (()=>{
        var _el$142 = $18e8c93f2f49788f$var$_tmpl$43(), _el$143 = _el$142.firstChild, _el$145 = _el$143.nextSibling, _el$146 = _el$145.firstChild, _el$147 = _el$146.nextSibling, _el$148 = _el$147.firstChild, _el$149 = _el$148.firstChild, _el$150 = _el$149.firstChild, _el$151 = _el$150.firstChild, _el$152 = _el$151.nextSibling, _el$153 = _el$150.nextSibling, _el$154 = _el$149.nextSibling, _el$155 = _el$154.firstChild, _el$156 = _el$155.firstChild, _el$157 = _el$156.nextSibling, _el$158 = _el$155.nextSibling, _el$159 = _el$154.nextSibling, _el$160 = _el$159.firstChild, _el$161 = _el$160.firstChild, _el$162 = _el$161.nextSibling, _el$163 = _el$160.nextSibling, _el$164 = _el$159.nextSibling, _el$165 = _el$164.firstChild, _el$166 = _el$165.firstChild, _el$167 = _el$166.nextSibling, _el$168 = _el$165.nextSibling;
        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$143, ()=>t("Your Internship Agreements"));
        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$142, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
            get when () {
                return errorMessage();
            },
            get children () {
                var _el$144 = $18e8c93f2f49788f$var$_tmpl$38();
                (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$144, errorMessage);
                return _el$144;
            }
        }), _el$145);
        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$146, ()=>t("Convention Status Guide"));
        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$151, ()=>t("Draft"));
        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$152, ()=>t("Private to you"));
        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$153, ()=>t("Edit and prepare your convention"));
        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$156, ()=>t("Pending"));
        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$157, ()=>t("Visible to teachers"));
        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$158, ()=>t("Awaiting teacher validation"));
        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$161, ()=>t("Validated"));
        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$162, ()=>t("Fully approved"));
        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$163, ()=>t("All teachers have validated"));
        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$166, ()=>t("Archived"));
        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$167, ()=>t("Inactive"));
        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$168, ()=>t("Stored for reference"));
        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$142, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
            get when () {
                return (0, $6258376c5c54faa9$export$7c73462e0d25e514)(()=>!!(groupedConventions().active.length === 0 && groupedConventions().pending.length === 0 && groupedConventions().validated.length === 0))() && groupedConventions().locked.length === 0;
            },
            get fallback () {
                return (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
                    get when () {
                        return groupedConventions().locked.length > 0;
                    },
                    get fallback () {
                        return (()=>{
                            var _el$186 = $18e8c93f2f49788f$var$_tmpl$44();
                            (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$186, ()=>t("You already have an active convention. To create a new one, you need to archive your current active convention."));
                            return _el$186;
                        })();
                    },
                    get children () {
                        var _el$185 = $18e8c93f2f49788f$var$_tmpl$44();
                        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$185, ()=>t("You already have a locked convention. You cannot create new conventions while having a locked one."));
                        return _el$185;
                    }
                });
            },
            get children () {
                var _el$169 = $18e8c93f2f49788f$var$_tmpl$39();
                _el$169.$$click = ()=>actions1.createConvention();
                (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$169, ()=>t("Create New Agreement"));
                return _el$169;
            }
        }), null);
        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$142, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
            get when () {
                return userStore.conventions.length > 0;
            },
            get fallback () {
                return (()=>{
                    var _el$187 = $18e8c93f2f49788f$var$_tmpl$45();
                    (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$187, ()=>t("You don't have any internship agreements yet. Create one to get started."));
                    return _el$187;
                })();
            },
            get children () {
                return [
                    (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
                        get when () {
                            return groupedConventions().locked.length > 0;
                        },
                        get children () {
                            return [
                                (()=>{
                                    var _el$170 = $18e8c93f2f49788f$var$_tmpl$40(), _el$171 = _el$170.firstChild;
                                    (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$170, ()=>t("Locked Convention"), null);
                                    return _el$170;
                                })(),
                                (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$bdf530073099ce9f), {
                                    get each () {
                                        return groupedConventions().locked;
                                    },
                                    children: (convention)=>(()=>{
                                            var _el$188 = $18e8c93f2f49788f$var$_tmpl$46(), _el$189 = _el$188.firstChild, _el$190 = _el$189.firstChild, _el$191 = _el$190.firstChild, _el$192 = _el$189.nextSibling, _el$193 = _el$192.firstChild, _el$194 = _el$193.firstChild, _el$195 = _el$194.nextSibling, _el$196 = _el$195.nextSibling;
                                            (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$190, ()=>t("Locked by Administrator"), null);
                                            (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$192, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)($18e8c93f2f49788f$export$665b5ec824ef65f, {
                                                convention: convention,
                                                startEditing: null,
                                                get conventionStructure () {
                                                    return userStore.conventionStructure;
                                                }
                                            }), _el$193);
                                            (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$195, ()=>t("This convention is locked."));
                                            (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$193, ()=>t("You cannot modify or archive it. Contact an administrator if you need changes."), null);
                                            (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$192, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
                                                get when () {
                                                    return (0, $6258376c5c54faa9$export$7c73462e0d25e514)(()=>!!convention.info?.validations)() && convention.info.validations.length > 0;
                                                },
                                                get children () {
                                                    var _el$197 = $18e8c93f2f49788f$var$_tmpl$33(), _el$198 = _el$197.firstChild, _el$199 = _el$198.firstChild, _el$200 = _el$198.nextSibling;
                                                    (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$198, ()=>t("Validators"), _el$199);
                                                    (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$200, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$bdf530073099ce9f), {
                                                        get each () {
                                                            return convention.info.validations;
                                                        },
                                                        children: (validation)=>(()=>{
                                                                var _el$201 = $18e8c93f2f49788f$var$_tmpl$37(), _el$202 = _el$201.firstChild, _el$203 = _el$202.nextSibling;
                                                                (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$202, ()=>validation.validatorName);
                                                                (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$203, ()=>new Date(validation.timestamp).toLocaleString());
                                                                return _el$201;
                                                            })()
                                                    }));
                                                    return _el$197;
                                                }
                                            }), null);
                                            return _el$188;
                                        })()
                                })
                            ];
                        }
                    }),
                    (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
                        get when () {
                            return groupedConventions().active.length > 0;
                        },
                        get children () {
                            return [
                                (()=>{
                                    var _el$172 = $18e8c93f2f49788f$var$_tmpl$41();
                                    (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$172, ()=>t("Active Convention"));
                                    return _el$172;
                                })(),
                                (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$bdf530073099ce9f), {
                                    get each () {
                                        return groupedConventions().active;
                                    },
                                    children: (convention)=>renderConventionCard(convention)
                                })
                            ];
                        }
                    }),
                    (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
                        get when () {
                            return groupedConventions().pending.length > 0;
                        },
                        get children () {
                            return [
                                (()=>{
                                    var _el$173 = $18e8c93f2f49788f$var$_tmpl$41();
                                    (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$173, ()=>t("Pending Validation"));
                                    return _el$173;
                                })(),
                                (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$bdf530073099ce9f), {
                                    get each () {
                                        return groupedConventions().pending;
                                    },
                                    children: (convention)=>renderConventionCard(convention)
                                })
                            ];
                        }
                    }),
                    (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
                        get when () {
                            return groupedConventions().validated.length > 0;
                        },
                        get children () {
                            return [
                                (()=>{
                                    var _el$174 = $18e8c93f2f49788f$var$_tmpl$41();
                                    (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$174, ()=>t("Validated Convention"));
                                    return _el$174;
                                })(),
                                (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$bdf530073099ce9f), {
                                    get each () {
                                        return groupedConventions().validated;
                                    },
                                    children: (convention)=>renderConventionCard(convention)
                                })
                            ];
                        }
                    }),
                    (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
                        get when () {
                            return groupedConventions().archived.length > 0;
                        },
                        get children () {
                            return [
                                (()=>{
                                    var _el$175 = $18e8c93f2f49788f$var$_tmpl$41();
                                    (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$175, ()=>t("Archived Conventions"));
                                    return _el$175;
                                })(),
                                (()=>{
                                    var _el$176 = $18e8c93f2f49788f$var$_tmpl$42(), _el$177 = _el$176.firstChild, _el$178 = _el$177.firstChild, _el$179 = _el$178.firstChild, _el$180 = _el$179.firstChild, _el$181 = _el$180.nextSibling, _el$182 = _el$181.nextSibling, _el$183 = _el$182.nextSibling, _el$184 = _el$178.nextSibling;
                                    (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$180, ()=>t("Title"));
                                    (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$181, ()=>t("Business"));
                                    (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$182, ()=>t("Period"));
                                    (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$183, ()=>t("Actions"));
                                    (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$184, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$bdf530073099ce9f), {
                                        get each () {
                                            return groupedConventions().archived;
                                        },
                                        children: (convention)=>(()=>{
                                                var _el$204 = $18e8c93f2f49788f$var$_tmpl$48(), _el$205 = _el$204.firstChild, _el$207 = _el$205.nextSibling, _el$208 = _el$207.nextSibling, _el$209 = _el$208.firstChild, _el$210 = _el$208.nextSibling, _el$211 = _el$210.firstChild, _el$212 = _el$211.firstChild, _el$213 = _el$212.firstChild, _el$214 = _el$213.nextSibling;
                                                (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$205, ()=>convention.info?.title || `${t("Internship Agreement")} (${convention.year})`, null);
                                                (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$205, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
                                                    get when () {
                                                        return convention.info?.fullyValidated;
                                                    },
                                                    get children () {
                                                        var _el$206 = $18e8c93f2f49788f$var$_tmpl$47();
                                                        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$206, ()=>t("Validated"));
                                                        (0, $8863cd8fe199f948$export$314dade334ae905d)(()=>(0, $6258376c5c54faa9$export$9fec4d97f1922e0b)(_el$206, "title", t("This convention was validated by all teachers")));
                                                        return _el$206;
                                                    }
                                                }), null);
                                                (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$207, ()=>convention.info?.business || t("Not specified"));
                                                (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$208, ()=>convention.info?.startDate || t("Not specified"), _el$209);
                                                (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$208, ()=>convention.info?.endDate || t("Not specified"), null);
                                                _el$212.$$click = ()=>makeActive(convention.id);
                                                (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$212, (()=>{
                                                    var _c$ = (0, $6258376c5c54faa9$export$7c73462e0d25e514)(()=>!!convention.info?.fullyValidated);
                                                    return ()=>_c$() ? t("Restore") : t("Activate");
                                                })(), null);
                                                (0, $8863cd8fe199f948$export$314dade334ae905d)((_p$)=>{
                                                    var _v$36 = convention.info?.fullyValidated ? "table-success" : "", _v$37 = convention.info?.fullyValidated ? "btn btn-sm btn-success" : "btn btn-sm btn-primary", _v$38 = convention.info?.fullyValidated ? t("Restore this convention as validated") : t("Make this convention active"), _v$39 = groupedConventions().locked.length > 0;
                                                    _v$36 !== _p$.e && (0, $6258376c5c54faa9$export$2913c0c0b5623090)(_el$204, _p$.e = _v$36);
                                                    _v$37 !== _p$.t && (0, $6258376c5c54faa9$export$2913c0c0b5623090)(_el$212, _p$.t = _v$37);
                                                    _v$38 !== _p$.a && (0, $6258376c5c54faa9$export$9fec4d97f1922e0b)(_el$212, "title", _p$.a = _v$38);
                                                    _v$39 !== _p$.o && (_el$212.disabled = _p$.o = _v$39);
                                                    return _p$;
                                                }, {
                                                    e: undefined,
                                                    t: undefined,
                                                    a: undefined,
                                                    o: undefined
                                                });
                                                return _el$204;
                                            })()
                                    }));
                                    return _el$176;
                                })()
                            ];
                        }
                    })
                ];
            }
        }), null);
        return _el$142;
    })();
}
(0, $6258376c5c54faa9$export$ad0f7f87f67e17d6)([
    "click",
    "input"
]);


var $bdea6a5dbfcecd8b$var$_tmpl$ = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<div class="alert alert-warning mb-4"><i class="fas fa-exclamation-triangle me-2"></i><strong></strong> `), $bdea6a5dbfcecd8b$var$_tmpl$2 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<div class="text-center my-5"><div class=spinner-border role=status></div><div class=mt-3>`), $bdea6a5dbfcecd8b$var$_tmpl$3 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<div class="alert alert-info my-4"><i class="fas fa-info-circle me-2">`), $bdea6a5dbfcecd8b$var$_tmpl$4 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<h3 class="text-danger mb-3"><i class="fas fa-lock me-2">`), $bdea6a5dbfcecd8b$var$_tmpl$5 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<h3 class="text-success mb-3"><i class="fas fa-check-circle me-2">`), $bdea6a5dbfcecd8b$var$_tmpl$6 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<h3 class="text-warning mb-3"><i class="fas fa-clock me-2">`), $bdea6a5dbfcecd8b$var$_tmpl$7 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<div class="alert alert-warning mb-3"><i class="fas fa-exclamation-triangle me-2"></i><strong></strong> `), $bdea6a5dbfcecd8b$var$_tmpl$8 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<ul class=list-group>`), $bdea6a5dbfcecd8b$var$_tmpl$9 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<p>`), $bdea6a5dbfcecd8b$var$_tmpl$0 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<div class=mt-3><h5></h5><div class=list-group>`), $bdea6a5dbfcecd8b$var$_tmpl$1 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<div class=modal-overlay style=position:fixed;top:0;left:0;right:0;bottom:0;background-color:rgba(0,0,0,0.5);z-index:2000;display:flex;align-items:center;justify-content:center><div class="modal-content bg-white p-4 rounded shadow-lg"style=width:90%;max-width:800px;max-height:90vh;overflow-y:auto><div class="d-flex justify-content-between align-items-start mb-3"><h3></h3><button type=button class=btn-close aria-label=Close></button></div><div class=mb-4></div><div class=mb-4><h5></h5></div><div class=mb-4></div><div class=text-end><button type=button class="btn btn-secondary">`), $bdea6a5dbfcecd8b$var$_tmpl$10 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<div class="container mt-4"><h2 class=mb-4> (<!>)`), $bdea6a5dbfcecd8b$var$_tmpl$11 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<div class="mt-1 small">: `), $bdea6a5dbfcecd8b$var$_tmpl$12 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<div class=mb-4><h4 class="border-bottom pb-2"></h4><div class=table-responsive><table class="table table-hover"><thead><tr><th></th><th></th><th></th><th></th></tr></thead><tbody>`), $bdea6a5dbfcecd8b$var$_tmpl$13 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<button type=button class="btn btn-sm btn-warning"><i class="fas fa-unlock me-1">`), $bdea6a5dbfcecd8b$var$_tmpl$14 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<tr class=table-secondary><td></td><td></td><td> - </td><td><button type=button class="btn btn-sm btn-outline-primary me-2"></button><button type=button class="btn btn-sm btn-info me-2"><i class="fas fa-print me-1">`), $bdea6a5dbfcecd8b$var$_tmpl$15 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<span> <small class=text-muted>(<!>)`), $bdea6a5dbfcecd8b$var$_tmpl$16 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<button type=button class="btn btn-sm btn-danger"><i class="fas fa-lock me-1">`), $bdea6a5dbfcecd8b$var$_tmpl$17 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<tr class=table-success><td></td><td></td><td> - </td><td><button type=button class="btn btn-sm btn-outline-primary me-2">`), $bdea6a5dbfcecd8b$var$_tmpl$18 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<div class=mb-4><h4 class="border-bottom pb-2"></h4><div class=table-responsive><table class="table table-hover"><thead><tr><th></th><th></th><th></th><th></th><th></th></tr></thead><tbody>`), $bdea6a5dbfcecd8b$var$_tmpl$19 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<span class="badge bg-warning text-dark">`), $bdea6a5dbfcecd8b$var$_tmpl$20 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<tr><td></td><td></td><td> - </td><td><div class=d-flex></div></td><td><button type=button class="btn btn-sm btn-outline-primary">`), $bdea6a5dbfcecd8b$var$_tmpl$21 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<div style=width:24px;height:24px>`), $bdea6a5dbfcecd8b$var$_tmpl$22 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<li class="list-group-item d-flex justify-content-between align-items-center"><span></span><span class=text-muted>`), $bdea6a5dbfcecd8b$var$_tmpl$23 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<small class="badge bg-info"><i class="fas fa-envelope me-1"></i> `), $bdea6a5dbfcecd8b$var$_tmpl$24 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<small class=text-muted> <!> `), $bdea6a5dbfcecd8b$var$_tmpl$25 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<div class=list-group-item><div class="d-flex justify-content-between align-items-center mb-1"><strong> </strong><small class=text-muted> <!> <!> </small></div><p class=mb-1></p><div class="d-flex gap-2">`);
function $bdea6a5dbfcecd8b$export$2e2bcd8739ae039() {
    const t = (0, $87927b02874039c5$export$3f3caade1c12f8c9)();
    const [adminStore, setAdminStore, adminActions] = (0, $059fd204a72364ff$export$b3189d039b00bb0c)();
    const [userStore] = (0, $c3b276e29c1ce2f2$export$87c54b525b914dab)();
    const [connectionStore] = (0, $89c51277d5b9a262$export$985e8768c0e91dbc)();
    const [promosWithConventions, setPromosWithConventions] = (0, $8863cd8fe199f948$export$c1e1e1ecbbe76a5)([]);
    const [selectedConvention, setSelectedConvention] = (0, $8863cd8fe199f948$export$c1e1e1ecbbe76a5)(null);
    const [loading, setLoading] = (0, $8863cd8fe199f948$export$c1e1e1ecbbe76a5)(true);
    const [lastUpdated, setLastUpdated] = (0, $8863cd8fe199f948$export$c1e1e1ecbbe76a5)(null);
    // Group conventions by status
    const groupedConventions = (0, $8863cd8fe199f948$export$c0c6c8b9c16bf6aa)(()=>{
        const data = promosWithConventions().length > 0 ? promosWithConventions() : adminStore.cachedConventions || [];
        const locked = [];
        const validated = [];
        const pending = [];
        data.forEach((promo)=>{
            const promoLocked = {
                ...promo,
                conventions: []
            };
            const promoValidated = {
                ...promo,
                conventions: []
            };
            const promoPending = {
                ...promo,
                conventions: []
            };
            promo.conventions.forEach((conv)=>{
                if (conv.status === 'locked') promoLocked.conventions.push(conv);
                else if (conv.status === 'validated' || conv.info?.fullyValidated) promoValidated.conventions.push(conv);
                else promoPending.conventions.push(conv);
            });
            if (promoLocked.conventions.length > 0) locked.push(promoLocked);
            if (promoValidated.conventions.length > 0) validated.push(promoValidated);
            if (promoPending.conventions.length > 0) pending.push(promoPending);
        });
        return {
            locked: locked,
            validated: validated,
            pending: pending
        };
    });
    // Immediately try to load cached data to avoid flicker when offline
    // This is especially important for new tabs opened in offline mode
    (0, $8863cd8fe199f948$export$7ea7134f704deda4)(()=>{
        // Check if we have data in adminStore
        if (adminStore.cachedConventions !== null) {
            console.log("Using cached conventions data from AdminContext");
            setPromosWithConventions(adminStore.cachedConventions || []);
            // Get the timestamp from adminStore
            if (adminStore.conventionsLastUpdated) {
                console.log("Using conventions timestamp from AdminContext:", adminStore.conventionsLastUpdated);
                setLastUpdated(adminStore.conventionsLastUpdated);
            }
            setLoading(false);
        }
    });
    // Effect to react to connection status changes and data loading state
    (0, $8863cd8fe199f948$export$7ea7134f704deda4)(()=>{
        // If we're offline, make sure we're displaying the right indicators
        if (connectionStore.isOffline) {
            // Only try to load if we don't already have conventions data (even if it's an empty array)
            if (adminStore.cachedConventions === null) adminActions.loadAllConventions();
            else // We have data (might be empty), so stop showing loader
            setLoading(false);
        }
        // Stop showing the loader when the admin store indicates conventions are no longer loading
        if (!adminStore.isLoadingConventions && loading()) setLoading(false);
    });
    (0, $8863cd8fe199f948$export$1e848a9e87980bd5)(()=>{
        console.log("AdminConventions mounted, requesting data...");
        // Request conventions data if we're online and don't have data yet
        if (!connectionStore.isOffline && adminStore.cachedConventions === null) adminActions.loadAllConventions();
        else if (adminStore.cachedConventions !== null) // We already have conventions data (even if empty array)
        setLoading(false);
    });
    // Show convention details
    const showConventionDetails = (convention)=>{
        setSelectedConvention(convention);
    };
    // Close convention details modal
    const closeModal = ()=>{
        setSelectedConvention(null);
    };
    // Print convention - uses external function
    const handlePrintConvention = (convention)=>{
        (0, $5aac5cd12531494a$export$548b48b1fc5fe68)(convention, adminStore.conventionStructure, promosWithConventions());
    };
    // Format date helper
    const formatDate = (dateString)=>{
        if (!dateString) return t("Not specified");
        try {
            return new Date(dateString).toLocaleDateString();
        } catch (e) {
            return dateString;
        }
    };
    // Get current year
    const currentYear = new Date().getFullYear();
    // Function to check if we have data but it's empty
    const hasEmptyData = (0, $8863cd8fe199f948$export$c0c6c8b9c16bf6aa)(()=>{
        return !loading() && (Array.isArray(promosWithConventions()) && promosWithConventions().length === 0 || Array.isArray(adminStore.cachedConventions) && adminStore.cachedConventions.length === 0);
    });
    return (()=>{
        var _el$ = $bdea6a5dbfcecd8b$var$_tmpl$10(), _el$2 = _el$.firstChild, _el$3 = _el$2.firstChild, _el$5 = _el$3.nextSibling, _el$4 = _el$5.nextSibling;
        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$2, ()=>t("All Internship Agreements"), _el$3);
        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$2, currentYear, _el$5);
        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
            get when () {
                return connectionStore.isOffline;
            },
            get children () {
                var _el$6 = $bdea6a5dbfcecd8b$var$_tmpl$(), _el$7 = _el$6.firstChild, _el$8 = _el$7.nextSibling, _el$9 = _el$8.nextSibling;
                (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$8, ()=>t("You are offline."));
                (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$6, ()=>t("Viewing cached data in read-only mode."), null);
                (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$6, (()=>{
                    var _c$ = (0, $6258376c5c54faa9$export$7c73462e0d25e514)(()=>!!lastUpdated());
                    return ()=>_c$() && (()=>{
                            var _el$40 = $bdea6a5dbfcecd8b$var$_tmpl$11(), _el$41 = _el$40.firstChild;
                            (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$40, ()=>t("Last updated"), _el$41);
                            (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$40, ()=>new Date(lastUpdated()).toLocaleString(), null);
                            return _el$40;
                        })();
                })(), null);
                return _el$6;
            }
        }), null);
        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
            get when () {
                return loading();
            },
            get children () {
                var _el$0 = $bdea6a5dbfcecd8b$var$_tmpl$2(), _el$1 = _el$0.firstChild, _el$10 = _el$1.nextSibling;
                (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$10, ()=>t("Loading conventions..."));
                return _el$0;
            }
        }), null);
        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
            get when () {
                return hasEmptyData();
            },
            get children () {
                var _el$11 = $bdea6a5dbfcecd8b$var$_tmpl$3(), _el$12 = _el$11.firstChild;
                (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$11, ()=>t("No internship agreements found for the current year."), null);
                return _el$11;
            }
        }), null);
        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
            get when () {
                return (0, $6258376c5c54faa9$export$7c73462e0d25e514)(()=>!!!loading())() && !hasEmptyData();
            },
            get children () {
                return [
                    (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
                        get when () {
                            return groupedConventions().locked.length > 0;
                        },
                        get children () {
                            return [
                                (()=>{
                                    var _el$13 = $bdea6a5dbfcecd8b$var$_tmpl$4(), _el$14 = _el$13.firstChild;
                                    (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$13, ()=>t("Locked Conventions"), null);
                                    return _el$13;
                                })(),
                                (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$bdf530073099ce9f), {
                                    get each () {
                                        return groupedConventions().locked;
                                    },
                                    children: (promo)=>(()=>{
                                            var _el$42 = $bdea6a5dbfcecd8b$var$_tmpl$12(), _el$43 = _el$42.firstChild, _el$44 = _el$43.nextSibling, _el$45 = _el$44.firstChild, _el$46 = _el$45.firstChild, _el$47 = _el$46.firstChild, _el$48 = _el$47.firstChild, _el$49 = _el$48.nextSibling, _el$50 = _el$49.nextSibling, _el$51 = _el$50.nextSibling, _el$52 = _el$46.nextSibling;
                                            (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$43, ()=>promo.name);
                                            (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$48, ()=>t("Student"));
                                            (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$49, ()=>t("Business"));
                                            (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$50, ()=>t("Period"));
                                            (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$51, ()=>t("Actions"));
                                            (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$52, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$bdf530073099ce9f), {
                                                get each () {
                                                    return promo.conventions;
                                                },
                                                children: (convention)=>(()=>{
                                                        var _el$53 = $bdea6a5dbfcecd8b$var$_tmpl$14(), _el$54 = _el$53.firstChild, _el$55 = _el$54.nextSibling, _el$56 = _el$55.nextSibling, _el$57 = _el$56.firstChild, _el$58 = _el$56.nextSibling, _el$59 = _el$58.firstChild, _el$60 = _el$59.nextSibling, _el$61 = _el$60.firstChild;
                                                        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$54, (()=>{
                                                            var _c$2 = (0, $6258376c5c54faa9$export$7c73462e0d25e514)(()=>!!convention.fullname);
                                                            return ()=>_c$2() ? (()=>{
                                                                    var _el$64 = $bdea6a5dbfcecd8b$var$_tmpl$15(), _el$65 = _el$64.firstChild, _el$66 = _el$65.nextSibling, _el$67 = _el$66.firstChild, _el$69 = _el$67.nextSibling, _el$68 = _el$69.nextSibling;
                                                                    (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$64, ()=>convention.fullname, _el$65);
                                                                    (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$66, ()=>convention.username, _el$69);
                                                                    return _el$64;
                                                                })() : convention.username;
                                                        })());
                                                        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$55, ()=>convention.info?.business || t("Not specified"));
                                                        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$56, ()=>formatDate(convention.info?.startDate), _el$57);
                                                        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$56, ()=>formatDate(convention.info?.endDate), null);
                                                        _el$59.$$click = ()=>showConventionDetails(convention);
                                                        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$59, ()=>t("View Details"));
                                                        _el$60.$$click = ()=>handlePrintConvention(convention);
                                                        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$60, ()=>t("Print"), null);
                                                        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$58, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
                                                            get when () {
                                                                return !connectionStore.isOffline;
                                                            },
                                                            get children () {
                                                                var _el$62 = $bdea6a5dbfcecd8b$var$_tmpl$13(), _el$63 = _el$62.firstChild;
                                                                _el$62.$$click = ()=>adminActions.unlockConvention(convention.id);
                                                                (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$62, ()=>t("Unlock"), null);
                                                                (0, $8863cd8fe199f948$export$314dade334ae905d)(()=>(0, $6258376c5c54faa9$export$9fec4d97f1922e0b)(_el$62, "title", t("Unlock this convention")));
                                                                return _el$62;
                                                            }
                                                        }), null);
                                                        (0, $8863cd8fe199f948$export$314dade334ae905d)(()=>(0, $6258376c5c54faa9$export$9fec4d97f1922e0b)(_el$60, "title", t("Print this convention")));
                                                        return _el$53;
                                                    })()
                                            }));
                                            return _el$42;
                                        })()
                                })
                            ];
                        }
                    }),
                    (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
                        get when () {
                            return groupedConventions().validated.length > 0;
                        },
                        get children () {
                            return [
                                (()=>{
                                    var _el$15 = $bdea6a5dbfcecd8b$var$_tmpl$5(), _el$16 = _el$15.firstChild;
                                    (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$15, ()=>t("Fully Validated Conventions"), null);
                                    return _el$15;
                                })(),
                                (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$bdf530073099ce9f), {
                                    get each () {
                                        return groupedConventions().validated;
                                    },
                                    children: (promo)=>(()=>{
                                            var _el$70 = $bdea6a5dbfcecd8b$var$_tmpl$12(), _el$71 = _el$70.firstChild, _el$72 = _el$71.nextSibling, _el$73 = _el$72.firstChild, _el$74 = _el$73.firstChild, _el$75 = _el$74.firstChild, _el$76 = _el$75.firstChild, _el$77 = _el$76.nextSibling, _el$78 = _el$77.nextSibling, _el$79 = _el$78.nextSibling, _el$80 = _el$74.nextSibling;
                                            (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$71, ()=>promo.name);
                                            (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$76, ()=>t("Student"));
                                            (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$77, ()=>t("Business"));
                                            (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$78, ()=>t("Period"));
                                            (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$79, ()=>t("Actions"));
                                            (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$80, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$bdf530073099ce9f), {
                                                get each () {
                                                    return promo.conventions;
                                                },
                                                children: (convention)=>(()=>{
                                                        var _el$81 = $bdea6a5dbfcecd8b$var$_tmpl$17(), _el$82 = _el$81.firstChild, _el$83 = _el$82.nextSibling, _el$84 = _el$83.nextSibling, _el$85 = _el$84.firstChild, _el$86 = _el$84.nextSibling, _el$87 = _el$86.firstChild;
                                                        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$82, (()=>{
                                                            var _c$3 = (0, $6258376c5c54faa9$export$7c73462e0d25e514)(()=>!!convention.fullname);
                                                            return ()=>_c$3() ? (()=>{
                                                                    var _el$90 = $bdea6a5dbfcecd8b$var$_tmpl$15(), _el$91 = _el$90.firstChild, _el$92 = _el$91.nextSibling, _el$93 = _el$92.firstChild, _el$95 = _el$93.nextSibling, _el$94 = _el$95.nextSibling;
                                                                    (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$90, ()=>convention.fullname, _el$91);
                                                                    (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$92, ()=>convention.username, _el$95);
                                                                    return _el$90;
                                                                })() : convention.username;
                                                        })());
                                                        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$83, ()=>convention.info?.business || t("Not specified"));
                                                        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$84, ()=>formatDate(convention.info?.startDate), _el$85);
                                                        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$84, ()=>formatDate(convention.info?.endDate), null);
                                                        _el$87.$$click = ()=>showConventionDetails(convention);
                                                        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$87, ()=>t("View Details"));
                                                        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$86, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
                                                            get when () {
                                                                return !connectionStore.isOffline;
                                                            },
                                                            get children () {
                                                                var _el$88 = $bdea6a5dbfcecd8b$var$_tmpl$16(), _el$89 = _el$88.firstChild;
                                                                _el$88.$$click = ()=>adminActions.lockConvention(convention.id);
                                                                (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$88, ()=>t("Lock this convention"), null);
                                                                (0, $8863cd8fe199f948$export$314dade334ae905d)(()=>(0, $6258376c5c54faa9$export$9fec4d97f1922e0b)(_el$88, "title", t("Lock this convention")));
                                                                return _el$88;
                                                            }
                                                        }), null);
                                                        return _el$81;
                                                    })()
                                            }));
                                            return _el$70;
                                        })()
                                })
                            ];
                        }
                    }),
                    (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
                        get when () {
                            return groupedConventions().pending.length > 0;
                        },
                        get children () {
                            return [
                                (()=>{
                                    var _el$17 = $bdea6a5dbfcecd8b$var$_tmpl$6(), _el$18 = _el$17.firstChild;
                                    (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$17, ()=>t("Pending Teacher Validation"), null);
                                    return _el$17;
                                })(),
                                (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$bdf530073099ce9f), {
                                    get each () {
                                        return groupedConventions().pending;
                                    },
                                    children: (promo)=>(()=>{
                                            var _el$96 = $bdea6a5dbfcecd8b$var$_tmpl$18(), _el$97 = _el$96.firstChild, _el$98 = _el$97.nextSibling, _el$99 = _el$98.firstChild, _el$100 = _el$99.firstChild, _el$101 = _el$100.firstChild, _el$102 = _el$101.firstChild, _el$103 = _el$102.nextSibling, _el$104 = _el$103.nextSibling, _el$105 = _el$104.nextSibling, _el$106 = _el$105.nextSibling, _el$107 = _el$100.nextSibling;
                                            (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$97, ()=>promo.name);
                                            (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$102, ()=>t("Student"));
                                            (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$103, ()=>t("Business"));
                                            (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$104, ()=>t("Period"));
                                            (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$105, ()=>t("Validation"));
                                            (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$106, ()=>t("Actions"));
                                            (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$107, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$bdf530073099ce9f), {
                                                get each () {
                                                    return promo.conventions;
                                                },
                                                children: (convention)=>(()=>{
                                                        var _el$108 = $bdea6a5dbfcecd8b$var$_tmpl$20(), _el$109 = _el$108.firstChild, _el$110 = _el$109.nextSibling, _el$111 = _el$110.nextSibling, _el$112 = _el$111.firstChild, _el$113 = _el$111.nextSibling, _el$114 = _el$113.firstChild, _el$116 = _el$113.nextSibling, _el$117 = _el$116.firstChild;
                                                        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$109, (()=>{
                                                            var _c$4 = (0, $6258376c5c54faa9$export$7c73462e0d25e514)(()=>!!convention.fullname);
                                                            return ()=>_c$4() ? (()=>{
                                                                    var _el$118 = $bdea6a5dbfcecd8b$var$_tmpl$15(), _el$119 = _el$118.firstChild, _el$120 = _el$119.nextSibling, _el$121 = _el$120.firstChild, _el$123 = _el$121.nextSibling, _el$122 = _el$123.nextSibling;
                                                                    (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$118, ()=>convention.fullname, _el$119);
                                                                    (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$120, ()=>convention.username, _el$123);
                                                                    return _el$118;
                                                                })() : convention.username;
                                                        })());
                                                        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$110, ()=>convention.info?.business || t("Not specified"));
                                                        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$111, ()=>formatDate(convention.info?.startDate), _el$112);
                                                        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$111, ()=>formatDate(convention.info?.endDate), null);
                                                        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$114, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
                                                            get when () {
                                                                return (0, $6258376c5c54faa9$export$7c73462e0d25e514)(()=>!!promo.validators)() && promo.validators.length > 0;
                                                            },
                                                            get children () {
                                                                return (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$bdf530073099ce9f), {
                                                                    get each () {
                                                                        return promo.validators;
                                                                    },
                                                                    children: (validator)=>{
                                                                        const hasValidated = convention.info?.validations?.some((v)=>v.validatorId === validator.id);
                                                                        return (()=>{
                                                                            var _el$124 = $bdea6a5dbfcecd8b$var$_tmpl$21();
                                                                            (0, $6258376c5c54faa9$export$2913c0c0b5623090)(_el$124, `rounded-circle me-1 ${hasValidated ? 'bg-success' : 'bg-danger'}`);
                                                                            (0, $8863cd8fe199f948$export$314dade334ae905d)(()=>(0, $6258376c5c54faa9$export$9fec4d97f1922e0b)(_el$124, "title", hasValidated ? `${t("Validated by")} ${validator.fullname ? `${validator.fullname} (${validator.username})` : validator.username}` : `${t("Not validated by")} ${validator.fullname ? `${validator.fullname} (${validator.username})` : validator.username}`));
                                                                            return _el$124;
                                                                        })();
                                                                    }
                                                                });
                                                            }
                                                        }), null);
                                                        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$114, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
                                                            get when () {
                                                                return !promo.validators || promo.validators.length === 0;
                                                            },
                                                            get children () {
                                                                var _el$115 = $bdea6a5dbfcecd8b$var$_tmpl$19();
                                                                (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$115, ()=>t("No validators"));
                                                                return _el$115;
                                                            }
                                                        }), null);
                                                        _el$117.$$click = ()=>showConventionDetails(convention);
                                                        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$117, ()=>t("View Details"));
                                                        return _el$108;
                                                    })()
                                            }));
                                            return _el$96;
                                        })()
                                })
                            ];
                        }
                    })
                ];
            }
        }), null);
        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
            get when () {
                return selectedConvention();
            },
            get children () {
                var _el$19 = $bdea6a5dbfcecd8b$var$_tmpl$1(), _el$20 = _el$19.firstChild, _el$21 = _el$20.firstChild, _el$22 = _el$21.firstChild, _el$23 = _el$22.nextSibling, _el$24 = _el$21.nextSibling, _el$29 = _el$24.nextSibling, _el$30 = _el$29.firstChild, _el$33 = _el$29.nextSibling, _el$38 = _el$33.nextSibling, _el$39 = _el$38.firstChild;
                (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$22, ()=>selectedConvention().info?.title || `${t("Internship Agreement")} (${selectedConvention().year})`);
                _el$23.$$click = closeModal;
                (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$24, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
                    get when () {
                        return connectionStore.isOffline;
                    },
                    get children () {
                        var _el$25 = $bdea6a5dbfcecd8b$var$_tmpl$7(), _el$26 = _el$25.firstChild, _el$27 = _el$26.nextSibling, _el$28 = _el$27.nextSibling;
                        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$27, ()=>t("You are offline."));
                        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$25, ()=>t("Viewing cached data in read-only mode."), null);
                        return _el$25;
                    }
                }));
                (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$20, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $18e8c93f2f49788f$export$665b5ec824ef65f), {
                    get convention () {
                        return selectedConvention();
                    },
                    startEditing: null,
                    get conventionStructure () {
                        return adminStore.conventionStructure;
                    }
                }), _el$29);
                (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$30, ()=>t("Validation Status"));
                (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$29, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
                    get when () {
                        return (0, $6258376c5c54faa9$export$7c73462e0d25e514)(()=>!!selectedConvention().info?.validations)() && selectedConvention().info?.validations.length > 0;
                    },
                    get children () {
                        var _el$31 = $bdea6a5dbfcecd8b$var$_tmpl$8();
                        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$31, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$bdf530073099ce9f), {
                            get each () {
                                return selectedConvention().info.validations;
                            },
                            children: (validation)=>(()=>{
                                    var _el$125 = $bdea6a5dbfcecd8b$var$_tmpl$22(), _el$126 = _el$125.firstChild, _el$127 = _el$126.nextSibling;
                                    (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$126, ()=>validation.validatorName);
                                    (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$127, ()=>new Date(validation.timestamp).toLocaleString());
                                    return _el$125;
                                })()
                        }));
                        return _el$31;
                    }
                }), null);
                (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$29, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
                    get when () {
                        return !selectedConvention().info?.validations || selectedConvention().info?.validations.length === 0;
                    },
                    get children () {
                        var _el$32 = $bdea6a5dbfcecd8b$var$_tmpl$9();
                        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$32, ()=>t("Not validated by any teacher yet."));
                        return _el$32;
                    }
                }), null);
                (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$33, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
                    get when () {
                        return !selectedConvention().info?.feedbackHistory || selectedConvention().info.feedbackHistory.length == 0 || selectedConvention().info.feedbackHistory[0].conventionVersion != selectedConvention().info.version;
                    },
                    get children () {
                        var _el$34 = $bdea6a5dbfcecd8b$var$_tmpl$9();
                        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$34, ()=>t("No feedback for current version"));
                        return _el$34;
                    }
                }), null);
                (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$33, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
                    get when () {
                        return (0, $6258376c5c54faa9$export$7c73462e0d25e514)(()=>!!selectedConvention().info?.feedbackHistory)() && selectedConvention().info.feedbackHistory.length > 0;
                    },
                    get children () {
                        var _el$35 = $bdea6a5dbfcecd8b$var$_tmpl$0(), _el$36 = _el$35.firstChild, _el$37 = _el$36.nextSibling;
                        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$36, ()=>t("Feedback History"));
                        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$37, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$bdf530073099ce9f), {
                            get each () {
                                return selectedConvention().info.feedbackHistory;
                            },
                            children: (historyItem)=>(()=>{
                                    var _el$128 = $bdea6a5dbfcecd8b$var$_tmpl$25(), _el$129 = _el$128.firstChild, _el$130 = _el$129.firstChild, _el$131 = _el$130.firstChild, _el$132 = _el$130.nextSibling, _el$133 = _el$132.firstChild, _el$136 = _el$133.nextSibling, _el$134 = _el$136.nextSibling, _el$137 = _el$134.nextSibling, _el$135 = _el$137.nextSibling, _el$138 = _el$129.nextSibling, _el$139 = _el$138.nextSibling;
                                    (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$130, ()=>t("Version"), _el$131);
                                    (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$130, ()=>historyItem.conventionVersion || '?', null);
                                    (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$132, ()=>t("by"), _el$133);
                                    (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$132, ()=>historyItem.teacher, _el$136);
                                    (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$132, ()=>t("on"), _el$137);
                                    (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$132, ()=>new Date(historyItem.date).toLocaleString(), null);
                                    (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$138, ()=>historyItem.feedback);
                                    (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$139, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
                                        get when () {
                                            return historyItem.notificationSent;
                                        },
                                        get children () {
                                            var _el$140 = $bdea6a5dbfcecd8b$var$_tmpl$23(), _el$141 = _el$140.firstChild, _el$142 = _el$141.nextSibling;
                                            (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$140, ()=>t("Notification sent"), null);
                                            return _el$140;
                                        }
                                    }), null);
                                    (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$139, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
                                        get when () {
                                            return (0, $6258376c5c54faa9$export$7c73462e0d25e514)(()=>!!historyItem.validations)() && historyItem.validations.length > 0;
                                        },
                                        get children () {
                                            var _el$143 = $bdea6a5dbfcecd8b$var$_tmpl$24(), _el$144 = _el$143.firstChild, _el$146 = _el$144.nextSibling, _el$145 = _el$146.nextSibling;
                                            (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$143, ()=>t("Validated by"), _el$144);
                                            (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$143, ()=>historyItem.validations.length, _el$146);
                                            (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$143, ()=>t("teacher(s)"), null);
                                            return _el$143;
                                        }
                                    }), null);
                                    return _el$128;
                                })()
                        }));
                        return _el$35;
                    }
                }), null);
                _el$39.$$click = closeModal;
                (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$39, ()=>t("Close"));
                return _el$19;
            }
        }), null);
        return _el$;
    })();
}
(0, $6258376c5c54faa9$export$ad0f7f87f67e17d6)([
    "click"
]);







var $160c389de53be6d6$var$_tmpl$ = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<div>`), $160c389de53be6d6$var$_tmpl$2 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<p class=text-center>`), $160c389de53be6d6$var$_tmpl$3 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<p class="text-center text-danger">`), $160c389de53be6d6$var$_tmpl$4 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<div class=list-group>`), $160c389de53be6d6$var$_tmpl$5 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<div class=card><div class=card-header><h5>: </h5></div><div class=card-body><form><div class=mb-3><label class=form-label></label><input type=text class=form-control></div><div class=mb-3><label class=form-label></label><input type=text class=form-control required></div><div class=mb-3><label class=form-label></label><textarea class=form-control rows=10 required></textarea><small class="form-text text-muted"></small></div><div class=mb-3><button type=submit class="btn btn-primary me-2"></button><button type=button class="btn btn-secondary">`), $160c389de53be6d6$var$_tmpl$6 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<div class=card><div class=card-body><p class="text-center text-muted">`), $160c389de53be6d6$var$_tmpl$7 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<div class="container-fluid mt-4"><h1></h1><div class=row><div class=col-md-12></div></div><div class=row><div class=col-md-5><div class=card><div class=card-header><h5></h5></div><div class=card-body></div></div></div><div class=col-md-7>`), $160c389de53be6d6$var$_tmpl$8 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<button><div class="d-flex w-100 justify-content-between"><h5 class=mb-1></h5></div><p class=mb-1></p><small>: `);
function $160c389de53be6d6$export$2e2bcd8739ae039() {
    const t = (0, $87927b02874039c5$export$3f3caade1c12f8c9)();
    const [adminStore, setAdminStore] = (0, $059fd204a72364ff$export$b3189d039b00bb0c)();
    const [editingTemplate, setEditingTemplate] = (0, $8863cd8fe199f948$export$c1e1e1ecbbe76a5)(null);
    const [subject, setSubject] = (0, $8863cd8fe199f948$export$c1e1e1ecbbe76a5)("");
    const [body, setBody] = (0, $8863cd8fe199f948$export$c1e1e1ecbbe76a5)("");
    const [description, setDescription] = (0, $8863cd8fe199f948$export$c1e1e1ecbbe76a5)("");
    const [message, setMessage] = (0, $8863cd8fe199f948$export$c1e1e1ecbbe76a5)(null);
    // Fetch email templates
    const [emailTemplates, { refetch: refetch }] = (0, $8863cd8fe199f948$export$edd172c6c83c39cc)(()=>{
        return new Promise((resolve)=>{
            (0, $a26018a1d2174fbf$export$2e2bcd8739ae039).emit("admin-get-email-templates", (templates)=>{
                resolve(templates);
            });
        });
    });
    // Handle form submission for template editing
    const handleSubmit = (e)=>{
        e.preventDefault();
        if (!editingTemplate()) return;
        const template = {
            id: editingTemplate().id,
            subject: subject(),
            body: body(),
            description: description()
        };
        (0, $a26018a1d2174fbf$export$2e2bcd8739ae039).emit("admin-update-email-template", template, (result)=>{
            if (result.success) {
                setMessage({
                    type: "success",
                    text: t("Template updated successfully")
                });
                refetch();
                setTimeout(()=>setMessage(null), 3000);
            } else setMessage({
                type: "error",
                text: t("Failed to update template")
            });
        });
    };
    // Start editing a template
    const startEdit = (template)=>{
        setEditingTemplate(template);
        setSubject(template.subject);
        setBody(template.body);
        setDescription(template.description || "");
    };
    // Cancel editing
    const cancelEdit = ()=>{
        setEditingTemplate(null);
        setSubject("");
        setBody("");
        setDescription("");
    };
    return (()=>{
        var _el$ = $160c389de53be6d6$var$_tmpl$7(), _el$2 = _el$.firstChild, _el$3 = _el$2.nextSibling, _el$4 = _el$3.firstChild, _el$6 = _el$3.nextSibling, _el$7 = _el$6.firstChild, _el$8 = _el$7.firstChild, _el$9 = _el$8.firstChild, _el$0 = _el$9.firstChild, _el$1 = _el$9.nextSibling, _el$13 = _el$7.nextSibling;
        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$2, ()=>t("Email Template Management"));
        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$4, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
            get when () {
                return message();
            },
            get children () {
                var _el$5 = $160c389de53be6d6$var$_tmpl$();
                (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$5, ()=>message().text);
                (0, $8863cd8fe199f948$export$314dade334ae905d)(()=>(0, $6258376c5c54faa9$export$2913c0c0b5623090)(_el$5, `alert alert-${message().type === "success" ? "success" : "danger"} mt-3`));
                return _el$5;
            }
        }));
        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$0, ()=>t("Email Templates"));
        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$1, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
            get when () {
                return emailTemplates.loading;
            },
            get children () {
                var _el$10 = $160c389de53be6d6$var$_tmpl$2();
                (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$10, ()=>t("Loading templates..."));
                return _el$10;
            }
        }), null);
        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$1, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
            get when () {
                return emailTemplates.error;
            },
            get children () {
                var _el$11 = $160c389de53be6d6$var$_tmpl$3();
                (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$11, ()=>t("Error loading templates"));
                return _el$11;
            }
        }), null);
        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$1, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
            get when () {
                return (0, $6258376c5c54faa9$export$7c73462e0d25e514)(()=>!!!emailTemplates.loading)() && !emailTemplates.error;
            },
            get children () {
                var _el$12 = $160c389de53be6d6$var$_tmpl$4();
                (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$12, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$bdf530073099ce9f), {
                    get each () {
                        return emailTemplates();
                    },
                    children: (template)=>(()=>{
                            var _el$36 = $160c389de53be6d6$var$_tmpl$8(), _el$37 = _el$36.firstChild, _el$38 = _el$37.firstChild, _el$39 = _el$37.nextSibling, _el$40 = _el$39.nextSibling, _el$41 = _el$40.firstChild;
                            _el$36.$$click = ()=>startEdit(template);
                            (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$38, ()=>template.name);
                            (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$39, ()=>template.description || t("No description"));
                            (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$40, ()=>t("Last updated"), _el$41);
                            (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$40, ()=>new Date(template.updated_at).toLocaleString(), null);
                            (0, $8863cd8fe199f948$export$314dade334ae905d)(()=>(0, $6258376c5c54faa9$export$2913c0c0b5623090)(_el$36, `list-group-item list-group-item-action ${editingTemplate() && editingTemplate().id === template.id ? 'active' : ''}`));
                            return _el$36;
                        })()
                }));
                return _el$12;
            }
        }), null);
        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$13, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
            get when () {
                return editingTemplate();
            },
            get children () {
                var _el$14 = $160c389de53be6d6$var$_tmpl$5(), _el$15 = _el$14.firstChild, _el$16 = _el$15.firstChild, _el$17 = _el$16.firstChild, _el$18 = _el$15.nextSibling, _el$19 = _el$18.firstChild, _el$20 = _el$19.firstChild, _el$21 = _el$20.firstChild, _el$22 = _el$21.nextSibling, _el$23 = _el$20.nextSibling, _el$24 = _el$23.firstChild, _el$25 = _el$24.nextSibling, _el$26 = _el$23.nextSibling, _el$27 = _el$26.firstChild, _el$28 = _el$27.nextSibling, _el$29 = _el$28.nextSibling, _el$30 = _el$26.nextSibling, _el$31 = _el$30.firstChild, _el$32 = _el$31.nextSibling;
                (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$16, ()=>t("Edit Template"), _el$17);
                (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$16, ()=>editingTemplate().name, null);
                _el$19.addEventListener("submit", handleSubmit);
                (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$21, ()=>t("Description"));
                _el$22.$$input = (e)=>setDescription(e.target.value);
                (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$24, ()=>t("Subject"));
                _el$25.$$input = (e)=>setSubject(e.target.value);
                (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$27, ()=>t("Body"));
                _el$28.$$input = (e)=>setBody(e.target.value);
                (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$29, ()=>t("Use placeholders like {{student_name}}, {{teacher_name}}, and {{base_url}}."));
                (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$31, ()=>t("Save Changes"));
                _el$32.$$click = cancelEdit;
                (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$32, ()=>t("Cancel"));
                (0, $8863cd8fe199f948$export$314dade334ae905d)(()=>_el$22.value = description());
                (0, $8863cd8fe199f948$export$314dade334ae905d)(()=>_el$25.value = subject());
                (0, $8863cd8fe199f948$export$314dade334ae905d)(()=>_el$28.value = body());
                return _el$14;
            }
        }), null);
        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$13, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
            get when () {
                return !editingTemplate();
            },
            get children () {
                var _el$33 = $160c389de53be6d6$var$_tmpl$6(), _el$34 = _el$33.firstChild, _el$35 = _el$34.firstChild;
                (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$35, ()=>t("Select a template to edit"));
                return _el$33;
            }
        }), null);
        return _el$;
    })();
}
(0, $6258376c5c54faa9$export$ad0f7f87f67e17d6)([
    "input",
    "click"
]);






var $a9c93b852c98b750$var$_tmpl$ = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<div>`), $a9c93b852c98b750$var$_tmpl$2 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<p class=text-center>Loading notifications...`), $a9c93b852c98b750$var$_tmpl$3 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<p class="text-center text-danger">Error loading notifications`), $a9c93b852c98b750$var$_tmpl$4 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<p class=text-center>No notifications found matching your criteria.`), $a9c93b852c98b750$var$_tmpl$5 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<div class="list-group notification-list">`), $a9c93b852c98b750$var$_tmpl$6 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<nav class=mt-3><ul class="pagination justify-content-center"><li><button class=page-link>Previous</button></li><li><button class=page-link>Next`), $a9c93b852c98b750$var$_tmpl$7 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<div class=card><div class=card-header><h5>Notification Details</h5></div><div class=card-body><div class=mb-3><h5>Template</h5><p></p></div><div class=mb-3><h5>Recipient</h5><p><strong>Username:</strong> <br><strong>Name:</strong> <br><strong>Email:</strong> </p></div><div class=mb-3><h5>Status</h5><p><span></span></p></div><div class=mb-3><h5>Timing</h5><p><strong>Created:</strong> <br><strong>Sent:</strong> </p></div><div class=mb-3><h5>Subject</h5><p></p></div><div class=mb-3><h5>Body</h5><div class="border rounded p-3 bg-light"><pre style=white-space:pre-wrap;font-family:var(--bs-font-sans-serif)>`), $a9c93b852c98b750$var$_tmpl$8 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<div class=card><div class=card-body><p class="text-center text-muted">Select a notification to view details`), $a9c93b852c98b750$var$_tmpl$9 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<div class="container-fluid mt-4"><h1>Email Notification Log</h1><div class=row><div class=col-md-12></div></div><div class="card mb-4"><div class=card-header><h5>Filter Notifications</h5></div><div class=card-body><form><div class=row><div class="col-md-4 mb-3"><label class=form-label>Search Terms</label><input type=text class=form-control placeholder="Search subject, body, or recipient"></div><div class="col-md-3 mb-3"><label class=form-label>Status</label><select class=form-select><option value>All Statuses</option><option value=sent>Sent</option><option value=pending>Pending</option><option value=failed>Failed</option></select></div><div class="col-md-3 mb-3"><label class=form-label>Recipient Email</label><input type=text class=form-control placeholder="Filter by email"></div><div class="col-md-2 d-flex align-items-end mb-3"><button type=submit class="btn btn-primary me-2">Apply</button><button type=button class="btn btn-secondary">Reset</button></div></div></form></div></div><div class=row><div class=col-lg-5><div class=card><div class=card-header><h5>Notification History</h5></div><div class=card-body></div></div></div><div class=col-lg-7>`), $a9c93b852c98b750$var$_tmpl$0 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<button><div class="d-flex w-100 justify-content-between"><h6 class="mb-1 text-truncate"style=max-width:300px></h6><span></span></div><div class="d-flex w-100 justify-content-between"><small>To: </small><small>`), $a9c93b852c98b750$var$_tmpl$1 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<li><button class=page-link>`);
function $a9c93b852c98b750$export$2e2bcd8739ae039() {
    const [adminStore, setAdminStore] = (0, $059fd204a72364ff$export$b3189d039b00bb0c)();
    const [selectedNotification, setSelectedNotification] = (0, $8863cd8fe199f948$export$c1e1e1ecbbe76a5)(null);
    const [filters, setFilters] = (0, $8863cd8fe199f948$export$c1e1e1ecbbe76a5)({
        search: "",
        status: "",
        email: ""
    });
    const [currentPage, setCurrentPage] = (0, $8863cd8fe199f948$export$c1e1e1ecbbe76a5)(1);
    const [message, setMessage] = (0, $8863cd8fe199f948$export$c1e1e1ecbbe76a5)(null);
    // Fetch notifications with current filters and pagination
    const [notificationsData, { refetch: refetch }] = (0, $8863cd8fe199f948$export$edd172c6c83c39cc)(()=>{
        return new Promise((resolve)=>{
            (0, $a26018a1d2174fbf$export$2e2bcd8739ae039).emit("admin-get-notifications", filters(), currentPage(), 20, (result)=>{
                resolve(result);
            });
        });
    });
    // Reset to first page when filters change
    (0, $8863cd8fe199f948$export$7ea7134f704deda4)(()=>{
        // This will trigger when filters change
        const currentFilters = filters();
        setCurrentPage(1);
    });
    // Format date for display
    const formatDate = (dateString)=>{
        if (!dateString) return "N/A";
        return new Date(dateString).toLocaleString();
    };
    // Get status badge class
    const getStatusBadgeClass = (status)=>{
        switch(status){
            case "sent":
                return "bg-success";
            case "pending":
                return "bg-warning";
            case "failed":
                return "bg-danger";
            default:
                return "bg-secondary";
        }
    };
    // Handle filter form submission
    const handleFilterSubmit = (e)=>{
        e.preventDefault();
        refetch();
    };
    // Handle filter reset
    const handleFilterReset = ()=>{
        setFilters({
            search: "",
            status: "",
            email: ""
        });
        refetch();
    };
    // Handle pagination
    const handlePageChange = (page)=>{
        setCurrentPage(page);
        refetch();
    };
    return (()=>{
        var _el$ = $a9c93b852c98b750$var$_tmpl$9(), _el$2 = _el$.firstChild, _el$3 = _el$2.nextSibling, _el$4 = _el$3.firstChild, _el$6 = _el$3.nextSibling, _el$7 = _el$6.firstChild, _el$8 = _el$7.nextSibling, _el$9 = _el$8.firstChild, _el$0 = _el$9.firstChild, _el$1 = _el$0.firstChild, _el$10 = _el$1.firstChild, _el$11 = _el$10.nextSibling, _el$12 = _el$1.nextSibling, _el$13 = _el$12.firstChild, _el$14 = _el$13.nextSibling, _el$15 = _el$12.nextSibling, _el$16 = _el$15.firstChild, _el$17 = _el$16.nextSibling, _el$18 = _el$15.nextSibling, _el$19 = _el$18.firstChild, _el$20 = _el$19.nextSibling, _el$21 = _el$6.nextSibling, _el$22 = _el$21.firstChild, _el$23 = _el$22.firstChild, _el$24 = _el$23.firstChild, _el$25 = _el$24.nextSibling, _el$36 = _el$22.nextSibling;
        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$4, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
            get when () {
                return message();
            },
            get children () {
                var _el$5 = $a9c93b852c98b750$var$_tmpl$();
                (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$5, ()=>message().text);
                (0, $8863cd8fe199f948$export$314dade334ae905d)(()=>(0, $6258376c5c54faa9$export$2913c0c0b5623090)(_el$5, `alert alert-${message().type === "success" ? "success" : "danger"} mt-3`));
                return _el$5;
            }
        }));
        _el$9.addEventListener("submit", handleFilterSubmit);
        _el$11.$$input = (e)=>setFilters({
                ...filters(),
                search: e.target.value
            });
        _el$14.addEventListener("change", (e)=>setFilters({
                ...filters(),
                status: e.target.value
            }));
        _el$17.$$input = (e)=>setFilters({
                ...filters(),
                email: e.target.value
            });
        _el$20.$$click = handleFilterReset;
        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$25, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
            get when () {
                return notificationsData.loading;
            },
            get children () {
                return $a9c93b852c98b750$var$_tmpl$2();
            }
        }), null);
        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$25, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
            get when () {
                return notificationsData.error;
            },
            get children () {
                return $a9c93b852c98b750$var$_tmpl$3();
            }
        }), null);
        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$25, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
            get when () {
                return (0, $6258376c5c54faa9$export$7c73462e0d25e514)(()=>!!!notificationsData.loading)() && !notificationsData.error;
            },
            get children () {
                return [
                    (()=>{
                        var _el$28 = $a9c93b852c98b750$var$_tmpl$5();
                        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$28, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
                            get when () {
                                return notificationsData()?.notifications?.length === 0;
                            },
                            get children () {
                                return $a9c93b852c98b750$var$_tmpl$4();
                            }
                        }), null);
                        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$28, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$bdf530073099ce9f), {
                            get each () {
                                return notificationsData()?.notifications || [];
                            },
                            children: (notification)=>(()=>{
                                    var _el$74 = $a9c93b852c98b750$var$_tmpl$0(), _el$75 = _el$74.firstChild, _el$76 = _el$75.firstChild, _el$77 = _el$76.nextSibling, _el$78 = _el$75.nextSibling, _el$79 = _el$78.firstChild, _el$80 = _el$79.firstChild, _el$81 = _el$79.nextSibling;
                                    _el$74.$$click = ()=>setSelectedNotification(notification);
                                    (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$76, ()=>notification.subject);
                                    (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$77, ()=>notification.status);
                                    (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$79, ()=>notification.email || notification.username, null);
                                    (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$81, ()=>formatDate(notification.created_at));
                                    (0, $8863cd8fe199f948$export$314dade334ae905d)((_p$)=>{
                                        var _v$5 = `list-group-item list-group-item-action ${selectedNotification() && selectedNotification().id === notification.id ? 'active' : ''}`, _v$6 = `badge ${getStatusBadgeClass(notification.status)}`;
                                        _v$5 !== _p$.e && (0, $6258376c5c54faa9$export$2913c0c0b5623090)(_el$74, _p$.e = _v$5);
                                        _v$6 !== _p$.t && (0, $6258376c5c54faa9$export$2913c0c0b5623090)(_el$77, _p$.t = _v$6);
                                        return _p$;
                                    }, {
                                        e: undefined,
                                        t: undefined
                                    });
                                    return _el$74;
                                })()
                        }), null);
                        return _el$28;
                    })(),
                    (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
                        get when () {
                            return notificationsData()?.pagination?.totalPages > 1;
                        },
                        get children () {
                            var _el$30 = $a9c93b852c98b750$var$_tmpl$6(), _el$31 = _el$30.firstChild, _el$32 = _el$31.firstChild, _el$33 = _el$32.firstChild, _el$34 = _el$32.nextSibling, _el$35 = _el$34.firstChild;
                            _el$33.$$click = ()=>handlePageChange(currentPage() - 1);
                            (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$31, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$bdf530073099ce9f), {
                                get each () {
                                    return Array.from({
                                        length: notificationsData().pagination.totalPages
                                    }, (_, i)=>i + 1);
                                },
                                children: (page)=>(()=>{
                                        var _el$82 = $a9c93b852c98b750$var$_tmpl$1(), _el$83 = _el$82.firstChild;
                                        _el$83.$$click = ()=>handlePageChange(page);
                                        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$83, page);
                                        (0, $8863cd8fe199f948$export$314dade334ae905d)(()=>(0, $6258376c5c54faa9$export$2913c0c0b5623090)(_el$82, `page-item ${currentPage() === page ? 'active' : ''}`));
                                        return _el$82;
                                    })()
                            }), _el$34);
                            _el$35.$$click = ()=>handlePageChange(currentPage() + 1);
                            (0, $8863cd8fe199f948$export$314dade334ae905d)((_p$)=>{
                                var _v$ = `page-item ${currentPage() === 1 ? 'disabled' : ''}`, _v$2 = currentPage() === 1, _v$3 = `page-item ${currentPage() === notificationsData().pagination.totalPages ? 'disabled' : ''}`, _v$4 = currentPage() === notificationsData().pagination.totalPages;
                                _v$ !== _p$.e && (0, $6258376c5c54faa9$export$2913c0c0b5623090)(_el$32, _p$.e = _v$);
                                _v$2 !== _p$.t && (_el$33.disabled = _p$.t = _v$2);
                                _v$3 !== _p$.a && (0, $6258376c5c54faa9$export$2913c0c0b5623090)(_el$34, _p$.a = _v$3);
                                _v$4 !== _p$.o && (_el$35.disabled = _p$.o = _v$4);
                                return _p$;
                            }, {
                                e: undefined,
                                t: undefined,
                                a: undefined,
                                o: undefined
                            });
                            return _el$30;
                        }
                    })
                ];
            }
        }), null);
        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$36, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
            get when () {
                return selectedNotification();
            },
            get children () {
                var _el$37 = $a9c93b852c98b750$var$_tmpl$7(), _el$38 = _el$37.firstChild, _el$39 = _el$38.nextSibling, _el$40 = _el$39.firstChild, _el$41 = _el$40.firstChild, _el$42 = _el$41.nextSibling, _el$43 = _el$40.nextSibling, _el$44 = _el$43.firstChild, _el$45 = _el$44.nextSibling, _el$46 = _el$45.firstChild, _el$47 = _el$46.nextSibling, _el$48 = _el$47.nextSibling, _el$49 = _el$48.nextSibling, _el$50 = _el$49.nextSibling, _el$51 = _el$50.nextSibling, _el$52 = _el$51.nextSibling, _el$53 = _el$52.nextSibling, _el$54 = _el$43.nextSibling, _el$55 = _el$54.firstChild, _el$56 = _el$55.nextSibling, _el$57 = _el$56.firstChild, _el$58 = _el$54.nextSibling, _el$59 = _el$58.firstChild, _el$60 = _el$59.nextSibling, _el$61 = _el$60.firstChild, _el$62 = _el$61.nextSibling, _el$63 = _el$62.nextSibling, _el$64 = _el$63.nextSibling, _el$65 = _el$64.nextSibling, _el$66 = _el$58.nextSibling, _el$67 = _el$66.firstChild, _el$68 = _el$67.nextSibling, _el$69 = _el$66.nextSibling, _el$70 = _el$69.firstChild, _el$71 = _el$70.nextSibling, _el$72 = _el$71.firstChild;
                (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$42, ()=>selectedNotification().template_name);
                (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$45, ()=>selectedNotification().username, _el$48);
                (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$45, ()=>selectedNotification().fullname || 'N/A', _el$51);
                (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$45, ()=>selectedNotification().email || 'N/A', null);
                (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$57, ()=>selectedNotification().status);
                (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$60, ()=>formatDate(selectedNotification().created_at), _el$63);
                (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$60, ()=>formatDate(selectedNotification().sent_at), null);
                (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$68, ()=>selectedNotification().subject);
                (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$72, ()=>selectedNotification().body);
                (0, $8863cd8fe199f948$export$314dade334ae905d)(()=>(0, $6258376c5c54faa9$export$2913c0c0b5623090)(_el$57, `badge ${getStatusBadgeClass(selectedNotification().status)}`));
                return _el$37;
            }
        }), null);
        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$36, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
            get when () {
                return !selectedNotification();
            },
            get children () {
                return $a9c93b852c98b750$var$_tmpl$8();
            }
        }), null);
        (0, $8863cd8fe199f948$export$314dade334ae905d)(()=>_el$11.value = filters().search);
        (0, $8863cd8fe199f948$export$314dade334ae905d)(()=>_el$14.value = filters().status);
        (0, $8863cd8fe199f948$export$314dade334ae905d)(()=>_el$17.value = filters().email);
        return _el$;
    })();
}
(0, $6258376c5c54faa9$export$ad0f7f87f67e17d6)([
    "input",
    "click"
]);







var $8d128670e8dc2b4b$var$_tmpl$ = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<p>`), $8d128670e8dc2b4b$var$_tmpl$2 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<div>`), $8d128670e8dc2b4b$var$_tmpl$3 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<form><div class=mb-3><label for=currentYearSelect class="form-label fw-bold"></label><select id=currentYearSelect class=form-select></select><div class=form-text></div></div><button type=submit class="btn btn-warning">`), $8d128670e8dc2b4b$var$_tmpl$4 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<div class=text-center><div class=spinner-border role=status></div><p>`), $8d128670e8dc2b4b$var$_tmpl$5 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<p class=text-center> <!>.`), $8d128670e8dc2b4b$var$_tmpl$6 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<div class="card mt-4"><div class=card-header><h5 class=mb-0> </h5></div><div class=card-body>`), $8d128670e8dc2b4b$var$_tmpl$7 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<div class="container mt-4"><h1 class=mb-4></h1><div class=row><div class=col-md-6><div class="card mb-4 border-warning"><div class="card-header bg-warning text-dark"><h5 class=mb-0></h5></div><div class=card-body><div class="alert alert-warning"><strong></strong> </div></div></div></div><div class=col-md-6><div class="card mb-4"><div class=card-header><h5 class=mb-0></h5></div><div class=card-body><div class=mb-3><label for=yearSelect class=form-label></label><select id=yearSelect class=form-select><option value></option></select><div class=form-text>`), $8d128670e8dc2b4b$var$_tmpl$8 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<option>`), $8d128670e8dc2b4b$var$_tmpl$9 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<div class=table-responsive><table class="table table-hover"><thead><tr><th></th><th></th><th></th><th></th></tr></thead><tbody>`), $8d128670e8dc2b4b$var$_tmpl$0 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<div class=mb-4><h5 class="border-bottom pb-2">`), $8d128670e8dc2b4b$var$_tmpl$1 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<tr><td></td><td></td><td> - </td><td><span>`), $8d128670e8dc2b4b$var$_tmpl$10 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<span> <small class=text-muted>(<!>)`);
function $8d128670e8dc2b4b$export$2e2bcd8739ae039() {
    const t = (0, $87927b02874039c5$export$3f3caade1c12f8c9)();
    const [adminStore, setAdminStore] = (0, $059fd204a72364ff$export$b3189d039b00bb0c)();
    const [currentYear, setCurrentYear] = (0, $8863cd8fe199f948$export$c1e1e1ecbbe76a5)(new Date().getFullYear());
    const [selectedYear, setSelectedYear] = (0, $8863cd8fe199f948$export$c1e1e1ecbbe76a5)(null);
    const [yearConventions, setYearConventions] = (0, $8863cd8fe199f948$export$c1e1e1ecbbe76a5)([]);
    const [saving, setSaving] = (0, $8863cd8fe199f948$export$c1e1e1ecbbe76a5)(false);
    const [message, setMessage] = (0, $8863cd8fe199f948$export$c1e1e1ecbbe76a5)(null);
    const [loading, setLoading] = (0, $8863cd8fe199f948$export$c1e1e1ecbbe76a5)(false);
    // Available years for the dropdown (current year and 10 years back)
    const availableYears = Array.from({
        length: 10
    }, (_, i)=>new Date().getFullYear() - i);
    // Fetch current year setting when component loads
    const [yearConfig] = (0, $8863cd8fe199f948$export$edd172c6c83c39cc)(async ()=>{
        return new Promise((resolve)=>{
            (0, $a26018a1d2174fbf$export$2e2bcd8739ae039).emit("admin-get-current-year", (data)=>{
                if (data && data.value) setCurrentYear(parseInt(data.value));
                resolve(data);
            });
        });
    });
    // Handle saving the new current year
    const saveCurrentYear = ()=>{
        // Show a confirmation dialog explaining the implications
        if (!confirm(t("WARNING: Changing the academic year will reset ALL student promo assignments. Students will need to select their promo again. This action cannot be undone. Are you sure you want to proceed?"))) return;
        setSaving(true);
        setMessage(null);
        (0, $a26018a1d2174fbf$export$2e2bcd8739ae039).emit("admin-set-current-year", currentYear(), (response)=>{
            setSaving(false);
            if (response.success) {
                const studentsReset = response.studentsReset || 0;
                setMessage({
                    type: "success",
                    text: `${t("Academic year updated successfully.")} ${studentsReset} ${studentsReset !== 1 ? t("students") : t("student")} ${t("had their promo reset")}.`
                });
            } else setMessage({
                type: "error",
                text: t("Failed to update academic year")
            });
            setTimeout(()=>setMessage(null), 5000);
        });
    };
    // Fetch conventions for a specific year
    const fetchYearConventions = (year)=>{
        if (!year) return;
        setLoading(true);
        setYearConventions([]);
        (0, $a26018a1d2174fbf$export$2e2bcd8739ae039).emit("admin-get-year-conventions", year, (data)=>{
            setLoading(false);
            if (data && data.promos) setYearConventions(data.promos);
        });
    };
    return (()=>{
        var _el$ = $8d128670e8dc2b4b$var$_tmpl$7(), _el$2 = _el$.firstChild, _el$3 = _el$2.nextSibling, _el$4 = _el$3.firstChild, _el$5 = _el$4.firstChild, _el$6 = _el$5.firstChild, _el$7 = _el$6.firstChild, _el$8 = _el$6.nextSibling, _el$9 = _el$8.firstChild, _el$0 = _el$9.firstChild, _el$1 = _el$0.nextSibling, _el$18 = _el$4.nextSibling, _el$19 = _el$18.firstChild, _el$20 = _el$19.firstChild, _el$21 = _el$20.firstChild, _el$22 = _el$20.nextSibling, _el$23 = _el$22.firstChild, _el$24 = _el$23.firstChild, _el$25 = _el$24.nextSibling, _el$26 = _el$25.firstChild, _el$27 = _el$25.nextSibling;
        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$2, ()=>t("Academic Year Management"));
        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$7, ()=>t("Current Academic Year"));
        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$0, ()=>t("Important:"));
        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$9, ()=>t("Changing the academic year will reset all student promo assignments. Students will need to select their promo again when they login."), null);
        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$8, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
            get when () {
                return yearConfig.loading;
            },
            get children () {
                var _el$10 = $8d128670e8dc2b4b$var$_tmpl$();
                (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$10, ()=>t("Loading current year setting..."));
                return _el$10;
            }
        }), null);
        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$8, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
            get when () {
                return !yearConfig.loading;
            },
            get children () {
                var _el$11 = $8d128670e8dc2b4b$var$_tmpl$3(), _el$12 = _el$11.firstChild, _el$13 = _el$12.firstChild, _el$14 = _el$13.nextSibling, _el$15 = _el$14.nextSibling, _el$16 = _el$12.nextSibling;
                _el$11.addEventListener("submit", (e)=>{
                    e.preventDefault();
                    saveCurrentYear();
                });
                (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$13, ()=>t("Set Current Academic Year"));
                _el$14.addEventListener("change", (e)=>setCurrentYear(parseInt(e.target.value)));
                (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$14, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$bdf530073099ce9f), {
                    each: availableYears,
                    children: (year)=>(()=>{
                            var _el$40 = $8d128670e8dc2b4b$var$_tmpl$8();
                            _el$40.value = year;
                            (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$40, year);
                            return _el$40;
                        })()
                }));
                (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$15, ()=>t("This setting determines the academic year for new conventions."));
                (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$16, (()=>{
                    var _c$ = (0, $6258376c5c54faa9$export$7c73462e0d25e514)(()=>!!saving());
                    return ()=>_c$() ? t("Saving...") : t("Update Academic Year");
                })());
                (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$11, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
                    get when () {
                        return message();
                    },
                    get children () {
                        var _el$17 = $8d128670e8dc2b4b$var$_tmpl$2();
                        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$17, ()=>message().text);
                        (0, $8863cd8fe199f948$export$314dade334ae905d)(()=>(0, $6258376c5c54faa9$export$2913c0c0b5623090)(_el$17, `alert alert-${message().type === "success" ? "success" : "danger"} mt-3`));
                        return _el$17;
                    }
                }), null);
                (0, $8863cd8fe199f948$export$314dade334ae905d)(()=>_el$16.disabled = saving());
                (0, $8863cd8fe199f948$export$314dade334ae905d)(()=>_el$14.value = currentYear());
                return _el$11;
            }
        }), null);
        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$21, ()=>t("View Conventions by Year"));
        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$24, ()=>t("Select Year"));
        _el$25.addEventListener("change", (e)=>{
            const year = parseInt(e.target.value);
            setSelectedYear(year);
            fetchYearConventions(year); // Automatically fetch when year changes
        });
        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$26, ()=>t("Choose a year..."));
        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$25, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$bdf530073099ce9f), {
            each: availableYears,
            children: (year)=>(()=>{
                    var _el$41 = $8d128670e8dc2b4b$var$_tmpl$8();
                    _el$41.value = year;
                    (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$41, year);
                    return _el$41;
                })()
        }), null);
        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$27, ()=>t("Select a year to view pending and validated conventions."));
        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
            get when () {
                return selectedYear();
            },
            get children () {
                var _el$28 = $8d128670e8dc2b4b$var$_tmpl$6(), _el$29 = _el$28.firstChild, _el$30 = _el$29.firstChild, _el$31 = _el$30.firstChild, _el$32 = _el$29.nextSibling;
                (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$30, ()=>t("Conventions for"), _el$31);
                (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$30, selectedYear, null);
                (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$32, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
                    get when () {
                        return loading();
                    },
                    get children () {
                        var _el$33 = $8d128670e8dc2b4b$var$_tmpl$4(), _el$34 = _el$33.firstChild, _el$35 = _el$34.nextSibling;
                        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$35, ()=>t("Loading conventions..."));
                        return _el$33;
                    }
                }), null);
                (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$32, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
                    get when () {
                        return (0, $6258376c5c54faa9$export$7c73462e0d25e514)(()=>!!!loading())() && yearConventions().length === 0;
                    },
                    get children () {
                        var _el$36 = $8d128670e8dc2b4b$var$_tmpl$5(), _el$37 = _el$36.firstChild, _el$39 = _el$37.nextSibling, _el$38 = _el$39.nextSibling;
                        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$36, ()=>t("No pending or validated conventions found for"), _el$37);
                        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$36, selectedYear, _el$39);
                        return _el$36;
                    }
                }), null);
                (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$32, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
                    get when () {
                        return (0, $6258376c5c54faa9$export$7c73462e0d25e514)(()=>!!!loading())() && yearConventions().length > 0;
                    },
                    get children () {
                        return (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$bdf530073099ce9f), {
                            get each () {
                                return yearConventions();
                            },
                            children: (promo)=>(()=>{
                                    var _el$42 = $8d128670e8dc2b4b$var$_tmpl$0(), _el$43 = _el$42.firstChild;
                                    (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$43, ()=>promo.name);
                                    (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$42, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
                                        get when () {
                                            return promo.conventions.length > 0;
                                        },
                                        get fallback () {
                                            return (()=>{
                                                var _el$53 = $8d128670e8dc2b4b$var$_tmpl$();
                                                (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$53, ()=>t("No conventions in this class."));
                                                return _el$53;
                                            })();
                                        },
                                        get children () {
                                            var _el$44 = $8d128670e8dc2b4b$var$_tmpl$9(), _el$45 = _el$44.firstChild, _el$46 = _el$45.firstChild, _el$47 = _el$46.firstChild, _el$48 = _el$47.firstChild, _el$49 = _el$48.nextSibling, _el$50 = _el$49.nextSibling, _el$51 = _el$50.nextSibling, _el$52 = _el$46.nextSibling;
                                            (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$48, ()=>t("Student"));
                                            (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$49, ()=>t("Business"));
                                            (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$50, ()=>t("Period"));
                                            (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$51, ()=>t("Status"));
                                            (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$52, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$bdf530073099ce9f), {
                                                get each () {
                                                    return promo.conventions;
                                                },
                                                children: (convention)=>(()=>{
                                                        var _el$54 = $8d128670e8dc2b4b$var$_tmpl$1(), _el$55 = _el$54.firstChild, _el$56 = _el$55.nextSibling, _el$57 = _el$56.nextSibling, _el$58 = _el$57.firstChild, _el$59 = _el$57.nextSibling, _el$60 = _el$59.firstChild;
                                                        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$55, (()=>{
                                                            var _c$2 = (0, $6258376c5c54faa9$export$7c73462e0d25e514)(()=>!!convention.fullname);
                                                            return ()=>_c$2() ? (()=>{
                                                                    var _el$61 = $8d128670e8dc2b4b$var$_tmpl$10(), _el$62 = _el$61.firstChild, _el$63 = _el$62.nextSibling, _el$64 = _el$63.firstChild, _el$66 = _el$64.nextSibling, _el$65 = _el$66.nextSibling;
                                                                    (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$61, ()=>convention.fullname, _el$62);
                                                                    (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$63, ()=>convention.username, _el$66);
                                                                    return _el$61;
                                                                })() : convention.username;
                                                        })());
                                                        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$56, ()=>convention.info?.business || t("Not specified"));
                                                        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$57, ()=>convention.info?.startDate || t("Not specified"), _el$58);
                                                        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$57, ()=>convention.info?.endDate || t("Not specified"), null);
                                                        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$60, ()=>t(convention.status));
                                                        (0, $8863cd8fe199f948$export$314dade334ae905d)(()=>(0, $6258376c5c54faa9$export$2913c0c0b5623090)(_el$60, `badge ${convention.status === 'validated' ? 'bg-success' : convention.status === 'pending' ? 'bg-warning' : convention.status === 'active' ? 'bg-primary' : 'bg-secondary'}`));
                                                        return _el$54;
                                                    })()
                                            }));
                                            return _el$44;
                                        }
                                    }), null);
                                    return _el$42;
                                })()
                        });
                    }
                }), null);
                return _el$28;
            }
        }), null);
        (0, $8863cd8fe199f948$export$314dade334ae905d)(()=>_el$25.value = selectedYear() || "");
        return _el$;
    })();
}









var $af282e640efc400b$var$_tmpl$ = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<div class=text-center><div class=spinner-border role=status></div><p>`), $af282e640efc400b$var$_tmpl$2 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<p class=text-center>`), $af282e640efc400b$var$_tmpl$3 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<div class="list-group mb-4">`), $af282e640efc400b$var$_tmpl$4 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<button type=button class="btn btn-primary">`), $af282e640efc400b$var$_tmpl$5 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<div>`), $af282e640efc400b$var$_tmpl$6 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<p class="text-center text-muted">`), $af282e640efc400b$var$_tmpl$7 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<div class="container mt-4"><h1 class=mb-4></h1><div class="alert alert-warning"><i class="fas fa-exclamation-triangle me-2"></i><strong>:</strong> </div><div class=card><div class="card-header d-flex justify-content-between align-items-center"><h5 class=mb-0></h5><button type=button class="btn btn-primary btn-sm"></button></div><div class=card-body></div></div><div class="card mt-4"><div class=card-header><h5 class=mb-0></h5></div><div class=card-body>`), $af282e640efc400b$var$_tmpl$8 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<div class="form-check mt-4"><input class=form-check-input type=checkbox><label class=form-check-label>`), $af282e640efc400b$var$_tmpl$9 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<div class="form-check mt-2"><input class=form-check-input type=checkbox><label class=form-check-label>`), $af282e640efc400b$var$_tmpl$0 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<small class=text-muted>`), $af282e640efc400b$var$_tmpl$1 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<p class="text-muted mt-4 small"><i class="fas fa-info-circle me-1">`), $af282e640efc400b$var$_tmpl$10 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<div class="row mb-3"><div class=col-md-12><label class=form-label></label><textarea class=form-control rows=5></textarea><div class=form-text>`), $af282e640efc400b$var$_tmpl$11 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<div><div class="row mb-3"><div class=col-md-6><label class=form-label></label><input type=text class=form-control placeholder=field_name><div class=form-text></div></div><div class=col-md-6><label class=form-label></label><input type=text class=form-control><div class=form-text></div></div></div><div class="row mb-3"><div class=col-md-6><label class=form-label></label><select class=form-select></select></div><div class=col-md-6></div></div><div class=btn-group><button type=button class="btn btn-sm btn-success"></button><button type=button class="btn btn-sm btn-outline-danger">`), $af282e640efc400b$var$_tmpl$12 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<div class=list-group-item>`), $af282e640efc400b$var$_tmpl$13 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<i class="fas fa-layer-group me-2">`), $af282e640efc400b$var$_tmpl$14 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<i class="fas fa-layer-group me-2 text-muted">`), $af282e640efc400b$var$_tmpl$15 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<span class="badge bg-danger ms-1">Required`), $af282e640efc400b$var$_tmpl$16 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<span class="badge bg-warning ms-1"><i class="fas fa-check-circle me-1"></i>Validation`), $af282e640efc400b$var$_tmpl$17 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<div class="d-flex justify-content-between align-items-center"><div><span class=fw-bold></span><span class="text-muted ms-2">(<!>)</span><span></span></div><div class=btn-group><button type=button class="btn btn-sm btn-outline-primary"></button><button type=button class="btn btn-sm btn-outline-secondary">\u{2191}</button><button type=button class="btn btn-sm btn-outline-secondary">\u{2193}</button><button type=button class="btn btn-sm btn-outline-danger">`), $af282e640efc400b$var$_tmpl$18 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<option>`);
function $af282e640efc400b$export$2e2bcd8739ae039() {
    const t = (0, $87927b02874039c5$export$3f3caade1c12f8c9)();
    const [adminStore, setAdminStore] = (0, $059fd204a72364ff$export$b3189d039b00bb0c)();
    const [editingField, setEditingField] = (0, $8863cd8fe199f948$export$c1e1e1ecbbe76a5)(null);
    const [saving, setSaving] = (0, $8863cd8fe199f948$export$c1e1e1ecbbe76a5)(false);
    const [message, setMessage] = (0, $8863cd8fe199f948$export$c1e1e1ecbbe76a5)(null);
    // Field types that can be used in conventions
    const fieldTypes = [
        "text",
        "textarea",
        "date",
        "checkbox",
        "select-single",
        "select-multiple",
        "group",
        "group-end"
    ];
    // Update field in the structure
    const updateField = (index, updates)=>{
        setAdminStore("conventionStructure", "fields", index, (prev)=>({
                ...prev,
                ...updates
            }));
    };
    // Add a new field
    const addField = ()=>{
        const newField = {
            name: `field${adminStore.conventionStructure.fields.length + 1}`,
            label: `New Field ${adminStore.conventionStructure.fields.length + 1}`,
            type: "text",
            required: false
        };
        setAdminStore("conventionStructure", "fields", adminStore.conventionStructure.fields.length, newField);
        // Start editing the new field
        setEditingField(adminStore.conventionStructure.fields.length - 1);
    };
    // Remove field from the structure
    const removeField = (index)=>{
        if (confirm(t("Are you sure you want to remove this field? This may affect existing conventions."))) {
            setAdminStore("conventionStructure", "fields", (fields)=>fields.filter((_, i)=>i !== index));
            if (editingField() === index) setEditingField(null);
            else if (editingField() > index) setEditingField(editingField() - 1);
        }
    };
    // Move a field up or down in the order
    const moveField = (index, direction)=>{
        if (direction === -1 && index === 0 || direction === 1 && index === adminStore.conventionStructure.fields.length - 1) return; // Can't move beyond boundaries
        const rawFields = [
            ...(0, $caa70d287a6ddb62$export$debb760848ca95a)(adminStore.conventionStructure.fields)
        ];
        // Get the fields we need to swap
        const field = rawFields[index];
        const otherField = rawFields[index + direction];
        rawFields[index] = otherField;
        rawFields[index + direction] = field;
        // Update both fields in the store
        //setStructure("fields", index, otherField);
        //setStructure("fields", index + direction, field);
        setAdminStore("conventionStructure", "fields", rawFields);
        // Update editing index if we're editing one of these fields
        if (editingField() === index) setEditingField(index + direction);
        else if (editingField() === index + direction) setEditingField(index);
    };
    // Save the updated structure
    const saveStructure = ()=>{
        // Basic validation
        const names = new Set();
        let hasError = false;
        for (const field of adminStore.conventionStructure.fields){
            // Check for empty names or labels
            if (!field.name.trim() || !field.label.trim()) {
                setMessage({
                    type: "error",
                    text: t("All fields must have a name and label")
                });
                hasError = true;
                break;
            }
            // Check for duplicate field names
            if (names.has(field.name)) {
                setMessage({
                    type: "error",
                    text: `${t("Duplicate field name")}: ${field.name}`
                });
                hasError = true;
                break;
            }
            names.add(field.name);
        }
        if (hasError) {
            setTimeout(()=>setMessage(null), 5000);
            return;
        }
        setSaving(true);
        setMessage(null);
        (0, $a26018a1d2174fbf$export$2e2bcd8739ae039).emit("admin-update-convention-structure", adminStore.conventionStructure, (response)=>{
            setSaving(false);
            if (response.success) {
                setMessage({
                    type: "success",
                    text: t("Convention structure updated successfully")
                });
                refetch(); // Refresh the data
            } else setMessage({
                type: "error",
                text: response.error || t("Failed to update convention structure")
            });
            setTimeout(()=>setMessage(null), 5000);
        });
    };
    return (()=>{
        var _el$ = $af282e640efc400b$var$_tmpl$7(), _el$2 = _el$.firstChild, _el$3 = _el$2.nextSibling, _el$4 = _el$3.firstChild, _el$5 = _el$4.nextSibling, _el$6 = _el$5.firstChild, _el$7 = _el$5.nextSibling, _el$8 = _el$3.nextSibling, _el$9 = _el$8.firstChild, _el$0 = _el$9.firstChild, _el$1 = _el$0.nextSibling, _el$10 = _el$9.nextSibling, _el$18 = _el$8.nextSibling, _el$19 = _el$18.firstChild, _el$20 = _el$19.firstChild, _el$21 = _el$19.nextSibling;
        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$2, ()=>t("Convention Structure Management"));
        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$5, ()=>t("Warning"), _el$6);
        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$3, ()=>t("Changing the convention structure will affect all existing and new conventions. Remove fields with caution as this may result in data loss."), null);
        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$0, ()=>t("Form Fields"));
        _el$1.$$click = addField;
        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$1, ()=>t("Add Field"));
        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$10, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
            get when () {
                return adminStore.conventionStructureLoading;
            },
            get children () {
                var _el$11 = $af282e640efc400b$var$_tmpl$(), _el$12 = _el$11.firstChild, _el$13 = _el$12.nextSibling;
                (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$13, ()=>t("Loading convention structure..."));
                return _el$11;
            }
        }), null);
        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$10, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
            get when () {
                return (0, $6258376c5c54faa9$export$7c73462e0d25e514)(()=>!!!adminStore.conventionStructureLoading)() && adminStore.conventionStructure.fields.length === 0;
            },
            get children () {
                var _el$14 = $af282e640efc400b$var$_tmpl$2();
                (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$14, ()=>t("No fields have been defined yet. Click \"Add Field\" to create your first field."));
                return _el$14;
            }
        }), null);
        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$10, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
            get when () {
                return (0, $6258376c5c54faa9$export$7c73462e0d25e514)(()=>!!!adminStore.conventionStructureLoading)() && adminStore.conventionStructure.fields.length > 0;
            },
            get children () {
                return [
                    (()=>{
                        var _el$15 = $af282e640efc400b$var$_tmpl$3();
                        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$15, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$bdf530073099ce9f), {
                            get each () {
                                return adminStore.conventionStructure.fields;
                            },
                            children: (field, index)=>(()=>{
                                    var _el$23 = $af282e640efc400b$var$_tmpl$12();
                                    (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$23, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
                                        get when () {
                                            return editingField() === index();
                                        },
                                        get fallback () {
                                            return (()=>{
                                                var _el$58 = $af282e640efc400b$var$_tmpl$17(), _el$59 = _el$58.firstChild, _el$62 = _el$59.firstChild, _el$63 = _el$62.nextSibling, _el$64 = _el$63.firstChild, _el$66 = _el$64.nextSibling, _el$65 = _el$66.nextSibling, _el$67 = _el$63.nextSibling, _el$70 = _el$59.nextSibling, _el$71 = _el$70.firstChild, _el$72 = _el$71.nextSibling, _el$73 = _el$72.nextSibling, _el$74 = _el$73.nextSibling;
                                                (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$59, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
                                                    get when () {
                                                        return field.type === "group";
                                                    },
                                                    get children () {
                                                        return $af282e640efc400b$var$_tmpl$13();
                                                    }
                                                }), _el$62);
                                                (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$59, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
                                                    get when () {
                                                        return field.type === "group-end";
                                                    },
                                                    get children () {
                                                        return $af282e640efc400b$var$_tmpl$14();
                                                    }
                                                }), _el$62);
                                                (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$62, ()=>field.label);
                                                (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$63, ()=>field.name, _el$66);
                                                (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$67, ()=>field.type);
                                                (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$59, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
                                                    get when () {
                                                        return (0, $6258376c5c54faa9$export$7c73462e0d25e514)(()=>!!(field.required && field.type !== "group"))() && field.type !== "group-end";
                                                    },
                                                    get children () {
                                                        return $af282e640efc400b$var$_tmpl$15();
                                                    }
                                                }), null);
                                                (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$59, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
                                                    get when () {
                                                        return (0, $6258376c5c54faa9$export$7c73462e0d25e514)(()=>!!(field.requiresValidation !== false && field.type !== "group"))() && field.type !== "group-end";
                                                    },
                                                    get children () {
                                                        var _el$69 = $af282e640efc400b$var$_tmpl$16();
                                                        (0, $8863cd8fe199f948$export$314dade334ae905d)(()=>(0, $6258376c5c54faa9$export$9fec4d97f1922e0b)(_el$69, "title", t("This field requires teacher validation")));
                                                        return _el$69;
                                                    }
                                                }), null);
                                                _el$71.$$click = ()=>setEditingField(index());
                                                (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$71, ()=>t("Edit"));
                                                _el$72.$$click = ()=>moveField(index(), -1);
                                                _el$73.$$click = ()=>moveField(index(), 1);
                                                _el$74.$$click = ()=>removeField(index());
                                                (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$74, ()=>t("Remove"));
                                                (0, $8863cd8fe199f948$export$314dade334ae905d)((_p$)=>{
                                                    var _v$5 = `badge ms-2 ${field.type === "group" ? "bg-info" : field.type === "group-end" ? "bg-secondary" : "bg-secondary"}`, _v$6 = t("Edit this field"), _v$7 = index() === 0, _v$8 = t("Move up"), _v$9 = index() === adminStore.conventionStructure.fields.length - 1, _v$0 = t("Move down"), _v$1 = t("Remove this field");
                                                    _v$5 !== _p$.e && (0, $6258376c5c54faa9$export$2913c0c0b5623090)(_el$67, _p$.e = _v$5);
                                                    _v$6 !== _p$.t && (0, $6258376c5c54faa9$export$9fec4d97f1922e0b)(_el$71, "title", _p$.t = _v$6);
                                                    _v$7 !== _p$.a && (_el$72.disabled = _p$.a = _v$7);
                                                    _v$8 !== _p$.o && (0, $6258376c5c54faa9$export$9fec4d97f1922e0b)(_el$72, "title", _p$.o = _v$8);
                                                    _v$9 !== _p$.i && (_el$73.disabled = _p$.i = _v$9);
                                                    _v$0 !== _p$.n && (0, $6258376c5c54faa9$export$9fec4d97f1922e0b)(_el$73, "title", _p$.n = _v$0);
                                                    _v$1 !== _p$.s && (0, $6258376c5c54faa9$export$9fec4d97f1922e0b)(_el$74, "title", _p$.s = _v$1);
                                                    return _p$;
                                                }, {
                                                    e: undefined,
                                                    t: undefined,
                                                    a: undefined,
                                                    o: undefined,
                                                    i: undefined,
                                                    n: undefined,
                                                    s: undefined
                                                });
                                                return _el$58;
                                            })();
                                        },
                                        get children () {
                                            var _el$24 = $af282e640efc400b$var$_tmpl$11(), _el$25 = _el$24.firstChild, _el$26 = _el$25.firstChild, _el$27 = _el$26.firstChild, _el$28 = _el$27.nextSibling, _el$29 = _el$28.nextSibling, _el$30 = _el$26.nextSibling, _el$31 = _el$30.firstChild, _el$32 = _el$31.nextSibling, _el$33 = _el$32.nextSibling, _el$34 = _el$25.nextSibling, _el$35 = _el$34.firstChild, _el$36 = _el$35.firstChild, _el$37 = _el$36.nextSibling, _el$38 = _el$35.nextSibling, _el$55 = _el$34.nextSibling, _el$56 = _el$55.firstChild, _el$57 = _el$56.nextSibling;
                                            (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$27, ()=>t("Field Name (ID)"));
                                            _el$28.$$input = (e)=>updateField(index(), {
                                                    name: e.target.value
                                                });
                                            (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$29, ()=>t("Unique identifier for the field (no spaces)"));
                                            (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$31, ()=>t("Field Label"));
                                            _el$32.$$input = (e)=>updateField(index(), {
                                                    label: e.target.value
                                                });
                                            (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$33, ()=>t("This text will be shown to users"));
                                            (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$36, ()=>t("Field Type"));
                                            _el$37.addEventListener("change", (e)=>updateField(index(), {
                                                    type: e.target.value
                                                }));
                                            (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$37, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$bdf530073099ce9f), {
                                                each: fieldTypes,
                                                children: (type)=>(()=>{
                                                        var _el$75 = $af282e640efc400b$var$_tmpl$18();
                                                        _el$75.value = type;
                                                        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$75, type);
                                                        return _el$75;
                                                    })()
                                            }));
                                            (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$38, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
                                                get when () {
                                                    return (0, $6258376c5c54faa9$export$7c73462e0d25e514)(()=>field.type !== "group")() && field.type !== "group-end";
                                                },
                                                get children () {
                                                    return [
                                                        (()=>{
                                                            var _el$39 = $af282e640efc400b$var$_tmpl$8(), _el$40 = _el$39.firstChild, _el$41 = _el$40.nextSibling;
                                                            _el$40.addEventListener("change", (e)=>updateField(index(), {
                                                                    required: e.target.checked
                                                                }));
                                                            (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$41, ()=>t("Required field"));
                                                            (0, $8863cd8fe199f948$export$314dade334ae905d)((_p$)=>{
                                                                var _v$ = `required-${index()}`, _v$2 = `required-${index()}`;
                                                                _v$ !== _p$.e && (0, $6258376c5c54faa9$export$9fec4d97f1922e0b)(_el$40, "id", _p$.e = _v$);
                                                                _v$2 !== _p$.t && (0, $6258376c5c54faa9$export$9fec4d97f1922e0b)(_el$41, "for", _p$.t = _v$2);
                                                                return _p$;
                                                            }, {
                                                                e: undefined,
                                                                t: undefined
                                                            });
                                                            (0, $8863cd8fe199f948$export$314dade334ae905d)(()=>_el$40.checked = field.required);
                                                            return _el$39;
                                                        })(),
                                                        (()=>{
                                                            var _el$42 = $af282e640efc400b$var$_tmpl$9(), _el$43 = _el$42.firstChild, _el$44 = _el$43.nextSibling;
                                                            _el$43.addEventListener("change", (e)=>updateField(index(), {
                                                                    requiresValidation: e.target.checked
                                                                }));
                                                            (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$44, ()=>t("Requires teacher validation"));
                                                            (0, $8863cd8fe199f948$export$314dade334ae905d)((_p$)=>{
                                                                var _v$3 = `requiresValidation-${index()}`, _v$4 = `requiresValidation-${index()}`;
                                                                _v$3 !== _p$.e && (0, $6258376c5c54faa9$export$9fec4d97f1922e0b)(_el$43, "id", _p$.e = _v$3);
                                                                _v$4 !== _p$.t && (0, $6258376c5c54faa9$export$9fec4d97f1922e0b)(_el$44, "for", _p$.t = _v$4);
                                                                return _p$;
                                                            }, {
                                                                e: undefined,
                                                                t: undefined
                                                            });
                                                            (0, $8863cd8fe199f948$export$314dade334ae905d)(()=>_el$43.checked = field.requiresValidation !== false);
                                                            return _el$42;
                                                        })(),
                                                        (()=>{
                                                            var _el$45 = $af282e640efc400b$var$_tmpl$0();
                                                            (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$45, ()=>t("If unchecked, students can modify this field even when convention is pending/validated"));
                                                            return _el$45;
                                                        })()
                                                    ];
                                                }
                                            }), null);
                                            (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$38, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
                                                get when () {
                                                    return field.type === "group";
                                                },
                                                get children () {
                                                    var _el$46 = $af282e640efc400b$var$_tmpl$1(), _el$47 = _el$46.firstChild;
                                                    (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$46, ()=>t("Groups are used to organize fields visually and cannot be required"), null);
                                                    return _el$46;
                                                }
                                            }), null);
                                            (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$38, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
                                                get when () {
                                                    return field.type === "group-end";
                                                },
                                                get children () {
                                                    var _el$48 = $af282e640efc400b$var$_tmpl$1(), _el$49 = _el$48.firstChild;
                                                    (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$48, ()=>t("Marks the end of a group section"), null);
                                                    return _el$48;
                                                }
                                            }), null);
                                            (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$24, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
                                                get when () {
                                                    return field.type === "select-single" || field.type === "select-multiple";
                                                },
                                                get children () {
                                                    var _el$50 = $af282e640efc400b$var$_tmpl$10(), _el$51 = _el$50.firstChild, _el$52 = _el$51.firstChild, _el$53 = _el$52.nextSibling, _el$54 = _el$53.nextSibling;
                                                    (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$52, ()=>t("Options (one per line)"));
                                                    _el$53.$$input = (e)=>{
                                                        const options = e.target.value.split('\n');
                                                        updateField(index(), {
                                                            options: options
                                                        });
                                                    };
                                                    (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$54, ()=>t("Enter each option on a new line"));
                                                    (0, $8863cd8fe199f948$export$314dade334ae905d)(()=>(0, $6258376c5c54faa9$export$9fec4d97f1922e0b)(_el$53, "placeholder", t("Option 1\nOption 2\nOption 3")));
                                                    (0, $8863cd8fe199f948$export$314dade334ae905d)(()=>_el$53.value = (field.options || []).join('\n'));
                                                    return _el$50;
                                                }
                                            }), _el$55);
                                            _el$56.$$click = ()=>setEditingField(null);
                                            (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$56, ()=>t("Done"));
                                            _el$57.$$click = ()=>removeField(index());
                                            (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$57, ()=>t("Remove"));
                                            (0, $8863cd8fe199f948$export$314dade334ae905d)(()=>(0, $6258376c5c54faa9$export$9fec4d97f1922e0b)(_el$32, "placeholder", t("Display label")));
                                            (0, $8863cd8fe199f948$export$314dade334ae905d)(()=>_el$28.value = field.name);
                                            (0, $8863cd8fe199f948$export$314dade334ae905d)(()=>_el$32.value = field.label);
                                            (0, $8863cd8fe199f948$export$314dade334ae905d)(()=>_el$37.value = field.type);
                                            return _el$24;
                                        }
                                    }));
                                    return _el$23;
                                })()
                        }));
                        return _el$15;
                    })(),
                    (()=>{
                        var _el$16 = $af282e640efc400b$var$_tmpl$4();
                        _el$16.$$click = saveStructure;
                        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$16, (()=>{
                            var _c$ = (0, $6258376c5c54faa9$export$7c73462e0d25e514)(()=>!!saving());
                            return ()=>_c$() ? t("Saving...") : t("Save Structure");
                        })());
                        (0, $8863cd8fe199f948$export$314dade334ae905d)(()=>_el$16.disabled = saving());
                        return _el$16;
                    })()
                ];
            }
        }), null);
        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$10, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
            get when () {
                return message();
            },
            get children () {
                var _el$17 = $af282e640efc400b$var$_tmpl$5();
                (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$17, ()=>message().text);
                (0, $8863cd8fe199f948$export$314dade334ae905d)(()=>(0, $6258376c5c54faa9$export$2913c0c0b5623090)(_el$17, `alert alert-${message().type === "success" ? "success" : "danger"} mt-3`));
                return _el$17;
            }
        }), null);
        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$20, ()=>t("Preview"));
        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$21, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $18e8c93f2f49788f$export$29a02d8b29a909dd), {
            get fields () {
                return adminStore.conventionStructure.fields;
            },
            values: {},
            onChange: ()=>{}
        }), null);
        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$21, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
            get when () {
                return adminStore.conventionStructure.fields.length === 0;
            },
            get children () {
                var _el$22 = $af282e640efc400b$var$_tmpl$6();
                (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$22, ()=>t("Add some fields to see a preview of the convention form"));
                return _el$22;
            }
        }), null);
        return _el$;
    })();
}
(0, $6258376c5c54faa9$export$ad0f7f87f67e17d6)([
    "click",
    "input"
]);



var $e4c7899627fd74c8$var$_tmpl$ = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<li><a class=dropdown-item href=/manage-users>`), $e4c7899627fd74c8$var$_tmpl$2 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<li><a class=dropdown-item href=/manage-promos>`), $e4c7899627fd74c8$var$_tmpl$3 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<li><a class=dropdown-item href=/manage-years>`), $e4c7899627fd74c8$var$_tmpl$4 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<li><a class=dropdown-item href=/manage-convention-structure>`), $e4c7899627fd74c8$var$_tmpl$5 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<li><a class=dropdown-item href=/manage-email-templates>`), $e4c7899627fd74c8$var$_tmpl$6 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<li><a class=dropdown-item href=/manage-notifications>`);
function $e4c7899627fd74c8$export$2e2bcd8739ae039() {
    const [adminStore, setAdminStore] = (0, $059fd204a72364ff$export$b3189d039b00bb0c)();
    const [userStore, setUserStore] = (0, $c3b276e29c1ce2f2$export$87c54b525b914dab)();
    const [activeTab, setActiveTab] = (0, $8863cd8fe199f948$export$c1e1e1ecbbe76a5)('Liste Etudiants');
    const tabClass = (tabName)=>{
        return activeTab() === tabName ? 'nav-link active' : 'nav-link';
    };
    const handleTabClick = (tabName)=>(event)=>{
            setActiveTab(tabName);
            event.preventDefault();
        };
    return (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$b5d5cf8927ab7262), {
        get children () {
            return [
                (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f421feb8fad20413), {
                    get when () {
                        return userStore.page === '/manage-users';
                    },
                    get children () {
                        return (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $dd67cc782607ead6$export$2e2bcd8739ae039), {});
                    }
                }),
                (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f421feb8fad20413), {
                    get when () {
                        return userStore.page === '/manage-promos';
                    },
                    get children () {
                        return (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $2bee3b9158526810$export$2e2bcd8739ae039), {});
                    }
                }),
                (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f421feb8fad20413), {
                    get when () {
                        return userStore.page === '/manage-email-templates';
                    },
                    get children () {
                        return (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $160c389de53be6d6$export$2e2bcd8739ae039), {});
                    }
                }),
                (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f421feb8fad20413), {
                    get when () {
                        return userStore.page === '/manage-notifications';
                    },
                    get children () {
                        return (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $a9c93b852c98b750$export$2e2bcd8739ae039), {});
                    }
                }),
                (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f421feb8fad20413), {
                    get when () {
                        return userStore.page === '/manage-years';
                    },
                    get children () {
                        return (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8d128670e8dc2b4b$export$2e2bcd8739ae039), {});
                    }
                }),
                (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f421feb8fad20413), {
                    get when () {
                        return userStore.page === '/manage-convention-structure';
                    },
                    get children () {
                        return (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $af282e640efc400b$export$2e2bcd8739ae039), {});
                    }
                }),
                (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f421feb8fad20413), {
                    get when () {
                        return userStore.page === '/';
                    },
                    get children () {
                        return (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $bdea6a5dbfcecd8b$export$2e2bcd8739ae039), {});
                    }
                })
            ];
        }
    });
}
const $e4c7899627fd74c8$export$fd88fd0f00d26ab7 = ()=>{
    const t = (0, $87927b02874039c5$export$3f3caade1c12f8c9)();
    const [userStore, setUserStore, userActions] = (0, $c3b276e29c1ce2f2$export$87c54b525b914dab)();
    return (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $b1a355c10f370609$export$461cb598b7fcff7b), {
        get label () {
            return t("Admin");
        },
        get children () {
            return [
                (()=>{
                    var _el$ = $e4c7899627fd74c8$var$_tmpl$(), _el$2 = _el$.firstChild;
                    _el$2.$$click = (e)=>{
                        e.preventDefault();
                        userActions.setPage('/manage-users');
                    };
                    (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$2, ()=>t("Manage Users"));
                    return _el$;
                })(),
                (()=>{
                    var _el$3 = $e4c7899627fd74c8$var$_tmpl$2(), _el$4 = _el$3.firstChild;
                    _el$4.$$click = (e)=>{
                        e.preventDefault();
                        userActions.setPage('/manage-promos');
                    };
                    (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$4, ()=>t("Manage Promos"));
                    return _el$3;
                })(),
                (()=>{
                    var _el$5 = $e4c7899627fd74c8$var$_tmpl$3(), _el$6 = _el$5.firstChild;
                    _el$6.$$click = (e)=>{
                        e.preventDefault();
                        userActions.setPage('/manage-years');
                    };
                    (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$6, ()=>t("Manage Years"));
                    return _el$5;
                })(),
                (()=>{
                    var _el$7 = $e4c7899627fd74c8$var$_tmpl$4(), _el$8 = _el$7.firstChild;
                    _el$8.$$click = (e)=>{
                        e.preventDefault();
                        userActions.setPage('/manage-convention-structure');
                    };
                    (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$8, ()=>t("Form Structure"));
                    return _el$7;
                })(),
                (()=>{
                    var _el$9 = $e4c7899627fd74c8$var$_tmpl$5(), _el$0 = _el$9.firstChild;
                    _el$0.$$click = (e)=>{
                        e.preventDefault();
                        userActions.setPage('/manage-email-templates');
                    };
                    (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$0, ()=>t("Email Templates"));
                    return _el$9;
                })(),
                (()=>{
                    var _el$1 = $e4c7899627fd74c8$var$_tmpl$6(), _el$10 = _el$1.firstChild;
                    _el$10.$$click = (e)=>{
                        e.preventDefault();
                        userActions.setPage('/manage-notifications');
                    };
                    (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$10, ()=>t("Notification Log"));
                    return _el$1;
                })()
            ];
        }
    });
};
(0, $6258376c5c54faa9$export$ad0f7f87f67e17d6)([
    "click"
]);










var $5de580f0a4763066$var$_tmpl$ = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<div class=mb-3><label for=studentNumber class=form-label></label><input type=text class=form-control id=studentNumber><div class=form-text>`), $5de580f0a4763066$var$_tmpl$2 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<div class=mb-3><label for=healthInsurance class=form-label></label><input type=text class=form-control id=healthInsurance><div class=form-text>`), $5de580f0a4763066$var$_tmpl$3 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<div class="alert alert-info mt-3">`), $5de580f0a4763066$var$_tmpl$4 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<span class="me-3 p-2 bg-light border rounded">`), $5de580f0a4763066$var$_tmpl$5 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<button type=button class="btn btn-outline-secondary">`), $5de580f0a4763066$var$_tmpl$6 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<div class="card mb-4"><div class=card-header></div><div class=card-body><div class=mb-3><label class=form-label></label><div class="d-flex align-items-center"></div><div class=form-text>`), $5de580f0a4763066$var$_tmpl$7 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<div><h1></h1><div class="card mb-4"><div class=card-header></div><div class=card-body><div class=mb-3><label for=username class=form-label></label><input type=text class=form-control id=username disabled><div class=form-text></div></div><div class=mb-3><label for=fullname class=form-label></label><input type=text class=form-control id=fullname><div class=form-text></div></div><div class=mb-3><label for=email class=form-label></label><div class=input-group><input type=email class=form-control id=email placeholder=your.email@example.com></div><div class=form-text></div></div><button type=button class="btn btn-primary"></button></div></div><div class=card><div class=card-header></div><div class=card-body><button type=button class="btn btn-danger">`), $5de580f0a4763066$var$_tmpl$8 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<span class="input-group-text bg-secondary text-white">`), $5de580f0a4763066$var$_tmpl$9 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<span class=text-muted>`);
var $5de580f0a4763066$export$2e2bcd8739ae039 = ()=>{
    const t = (0, $87927b02874039c5$export$3f3caade1c12f8c9)();
    const [userStore, setUserStore, userActions] = (0, $c3b276e29c1ce2f2$export$87c54b525b914dab)();
    const [fullname, setFullname] = (0, $8863cd8fe199f948$export$c1e1e1ecbbe76a5)(userStore.fullname || "");
    const [studentNumber, setStudentNumber] = (0, $8863cd8fe199f948$export$c1e1e1ecbbe76a5)(userStore.student_number || "");
    const [healthInsurance, setHealthInsurance] = (0, $8863cd8fe199f948$export$c1e1e1ecbbe76a5)(userStore.additional_info?.healthInsurance || "");
    // Create reactive memos for email-related values
    const isDefaultEmail = (0, $8863cd8fe199f948$export$c0c6c8b9c16bf6aa)(()=>!userStore.email);
    const defaultEmailValue = (0, $8863cd8fe199f948$export$c0c6c8b9c16bf6aa)(()=>(0, $bc18280b634ac0b4$export$a92adec574c54595)(userStore.username, userStore.role));
    const [email, setEmail] = (0, $8863cd8fe199f948$export$c1e1e1ecbbe76a5)(userStore.email || defaultEmailValue());
    const [saving, setSaving] = (0, $8863cd8fe199f948$export$c1e1e1ecbbe76a5)(false);
    const [message, setMessage] = (0, $8863cd8fe199f948$export$c1e1e1ecbbe76a5)("");
    const saveProfile = ()=>{
        setSaving(true);
        setMessage("");
        // Only update fullname for students, admin users can update both fullname and email
        const updateData = userStore.role === 'student' ? {
            fullname: fullname(),
            student_number: studentNumber(),
            additional_info: {
                ...userStore.additional_info,
                healthInsurance: healthInsurance()
            }
        } : {
            fullname: fullname(),
            email: email()
        };
        userActions.updateUserProfile(updateData).then(()=>{
            setMessage("Profile updated successfully!");
            setSaving(false);
        }).catch((err)=>{
            setMessage("Error updating profile.");
            setSaving(false);
        });
    };
    const handleLeavePromo = ()=>{
        if (confirm(t("Are you sure you want to leave your current class? You'll need to select a new one before creating internship agreements."))) {
            userActions.leavePromo();
            setMessage(t("You've left your class successfully. You can select a new one from the home page."));
        }
    };
    return (()=>{
        var _el$ = $5de580f0a4763066$var$_tmpl$7(), _el$2 = _el$.firstChild, _el$3 = _el$2.nextSibling, _el$4 = _el$3.firstChild, _el$5 = _el$4.nextSibling, _el$6 = _el$5.firstChild, _el$7 = _el$6.firstChild, _el$8 = _el$7.nextSibling, _el$9 = _el$8.nextSibling, _el$0 = _el$6.nextSibling, _el$1 = _el$0.firstChild, _el$10 = _el$1.nextSibling, _el$11 = _el$10.nextSibling, _el$20 = _el$0.nextSibling, _el$21 = _el$20.firstChild, _el$22 = _el$21.nextSibling, _el$23 = _el$22.firstChild, _el$24 = _el$22.nextSibling, _el$25 = _el$20.nextSibling, _el$36 = _el$3.nextSibling, _el$37 = _el$36.firstChild, _el$38 = _el$37.nextSibling, _el$39 = _el$38.firstChild;
        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$2, ()=>t("Settings"));
        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$4, ()=>t("Profile Information"));
        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$7, ()=>t("Username"));
        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$9, ()=>t("Your login username cannot be changed."));
        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$1, ()=>t("Full Name"));
        _el$10.$$input = (e)=>setFullname(e.target.value);
        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$11, ()=>t("Your full name will be displayed to other users."));
        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$5, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
            get when () {
                return userStore.role === 'student';
            },
            get children () {
                return [
                    (()=>{
                        var _el$12 = $5de580f0a4763066$var$_tmpl$(), _el$13 = _el$12.firstChild, _el$14 = _el$13.nextSibling, _el$15 = _el$14.nextSibling;
                        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$13, ()=>t("Student Number"));
                        _el$14.$$input = (e)=>setStudentNumber(e.target.value);
                        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$15, ()=>t("Your student number for administrative purposes."));
                        (0, $8863cd8fe199f948$export$314dade334ae905d)(()=>(0, $6258376c5c54faa9$export$9fec4d97f1922e0b)(_el$14, "placeholder", t("Enter your student number")));
                        (0, $8863cd8fe199f948$export$314dade334ae905d)(()=>_el$14.value = studentNumber());
                        return _el$12;
                    })(),
                    (()=>{
                        var _el$16 = $5de580f0a4763066$var$_tmpl$2(), _el$17 = _el$16.firstChild, _el$18 = _el$17.nextSibling, _el$19 = _el$18.nextSibling;
                        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$17, ()=>t("Health Insurance - City + Region"));
                        _el$18.$$input = (e)=>setHealthInsurance(e.target.value);
                        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$19, ()=>t("Your health insurance fund with city and region."));
                        (0, $8863cd8fe199f948$export$314dade334ae905d)(()=>(0, $6258376c5c54faa9$export$9fec4d97f1922e0b)(_el$18, "placeholder", t("e.g., CPAM Strasbourg - Grand Est")));
                        (0, $8863cd8fe199f948$export$314dade334ae905d)(()=>_el$18.value = healthInsurance());
                        return _el$16;
                    })()
                ];
            }
        }), _el$20);
        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$21, ()=>t("Email Address"));
        _el$23.$$input = (e)=>userStore.role !== 'student' && setEmail(e.target.value);
        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$22, (()=>{
            var _c$ = (0, $6258376c5c54faa9$export$7c73462e0d25e514)(()=>!!isDefaultEmail());
            return ()=>_c$() && (()=>{
                    var _el$40 = $5de580f0a4763066$var$_tmpl$8();
                    (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$40, ()=>t("default"));
                    (0, $8863cd8fe199f948$export$314dade334ae905d)(()=>(0, $6258376c5c54faa9$export$9fec4d97f1922e0b)(_el$40, "title", t("Default email based on username and role")));
                    return _el$40;
                })();
        })(), null);
        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$24, (()=>{
            var _c$2 = (0, $6258376c5c54faa9$export$7c73462e0d25e514)(()=>userStore.role === 'student');
            return ()=>_c$2() ? t("Your email address cannot be changed. Contact an administrator if it needs to be updated.") : (0, $6258376c5c54faa9$export$7c73462e0d25e514)(()=>!!isDefaultEmail())() ? t("This is your default email based on your username and role. You can change it if needed.") : t("Your email is used for notifications about feedback requests and validations.");
        })());
        _el$25.$$click = saveProfile;
        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$25, (()=>{
            var _c$3 = (0, $6258376c5c54faa9$export$7c73462e0d25e514)(()=>!!saving());
            return ()=>_c$3() ? t("Saving...") : t("Save Changes");
        })());
        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$5, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
            get when () {
                return message();
            },
            get children () {
                var _el$26 = $5de580f0a4763066$var$_tmpl$3();
                (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$26, message);
                return _el$26;
            }
        }), null);
        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
            get when () {
                return userStore.role === 'student';
            },
            get children () {
                var _el$27 = $5de580f0a4763066$var$_tmpl$6(), _el$28 = _el$27.firstChild, _el$29 = _el$28.nextSibling, _el$30 = _el$29.firstChild, _el$31 = _el$30.firstChild, _el$32 = _el$31.nextSibling, _el$35 = _el$32.nextSibling;
                (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$28, ()=>t("Class Information"));
                (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$31, ()=>t("Current Class/Promo"));
                (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$32, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
                    get when () {
                        return userStore.promo_id;
                    },
                    get fallback () {
                        return (()=>{
                            var _el$41 = $5de580f0a4763066$var$_tmpl$9();
                            (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$41, ()=>t("No class selected. Please select a class from the home page."));
                            return _el$41;
                        })();
                    },
                    get children () {
                        return [
                            (()=>{
                                var _el$33 = $5de580f0a4763066$var$_tmpl$4();
                                (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$33, ()=>userStore.promos_by_id[userStore.promo_id]?.name || t("Loading..."));
                                return _el$33;
                            })(),
                            (()=>{
                                var _el$34 = $5de580f0a4763066$var$_tmpl$5();
                                _el$34.$$click = handleLeavePromo;
                                (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$34, ()=>t("Leave Class"));
                                return _el$34;
                            })()
                        ];
                    }
                }));
                (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$35, ()=>t("Your class determines who can validate your internship agreements."));
                return _el$27;
            }
        }), _el$36);
        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$37, ()=>t("Account Actions"));
        _el$39.$$click = ()=>{
            localStorage.removeItem('jwt');
            location.reload();
        };
        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$39, ()=>t("Logout"));
        (0, $8863cd8fe199f948$export$314dade334ae905d)((_p$)=>{
            var _v$ = t("Enter your full name"), _v$2 = userStore.role === 'student', _v$3 = saving();
            _v$ !== _p$.e && (0, $6258376c5c54faa9$export$9fec4d97f1922e0b)(_el$10, "placeholder", _p$.e = _v$);
            _v$2 !== _p$.t && (_el$23.disabled = _p$.t = _v$2);
            _v$3 !== _p$.a && (_el$25.disabled = _p$.a = _v$3);
            return _p$;
        }, {
            e: undefined,
            t: undefined,
            a: undefined
        });
        (0, $8863cd8fe199f948$export$314dade334ae905d)(()=>_el$8.value = userStore.username);
        (0, $8863cd8fe199f948$export$314dade334ae905d)(()=>_el$10.value = fullname());
        (0, $8863cd8fe199f948$export$314dade334ae905d)(()=>_el$23.value = email());
        return _el$;
    })();
};
(0, $6258376c5c54faa9$export$ad0f7f87f67e17d6)([
    "input",
    "click"
]);







var $e59a09545c17b201$var$_tmpl$ = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<div class="container mt-4"><div class=card><div class=card-body><h5 class=card-title></h5><p class=card-text></p><form><div class=mb-3><label for=promoSelect class=form-label>:</label><select id=promoSelect class=form-select required><option value disabled></option></select></div><button type=submit class="btn btn-primary">`), $e59a09545c17b201$var$_tmpl$2 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<option>`);
function $e59a09545c17b201$export$2e2bcd8739ae039() {
    const t = (0, $87927b02874039c5$export$3f3caade1c12f8c9)();
    const [userStore, setUserStore, actions] = (0, $c3b276e29c1ce2f2$export$87c54b525b914dab)();
    const [selectedPromo, setSelectedPromo] = (0, $8863cd8fe199f948$export$c1e1e1ecbbe76a5)(null);
    const handleSubmit = (e)=>{
        e.preventDefault();
        if (selectedPromo()) actions.selectPromo(selectedPromo());
    };
    return (()=>{
        var _el$ = $e59a09545c17b201$var$_tmpl$(), _el$2 = _el$.firstChild, _el$3 = _el$2.firstChild, _el$4 = _el$3.firstChild, _el$5 = _el$4.nextSibling, _el$6 = _el$5.nextSibling, _el$7 = _el$6.firstChild, _el$8 = _el$7.firstChild, _el$9 = _el$8.firstChild, _el$0 = _el$8.nextSibling, _el$1 = _el$0.firstChild, _el$10 = _el$7.nextSibling;
        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$4, ()=>t("Welcome to the Internship Management Platform"));
        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$5, ()=>t("Before you can create internship agreements, please select your class/promo:"));
        _el$6.addEventListener("submit", handleSubmit);
        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$8, ()=>t("Select your class:"), _el$9);
        _el$0.addEventListener("change", (e)=>setSelectedPromo(e.target.value));
        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$1, ()=>t("Choose a class"));
        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$0, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$bdf530073099ce9f), {
            get each () {
                return Object.values(userStore.promos_by_id);
            },
            children: (promo)=>(()=>{
                    var _el$11 = $e59a09545c17b201$var$_tmpl$2();
                    (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$11, ()=>promo.name);
                    (0, $8863cd8fe199f948$export$314dade334ae905d)(()=>_el$11.value = promo.id);
                    return _el$11;
                })()
        }), null);
        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$10, ()=>t("Confirm Selection"));
        (0, $8863cd8fe199f948$export$314dade334ae905d)(()=>_el$0.value = selectedPromo() || "");
        return _el$;
    })();
}








var $2216a7ab50ec14b7$var$_tmpl$ = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<div class="container mt-4"><h1 class=mb-4>`), $2216a7ab50ec14b7$var$_tmpl$2 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<div class=text-center><div class=spinner-border role=status>`), $2216a7ab50ec14b7$var$_tmpl$3 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<p>`), $2216a7ab50ec14b7$var$_tmpl$4 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<h4 class="mt-4 mb-3"> (<!>)`), $2216a7ab50ec14b7$var$_tmpl$5 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<div class=table-responsive><table class="table table-hover"><thead><tr><th></th><th></th><th></th><th></th><th></th></tr></thead><tbody>`), $2216a7ab50ec14b7$var$_tmpl$6 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<div class=table-responsive><table class="table table-hover table-sm"><thead><tr><th></th><th></th><th></th><th></th></tr></thead><tbody>`), $2216a7ab50ec14b7$var$_tmpl$7 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<div class="alert alert-info"><i class="fas fa-lock me-2">`), $2216a7ab50ec14b7$var$_tmpl$8 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<div class="alert alert-warning"><i class="fas fa-edit me-2">`), $2216a7ab50ec14b7$var$_tmpl$9 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<div class=mb-5><h2 class="border-bottom pb-2">`), $2216a7ab50ec14b7$var$_tmpl$0 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<span class="badge bg-success">`), $2216a7ab50ec14b7$var$_tmpl$1 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<br>`), $2216a7ab50ec14b7$var$_tmpl$10 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<span class="badge bg-info mt-1">`), $2216a7ab50ec14b7$var$_tmpl$11 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<tr><td></td><td></td><td></td><td></td><td><button type=button class="btn btn-sm btn-primary"><i class="fas fa-edit me-1">`), $2216a7ab50ec14b7$var$_tmpl$12 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<small class=text-muted>`), $2216a7ab50ec14b7$var$_tmpl$13 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<span class="badge bg-warning text-dark">`), $2216a7ab50ec14b7$var$_tmpl$14 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<tr><td></td><td></td><td></td><td><button type=button class="btn btn-sm btn-outline-secondary"><i class="fas fa-eye me-1">`), $2216a7ab50ec14b7$var$_tmpl$15 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<tr class=table-danger><td></td><td><br><span class="badge bg-danger"></span></td><td></td><td><button type=button class="btn btn-sm btn-outline-secondary"><i class="fas fa-eye me-1">`), $2216a7ab50ec14b7$var$_tmpl$16 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<small class=text-muted> <br>`), $2216a7ab50ec14b7$var$_tmpl$17 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<tr class=table-warning><td></td><td><br><span class="badge bg-warning text-dark"></span></td><td></td><td><button type=button class="btn btn-sm btn-outline-secondary"><i class="fas fa-eye me-1">`), $2216a7ab50ec14b7$var$_tmpl$18 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<span class="badge bg-danger ms-2">`), $2216a7ab50ec14b7$var$_tmpl$19 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<span class="badge bg-warning text-dark ms-2">`), $2216a7ab50ec14b7$var$_tmpl$20 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<div class=mt-2><div>:</div><ul>`), $2216a7ab50ec14b7$var$_tmpl$21 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<span>`), $2216a7ab50ec14b7$var$_tmpl$22 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<div class="mb-3 mt-4"><h6>:`), $2216a7ab50ec14b7$var$_tmpl$23 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<div class=mb-3><strong>:</strong><ul class=mt-1>`), $2216a7ab50ec14b7$var$_tmpl$24 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<span class="badge bg-info ms-2">`), $2216a7ab50ec14b7$var$_tmpl$25 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<div class="alert alert-info mt-2"><small> `), $2216a7ab50ec14b7$var$_tmpl$26 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<button type=button class="btn btn-sm btn-success"><i class="fas fa-paper-plane">`), $2216a7ab50ec14b7$var$_tmpl$27 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<div class="d-flex align-items-center"><div class=me-auto></div><div class=btn-group role=group><button type=button class="btn btn-sm btn-primary">`), $2216a7ab50ec14b7$var$_tmpl$28 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<div class=mb-3><strong>:</strong><div class="card mt-2"><div class="card-body p-0"><div class="list-group list-group-flush">`), $2216a7ab50ec14b7$var$_tmpl$29 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<button type=button class="btn btn-success"><i class="fas fa-check me-1">`), $2216a7ab50ec14b7$var$_tmpl$30 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<div class="modal show d-block"style=background-color:rgba(0,0,0,0.5)><div class="modal-dialog modal-xl modal-dialog-scrollable"><div class=modal-content><div class=modal-header><h5 class=modal-title></h5><button type=button class=btn-close></button></div><div class=modal-body><div class=mb-3><h6 class=text-muted>: </h6></div></div><div class=modal-footer><button type=button class="btn btn-secondary">`), $2216a7ab50ec14b7$var$_tmpl$31 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<small>(<!>)`), $2216a7ab50ec14b7$var$_tmpl$32 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<li> - `), $2216a7ab50ec14b7$var$_tmpl$33 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<li>`), $2216a7ab50ec14b7$var$_tmpl$34 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<small class=text-muted>(<!>)`), $2216a7ab50ec14b7$var$_tmpl$35 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<div class=mt-2><textarea class="form-control mb-2"rows=5></textarea><div class="d-flex gap-2"><button type=button class="btn btn-primary"></button><button type=button class="btn btn-success"><i class="fas fa-paper-plane me-1"></i></button><button type=button class="btn btn-secondary">`), $2216a7ab50ec14b7$var$_tmpl$36 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<div><p class=mb-0 style=white-space:pre-wrap></p><small class=text-muted>: `), $2216a7ab50ec14b7$var$_tmpl$37 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<small class="badge bg-info"><i class="fas fa-envelope me-1"></i> `), $2216a7ab50ec14b7$var$_tmpl$38 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<small class=text-muted> <!> `), $2216a7ab50ec14b7$var$_tmpl$39 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<div class=list-group-item><div class="d-flex justify-content-between align-items-center mb-1"><strong> </strong><small class=text-muted> <!> <!> </small></div><p class=mb-1 style=white-space:pre-wrap></p><div class="d-flex gap-2">`), $2216a7ab50ec14b7$var$_tmpl$40 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<div class="card mt-2"><div class=card-body><div class="d-flex justify-content-between align-items-center mb-2"><strong></strong><small class=text-muted> <!> <!> </small></div><p class=mb-1 style=white-space:pre-wrap>`);
function $2216a7ab50ec14b7$export$2e2bcd8739ae039() {
    const t = (0, $87927b02874039c5$export$3f3caade1c12f8c9)();
    const [userStore, setUserStore] = (0, $c3b276e29c1ce2f2$export$87c54b525b914dab)();
    const [promosWithConventions, setPromosWithConventions] = (0, $8863cd8fe199f948$export$c1e1e1ecbbe76a5)([]);
    const [loading, setLoading] = (0, $8863cd8fe199f948$export$c1e1e1ecbbe76a5)(true);
    // If we have cached data, use it immediately
    if (userStore.cachedTeacherConventions) {
        console.log("Using cached teacher conventions data");
        setPromosWithConventions(userStore.cachedTeacherConventions);
        setLoading(false);
    }
    // Handler for teacher-conventions events
    const handleTeacherConventions = (data)=>{
        console.log("Received teacher conventions data:", data);
        setPromosWithConventions(data);
        setLoading(false);
        // Cache the data for future use
        setUserStore('cachedTeacherConventions', data);
    };
    (0, $8863cd8fe199f948$export$1e848a9e87980bd5)(()=>{
        console.log("TeacherView mounted, requesting data...");
        // Request data from the server
        (0, $a26018a1d2174fbf$export$2e2bcd8739ae039).emit("teacher-request-conventions");
        // If we don't have cached data, show loading indicator
        if (!userStore.cachedTeacherConventions) setLoading(true);
        // Always register the handler (and remove old one if it exists)
        (0, $a26018a1d2174fbf$export$2e2bcd8739ae039).off("teacher-conventions", handleTeacherConventions);
        (0, $a26018a1d2174fbf$export$2e2bcd8739ae039).on("teacher-conventions", handleTeacherConventions);
        // Cleanup when component unmounts
        (0, $8863cd8fe199f948$export$b36e5eaa3e8c43ab)(()=>{
            console.log("TeacherView unmounting, cleaning up socket handler");
            (0, $a26018a1d2174fbf$export$2e2bcd8739ae039).off("teacher-conventions", handleTeacherConventions);
        });
    });
    return (()=>{
        var _el$ = $2216a7ab50ec14b7$var$_tmpl$(), _el$2 = _el$.firstChild;
        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$2, ()=>t("Teacher Dashboard"));
        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
            get when () {
                return !loading();
            },
            get fallback () {
                return $2216a7ab50ec14b7$var$_tmpl$2();
            },
            get children () {
                return (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
                    get when () {
                        return promosWithConventions().length > 0;
                    },
                    get fallback () {
                        return (()=>{
                            var _el$4 = $2216a7ab50ec14b7$var$_tmpl$3();
                            (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$4, ()=>t("You are not assigned as a validator for any class yet."));
                            return _el$4;
                        })();
                    },
                    get children () {
                        return (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$bdf530073099ce9f), {
                            get each () {
                                return promosWithConventions();
                            },
                            children: (promo)=>(0, $8863cd8fe199f948$export$60e54eaca7e7fb38)($2216a7ab50ec14b7$var$PromoView, {
                                    promo: promo
                                })
                        });
                    }
                });
            }
        }), null);
        return _el$;
    })();
}
function $2216a7ab50ec14b7$var$PromoView(props) {
    const t = (0, $87927b02874039c5$export$3f3caade1c12f8c9)();
    const [userStore] = (0, $c3b276e29c1ce2f2$export$87c54b525b914dab)();
    const [selectedConvention, setSelectedConvention] = (0, $8863cd8fe199f948$export$c1e1e1ecbbe76a5)(null);
    const [editingFeedback, setEditingFeedback] = (0, $8863cd8fe199f948$export$c1e1e1ecbbe76a5)({
        conventionId: null,
        feedback: ""
    });
    const startEditingFeedback = (convention)=>{
        setEditingFeedback({
            conventionId: convention.id,
            feedback: convention.info.teacherFeedback || ""
        });
    };
    const saveFeedback = (sendNotification = false)=>{
        const { conventionId: conventionId, feedback: feedback } = editingFeedback();
        if (sendNotification) {
            if (!confirm(t("The convention will return to draft mode for the student, and they will receive a notification. Continue?"))) return;
        }
        (0, $a26018a1d2174fbf$export$2e2bcd8739ae039).emit("teacher-update-convention-feedback", {
            conventionId: conventionId,
            feedback: feedback,
            sendNotification: sendNotification
        });
        setEditingFeedback({
            conventionId: null,
            feedback: ""
        });
    };
    const cancelEditingFeedback = ()=>{
        setEditingFeedback({
            conventionId: null,
            feedback: ""
        });
    };
    const openConventionModal = (convention)=>{
        setSelectedConvention(convention);
    };
    const closeConventionModal = ()=>{
        setSelectedConvention(null);
        setEditingFeedback({
            conventionId: null,
            feedback: ""
        });
    };
    // Check if the current teacher has validated this convention
    const hasValidated = (convention)=>{
        if (!convention.info.validations) return false;
        return convention.info.validations.some((v)=>v.validatorId === userStore.id);
    };
    // Get validators that haven't yet validated
    const getRemainingValidators = (convention, promo)=>{
        if (!convention.info.validations) return promo.validators || [];
        const validatedIds = convention.info.validations.map((v)=>v.validatorId);
        return (promo.validators || []).filter((v)=>!validatedIds.includes(v.id));
    };
    const validateConvention = (conventionId)=>{
        (0, $a26018a1d2174fbf$export$2e2bcd8739ae039).emit("teacher-validate-convention", conventionId);
    };
    const sendExistingFeedbackNotification = (conventionId)=>{
        if (confirm(t("The convention will return to draft mode for the student, and they will receive a notification. Continue?"))) (0, $a26018a1d2174fbf$export$2e2bcd8739ae039).emit("teacher-send-existing-feedback-notification", {
            conventionId: conventionId
        });
    };
    // Separate conventions by status
    const validatedConventions = (0, $8863cd8fe199f948$export$c0c6c8b9c16bf6aa)(()=>{
        console.log('all conventions:', props.promo.conventions);
        return props.promo.conventions.filter((c)=>c.info.fullyValidated && c.status !== 'locked');
    });
    const pendingConventions = (0, $8863cd8fe199f948$export$c0c6c8b9c16bf6aa)(()=>props.promo.conventions.filter((c)=>!c.info.fullyValidated && c.status !== 'locked' && c.status !== 'active'));
    const lockedConventions = (0, $8863cd8fe199f948$export$c0c6c8b9c16bf6aa)(()=>props.promo.conventions.filter((c)=>c.status === 'locked'));
    const draftWithFeedback = (0, $8863cd8fe199f948$export$c0c6c8b9c16bf6aa)(()=>props.promo.conventions.filter((c)=>c.status === 'active' && c.info.feedbackHistory && c.info.feedbackHistory.length > 0));
    return (()=>{
        var _el$5 = $2216a7ab50ec14b7$var$_tmpl$9(), _el$6 = _el$5.firstChild;
        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$6, ()=>props.promo.name);
        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$5, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
            get when () {
                return pendingConventions().length > 0 || validatedConventions().length > 0 || lockedConventions().length > 0 || draftWithFeedback().length > 0;
            },
            get fallback () {
                return (()=>{
                    var _el$62 = $2216a7ab50ec14b7$var$_tmpl$3();
                    (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$62, ()=>t("No internship agreements in this class yet."));
                    return _el$62;
                })();
            },
            get children () {
                return [
                    (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
                        get when () {
                            return pendingConventions().length > 0;
                        },
                        get children () {
                            return [
                                (()=>{
                                    var _el$7 = $2216a7ab50ec14b7$var$_tmpl$4(), _el$8 = _el$7.firstChild, _el$0 = _el$8.nextSibling, _el$9 = _el$0.nextSibling;
                                    (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$7, ()=>t("Pending Agreements"), _el$8);
                                    (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$7, ()=>pendingConventions().length, _el$0);
                                    return _el$7;
                                })(),
                                (()=>{
                                    var _el$1 = $2216a7ab50ec14b7$var$_tmpl$5(), _el$10 = _el$1.firstChild, _el$11 = _el$10.firstChild, _el$12 = _el$11.firstChild, _el$13 = _el$12.firstChild, _el$14 = _el$13.nextSibling, _el$15 = _el$14.nextSibling, _el$16 = _el$15.nextSibling, _el$17 = _el$16.nextSibling, _el$18 = _el$11.nextSibling;
                                    (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$13, ()=>t("Student"));
                                    (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$14, ()=>t("Title"));
                                    (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$15, ()=>t("Business"));
                                    (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$16, ()=>t("Status"));
                                    (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$17, ()=>t("Actions"));
                                    (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$18, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$bdf530073099ce9f), {
                                        get each () {
                                            return pendingConventions();
                                        },
                                        children: (convention)=>(()=>{
                                                var _el$63 = $2216a7ab50ec14b7$var$_tmpl$11(), _el$64 = _el$63.firstChild, _el$65 = _el$64.nextSibling, _el$66 = _el$65.nextSibling, _el$67 = _el$66.nextSibling, _el$71 = _el$67.nextSibling, _el$72 = _el$71.firstChild, _el$73 = _el$72.firstChild;
                                                (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$64, (()=>{
                                                    var _c$ = (0, $6258376c5c54faa9$export$7c73462e0d25e514)(()=>!!convention.fullname);
                                                    return ()=>_c$() ? [
                                                            (0, $6258376c5c54faa9$export$7c73462e0d25e514)(()=>convention.fullname),
                                                            $2216a7ab50ec14b7$var$_tmpl$1(),
                                                            (()=>{
                                                                var _el$75 = $2216a7ab50ec14b7$var$_tmpl$12();
                                                                (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$75, ()=>convention.username);
                                                                return _el$75;
                                                            })()
                                                        ] : convention.username;
                                                })());
                                                (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$65, ()=>convention.info?.title || t("Internship Agreement"));
                                                (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$66, ()=>convention.info?.business || t("Not specified"));
                                                (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$67, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
                                                    get when () {
                                                        return hasValidated(convention);
                                                    },
                                                    get fallback () {
                                                        return (()=>{
                                                            var _el$76 = $2216a7ab50ec14b7$var$_tmpl$13();
                                                            (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$76, ()=>t("Awaiting validation"));
                                                            return _el$76;
                                                        })();
                                                    },
                                                    get children () {
                                                        var _el$68 = $2216a7ab50ec14b7$var$_tmpl$0();
                                                        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$68, ()=>t("Validated by you"));
                                                        return _el$68;
                                                    }
                                                }), null);
                                                (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$67, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
                                                    get when () {
                                                        return (0, $6258376c5c54faa9$export$7c73462e0d25e514)(()=>!!convention.info?.feedbackHistory)() && convention.info.feedbackHistory.length > 0;
                                                    },
                                                    get children () {
                                                        return [
                                                            $2216a7ab50ec14b7$var$_tmpl$1(),
                                                            (()=>{
                                                                var _el$70 = $2216a7ab50ec14b7$var$_tmpl$10();
                                                                (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$70, ()=>t("Resubmitted"));
                                                                return _el$70;
                                                            })()
                                                        ];
                                                    }
                                                }), null);
                                                _el$72.$$click = ()=>openConventionModal(convention);
                                                (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$72, ()=>t("Process"), null);
                                                return _el$63;
                                            })()
                                    }));
                                    return _el$1;
                                })()
                            ];
                        }
                    }),
                    (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
                        get when () {
                            return validatedConventions().length > 0;
                        },
                        get children () {
                            return [
                                (()=>{
                                    var _el$19 = $2216a7ab50ec14b7$var$_tmpl$4(), _el$20 = _el$19.firstChild, _el$22 = _el$20.nextSibling, _el$21 = _el$22.nextSibling;
                                    (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$19, ()=>t("Validated Agreements"), _el$20);
                                    (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$19, ()=>validatedConventions().length, _el$22);
                                    return _el$19;
                                })(),
                                (()=>{
                                    var _el$23 = $2216a7ab50ec14b7$var$_tmpl$6(), _el$24 = _el$23.firstChild, _el$25 = _el$24.firstChild, _el$26 = _el$25.firstChild, _el$27 = _el$26.firstChild, _el$28 = _el$27.nextSibling, _el$29 = _el$28.nextSibling, _el$30 = _el$29.nextSibling, _el$31 = _el$25.nextSibling;
                                    (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$27, ()=>t("Student"));
                                    (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$28, ()=>t("Title"));
                                    (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$29, ()=>t("Business"));
                                    (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$30, ()=>t("Actions"));
                                    (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$31, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$bdf530073099ce9f), {
                                        get each () {
                                            return validatedConventions();
                                        },
                                        children: (convention)=>(()=>{
                                                var _el$77 = $2216a7ab50ec14b7$var$_tmpl$14(), _el$78 = _el$77.firstChild, _el$79 = _el$78.nextSibling, _el$80 = _el$79.nextSibling, _el$81 = _el$80.nextSibling, _el$82 = _el$81.firstChild, _el$83 = _el$82.firstChild;
                                                (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$78, (()=>{
                                                    var _c$2 = (0, $6258376c5c54faa9$export$7c73462e0d25e514)(()=>!!convention.fullname);
                                                    return ()=>_c$2() ? [
                                                            (0, $6258376c5c54faa9$export$7c73462e0d25e514)(()=>convention.fullname),
                                                            $2216a7ab50ec14b7$var$_tmpl$1(),
                                                            (()=>{
                                                                var _el$85 = $2216a7ab50ec14b7$var$_tmpl$12();
                                                                (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$85, ()=>convention.username);
                                                                return _el$85;
                                                            })()
                                                        ] : convention.username;
                                                })());
                                                (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$79, ()=>convention.info?.title || t("Internship Agreement"));
                                                (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$80, ()=>convention.info?.business || t("Not specified"));
                                                _el$82.$$click = ()=>openConventionModal(convention);
                                                (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$82, ()=>t("View"), null);
                                                return _el$77;
                                            })()
                                    }));
                                    return _el$23;
                                })()
                            ];
                        }
                    }),
                    (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
                        get when () {
                            return lockedConventions().length > 0;
                        },
                        get children () {
                            return [
                                (()=>{
                                    var _el$32 = $2216a7ab50ec14b7$var$_tmpl$4(), _el$33 = _el$32.firstChild, _el$35 = _el$33.nextSibling, _el$34 = _el$35.nextSibling;
                                    (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$32, ()=>t("Locked Agreements"), _el$33);
                                    (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$32, ()=>lockedConventions().length, _el$35);
                                    return _el$32;
                                })(),
                                (()=>{
                                    var _el$36 = $2216a7ab50ec14b7$var$_tmpl$7(), _el$37 = _el$36.firstChild;
                                    (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$36, ()=>t("These agreements have been locked by an administrator and cannot be modified."), null);
                                    return _el$36;
                                })(),
                                (()=>{
                                    var _el$38 = $2216a7ab50ec14b7$var$_tmpl$6(), _el$39 = _el$38.firstChild, _el$40 = _el$39.firstChild, _el$41 = _el$40.firstChild, _el$42 = _el$41.firstChild, _el$43 = _el$42.nextSibling, _el$44 = _el$43.nextSibling, _el$45 = _el$44.nextSibling, _el$46 = _el$40.nextSibling;
                                    (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$42, ()=>t("Student"));
                                    (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$43, ()=>t("Title"));
                                    (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$44, ()=>t("Business"));
                                    (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$45, ()=>t("Actions"));
                                    (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$46, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$bdf530073099ce9f), {
                                        get each () {
                                            return lockedConventions();
                                        },
                                        children: (convention)=>(()=>{
                                                var _el$86 = $2216a7ab50ec14b7$var$_tmpl$15(), _el$87 = _el$86.firstChild, _el$88 = _el$87.nextSibling, _el$89 = _el$88.firstChild, _el$90 = _el$89.nextSibling, _el$91 = _el$88.nextSibling, _el$92 = _el$91.nextSibling, _el$93 = _el$92.firstChild, _el$94 = _el$93.firstChild;
                                                (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$87, (()=>{
                                                    var _c$3 = (0, $6258376c5c54faa9$export$7c73462e0d25e514)(()=>!!convention.fullname);
                                                    return ()=>_c$3() ? [
                                                            (0, $6258376c5c54faa9$export$7c73462e0d25e514)(()=>convention.fullname),
                                                            $2216a7ab50ec14b7$var$_tmpl$1(),
                                                            (()=>{
                                                                var _el$96 = $2216a7ab50ec14b7$var$_tmpl$12();
                                                                (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$96, ()=>convention.username);
                                                                return _el$96;
                                                            })()
                                                        ] : convention.username;
                                                })());
                                                (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$88, ()=>convention.info?.title || t("Internship Agreement"), _el$89);
                                                (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$90, ()=>t("Locked"));
                                                (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$91, ()=>convention.info?.business || t("Not specified"));
                                                _el$93.$$click = ()=>openConventionModal(convention);
                                                (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$93, ()=>t("View"), null);
                                                return _el$86;
                                            })()
                                    }));
                                    return _el$38;
                                })()
                            ];
                        }
                    }),
                    (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
                        get when () {
                            return draftWithFeedback().length > 0;
                        },
                        get children () {
                            return [
                                (()=>{
                                    var _el$47 = $2216a7ab50ec14b7$var$_tmpl$4(), _el$48 = _el$47.firstChild, _el$50 = _el$48.nextSibling, _el$49 = _el$50.nextSibling;
                                    (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$47, ()=>t("Returned for Revision"), _el$48);
                                    (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$47, ()=>draftWithFeedback().length, _el$50);
                                    return _el$47;
                                })(),
                                (()=>{
                                    var _el$51 = $2216a7ab50ec14b7$var$_tmpl$8(), _el$52 = _el$51.firstChild;
                                    (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$51, ()=>t("These agreements were returned to the student with feedback and are being revised."), null);
                                    return _el$51;
                                })(),
                                (()=>{
                                    var _el$53 = $2216a7ab50ec14b7$var$_tmpl$6(), _el$54 = _el$53.firstChild, _el$55 = _el$54.firstChild, _el$56 = _el$55.firstChild, _el$57 = _el$56.firstChild, _el$58 = _el$57.nextSibling, _el$59 = _el$58.nextSibling, _el$60 = _el$59.nextSibling, _el$61 = _el$55.nextSibling;
                                    (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$57, ()=>t("Student"));
                                    (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$58, ()=>t("Title"));
                                    (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$59, ()=>t("Last Feedback"));
                                    (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$60, ()=>t("Actions"));
                                    (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$61, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$bdf530073099ce9f), {
                                        get each () {
                                            return draftWithFeedback();
                                        },
                                        children: (convention)=>(()=>{
                                                var _el$97 = $2216a7ab50ec14b7$var$_tmpl$17(), _el$98 = _el$97.firstChild, _el$99 = _el$98.nextSibling, _el$100 = _el$99.firstChild, _el$101 = _el$100.nextSibling, _el$102 = _el$99.nextSibling, _el$106 = _el$102.nextSibling, _el$107 = _el$106.firstChild, _el$108 = _el$107.firstChild;
                                                (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$98, (()=>{
                                                    var _c$4 = (0, $6258376c5c54faa9$export$7c73462e0d25e514)(()=>!!convention.fullname);
                                                    return ()=>_c$4() ? [
                                                            (0, $6258376c5c54faa9$export$7c73462e0d25e514)(()=>convention.fullname),
                                                            $2216a7ab50ec14b7$var$_tmpl$1(),
                                                            (()=>{
                                                                var _el$110 = $2216a7ab50ec14b7$var$_tmpl$12();
                                                                (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$110, ()=>convention.username);
                                                                return _el$110;
                                                            })()
                                                        ] : convention.username;
                                                })());
                                                (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$99, ()=>convention.info?.title || t("Internship Agreement"), _el$100);
                                                (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$101, ()=>t("In Revision"));
                                                (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$102, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
                                                    get when () {
                                                        return (0, $6258376c5c54faa9$export$7c73462e0d25e514)(()=>!!convention.info?.feedbackHistory)() && convention.info.feedbackHistory.length > 0;
                                                    },
                                                    get children () {
                                                        var _el$103 = $2216a7ab50ec14b7$var$_tmpl$16(), _el$104 = _el$103.firstChild, _el$105 = _el$104.nextSibling;
                                                        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$103, ()=>t("by"), _el$104);
                                                        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$103, ()=>convention.info.feedbackHistory[0].teacher, _el$105);
                                                        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$103, ()=>new Date(convention.info.feedbackHistory[0].date).toLocaleDateString(), null);
                                                        return _el$103;
                                                    }
                                                }));
                                                _el$107.$$click = ()=>openConventionModal(convention);
                                                (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$107, ()=>t("View"), null);
                                                return _el$97;
                                            })()
                                    }));
                                    return _el$53;
                                })()
                            ];
                        }
                    })
                ];
            }
        }), null);
        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$5, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
            get when () {
                return selectedConvention();
            },
            get children () {
                return (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)($2216a7ab50ec14b7$var$ConventionModal, {
                    get convention () {
                        return selectedConvention();
                    },
                    get promo () {
                        return props.promo;
                    },
                    onClose: closeConventionModal,
                    get hasValidated () {
                        return hasValidated(selectedConvention());
                    },
                    getRemainingValidators: ()=>getRemainingValidators(selectedConvention(), props.promo),
                    onValidate: validateConvention,
                    get editingFeedback () {
                        return editingFeedback();
                    },
                    onStartEditingFeedback: ()=>startEditingFeedback(selectedConvention()),
                    onSaveFeedback: saveFeedback,
                    onCancelEditingFeedback: cancelEditingFeedback,
                    onSendExistingFeedback: sendExistingFeedbackNotification,
                    setEditingFeedback: setEditingFeedback,
                    userStore: userStore
                });
            }
        }), null);
        return _el$5;
    })();
}
// Convention Modal Component
function $2216a7ab50ec14b7$var$ConventionModal(props) {
    const t = (0, $87927b02874039c5$export$3f3caade1c12f8c9)();
    return (()=>{
        var _el$111 = $2216a7ab50ec14b7$var$_tmpl$30(), _el$112 = _el$111.firstChild, _el$113 = _el$112.firstChild, _el$114 = _el$113.firstChild, _el$115 = _el$114.firstChild, _el$118 = _el$115.nextSibling, _el$119 = _el$114.nextSibling, _el$120 = _el$119.firstChild, _el$121 = _el$120.firstChild, _el$122 = _el$121.firstChild, _el$157 = _el$119.nextSibling, _el$160 = _el$157.firstChild;
        (0, $6258376c5c54faa9$export$3f65cefe8380dbea)(_el$111, "click", props.onClose, true);
        _el$112.$$click = (e)=>e.stopPropagation();
        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$115, ()=>props.convention.info?.title || `${t("Internship Agreement")} (${props.convention.year})`, null);
        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$115, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
            get when () {
                return props.convention.status === 'locked';
            },
            get children () {
                var _el$116 = $2216a7ab50ec14b7$var$_tmpl$18();
                (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$116, ()=>t("Locked"));
                return _el$116;
            }
        }), null);
        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$115, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
            get when () {
                return props.convention.status === 'active';
            },
            get children () {
                var _el$117 = $2216a7ab50ec14b7$var$_tmpl$19();
                (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$117, ()=>t("In Revision"));
                return _el$117;
            }
        }), null);
        (0, $6258376c5c54faa9$export$3f65cefe8380dbea)(_el$118, "click", props.onClose, true);
        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$121, ()=>t("Student"), _el$122);
        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$121, (()=>{
            var _c$5 = (0, $6258376c5c54faa9$export$7c73462e0d25e514)(()=>!!props.convention.fullname);
            return ()=>_c$5() ? [
                    (0, $6258376c5c54faa9$export$7c73462e0d25e514)(()=>props.convention.fullname),
                    " ",
                    (()=>{
                        var _el$161 = $2216a7ab50ec14b7$var$_tmpl$31(), _el$162 = _el$161.firstChild, _el$164 = _el$162.nextSibling, _el$163 = _el$164.nextSibling;
                        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$161, ()=>props.convention.username, _el$164);
                        return _el$161;
                    })()
                ] : props.convention.username;
        })(), null);
        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$119, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $18e8c93f2f49788f$export$665b5ec824ef65f), {
            get convention () {
                return props.convention;
            },
            startEditing: ()=>{},
            get conventionStructure () {
                return props.userStore.conventionStructure;
            }
        }), null);
        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$119, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
            get when () {
                return props.convention.status !== 'active';
            },
            get children () {
                return [
                    (()=>{
                        var _el$123 = $2216a7ab50ec14b7$var$_tmpl$22(), _el$124 = _el$123.firstChild, _el$125 = _el$124.firstChild;
                        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$124, ()=>t("Validation Status"), _el$125);
                        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$123, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
                            get when () {
                                return (0, $6258376c5c54faa9$export$7c73462e0d25e514)(()=>!!props.convention.info.validations)() && props.convention.info.validations.length > 0;
                            },
                            get children () {
                                var _el$126 = $2216a7ab50ec14b7$var$_tmpl$20(), _el$127 = _el$126.firstChild, _el$128 = _el$127.firstChild, _el$129 = _el$127.nextSibling;
                                (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$127, ()=>t("Validated by"), _el$128);
                                (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$129, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$bdf530073099ce9f), {
                                    get each () {
                                        return props.convention.info.validations;
                                    },
                                    children: (validation)=>(()=>{
                                            var _el$165 = $2216a7ab50ec14b7$var$_tmpl$32(), _el$166 = _el$165.firstChild;
                                            (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$165, ()=>validation.validatorName, _el$166);
                                            (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$165, ()=>new Date(validation.timestamp).toLocaleString(), null);
                                            return _el$165;
                                        })()
                                }));
                                return _el$126;
                            }
                        }), null);
                        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$123, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
                            get when () {
                                return !props.convention.info.validations || props.convention.info.validations.length === 0;
                            },
                            get children () {
                                var _el$130 = $2216a7ab50ec14b7$var$_tmpl$21();
                                (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$130, ()=>t("Not validated yet"));
                                return _el$130;
                            }
                        }), null);
                        return _el$123;
                    })(),
                    (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
                        get when () {
                            return props.getRemainingValidators().length > 0;
                        },
                        get children () {
                            var _el$131 = $2216a7ab50ec14b7$var$_tmpl$23(), _el$132 = _el$131.firstChild, _el$133 = _el$132.firstChild, _el$134 = _el$132.nextSibling;
                            (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$132, ()=>t("Waiting for validation from"), _el$133);
                            (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$134, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$bdf530073099ce9f), {
                                get each () {
                                    return props.getRemainingValidators();
                                },
                                children: (validator)=>(()=>{
                                        var _el$167 = $2216a7ab50ec14b7$var$_tmpl$33();
                                        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$167, (()=>{
                                            var _c$8 = (0, $6258376c5c54faa9$export$7c73462e0d25e514)(()=>!!validator.fullname);
                                            return ()=>_c$8() ? [
                                                    (0, $6258376c5c54faa9$export$7c73462e0d25e514)(()=>validator.fullname),
                                                    " ",
                                                    (()=>{
                                                        var _el$168 = $2216a7ab50ec14b7$var$_tmpl$34(), _el$169 = _el$168.firstChild, _el$171 = _el$169.nextSibling, _el$170 = _el$171.nextSibling;
                                                        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$168, ()=>validator.username, _el$171);
                                                        return _el$168;
                                                    })()
                                                ] : validator.username;
                                        })());
                                        return _el$167;
                                    })()
                            }));
                            return _el$131;
                        }
                    })
                ];
            }
        }), null);
        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$119, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
            get when () {
                return props.convention.status === 'pending' || props.convention.status === 'validated';
            },
            get children () {
                return [
                    (()=>{
                        var _el$135 = $2216a7ab50ec14b7$var$_tmpl$22(), _el$136 = _el$135.firstChild, _el$137 = _el$136.firstChild;
                        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$136, ()=>t("Teacher Feedback"), _el$137);
                        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$135, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
                            get when () {
                                return (0, $6258376c5c54faa9$export$7c73462e0d25e514)(()=>!!props.convention.info?.feedbackHistory)() && props.convention.info.feedbackHistory.length > 0;
                            },
                            get children () {
                                return [
                                    (()=>{
                                        var _el$138 = $2216a7ab50ec14b7$var$_tmpl$24();
                                        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$138, ()=>t("Resubmitted"));
                                        return _el$138;
                                    })(),
                                    (()=>{
                                        var _el$139 = $2216a7ab50ec14b7$var$_tmpl$25(), _el$140 = _el$139.firstChild, _el$141 = _el$140.firstChild;
                                        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$140, ()=>t("This convention has been resubmitted after receiving feedback."), _el$141);
                                        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$140, ()=>t("Previous feedback can be found below."), null);
                                        return _el$139;
                                    })()
                                ];
                            }
                        }), null);
                        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$135, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
                            get when () {
                                return props.editingFeedback.conventionId !== props.convention.id;
                            },
                            get fallback () {
                                return (()=>{
                                    var _el$172 = $2216a7ab50ec14b7$var$_tmpl$35(), _el$173 = _el$172.firstChild, _el$174 = _el$173.nextSibling, _el$175 = _el$174.firstChild, _el$176 = _el$175.nextSibling, _el$177 = _el$176.firstChild, _el$178 = _el$176.nextSibling;
                                    _el$173.$$input = (e)=>props.setEditingFeedback({
                                            ...props.editingFeedback,
                                            feedback: e.currentTarget.value
                                        });
                                    _el$175.$$click = ()=>props.onSaveFeedback(false);
                                    (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$175, ()=>t("Save Draft"));
                                    _el$176.$$click = ()=>props.onSaveFeedback(true);
                                    (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$176, ()=>t("Save & Send Notification"), null);
                                    (0, $6258376c5c54faa9$export$3f65cefe8380dbea)(_el$178, "click", props.onCancelEditingFeedback, true);
                                    (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$178, ()=>t("Cancel"));
                                    (0, $8863cd8fe199f948$export$314dade334ae905d)((_p$)=>{
                                        var _v$ = t("Save without sending notification to student"), _v$2 = t("Save and send notification to student");
                                        _v$ !== _p$.e && (0, $6258376c5c54faa9$export$9fec4d97f1922e0b)(_el$175, "title", _p$.e = _v$);
                                        _v$2 !== _p$.t && (0, $6258376c5c54faa9$export$9fec4d97f1922e0b)(_el$176, "title", _p$.t = _v$2);
                                        return _p$;
                                    }, {
                                        e: undefined,
                                        t: undefined
                                    });
                                    (0, $8863cd8fe199f948$export$314dade334ae905d)(()=>_el$173.value = props.editingFeedback.feedback);
                                    return _el$172;
                                })();
                            },
                            get children () {
                                var _el$142 = $2216a7ab50ec14b7$var$_tmpl$27(), _el$143 = _el$142.firstChild, _el$144 = _el$143.nextSibling, _el$145 = _el$144.firstChild;
                                (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$143, (()=>{
                                    var _c$6 = (0, $6258376c5c54faa9$export$7c73462e0d25e514)(()=>!!props.convention.info?.teacherFeedback);
                                    return ()=>_c$6() ? (()=>{
                                            var _el$179 = $2216a7ab50ec14b7$var$_tmpl$36(), _el$180 = _el$179.firstChild, _el$181 = _el$180.nextSibling, _el$182 = _el$181.firstChild;
                                            (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$180, ()=>props.convention.info.teacherFeedback);
                                            (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$181, ()=>t("Last updated"), _el$182);
                                            (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$181, ()=>new Date(props.convention.info.feedbackDate).toLocaleString(), null);
                                            return _el$179;
                                        })() : t("No feedback draft");
                                })());
                                (0, $6258376c5c54faa9$export$3f65cefe8380dbea)(_el$145, "click", props.onStartEditingFeedback, true);
                                (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$145, (()=>{
                                    var _c$7 = (0, $6258376c5c54faa9$export$7c73462e0d25e514)(()=>!!props.convention.info?.teacherFeedback);
                                    return ()=>_c$7() ? t("Edit Feedback") : t("Add Feedback");
                                })());
                                (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$144, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
                                    get when () {
                                        return props.convention.info?.teacherFeedback;
                                    },
                                    get children () {
                                        var _el$146 = $2216a7ab50ec14b7$var$_tmpl$26(), _el$147 = _el$146.firstChild;
                                        _el$146.$$click = ()=>props.onSendExistingFeedback(props.convention.id);
                                        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$146, ()=>t("Send Notification"), null);
                                        (0, $8863cd8fe199f948$export$314dade334ae905d)(()=>(0, $6258376c5c54faa9$export$9fec4d97f1922e0b)(_el$146, "title", t("Send notification to student about this feedback")));
                                        return _el$146;
                                    }
                                }), null);
                                return _el$142;
                            }
                        }), null);
                        return _el$135;
                    })(),
                    (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
                        get when () {
                            return (0, $6258376c5c54faa9$export$7c73462e0d25e514)(()=>!!props.convention.info?.feedbackHistory)() && props.convention.info.feedbackHistory.length > 0;
                        },
                        get children () {
                            var _el$148 = $2216a7ab50ec14b7$var$_tmpl$28(), _el$149 = _el$148.firstChild, _el$150 = _el$149.firstChild, _el$151 = _el$149.nextSibling, _el$152 = _el$151.firstChild, _el$153 = _el$152.firstChild;
                            (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$149, ()=>t("Feedback History"), _el$150);
                            (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$153, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$bdf530073099ce9f), {
                                get each () {
                                    return props.convention.info.feedbackHistory;
                                },
                                children: (historyItem)=>(()=>{
                                        var _el$183 = $2216a7ab50ec14b7$var$_tmpl$39(), _el$184 = _el$183.firstChild, _el$185 = _el$184.firstChild, _el$186 = _el$185.firstChild, _el$187 = _el$185.nextSibling, _el$188 = _el$187.firstChild, _el$191 = _el$188.nextSibling, _el$189 = _el$191.nextSibling, _el$192 = _el$189.nextSibling, _el$190 = _el$192.nextSibling, _el$193 = _el$184.nextSibling, _el$194 = _el$193.nextSibling;
                                        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$185, ()=>t("Version"), _el$186);
                                        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$185, ()=>historyItem.conventionVersion || '?', null);
                                        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$187, ()=>t("by"), _el$188);
                                        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$187, ()=>historyItem.teacher, _el$191);
                                        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$187, ()=>t("on"), _el$192);
                                        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$187, ()=>new Date(historyItem.date).toLocaleString(), null);
                                        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$193, ()=>historyItem.feedback);
                                        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$194, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
                                            get when () {
                                                return historyItem.notificationSent;
                                            },
                                            get children () {
                                                var _el$195 = $2216a7ab50ec14b7$var$_tmpl$37(), _el$196 = _el$195.firstChild, _el$197 = _el$196.nextSibling;
                                                (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$195, ()=>t("Notification sent"), null);
                                                return _el$195;
                                            }
                                        }), null);
                                        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$194, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
                                            get when () {
                                                return (0, $6258376c5c54faa9$export$7c73462e0d25e514)(()=>!!historyItem.validations)() && historyItem.validations.length > 0;
                                            },
                                            get children () {
                                                var _el$198 = $2216a7ab50ec14b7$var$_tmpl$38(), _el$199 = _el$198.firstChild, _el$201 = _el$199.nextSibling, _el$200 = _el$201.nextSibling;
                                                (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$198, ()=>t("Validated by"), _el$199);
                                                (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$198, ()=>historyItem.validations.length, _el$201);
                                                (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$198, ()=>t("teacher(s)"), null);
                                                return _el$198;
                                            }
                                        }), null);
                                        return _el$183;
                                    })()
                            }));
                            return _el$148;
                        }
                    })
                ];
            }
        }), null);
        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$119, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
            get when () {
                return (0, $6258376c5c54faa9$export$7c73462e0d25e514)(()=>props.convention.status === 'active')() && props.convention.info?.feedbackHistory;
            },
            get children () {
                var _el$154 = $2216a7ab50ec14b7$var$_tmpl$22(), _el$155 = _el$154.firstChild, _el$156 = _el$155.firstChild;
                (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$155, ()=>t("Feedback History"), _el$156);
                (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$154, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$bdf530073099ce9f), {
                    get each () {
                        return props.convention.info.feedbackHistory;
                    },
                    children: (historyItem, index)=>(()=>{
                            var _el$202 = $2216a7ab50ec14b7$var$_tmpl$40(), _el$203 = _el$202.firstChild, _el$204 = _el$203.firstChild, _el$205 = _el$204.firstChild, _el$206 = _el$205.nextSibling, _el$207 = _el$206.firstChild, _el$210 = _el$207.nextSibling, _el$208 = _el$210.nextSibling, _el$211 = _el$208.nextSibling, _el$209 = _el$211.nextSibling, _el$212 = _el$204.nextSibling;
                            (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$205, (()=>{
                                var _c$9 = (0, $6258376c5c54faa9$export$7c73462e0d25e514)(()=>index() === 0);
                                return ()=>_c$9() ? t("Last Feedback Sent") : `${t("Version")} ${historyItem.conventionVersion || '?'}`;
                            })());
                            (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$206, ()=>t("by"), _el$207);
                            (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$206, ()=>historyItem.teacher, _el$210);
                            (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$206, ()=>t("on"), _el$211);
                            (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$206, ()=>new Date(historyItem.date).toLocaleString(), null);
                            (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$212, ()=>historyItem.feedback);
                            (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$203, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
                                get when () {
                                    return (0, $6258376c5c54faa9$export$7c73462e0d25e514)(()=>!!historyItem.validations)() && historyItem.validations.length > 0;
                                },
                                get children () {
                                    var _el$213 = $2216a7ab50ec14b7$var$_tmpl$38(), _el$214 = _el$213.firstChild, _el$216 = _el$214.nextSibling, _el$215 = _el$216.nextSibling;
                                    (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$213, ()=>t("Validated by"), _el$214);
                                    (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$213, ()=>historyItem.validations.length, _el$216);
                                    (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$213, ()=>t("teacher(s)"), null);
                                    return _el$213;
                                }
                            }), null);
                            return _el$202;
                        })()
                }), null);
                return _el$154;
            }
        }), null);
        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$157, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
            get when () {
                return (0, $6258376c5c54faa9$export$7c73462e0d25e514)(()=>!!!props.hasValidated)() && props.convention.status === 'pending';
            },
            get children () {
                var _el$158 = $2216a7ab50ec14b7$var$_tmpl$29(), _el$159 = _el$158.firstChild;
                _el$158.$$click = ()=>{
                    props.onValidate(props.convention.id);
                    props.onClose();
                };
                (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$158, ()=>t("Validate"), null);
                return _el$158;
            }
        }), _el$160);
        (0, $6258376c5c54faa9$export$3f65cefe8380dbea)(_el$160, "click", props.onClose, true);
        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$160, ()=>t("Close"));
        return _el$111;
    })();
}
(0, $6258376c5c54faa9$export$ad0f7f87f67e17d6)([
    "click",
    "input"
]);



var $bd3f6eae7d713afc$var$_tmpl$ = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<form class=mt-3><div class="row g-3 align-items-center"><div class=col-auto><input type=text class=form-control required></div><div class=col-auto><button type=submit class="btn btn-primary">`), $bd3f6eae7d713afc$var$_tmpl$2 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<div class="text-danger mt-2">`), $bd3f6eae7d713afc$var$_tmpl$3 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<li><a class=dropdown-item href=/user-settings>`), $bd3f6eae7d713afc$var$_tmpl$4 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<h1>Non connect\xe9`), $bd3f6eae7d713afc$var$_tmpl$5 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<button type=button class="btn btn-primary">Se connecter`), $bd3f6eae7d713afc$var$_tmpl$6 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<h1 class=mb-4>`), $bd3f6eae7d713afc$var$_tmpl$7 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<br>`), $bd3f6eae7d713afc$var$_tmpl$8 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<pre>`), $bd3f6eae7d713afc$var$_tmpl$9 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<div class=container><nav class="navbar navbar-expand-lg sticky-top navbar-light bg-light"><div class=container-fluid><a class=navbar-brand href=/></a><button class=navbar-toggler type=button aria-controls=navbarNavDropdown aria-label="Toggle navigation"><span class=navbar-toggler-icon></span></button><div id=navbarNavDropdown><ul class=navbar-nav><li class=nav-item><a class="nav-link active"aria-current=page href=/>`), $bd3f6eae7d713afc$var$_tmpl$0 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<span> <small class=text-muted>(<!>)`), $bd3f6eae7d713afc$var$_tmpl$1 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<li>`), $bd3f6eae7d713afc$var$_tmpl$10 = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<div class="alert alert-warning mb-4"><h4 class=alert-heading></h4><p></p><ul></ul><p></p><button type=button class="btn btn-primary">`);
// Fullname Form Component
const $bd3f6eae7d713afc$var$FullnameForm = ()=>{
    const t = (0, $87927b02874039c5$export$3f3caade1c12f8c9)();
    const [userStore, setUserStore, userActions] = (0, $c3b276e29c1ce2f2$export$87c54b525b914dab)();
    const [fullname, setFullname] = (0, $8863cd8fe199f948$export$c1e1e1ecbbe76a5)("");
    const [saving, setSaving] = (0, $8863cd8fe199f948$export$c1e1e1ecbbe76a5)(false);
    const [error, setError] = (0, $8863cd8fe199f948$export$c1e1e1ecbbe76a5)("");
    const handleSubmit = (e)=>{
        e.preventDefault();
        if (!fullname().trim()) {
            setError(t("Please enter your full name"));
            return;
        }
        setSaving(true);
        setError("");
        userActions.updateUserProfile({
            fullname: fullname()
        }).then(()=>{
            setSaving(false);
        }).catch((err)=>{
            setError(t("Error updating profile. Please try again."));
            setSaving(false);
        });
    };
    return (()=>{
        var _el$ = $bd3f6eae7d713afc$var$_tmpl$(), _el$2 = _el$.firstChild, _el$3 = _el$2.firstChild, _el$4 = _el$3.firstChild, _el$5 = _el$3.nextSibling, _el$6 = _el$5.firstChild;
        _el$.addEventListener("submit", handleSubmit);
        _el$4.$$input = (e)=>setFullname(e.target.value);
        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$6, (()=>{
            var _c$ = (0, $6258376c5c54faa9$export$7c73462e0d25e514)(()=>!!saving());
            return ()=>_c$() ? t("Saving...") : t("Save");
        })());
        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$, (()=>{
            var _c$2 = (0, $6258376c5c54faa9$export$7c73462e0d25e514)(()=>!!error());
            return ()=>_c$2() && (()=>{
                    var _el$7 = $bd3f6eae7d713afc$var$_tmpl$2();
                    (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$7, error);
                    return _el$7;
                })();
        })(), null);
        (0, $8863cd8fe199f948$export$314dade334ae905d)((_p$)=>{
            var _v$ = t("Enter your full name"), _v$2 = saving();
            _v$ !== _p$.e && (0, $6258376c5c54faa9$export$9fec4d97f1922e0b)(_el$4, "placeholder", _p$.e = _v$);
            _v$2 !== _p$.t && (_el$6.disabled = _p$.t = _v$2);
            return _p$;
        }, {
            e: undefined,
            t: undefined
        });
        (0, $8863cd8fe199f948$export$314dade334ae905d)(()=>_el$4.value = fullname());
        return _el$;
    })();
};
function $bd3f6eae7d713afc$export$2e2bcd8739ae039() {
    const t = (0, $87927b02874039c5$export$3f3caade1c12f8c9)();
    const [userStore, setUserStore, userActions] = (0, $c3b276e29c1ce2f2$export$87c54b525b914dab)();
    const [navbarExpanded, setNavbarExpanded] = (0, $8863cd8fe199f948$export$c1e1e1ecbbe76a5)(false); // Add this line
    const [log, setLog] = (0, $8863cd8fe199f948$export$c1e1e1ecbbe76a5)('');
    (0, $8863cd8fe199f948$export$1e848a9e87980bd5)(()=>{
        (0, $a26018a1d2174fbf$export$2e2bcd8739ae039).on('log', (data)=>{
            setLog(log() + '\n' + data);
        });
    });
    // Add this function to toggle navbar state
    const toggleNavbar = ()=>{
        setNavbarExpanded(!navbarExpanded());
    };
    return [
        (()=>{
            var _el$8 = $bd3f6eae7d713afc$var$_tmpl$9(), _el$9 = _el$8.firstChild, _el$0 = _el$9.firstChild, _el$1 = _el$0.firstChild, _el$10 = _el$1.nextSibling, _el$11 = _el$10.nextSibling, _el$12 = _el$11.firstChild, _el$13 = _el$12.firstChild, _el$14 = _el$13.firstChild;
            _el$1.$$click = (e)=>{
                e.preventDefault();
                userActions.setPage('/');
            };
            (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$1, ()=>t("Pre-Stage"));
            _el$10.$$click = toggleNavbar;
            _el$14.$$click = (e)=>{
                e.preventDefault();
                userActions.setPage('/');
            };
            (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$14, ()=>t("Home"));
            (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$12, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $b1a355c10f370609$export$461cb598b7fcff7b), {
                get label () {
                    return (0, $6258376c5c54faa9$export$7c73462e0d25e514)(()=>!!userStore.username)() ? (0, $6258376c5c54faa9$export$7c73462e0d25e514)(()=>!!userStore.fullname)() ? (()=>{
                        var _el$22 = $bd3f6eae7d713afc$var$_tmpl$0(), _el$23 = _el$22.firstChild, _el$24 = _el$23.nextSibling, _el$25 = _el$24.firstChild, _el$27 = _el$25.nextSibling, _el$26 = _el$27.nextSibling;
                        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$22, ()=>userStore.fullname, _el$23);
                        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$24, ()=>userStore.username, _el$27);
                        return _el$22;
                    })() : userStore.username : "Non connect\xe9";
                },
                get children () {
                    var _el$15 = $bd3f6eae7d713afc$var$_tmpl$3(), _el$16 = _el$15.firstChild;
                    _el$16.$$click = (e)=>{
                        e.preventDefault();
                        userActions.setPage('/user-settings');
                    };
                    (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$16, ()=>t("Settings"));
                    return _el$15;
                }
            }), null);
            (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$12, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
                get when () {
                    return userStore.role === 'admin';
                },
                get children () {
                    return (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $e4c7899627fd74c8$export$fd88fd0f00d26ab7), {});
                }
            }), null);
            (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$8, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
                get when () {
                    return (0, $6258376c5c54faa9$export$7c73462e0d25e514)(()=>!!!userStore.username)() && userStore.loadingUser;
                },
                get children () {
                    return (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $b1a355c10f370609$export$3b0d6d7590275603), {});
                }
            }), null);
            (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$8, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
                get when () {
                    return (0, $6258376c5c54faa9$export$7c73462e0d25e514)(()=>!!!userStore.username)() && !userStore.loadingUser;
                },
                get children () {
                    return [
                        $bd3f6eae7d713afc$var$_tmpl$4(),
                        (()=>{
                            var _el$18 = $bd3f6eae7d713afc$var$_tmpl$5();
                            _el$18.$$click = ()=>{
                                location.href = '/login';
                            };
                            return _el$18;
                        })()
                    ];
                }
            }), null);
            (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$8, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
                get when () {
                    return userStore.username;
                },
                get children () {
                    return [
                        (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
                            get when () {
                                return (0, $6258376c5c54faa9$export$7c73462e0d25e514)(()=>userStore.role === 'admin')() && (userStore.page === '/' || userStore.page === '/manage-users' || userStore.page === '/manage-promos' || userStore.page === '/manage-notifications' || userStore.page === '/manage-years' || userStore.page === '/manage-convention-structure' || userStore.page === '/manage-email-templates');
                            },
                            get children () {
                                return (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $e4c7899627fd74c8$export$2e2bcd8739ae039), {});
                            }
                        }),
                        (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
                            get when () {
                                return (0, $6258376c5c54faa9$export$7c73462e0d25e514)(()=>userStore.role === 'teacher')() && userStore.page === '/';
                            },
                            get children () {
                                return (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $2216a7ab50ec14b7$export$2e2bcd8739ae039), {});
                            }
                        }),
                        (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
                            get when () {
                                return (0, $6258376c5c54faa9$export$7c73462e0d25e514)(()=>!!(userStore.role !== 'admin' && userStore.role !== 'teacher'))() && userStore.page === '/';
                            },
                            get children () {
                                return (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
                                    get when () {
                                        return userStore.promo_id;
                                    },
                                    get fallback () {
                                        return (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $e59a09545c17b201$export$2e2bcd8739ae039), {});
                                    },
                                    get children () {
                                        return (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
                                            get when () {
                                                return (0, $6258376c5c54faa9$export$7c73462e0d25e514)(()=>!!(userStore.fullname && userStore.student_number))() && userStore.additional_info?.healthInsurance;
                                            },
                                            get fallback () {
                                                return (()=>{
                                                    var _el$28 = $bd3f6eae7d713afc$var$_tmpl$10(), _el$29 = _el$28.firstChild, _el$30 = _el$29.nextSibling, _el$31 = _el$30.nextSibling, _el$35 = _el$31.nextSibling, _el$36 = _el$35.nextSibling;
                                                    (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$29, ()=>t("Complete Your Profile"));
                                                    (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$30, ()=>t("Please complete your profile information before creating internship agreements:"));
                                                    (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$31, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
                                                        get when () {
                                                            return !userStore.fullname;
                                                        },
                                                        get children () {
                                                            var _el$32 = $bd3f6eae7d713afc$var$_tmpl$1();
                                                            (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$32, ()=>t("Full Name"));
                                                            return _el$32;
                                                        }
                                                    }), null);
                                                    (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$31, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
                                                        get when () {
                                                            return !userStore.student_number;
                                                        },
                                                        get children () {
                                                            var _el$33 = $bd3f6eae7d713afc$var$_tmpl$1();
                                                            (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$33, ()=>t("Student Number"));
                                                            return _el$33;
                                                        }
                                                    }), null);
                                                    (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$31, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
                                                        get when () {
                                                            return !userStore.additional_info?.healthInsurance;
                                                        },
                                                        get children () {
                                                            var _el$34 = $bd3f6eae7d713afc$var$_tmpl$1();
                                                            (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$34, ()=>t("Health Insurance - City + Region"));
                                                            return _el$34;
                                                        }
                                                    }), null);
                                                    (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$35, ()=>t("Please also verify that your email address is correct."));
                                                    _el$36.$$click = ()=>userActions.setPage('/user-settings');
                                                    (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$36, ()=>t("Go to Settings"));
                                                    return _el$28;
                                                })();
                                            },
                                            get children () {
                                                return [
                                                    (()=>{
                                                        var _el$19 = $bd3f6eae7d713afc$var$_tmpl$6();
                                                        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$19, ()=>t("Internship Management Platform"));
                                                        return _el$19;
                                                    })(),
                                                    (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $18e8c93f2f49788f$export$2e2bcd8739ae039), {})
                                                ];
                                            }
                                        });
                                    }
                                });
                            }
                        }),
                        (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $8863cd8fe199f948$export$f6a3d19be20f5819), {
                            get when () {
                                return userStore.page === '/user-settings';
                            },
                            get children () {
                                return (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $5de580f0a4763066$export$2e2bcd8739ae039), {});
                            }
                        }),
                        $bd3f6eae7d713afc$var$_tmpl$7(),
                        (()=>{
                            var _el$21 = $bd3f6eae7d713afc$var$_tmpl$8();
                            (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$21, log);
                            return _el$21;
                        })()
                    ];
                }
            }), null);
            (0, $8863cd8fe199f948$export$314dade334ae905d)((_p$)=>{
                var _v$3 = navbarExpanded() ? "true" : "false", _v$4 = `collapse navbar-collapse ${navbarExpanded() ? 'show' : ''}`;
                _v$3 !== _p$.e && (0, $6258376c5c54faa9$export$9fec4d97f1922e0b)(_el$10, "aria-expanded", _p$.e = _v$3);
                _v$4 !== _p$.t && (0, $6258376c5c54faa9$export$2913c0c0b5623090)(_el$11, _p$.t = _v$4);
                return _p$;
            }, {
                e: undefined,
                t: undefined
            });
            return _el$8;
        })(),
        (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $a26018a1d2174fbf$export$d049364d16567d0d), {})
    ];
}
(0, $6258376c5c54faa9$export$ad0f7f87f67e17d6)([
    "input",
    "click"
]);








var $5a283b6fa3b36b50$var$_tmpl$ = /*#__PURE__*/ (0, $6258376c5c54faa9$export$ce69bd05624d0c48)(`<div><footer class=footer style=display:none><div class=container><span class=text-muted><a href=http://bramas.fr>bramas.fr</a></span> | <span class=text-muted><a href=#>Se d\xe9connecter`);
var $4ff066660f9e079a$exports = {};
$4ff066660f9e079a$exports = import.meta.resolve("fcy7C");


// Register service worker for offline capabilities
// Using URL constructor which works with Parcel
if ('serviceWorker' in navigator) window.addEventListener('load', ()=>{
    // Instead of using a string literal, use a URL object
    const swUrl = new URL($4ff066660f9e079a$exports);
    navigator.serviceWorker.register(swUrl).then((registration)=>{
        console.log('Service worker registered successfully with scope:', registration.scope);
    }).catch((error)=>{
        console.error('Service worker registration failed:', error);
    });
});
const $5a283b6fa3b36b50$var$app = document.getElementById('app');
if ($5a283b6fa3b36b50$var$app) (0, $6258376c5c54faa9$export$b3890eb0ae9dca99)(()=>(()=>{
        var _el$ = $5a283b6fa3b36b50$var$_tmpl$(), _el$2 = _el$.firstChild, _el$3 = _el$2.firstChild, _el$4 = _el$3.firstChild, _el$5 = _el$4.nextSibling, _el$6 = _el$5.nextSibling, _el$7 = _el$6.firstChild;
        (0, $6258376c5c54faa9$export$21a5ca8aa77d35ff)(_el$, (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $89c51277d5b9a262$export$30c420163f6d7eb3), {
            get children () {
                return (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $ef60b4f4f09c584e$export$dc480220161ce7c5), {
                    get children () {
                        return (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $c3b276e29c1ce2f2$export$2e7f18b06f26b111), {
                            get children () {
                                return (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $059fd204a72364ff$export$66cafb854a568b29), {
                                    get children () {
                                        return (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $87927b02874039c5$export$a54013f0d02a8f82), {
                                            get children () {
                                                return (0, $8863cd8fe199f948$export$60e54eaca7e7fb38)((0, $bd3f6eae7d713afc$export$2e2bcd8739ae039), {});
                                            }
                                        });
                                    }
                                });
                            }
                        });
                    }
                });
            }
        }), _el$2);
        _el$7.$$click = ()=>{};
        return _el$;
    })(), $5a283b6fa3b36b50$var$app);
(0, $6258376c5c54faa9$export$ad0f7f87f67e17d6)([
    "click"
]);


//# sourceMappingURL=client.621e9613.js.map
